<template>
 <div class="scroll-content" @scroll="handleScroll">
    <div class="contenedorS">
    <p style="text-indent: 0pt;text-align: center;">
      <br />
    </p>
    <p style="padding-left: 9pt;text-indent: 0pt;text-align: center;">
      <a name="bookmark0">&zwnj;</a>Condiciones Generales
    </p>
    <h1 style="padding-top: 4pt;padding-left: 9pt;text-indent: 0pt;line-height: 112%;text-align: center;">
      <a name="a0">Seguro de Automóviles, Camionetas y Pick-ups de hasta 3 ½ toneladas de uso particular</a>
    </h1>
    <p style="text-indent: 0pt;text-align: center;">
      <br />
    </p>
    <p style="padding-left: 9pt;text-indent: 0pt;text-align: center;">LA LATINOAMERICANA SEGUROS, S.A. </p>
    <p style="text-indent: 0pt;text-align: center;">
      <br />
    </p>      
    <p class="s3" style="padding-left: 49pt;text-indent: 0pt;text-align: center;">Eje Central Lázaro Cárdenas 2, Piso 8, Col. Centro, Alc. Cuauhtémoc, C.P. 06000, CDMX.</p>
    <p style="padding-top: 5pt;padding-left: 161pt;text-indent: 0pt;text-align: center;">
      <a href="http://www.latinoseguros.com.mx/" class="s5" target="_blank">Latino-seguros LatinomxOficial www.latinoseguros.com.mx</a>
    </p>
    <p style="text-indent: 0pt;text-align: center;">
      <br />
    </p>
    <p class="s6" style="padding-left: 5pt;text-indent: 0pt;text-align: center;">
      <a name="bookmark1">&zwnj;</a>LA LATINOAMERICANA SEGUROS, S. A.
    </p>
    <p style="text-indent: 0pt;text-align: center;">
      <br />
    </p>
    <p style="text-indent: 0pt;text-align: center;">
      <span>
        <img width="289" height="289" alt="image" src="./Image_002.png" />
      </span>
      <span>
        <img width="289" height="289" alt="image" src="./Image_003.png" />
      </span>      
    </p>
    <p style="padding-top: 7pt;text-indent: 0pt;text-align: center;">
      <br />
    </p>
    <p class="s7" style="padding-left: 7pt;text-indent: 0pt;text-align: center;">
      <a name="a1">CONDICIONES GENERALES</a>
    </p>
    <p style="padding-top: 2pt;text-indent: 0pt;text-align: center;">
      <br />
    </p>
    <p class="s9" style="padding-left: 26pt;text-indent: 0pt;text-align: justify;">En cumplimiento a lo dispuesto en el artículo 202 de la Ley de Instituciones de Seguros y de Fianzas, la Documentación Contractual y la Nota Técnica que integran este producto de seguro, quedaron registradas ante la Comisión Nacional de Seguros y Fianzas, a partir del día 30 de enero del 2024, con el número PPAQ-S0013-0045-2023 / CONDUSEF-006011-04.</p>
    <p style="text-indent: 0pt;text-align: center;">
      <br />
    </p>
    <p class="s12" style="padding-top: 12pt;text-indent: 0pt;text-align: center;">Preliminar</p>
    <p class="s11" style="text-indent: 0pt;text-align: justify;padding-top: 4pt;padding-left: 39pt;">
      <a name="a3">
        <b>Cláusula 1ª</b>
      </a>. <span class="s8">Definiciones </span>
      <b>Cláusula 2ª</b>. <span class="s8">Coberturas</span>.
    </p>
    <p style="padding-top: 1pt;text-indent: 0pt;text-align: justify;padding-top: 4pt;padding-left: 39pt;">
      <br />
    </p>
    <p class="s12" style="text-indent: 0pt;text-align: justify;padding-top: 4pt;padding-left: 39pt;">Sección de Daños Materiales</p>
    <p class="s8" style="text-indent: 0pt;text-align: justify;padding-top: 4pt;padding-left: 39pt;">
      <a name="a4">Cobertura Básica:</a>
    </p>
    <p class="s9" style="padding-top: 11pt;text-indent: 0pt;line-height: 13pt;text-align: justify;padding-top: 4pt;padding-left: 39pt;">Cláusula 2.1. <span class="s11">Daños Materiales (Pérdida Total y Parcial).</span>
    </p>
    <p class="s9" style="text-indent: 0pt;line-height: 13pt;text-align: justify;padding-top: 4pt;padding-left: 39pt;">Cláusula 2.2 <span class="s11">. Solo Pérdida Total.</span>
    </p>
    <p style="text-indent: 0pt;text-align: justify;padding-top: 4pt;padding-left: 39pt;">
      <br />
    </p>
    <p class="s8" style="text-indent: 0pt;text-align: justify;padding-top: 4pt;padding-left: 39pt;">
      <a name="a5">Coberturas Accesorias:</a>
    </p>
    <p class="s9" style="text-indent: 0pt;text-align: justify;padding-top: 4pt;padding-left: 39pt;">
      <a name="a6">Cláusula 2.3. </a>
      <span class="s11">Quédate Conmigo (Eliminación de Deducible por Daños provocados por un Tercero sin seguro).</span>
    </p>
    <p class="s9" style="text-indent: 0pt;line-height: 12pt;text-align: justify;padding-top: 4pt;padding-left: 39pt;">Cláusula 2.4. <span class="s11">Rueda Segura (Daños materiales a llantas y rines).</span>
    </p>
    <p style="padding-top: 1pt;text-indent: 0pt;text-align: justify;padding-top: 4pt;padding-left: 39pt;">
      <br />
    </p>
    <p class="s12" style="text-indent: 0pt;text-align: justify;padding-top: 4pt;padding-left: 39pt;">
      Sección de Robo
    </p>
    <p class="s8" style="text-indent: 0pt;text-align: justify;padding-top: 4pt;padding-left: 39pt;">Cobertura Básica: <span style=" color: #000;">Cláusula 2.5. </span>
      <span class="s11">Robo Total.</span>
    </p>
    <p class="s8" style="padding-top: 12pt;text-indent: 0pt;text-align: justify;padding-top: 4pt;padding-left: 39pt;">
      <a name="a8">Coberturas Accesorias </a>
      <span class="s11">:</span>
    </p>
    <p class="s9" style="text-indent: 0pt;text-align: justify;padding-top: 4pt;padding-left: 39pt;">Cláusula 2.6. <span class="s11">Robo Parcial.</span>
    </p>
    <p style="text-indent: 0pt;text-align: justify;padding-top: 4pt;padding-left: 39pt;">
      <br />
    </p>
    <p class="s12" style="text-indent: 0pt;text-align: justify;padding-top: 4pt;padding-left: 39pt;">
      Sección de Daños Materiales y Robo
    </p>
    <p class="s8" style="padding-top: 12pt;text-indent: 0pt;line-height: 13pt;text-align: justify;padding-top: 4pt;padding-left: 39pt;">Coberturas Accesorias:</p>
    <p class="s9" style="text-indent: 0pt;line-height: 13pt;text-align: justify;padding-top: 4pt;padding-left: 39pt;">Cláusula 2.7 <span class="s11">. Agencia +5 (Reparación en Agencia).</span>
    </p>
    <p class="s9" style="text-indent: 0pt;line-height: 13pt;text-align: justify;padding-top: 4pt;padding-left: 39pt;">Cláusula 2.8 <span class="s11">. + Valor (Beneficio en caso de Pérdida Total).</span>
    </p>
    <p class="s9" style="text-indent: 0pt;text-align: justify;padding-top: 4pt;padding-left: 39pt;">Cláusula 2.9 <span class="s11">. Deducible 0 (Eliminación de Deducible por Pérdida Total).</span>
    </p>
    <p class="s12" style="padding-top: 2pt;text-indent: 21pt;line-height: 25pt;text-align: justify;padding-top: 4pt;padding-left: 39pt;">
      Sección de Daños Materiales, Robo y Responsabilidad Civil Coberturas Accesorias:
    </p>
    <p class="s9" style="text-indent: 0pt;line-height: 10pt;text-align: justify;padding-top: 4pt;padding-left: 39pt;">Cláusula 2.10 <span class="s11">. Adaptaciones, Conversiones y Equipo Especial</span>
    </p>
    <p style="padding-top: 11pt;text-indent: 0pt;text-align: justify;padding-top: 4pt;padding-left: 39pt;">
      <br />
    </p>
    <p class="s12" style="text-indent: 0pt; text-align: justify; padding-top: 4pt;padding-left: 39pt;">
      Sección de Responsabilidad Civil
    </p>
    <p class="s8" style="text-indent: 0pt;text-align: justify;padding-top: 4pt;padding-left: 39pt;">Cobertura Básica:</p>
    <p class="s9" style="text-indent: 0pt;text-align: justify;padding-top: 4pt;padding-left: 39pt;">Cláusula 2.11 <span class="s11">. R.C. Terceros (LUC).</span>
    </p>
    <p class="s8" style="padding-top: 12pt;text-indent: 0pt;line-height: 13pt;text-align: justify;padding-top: 4pt;padding-left: 39pt;">
      <a name="a12">Coberturas Accesorias </a>
      <span class="s11">:</span>
    </p>
    <p class="s9" style="text-indent: 0pt;line-height: 13pt;text-align: justify;padding-top: 4pt;padding-left: 39pt;">Cláusula 2.12 <span class="s11">. R.C. Otros vehículos (Extensión de R.C.).</span>
    </p>
    <p class="s9" style="text-indent: 0pt;text-align: justify;padding-top: 4pt;padding-left: 39pt;">Cláusula 2.13 <span class="s11">. R.C. Muerte 3º. (R.C. Catastrófica).</span>
    </p>
    <p class="s9" style="text-indent: 0pt;text-align: justify;padding-top: 4pt;padding-left: 39pt;">Cláusula 2.14 <span class="s11">. Cuidando tus Bienes (R.C. Cruzada).</span>
    </p>
    <p class="s9" style="padding-top: 2pt;;text-indent: 0pt;text-align: justify;padding-top: 4pt;padding-left: 39pt;">Cláusula 2.15 <span class="s11">. R.C. Remolque.</span>
    </p>
    <p class="s9" style="padding-top: 7pt;text-indent: 0pt;text-align: justify;padding-top: 4pt;padding-left: 39pt;">Cláusula 2.16 <span class="s11">. R.C. Carga.</span>
    </p>
    <p class="s12" style="padding-top: 1pt;text-indent: 69pt;line-height: 24pt;text-align: justify;padding-top: 4pt;padding-left: 39pt;">
      Sección de Responsabilidad Civil y Gastos Médicos Cobertura Accesoria:
    </p>
    <p class="s13" style="text-indent: 0pt;text-align: justify;padding-top: 4pt;padding-left: 39pt;">Cláusula 2.17 <span class="p">. Protección Ocupantes (R.C. Ocupantes)</span>
    </p>
    <p style="padding-top: 11pt;text-indent: 0pt;text-align: justify;padding-top: 4pt;padding-left: 39pt;">
      <br />
    </p>
    <p class="s12" style="text-indent: 0pt;line-height: 13pt;text-align: justify;padding-top: 4pt;padding-left: 39pt;">
      Sección de Responsabilidad Civil Familiar
    </p>
    <p class="s8" style="text-indent: 0pt;line-height: 13pt;text-align: justify;padding-top: 4pt;padding-left: 39pt;">Cobertura Básica:</p>
    <p class="s13" style="text-indent: 0pt;text-align: justify;padding-top: 4pt;padding-left: 39pt;">Cláusula 2.18 <span class="p">. Protección Familiar (R.C. Familiar)</span>
    </p>
    <p style="text-indent: 0pt;text-align: justify;padding-top: 4pt;padding-left: 39pt;">
      <br />
    </p>
    <p class="s12" style="text-indent: 0pt;text-align: justify;padding-top: 4pt;padding-left: 39pt;">
      Sección de Gastos Médicos
    </p>
    <p class="s8" style="text-indent: 0pt;line-height: 12pt;text-align: justify;padding-top: 4pt;padding-left: 39pt;">Cobertura Accesoria <span class="p">:</span>
    </p>
    <p class="s13" style="text-indent: 0pt;line-height: 11pt;text-align: justify;padding-top: 4pt;padding-left: 39pt;">Cláusula 2.19 <span class="p">. Gastos Médicos Ocupantes.</span>
    </p>
    <p style="text-indent: 0pt;text-align: justify;padding-top: 4pt;padding-left: 39pt;">
      <br />
    </p>
    <p class="s12" style="text-indent: 0pt;text-align: justify;padding-top: 4pt;padding-left: 39pt;">
      Sección de Accidentes Personales
    </p>
    <p class="s8" style="text-indent: 0pt;line-height: 12pt;text-align: justify;padding-top: 4pt;padding-left: 39pt;">Cobertura Accesoria <span class="p">:</span>
    </p>
    <p class="s13" style="text-indent: 0pt;text-align: justify;padding-top: 4pt;padding-left: 39pt;">Cláusula 2.20 <span class="p">. Accidentes al Conductor.</span>
    </p>
    <p class="s8" style="padding-top: 11pt;text-indent: 0pt;text-align: justify;padding-top: 4pt;padding-left: 39pt;">
      <a name="a17">Cláusula 3ª. Servicios y Asistencias </a>
      <span class="p">.</span>
    </p>
    <p class="s13" style="padding-top: 11pt;text-indent: 0pt;text-align: justify;padding-top: 4pt;padding-left: 39pt;">Cláusula 3.1 <span class="p">. Asistencia Legal. </span>Cláusula 3.2. <span class="p">Asistencia Vial. </span>Cláusula 3.3 <span class="p">. Asistencia Vial Plus</span>
    </p>
    <p class="s13" style="text-indent: 0pt;text-align: justify;padding-top: 4pt;padding-left: 39pt;">Cláusula 3.4 <span class="p">. Asistencia Funeraria al Conductor. </span>Cláusula 3.5 <span class="p">. Asistencia Funeraria Ocupantes. </span>Cláusula 3.6 <span class="p">. Cuidando tu Salud (Asistencia médica). </span>Cláusula 3.7 <span class="p">. + Cuidados (Asistencia en el hogar).</span>
    </p>
    <p class="s13" style="text-indent: 0pt;text-align: justify;padding-top: 4pt;padding-left: 39pt;">Cláusula 3.8 <span class="p">. Cuidando tu Visión (Asistencia visión).</span>
    </p>
    <p class="s13" style="text-indent: 0pt;text-align: justify;padding-top: 4pt;padding-left: 39pt;">Cláusula 3.9 <span class="p">. Traslado Seguro (Conductor o arrastre de grúa).</span>
    </p>
    <p class="s13" style="text-indent: 0pt;text-align: justify;padding-top: 4pt;padding-left: 39pt;">Cláusula 3.10 <span class="p">. Auto x Auto (Renta de auto).</span>
    </p>
    <p class="s13" style="text-indent: 0pt;text-align: justify;padding-top: 4pt;padding-left: 39pt;">Cláusula 3.11 <span class="p">. Llave latino (Asistencia de cerrajería de auto).</span>
    </p>
    <p style="text-indent: 0pt;text-align: justify;padding-top: 4pt;padding-left: 39pt;">
      <br />
    </p>
    <p class="s13" style="text-indent: 0pt;text-align: justify;padding-top: 4pt;padding-left: 39pt;">Cláusula 4ª <span class="p">. </span>
      <span class="s8">Exclusiones Generales</span>
    </p>
    <p style="padding-top: 11pt;text-indent: 0pt;text-align: justify;padding-top: 4pt;padding-left: 39pt;">
      <b>Cláusula 5ª</b>. <span class="s8">Cláusulas Generales</span>.
    </p>
    <p class="s13" style="padding-top: 11pt;text-indent: 0pt;line-height: 11pt;text-align: justify;padding-top: 4pt;padding-left: 39pt;">Cláusula 5.1 <span class="p">. Determinación de la Responsabilidad.</span>
    </p>
    <p class="s13" style="text-indent: 0pt;line-height: 11pt;text-align: justify;padding-top: 4pt;padding-left: 39pt;">Cláusula 5.2 <span class="p">. Prima, plazos y obligaciones de pago.</span>
    </p>
    <p class="s13" style="text-indent: 0pt;text-align: justify;padding-top: 4pt;padding-left: 39pt;">Cláusula 5.3. <span class="p">Obligaciones del Asegurado en caso de Siniestro.</span>
    </p>
    <p class="s13" style="text-indent: 0pt;text-align: justify;padding-top: 4pt;padding-left: 39pt;">Cláusula 5.4 <span class="p">. Reinstalación Automática del Límite Máximo de Responsabilidad.</span>
    </p>
    <p class="s13" style="text-indent: 0pt;text-align: justify;padding-top: 4pt;padding-left: 39pt;">Cláusula 5.5. <span class="p">Valuación y reparación del Daño en caso de Siniestro. </span>Cláusula 5.6 <span class="p">. Sumas Aseguradas y Bases de Indemnización </span>Cláusula 5.7 <span class="p">. Interés Moratorio.</span>
    </p>
    <p class="s13" style="text-indent: 0pt;line-height: 11pt;text-align: justify;padding-top: 4pt;padding-left: 39pt;">Cláusula 5.8 <span class="p">. Pérdida al derecho a ser indemnizado.</span>
    </p>
    <p class="s13" style="text-indent: 0pt;line-height: 11pt;text-align: justify;padding-top: 4pt;padding-left: 39pt;">Cláusula 5.9. <span class="p">Territorialidad.</span>
    </p>
    <p class="s13" style="text-indent: 0pt;text-align: justify;padding-top: 4pt;padding-left: 39pt;">Cláusula 5.10 <span class="p">. Salvamentos y Recuperaciones. </span>Cláusula 5.11 <span class="p">. Terminación anticipada del Contrato. </span>Cláusula 5.12 <span class="p">. Prescripción.</span>
    </p>
    <p class="s13" style="text-indent: 0pt;line-height: 11pt;text-align: justify;padding-top: 4pt;padding-left: 39pt;">Cláusula 5.13 <span class="p">. Competencia.</span>
    </p>
    <p class="s13" style="text-indent: 0pt;line-height: 11pt;text-align: justify;padding-top: 4pt;padding-left: 39pt;">Cláusula 5.14 <span class="p">. Subrogación.</span>
    </p>
    <p class="s13" style="text-indent: 0pt;text-align: justify;padding-top: 4pt;padding-left: 39pt;">Cláusula 5.15. <span class="p">Aceptación del Contrato.</span>
    </p>
    <p class="s13" style="text-indent: 0pt;text-align: justify;padding-top: 4pt;padding-left: 39pt;">Cláusula 5.16 <span class="p">. Inspección vehicular.</span>
    </p>
    <p class="s13" style="text-indent: 0pt;text-align: justify;padding-top: 4pt;padding-left: 39pt;">Cláusula 5.17 <span class="p">. Conocimiento explícito del Contrato.</span>
    </p>
    <p class="s13" style="padding-top: 7pt;text-indent: 0pt;text-align: justify;padding-top: 4pt;padding-left: 39pt;">Cláusula 5.18 <span class="p">. Modificaciones hechas a las Condiciones Generales. </span>Cláusula 5.18. <span class="p">Modificaciones hechas a las Condiciones Generales. </span>Cláusula 5.19. <span class="p">Agravación del Riesgo.</span>
    </p>
    <p class="s13" style="text-indent: 0pt;line-height: 11pt;text-align: justify;padding-top: 4pt;padding-left: 39pt;">Cláusula 5.20. <span class="p">Gastos de recuperación y traslado.</span>
    </p>
    <p class="s13" style="text-indent: 0pt;line-height: 11pt;text-align: justify;padding-top: 4pt;padding-left: 39pt;">Cláusula 5.21. <span class="p">Peritaje.</span>
    </p>
    <p class="s13" style="text-indent: 0pt;text-align: justify;padding-top: 4pt;padding-left: 39pt;">Cláusula 5.22. <span class="p">Renovación.</span>
    </p>
    <p class="s13" style="text-indent: 0pt;text-align: justify;padding-top: 4pt;padding-left: 39pt;">Cláusula 5.23. <span class="p">Descuento por nómina, domiciliación bancaria o cargo on-line recurrente.</span>
    </p>
    <p class="s13" style="text-indent: 0pt;text-align: justify;padding-top: 4pt;padding-left: 39pt;">Cláusula 5.24. <span class="p">Entrega de documentación cuando la contratación de este seguro se efectúe a través de un prestador de servicios.</span>
    </p>
    <p class="s13" style="text-indent: 0pt;text-align: justify;padding-top: 4pt;padding-left: 39pt;">Cláusula 5.25. <span class="p">Limitación en la intermediación. </span>Cláusula 5.26. <span class="p">Derechos de los Contratantes. </span>Cláusula 5.27. <span class="p">Datos de la UNE y CONDUSEF.</span>
    </p>
    <p class="s13" style="text-indent: 0pt;line-height: 11pt;text-align: justify;padding-top: 4pt;padding-left: 39pt;">Cláusula 5.28. <span class="p">Cláusula relativa a los delitos considerados</span>
    </p>
    <p style="text-indent: 0pt;line-height: 11pt;text-align: justify;padding-top: 4pt;padding-left: 39pt;">por el artículo 492 de la Ley de Instituciones de Seguros y de Fianzas.</p>
    <p class="s13" style="text-indent: 0pt;text-align: justify;padding-top: 4pt;padding-left: 39pt;">Cláusula 5.29. <span class="p">Aviso de privacidad. Clientes o Beneficiarios.</span>
    </p>








    <p class="s14" style="padding-top: 7pt;padding-left: 39pt;text-indent: 0pt;line-height: 173%;text-align: center;">CONDICIONES GENERALES PRELIMINAR</p>
    <p style="padding-top: 4pt;padding-left: 39pt;text-indent: 0pt;text-align: justify;">LA LATINOAMERICANA SEGUROS S.A. en adelante <b>L A T I N O </b>y el <b>Contratante</b>, en conjunto LAS PARTES, han convenido las <b>Coberturas</b>, <b>Sumas Aseguradas</b>, <b>Deducibles </b>y montos de responsabilidad máxima que aparecen en la <b>Carátula </b>de esta <b>Póliza </b>como contratados, con conocimiento de que se puede elegir una o varias de las <b>Coberturas </b>básicas y accesorias o de servicio, descritas en las presentes <b>Condiciones Generales</b>. </p>
    <p style="padding-top: 11pt;padding-left: 39pt;text-indent: 0pt;text-align: justify;">El <b>Contratante </b>declara que, de acuerdo con lo estipulado por el artículo 8 de la Ley Sobre el Contrato de Seguro, ha informado por escrito a <b>L A T I N O </b>sobre todos los hechos importantes para la apreciación del Riesgo y que puedan influir en las condiciones convenidas, tales como los conozca o deba conocer en el momento de la celebración de este <b>Contrato</b>. </p>
    <p style="text-indent: 0pt;text-align: center;">
      <br />
    </p>
    <p style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">Para los efectos del presente <b>Contrato</b>, el concepto de <b>Vehículo Asegurado </b>comprende la unidad automotriz descrita en la <b>Carátula </b>de esta <b>Póliza</b>, incluyendo las partes o accesorios que el fabricante adapta originalmente para cada modelo o tipo específico que presenta al mercado, <span class="s15">excluyendo cualquier tipo de blindaje, equipo especial, accesorio, rótulo, adaptación y/o conversión instalada adicionalmente y a petición expresa del comprador o propietario, requerirá de cobertura específica.</span>
    </p>
    <p style="text-indent: 0pt;text-align: center;">
      <br />
    </p>
    <p style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">Los Riesgos que pueden ampararse bajo esta <b>Carátula </b>de <b>Póliza </b>de las presentes <b>Condiciones Generales </b>y su contratación se indica mediante las anotaciones correspondientes en la <b>Carátula </b>de esta <b>Póliza</b>, quedando sujetas a los <b>Límites Máximos de Responsabilidad </b>de <b>L A T I N O </b>que en la misma se mencionan. </p>
    <p style="text-indent: 0pt;text-align: center;">
      <br />
    </p>
    <p style="padding-left: 38pt;text-indent: 0pt;text-align: justify;">Este Contrato es sobre un <i>SEGURO DE AUTOMOVILES CAMIONETAS Y PICK UPS DE HASTA</i>
    </p>
    <p class="s16" style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">3½ TONELADAS DE USO PARTICULAR <span class="p">, </span>
      <span class="s15">en NINGUN caso podrá cubrir vehículos de uso con fines de lucro tales como servicios de trasporte incluyendo taxi, servicio de transporte privado, de transporte de alimentos, de transporte de personal, transporte de mercancías, transporte derivado de aplicaciones electrónicas como UBER, Rappi, Cabify, o similares.</span>
    </p>
    <p style="padding-top: 11pt;padding-left: 39pt;text-indent: 0pt;text-align: justify;">Este es un <b>Contrato de Seguro </b>de <b>Daños </b>con carácter <i>
        <b>INDEMNIZATORIO, </b>
      </i>es decir, que el pago realizado por la Aseguradora, tiene su límite en el <b>Daño </b>real causado, o en el límite de la <b>Suma Asegurada </b>contratada, lo que ocurra primero, a manera tal que, NO puede transformarse en objeto de lucro o ganancia para el <i>
        <b>Asegurado</b>
      </i>. </p>
    <p style="padding-top: 10pt;padding-left: 39pt;text-indent: 0pt;text-align: justify;">Convienen expresamente <i>LAS PARTES </i>que las presentes <b>Condiciones Generales </b>rigen al <b>Contrato de Seguro </b>celebrado entre ellas, y en todo lo no previsto se aplicará la Ley Sobre el Contrato de Seguro y demás leyes aplicables. </p>
    <p class="s8" style="padding-top: 7pt;padding-left: 38pt;text-indent: 0pt;line-height: 13pt;text-align: justify;">
      <a name="a18">Cláusula 1ª. Definiciones.</a>
    </p>
    <p style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">Para todos los efectos del presente <b>Contrato de Seguro </b>y a fin de establecer claridad en términos, las siguientes palabras tendrán el significado mencionado a continuación, debiendo también atender a la particularidad de las definiciones que cada cobertura y asistencia contenga. </p>
    <p style="text-indent: 0pt;text-align: center;">
      <br />
    </p>
    <h2 style="padding-left: 38pt;text-indent: 0pt;text-align: center;">
      <a name="a19">A</a>
    </h2>
    <p class="s13" style="padding-left: 38pt;text-indent: 0pt;text-align: justify;">Abuso de confianza <span class="p">Comete el delito de </span>Abuso de confianza <span class="p">, el que, con perjuicio de</span>
    </p>
    <p class="Definiciones">alguien, disponga para sí o para otros de cualquier cosa mueble ajena, de la que se le haya transferido su tenencia y no el dominio.</p>
    <p style="text-indent: 0pt;text-align: center;">
      <br />
    </p>
    <p class="s13" style="padding-left: 38pt;text-indent: 0pt;text-align: justify;">Accidente Automovilístico <span class="p">Todo acontecimiento externo, súbito, fortuito y violento, que cause</span>
    </p>
    <p class="Definiciones">Daños materiales a uno o varios objetos y/o lesiones a una o varias personas, causados involuntariamente por el <b>Conductor </b>como consecuencia del <b>Uso del Vehículo Asegurado</b>. </p>
    <p style="text-indent: 0pt;text-align: center;">
      <br />
    </p>
    <p class="s13" style="padding-left: 38pt;text-indent: 0pt;text-align: justify;">Accidentes al Conductor <span class="p">Cualquier </span>Accidente Automovilístico <span class="p">que produzca lesión</span>
    </p>
    <p class="Definiciones">corporal al <b>Conductor </b>por la acción de una fuerza externa, súbita, fortuita y violenta, mientras se encuentre dentro del <b>Vehículo Asegurado </b>y como consecuencia de las <b>Coberturas </b>amparadas en la <b>Póliza</b>. </p>
    <p style="text-indent: 0pt;text-align: center;">
      <br />
    </p>
    <p class="s13" style="padding-left: 38pt;text-indent: 0pt;text-align: justify;">
      <a name="a20">Adaptaciones, Conversiones y Equipo Especial</a>
    </p>
    <p class="Definiciones">Toda modificación y/o adición en carrocería, estructura, partes, accesorios o rótulos instalados a petición del comprador o propietario, en adición a las partes o accesorios con los que el fabricante adapta originalmente cada modelo y tipo específico que presenta al mercado.</p>
    <p style="text-indent: 0pt;text-align: center;">
      <br />
    </p>
    <p class="s13" >Asegurado <span class="p">Persona física o moral cuya propuesta de seguro ha sido aceptada por </span>L A T I N O <span class="p">en los términos de la presente </span>Póliza <span class="p">, con base en los datos e informes proporcionados por aquélla, para que al verificarse la eventualidad prevista, </span>L A T I N O <span class="p">resarza el </span>Daño <span class="p">, pague una suma de dinero o preste los servicios que constituyen el contenido de la obligación a su cargo a quien legalmente corresponde, y quien deberá aparecer identificada en la </span>Póliza <span class="p">, quien por su parte se compromete a cumplir con las obligaciones conferidas a su cargo derivado de la celebración del </span>Contrato de Seguro <span class="p">.</span>
    </p>
    <p style="padding-top: 11pt;text-indent: 0pt;text-align: center;">
      <br />
    </p>
    <p class="s13" style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">Atención médica <span class="p">Es la asistencia esencial, basada en métodos y tecnologías</span>
    </p>
    <p class="s13-CGP">prácticas, científicamente fundadas y socialmente aceptables, mediante su plena participación para la atención de lesiones sufridas a causa de un <b>Accidente Automovilístico</b>. </p>
    <p style="text-indent: 0pt;text-align: center;">
      <br />
    </p>
    <p class="s13" style="padding-left: 38pt;text-indent: 0pt;text-align: justify;">
      <a name="a21">Avería, Descompostura o Falla Mecánica</a>
    </p>
    <p style="text-indent: 0pt;text-align: center;">
      <br />
    </p>
    <p class="s13-CGP">Todo Daño, rotura y/o deterioro fortuito, que impida la circulación autónoma y/o correcto funcionamiento del Vehículo Asegurado durante la vigencia de este Contrato, siempre y cuando no sea a</p>
    <p class="s13-CGP">consecuencia de un <b>Accidente Automovilístico</b>. </p>
    <p style="text-indent: 0pt;text-align: center;">
      <br />
    </p>
    <p class="s13-CGP-BLACK">Avería Gruesa <span class="p">Para efectos de las presentes </span>Condiciones Generales <span class="p">se</span>
    </p>
    <p class="s13-CGP">entenderá como el Daño ocasionado al <b>Vehículo Asegurado </b>mientras es trasladado en un buque u otro medio de transporte con la intención de salvaguardar el resto de los bienes. </p>
    <h2 style="padding-top: 11pt;padding-left: 38pt;text-indent: 0pt;text-align: center;">
      <a name="a22">B</a>
    </h2>
    <p class="s13" style="padding-left: 38pt;text-indent: 0pt;text-align: justify;">Beneficiario <span class="p">Es la persona física o moral que al momento de un </span>Siniestro <span class="p">que</span>
    </p>
    <p style="padding-left: 180pt;text-indent: 0pt;text-align: justify;">amerite indemnización, según lo establecido en esta <b>Póliza</b>, tiene derecho al pago o servicio correspondiente. </p>
    <p style="text-indent: 0pt;text-align: center;">
      <br />
    </p>
    <p class="s13" style="padding-left: 38pt;text-indent: 0pt;text-align: justify;">Beneficiario Preferente <span class="p">Es la persona física o moral designada por el </span>Contratante <span class="p">al</span>
    </p>
    <p style="padding-left: 180pt;text-indent: 0pt;text-align: justify;">momento de contratar la <b>Póliza</b>, que tiene derecho a la indemnización correspondiente sobre cualquier otro <b>Beneficiario</b>, cuando el <b>Vehículo Asegurado </b>se haya declarado como <b>Pérdida Total </b>por <b>Daños </b>materiales o <b>Robo Total</b>. </p>
    <h2 style="padding-top: 11pt;padding-left: 38pt;text-indent: 0pt;text-align: center;">
      <a name="a23">C</a>
    </h2>
    <p class="s13" style="padding-left: 38pt;text-indent: 0pt;text-align: center;">Camino Intransitable <span class="p">Se considera un camino intransitable cuando la vía de circulación</span>
    </p>
    <p style="padding-left: 180pt;text-indent: 0pt;text-align: center;">se encuentre obstruida, restringida o señalada en sus condiciones de terreno y altura no permitiendo la libre circulación vehicular.</p>
    <p style="text-indent: 0pt;text-align: center;">
      <br />
    </p>
    <p class="s13" style="padding-left: 38pt;text-indent: 0pt;text-align: center;">Carátula de la Póliza <span class="p">Documento contractual que específica datos, número de póliza,</span>
    </p>
    <p style="padding-left: 180pt;text-indent: 0pt;text-align: center;">sumas aseguradas, vigencia de la póliza, entre otros datos.</p>
    <p style="text-indent: 0pt;text-align: center;">
      <br />
    </p>
    <p class="s13" style="padding-left: 180pt;text-indent: -142pt;text-align: justify;">Coberturas <span class="p">Conjunto de riesgos que pueden ser amparados en el </span>Contrato de Seguro <span class="p">. Las partes han convenido las </span>Coberturas <span class="p">que se indican como amparadas en la </span>Carátula de la Póliza <span class="p">. Las </span>Coberturas <span class="p">que no se señalen como amparadas no tendrán validez ni eficacia entre las partes, aun cuando se consignen y regulen en estas </span>Condiciones Generales. </p>
    <p style="text-indent: 0pt;text-align: center;">
      <br />
    </p>
    <p class="s13" style="padding-left: 180pt;text-indent: -142pt;text-align: justify;">Colisión <span class="p">Es el impacto del </span>Vehículo Asegurado <span class="p">, en un solo </span>Evento <span class="p">, con uno o más objetos y/o personas externas al citado vehículo, que como consecuencia cause </span>Daños <span class="p">materiales a uno o varios objetos y/o lesiones a una o varias personas. La realización de algún riesgo que afecte una o varias de las </span>Coberturas <span class="p">contratadas, obligará al Asegurado al pago de los </span>Deducibles <span class="p">que correspondan conforme a las </span>Condiciones Generales <span class="p">de la </span>Póliza <span class="p">. En caso de que el </span>Vehículo Asegurado <span class="p">sufriese como consecuencia de un </span>Evento <span class="p">un segundo Evento para la indemnización de cada uno de ellos, por parte de </span>L A T I N O <span class="p">, el Asegurado deberá pagar los </span>Deducibles <span class="p">que correspondan.</span>
    </p>
    <p style="text-indent: 0pt;text-align: center;">
      <br />
    </p>
    <p class="s13" style="padding-left: 38pt;text-indent: 0pt;text-align: center;">Condiciones Generales <span class="p">Documento donde se establecen los derechos y obligaciones entre</span>
    </p>
    <p style="padding-left: 180pt;text-indent: 0pt;text-align: center;">el <b>Asegurado </b>y/o <b>Contratante </b>y <b>LATINO</b>. El <b>Asegurado </b>y/o <b>Contratante</b>, en dicha calidad, e inicialmente como proponente del <b>Contrato de Seguro</b>, según lo establece la Ley Sobre el Contrato de Seguro, ha tenido acceso y conocimiento de las <b>Condiciones</b>
    </p>
    <p class="s13" style="padding-top: 7pt;padding-left: 180pt;text-indent: 0pt;text-align: justify;">Generales <span class="p">aplicables al producto y </span>Coberturas <span class="p">establecidas en esta Póliza, además de que las mismas le han sido entregadas. No obstante</span>
    </p>
    <p style="text-indent: 0pt;text-align: center;">
      <br />
    </p>
    <p style="padding-left: 180pt;text-indent: 0pt;text-align: justify;">lo anterior, se hace de su conocimiento que las <b>Condiciones Generales </b>están a su disposición para su impresión y consulta en la página de internet de <a href="http://www.latinoseguros.com.mx/" style=" color: black; font-family:Arial, sans-serif; font-style: normal; font-weight: bold; text-decoration: none; font-size: 10pt;" target="_blank">L A T I N O </a>www.latinoseguros.com.mx, así como a través del sello “QR” que aparece en esta <b>Póliza</b>, o en las oficinas de <b>L A T I N O </b>en la dirección establecida en la misma. </p>
    <p style="text-indent: 0pt;text-align: center;">
      <br />
    </p>
    <p class="s13" style="padding-left: 180pt;text-indent: -142pt;text-align: justify;">Conductor <span class="p">Es la persona física designada en la </span>Carátula de la Póliza <span class="p">que con mayor frecuencia utiliza el </span>Vehículo Asegurado <span class="p">, y cuyas características personales son determinantes para el cálculo de la </span>Prima <span class="p">.</span>
    </p>
    <p style="padding-left: 180pt;text-indent: 0pt;text-align: justify;">El <b>Conductor </b>declarado, que se establezca en la <b>Carátula de la Póliza</b>, deberá ser alguno de los que a continuación se definen: </p>
    <ol id="l1">
      <li data-list-text="1.">
        <p class="s13" style="padding-left: 216pt;text-indent: -18pt;text-align: justify;">Habitual <span class="p">. Es cuando la persona física designada en la Carátula de la Póliza es quien utiliza el Vehículo Asegurado con mayor frecuencia.</span>
        </p>
      </li>
      <li data-list-text="2.">
        <p class="s13" style="padding-left: 216pt;text-indent: -18pt;text-align: justify;">Universal <span class="p">. Es cuando la persona física designada en la </span>Carátula de la Póliza <span class="p">comparte el uso del </span>Vehículo Asegurado <span class="p">con otros </span>Conductores <span class="p">con características personales diferentes a las determinadas para el cálculo de la </span>Prima <span class="p">.</span>
        </p>
      </li>
      <li data-list-text="3.">
        <p class="s13" style="padding-left: 216pt;text-indent: -18pt;text-align: justify;">Indeterminado <span class="p">(solo cuando el </span>Contratante <span class="p">sea Persona Moral). Es cuando el </span>Vehículo Asegurado <span class="p">no se asigna a un Conductor específico, sino que por su operación amerita ser conducido por diferentes personas.</span>
        </p>
      </li>
    </ol>
    <p class="s13" style="padding-top: 11pt;padding-left: 180pt;text-indent: -142pt;text-align: center;">Contratante <span class="p">Persona física o moral cuya propuesta de seguro ha sido aceptada por </span>L A T I N O <span class="p">en los términos de la presente </span>Póliza <span class="p">, con base en los datos e informes proporcionados por aquélla, quien tiene la obligación legal que se deriva de la </span>Póliza <span class="p">.</span>
    </p>
    <p style="text-indent: 0pt;text-align: center;">
      <br />
    </p>
    <p class="s13" style="padding-left: 38pt;text-indent: 0pt;text-align: justify;">
      <a name="a24">Contrato o Contrato de Seguro</a>
    </p>
    <p style="padding-left: 180pt;text-indent: 0pt;text-align: justify;">Por el <b>Contrato de Seguro</b>, <b>LATINO </b>se obliga, mediante una <b>Prima</b>, a resarcir un <b>Daño </b>o a pagar una suma de dinero al verificarse la eventualidad prevista en el <b>Contrato</b>. </p>
    <p style="text-indent: 0pt;text-align: center;">
      <br />
    </p>
    <p class="s13" style="padding-top: 4pt;padding-left: 38pt;text-indent: 0pt;text-align: center;">
      <a name="a25">Costo Usual y Acostumbrado</a>
    </p>
    <p style="text-indent: 0pt;text-align: center;">
      <br />
    </p>
    <p class="s13" style="padding-left: 38pt;text-indent: 0pt;text-align: center;">Culpa Grave</p>
    <p style="padding-top: 4pt;text-indent: 0pt;text-align: center;">
      <br />
    </p>
    <p style="padding-left: 2pt;text-indent: 0pt;text-align: justify;">Es el valor promedio incluido en el contrato correspondiente, que se refiere a los precios, tarifas y honorarios profesionales fijados en una plaza o un lugar determinado, para los prestadores y receptores de servicios médicos y hospitalarios contratados y seleccionados por <b>L A T I N O</b>, atendiendo a la naturaleza y complejidad técnica de los servicios, así como a la calidad, tiempo y costo de uso de las instalaciones correspondientes. </p>
    <p style="padding-top: 1pt;text-indent: 0pt;text-align: center;">
      <br />
    </p>
    <p style="padding-left: 2pt;text-indent: 0pt;text-align: justify;">Omisión de la conducta debida para prever y evitar un <b>Daño </b>que </p>
    <p style="padding-top: 7pt;padding-left: 180pt;text-indent: 0pt;text-align: center;">incluso las personas más negligentes emplearían.</p>
    <p style="text-indent: 0pt;text-align: center;">
      <br />
    </p>
    <h2 style="padding-left: 38pt;text-indent: 0pt;text-align: center;">
      <a name="a26">D</a>
    </h2>
    <p class="s13" style="padding-left: 38pt;text-indent: 0pt;text-align: center;">Daño <span class="p">Pérdida personal o material producida a consecuencia directa de un</span>
    </p>
    <p class="s13" style="padding-left: 180pt;text-indent: 0pt;text-align: center;">
      <a name="a27">Siniestro</a>
      <span class="p">.</span>
    </p>
    <p style="text-indent: 0pt;text-align: center;">
      <br />
    </p>
    <p class="s13" style="padding-left: 180pt;text-indent: -142pt;text-align: justify;">Deducible <span class="p">Cantidad económica que invariablemente queda a cargo del </span>Asegurado <span class="p">o </span>Beneficiario <span class="p">, a consecuencia de la afectación de alguna de las </span>Coberturas <span class="p">amparadas en la </span>Carátula de la Póliza <span class="p">. Esta obligación se contrata en porcentaje sobre el </span>Límite Máximo de Responsabilidad <span class="p">al momento del </span>Siniestro <span class="p">, según corresponda a cada </span>Cobertura <span class="p">.</span>
    </p>
    <p style="text-indent: 0pt;text-align: center;">
      <br />
    </p>
    <p class="s13" style="padding-left: 38pt;text-indent: 0pt;text-align: center;">Dependiente Económico <span class="p">Es la persona o personas cuyo sustento es el salario del</span>
    </p>
    <p class="s13" style="padding-left: 180pt;text-indent: 0pt;text-align: center;">Asegurado <span class="p">, cualquiera que sea el título de su vida en común.</span>
    </p>
    <p style="text-indent: 0pt;text-align: center;">
      <br />
    </p>
    <p class="s13" style="padding-left: 38pt;text-indent: 0pt;text-align: center;">Desbielamiento <span class="p">Se entenderá por </span>Desbielamiento <span class="p">la rotura, doblez o Daño en</span>
    </p>
    <p style="padding-left: 180pt;text-indent: 0pt;text-align: justify;">alguno o todos los componentes internos del motor del <b>Vehículo Asegurado.</b>
    </p>
    <p style="text-indent: 0pt;text-align: center;">
      <br />
    </p>
    <p class="s13" style="padding-left: 38pt;text-indent: 0pt;text-align: justify;">Documentación Contractual <span class="p">Son todos aquellos documentos que forman parte de la contratación</span>
    </p>
    <p style="padding-left: 180pt;text-indent: 0pt;text-align: justify;">del seguro tales como la <b>Póliza, Carátula de la Póliza</b>, documentos que contengan cláusulas adicionales de la misma, las solicitudes de aseguramiento, los formularios de ofertas suministrados por <b>L A T I N O </b>y, en general, todos los documentos usados en la contratación del seguro. </p>
    <h2 style="padding-top: 11pt;padding-left: 38pt;text-indent: 0pt;text-align: center;">
      <a name="a28">E</a>
    </h2>
    <p class="s13" style="padding-left: 38pt;text-indent: 0pt;text-align: justify;">Enfermedad Congénita <span class="p">Es aquélla que existe en el momento del nacimiento, como</span>
    </p>
    <p style="padding-left: 180pt;text-indent: 0pt;text-align: justify;">consecuencia de factores hereditarios o afecciones adquiridas durante la gestación hasta el mismo momento del nacimiento. Puede manifestarse y ser reconocida inmediatamente después del nacimiento, o bien ser descubierta más tarde, en cualquier momento en la vida del individuo.</p>
    <p style="text-indent: 0pt;text-align: center;">
      <br />
    </p>
    <p class="s13" style="padding-left: 38pt;text-indent: 0pt;text-align: justify;">Enfermedad Preexistente <span class="p">Es aquélla que desde el punto de vista médico ya existía con</span>
    </p>
    <p style="padding-left: 180pt;text-indent: 0pt;text-align: justify;">anterioridad al momento del <b>Accidente Automovilístico</b>, sin ser forzoso que sus signos o síntomas se hayan presentado previo a éste; dicha enfermedad será confirmada mediante estudios de gabinete y reportes médicos cuando no sea posible diagnosticarla mediante historia clínica. </p>
    <p style="text-indent: 0pt;text-align: center;">
      <br />
    </p>
    <p class="s13" style="padding-left: 38pt;text-indent: 0pt;text-align: center;">Estado de Ebriedad <span class="p">Se entenderá que el </span>Conductor <span class="p">se encuentra en </span>Estado de </p>
    <p class="s13" style="padding-left: 180pt;text-indent: 0pt;text-align: center;">Ebriedad <span class="p">cuando exceda el límite de gramos de alcohol en un litro de sangre, o bien, cuando exceda el límite de miligramos de alcohol en un litro de aliento o aire espirado, permitido por las disposiciones legales y reglamentarias en las distintas entidades de los Estados Unidos Mexicanos, debiendo existir constancia o certificado médico</span>
    </p>
    <p style="padding-top: 7pt;padding-left: 180pt;text-indent: 0pt;text-align: justify;">expedido por la autoridad competente en el que se indique el resultado de la prueba realizada, ya sea por análisis en sangre practicada por un laboratorio, o a través del instrumento de medición llamado “Alcoholímetro”, o bien por certificado médico expedido por el Médico Legista adscrito al Ministerio Público, Juzgado Cívico, Juzgado Calificador, o autoridad equivalente.</p>
    <p style="text-indent: 0pt;text-align: center;">
      <br />
    </p>
    <p class="s13" style="padding-left: 180pt;text-indent: -142pt;text-align: center;">Evento <span class="p">Manifestación concreta del riesgo(s) asegurado(s) que confluye en un mismo momento de tiempo y circunstancia.</span>
    </p>
    <p style="text-indent: 0pt;text-align: center;">
      <br />
    </p>
    <p class="s13" style="padding-left: 38pt;text-indent: 0pt;text-align: justify;">Exclusiones <span class="p">Cualquier hecho o acto que no son sujetos de cobertura ni</span>
    </p>
    <p style="padding-left: 180pt;text-indent: 0pt;text-align: justify;">reconocimiento con base en el presente condicionado, quedando en todo momento de conformidad con las leyes que para el efecto puedan invocarse.</p>
    <h2 style="padding-top: 11pt;padding-left: 38pt;text-indent: 0pt;text-align: center;">
      <a name="a29">F</a>
    </h2>
    <p class="s13" style="padding-left: 180pt;text-indent: -142pt;text-align: justify;">Fraude <span class="p">Comete el delito de </span>Fraude <span class="p">el que engañando a uno o aprovechándose del error en que éste se halla, se hace ilícitamente de alguna cosa o alcanza un lucro indebido.</span>
    </p>
    <p style="text-indent: 0pt;text-align: center;">
      <br />
    </p>
    <p class="s13" style="padding-left: 180pt;text-indent: -142pt;text-align: justify;">Finiquito <span class="p">Es una declaración de las partes, en donde se asienta que la relación o reclamo quedan extinguidos. Se trata de un documento otorgado por L A T I N O, requisitado y firmado por un </span>Asegurado <span class="p">(contratante) o un </span>afectado en un siniestro <span class="p">, luego de que la entidad aseguradora honre la indemnización derivada del evento.</span>
    </p>
    <h2 style="padding-top: 11pt;padding-left: 38pt;text-indent: 0pt;text-align: center;">
      <a name="a30">G</a>
    </h2>
    <p class="s13" style="padding-left: 38pt;text-indent: 0pt;text-align: center;">Gastos Funerarios <span class="p">Comprende urna, ataúd, cremación, capilla de velación, impuestos</span>
    </p>
    <p style="padding-left: 180pt;text-indent: 0pt;text-align: center;">por entierro y traslado, hasta el límite señalado para este riesgo en la <b>Cobertura </b>respectiva. </p>
    <h2 style="padding-top: 11pt;padding-left: 38pt;text-indent: 0pt;text-align: center;">
      <a name="a31">I</a>
    </h2>
    <p style="padding-left: 180pt;text-indent: -142pt;text-align: center;">Incendio Ocurrencia no controlada de fuego que provoca Daños materiales al <b>Vehículo Asegurado</b>. </p>
    <p style="text-indent: 0pt;text-align: center;">
      <br />
    </p>
    <p class="s13" style="padding-left: 38pt;text-indent: 0pt;text-align: center;">
      <a name="a32">Inundación del Vehículo Asegurado</a>
    </p>
    <p style="padding-left: 180pt;text-indent: 0pt;text-align: center;">Es la penetración de agua del exterior al interior del distinta de la necesaria para su operación y/o funcionamiento.</p>
    <h2 style="padding-left: 38pt;text-indent: 0pt;text-align: center;">
      <a name="a33">L</a>
    </h2>
    <p class="s13" style="padding-left: 38pt;text-indent: 0pt;text-align: center;">
      <a name="a34">L A T I N O y/o La Compañía</a>
    </p>
    <p style="text-indent: 0pt;text-align: center;">
      <br />
    </p>
    <p style="padding-left: 8pt;text-indent: 0pt;text-align: justify;">La Latinoamericana Seguros, S.A., es una empresa autorizada por la Secretaría de Hacienda y Crédito Público, que emite la <b>Póliza, </b>asumiendo su responsabilidad respecto de la <b>Cobertura </b>o <b>Coberturas </b>indicadas y que aparezcan como amparadas en la <b>Carátula de la Póliza</b>, de acuerdo con las presentes <b>Condiciones Generales </b>y particulares. </p>
    <p class="s13" style="padding-top: 11pt;text-indent: 0pt;text-align: right;">Límite Único y Combinado <span class="p">Es el </span>Límite Máximo de Responsabilidad <span class="p">conformado por la suma</span>
    </p>
    <p style="text-indent: 0pt;text-align: right;">de los límites de responsabilidad de las <b>Coberturas </b>que lo integran, </p>
    <p style="padding-top: 7pt;padding-left: 180pt;text-indent: 0pt;text-align: center;">y que opera cuando se rebasa el límite de responsabilidad de la cobertura originalmente afectada.</p>
    <p style="text-indent: 0pt;text-align: center;">
      <br />
    </p>
    <p class="s13" style="padding-left: 38pt;text-indent: 0pt;text-align: center;">Llanta Runflat <span class="p">Neumático reforzado que permite seguir rodando durante una cierta</span>
    </p>
    <p style="padding-left: 180pt;text-indent: 0pt;text-align: center;">distancia y a una cierta velocidad cuando se produce una pérdida de presión.</p>
    <h2 style="padding-top: 19pt;padding-left: 38pt;text-indent: 0pt;text-align: center;">
      <a name="a35">O</a>
    </h2>
    <p class="s13" style="padding-left: 180pt;text-indent: -142pt;text-align: justify;">Ocupantes <span class="p">Toda persona física que se encuentre dentro del compartimiento, caseta o cabina, destinada al transporte de personas del </span>Vehículo Asegurado <span class="p">, al momento de producirse un </span>Accidente Automovilístico, Descompostura <span class="p">o </span>Falla Mecánica <span class="p">, sin incluir al </span>Conductor <span class="p">del vehículo.</span>
    </p>
    <h2 style="padding-top: 11pt;padding-left: 38pt;text-indent: 0pt;text-align: center;">
      <a name="a36">P</a>
    </h2>
    <p class="s13" style="padding-left: 180pt;text-indent: -142pt;text-align: justify;">Parentesco <span class="p">Es el vínculo que existe entre dos personas en cualquiera de sus modalidades y hasta en segundo grado, ya sea por afinidad, civil o consanguinidad.</span>
    </p>
    <p style="text-indent: 0pt;text-align: center;">
      <br />
    </p>
    <p class="s13" style="padding-left: 38pt;text-indent: 0pt;text-align: justify;">Pérdida Parcial <span class="p">Existe </span>Pérdida Parcial <span class="p">cuando el importe total que se requiere para</span>
    </p>
    <p style="padding-left: 180pt;text-indent: 0pt;text-align: justify;">la reparación del <b>Daño </b>causado al <b>Vehículo Asegurado</b>, incluyendo mano de obra, refacciones y materiales necesarios, según <b>Peritación </b>realizada y validada por <b>L A T I N O</b>, no excede del 75% de la <b>Suma Asegurada </b>o <b>Valor Comercial </b>a la fecha del <b>Siniestro</b>. </p>
    <p class="s13" style="padding-top: 11pt;padding-left: 38pt;text-indent: 0pt;text-align: justify;">Partes Bajas del vehículo <span class="p">Componentes de carrocería y mecánicos que se encuentran en la</span>
    </p>
    <p style="padding-left: 180pt;text-indent: 0pt;text-align: justify;">parte inferior del vehículo que sirven como soporte de la estructura y elementos para el funcionamiento de los distintos sistemas, entre los que se encuentra el sistema motriz, suspensión, escape y tracción.</p>
    <p style="text-indent: 0pt;text-align: center;">
      <br />
    </p>
    <p class="s13" style="padding-left: 38pt;text-indent: 0pt;text-align: justify;">Pérdida Total <span class="p">Existe </span>Pérdida Total <span class="p">cuando el importe total que se requiere para</span>
    </p>
    <p style="padding-left: 180pt;text-indent: 0pt;text-align: justify;">la reparación del <b>Daño </b>causado al <b>Vehículo Asegurado</b>, incluyendo mano de obra, refacciones y materiales necesarios, según avalúo validado o realizado por <b>L A T I N O</b>, es mayor al 75% de la <b>Suma Asegurada </b>o del <b>Valor Comercial </b>a la fecha del <b>Siniestro</b>. </p>
    <p style="text-indent: 0pt;text-align: center;">
      <br />
    </p>
    <p style="padding-left: 180pt;text-indent: 0pt;text-align: justify;">De forma independiente al porcentaje de los <b>Daños </b>a que se refiere el párrafo anterior, también existe <b>Pérdida Total </b>cuando se emita dictamen del perito y avalúo realizado y validado por <b>L A T I N O</b>, que determine técnicamente la inviabilidad de la reparación del <b>Vehículo Asegurado</b>. </p>
    <p style="text-indent: 0pt;text-align: center;">
      <br />
    </p>
    <p class="s13" style="padding-left: 180pt;text-indent: -142pt;text-align: justify;">Póliza <span class="p">Documento en que constan los derechos y obligaciones de las partes, las </span>Coberturas <span class="p">amparadas por </span>L A T I N O, <span class="p">las</span>
    </p>
    <p style="text-indent: 0pt;text-align: center;">
      <br />
    </p>
    <p style="padding-left: 180pt;text-indent: 0pt;text-align: center;">particularidades que identifican al riesgo, las modificaciones que se produzcan durante la vigencia del seguro, así como los <b>Límites</b>
    </p>
    <p class="s13" style="padding-top: 7pt;padding-left: 180pt;text-indent: 0pt;text-align: center;">Máximos de Responsabilidad <span class="p">, </span>Primas <span class="p">y datos del </span>Contratante, Asegurado <span class="p">y </span>Conductor <span class="p">.</span>
    </p>
    <p style="text-indent: 0pt;text-align: center;">
      <br />
    </p>
    <p class="s13" style="padding-left: 38pt;text-indent: 0pt;text-align: center;">
      <a name="a37">Práctica de deportes como profesional</a>
    </p>
    <p style="padding-left: 180pt;text-indent: 0pt;text-align: center;">Es la actividad física que realiza una persona y por la cual recibe una remuneración o sueldo.</p>
    <p style="text-indent: 0pt;text-align: center;">
      <br />
    </p>
    <p class="s13" style="padding-left: 180pt;text-indent: -142pt;text-align: justify;">Prima <span class="p">Es la cantidad de dinero que el </span>Contratante <span class="p">se obliga a pagar a </span>L A T I N O <span class="p">en términos del </span>Contrato de Seguro <span class="p">, como contraprestación por el riesgo que se asume.</span>
    </p>
    <h2 style="padding-left: 38pt;text-indent: 0pt;text-align: center;">
      <a name="a38">R</a>
    </h2>
    <p class="s13" style="padding-left: 180pt;text-indent: -142pt;text-align: justify;">Robo Total <span class="p">Es el apoderamiento del </span>Vehículo Asegurado <span class="p">contra la voluntad del propietario, </span>Asegurado <span class="p">o </span>Conductor <span class="p">del mismo, ya sea que se encuentre estacionado o en circulación. Para efectos de este contrato, la reclamación del </span>Robo Total <span class="p">iniciará cuando se presente la denuncia de hechos ante las autoridades correspondientes.</span>
    </p>
    <h2 style="padding-left: 38pt;text-indent: 0pt;line-height: 25pt;text-align: center;">
      <a name="a39">S</a>
    </h2>
    <p style="padding-left: 180pt;text-indent: -142pt;text-align: justify;">Siniestro Es la realización de la eventualidad prevista en el <b>Contrato</b>, cuyas consecuencias económicas están cubiertas por la <b>Póliza </b>de acuerdo con los límites de las <b>Coberturas </b>contratadas y pagadas. El conjunto de los <b>Daños </b>corporales y materiales derivados de un mismo <b>Evento </b>constituye un solo <b>Siniestro</b>. </p>
    <p style="text-indent: 0pt;text-align: center;">
      <br />
    </p>
    <p class="s13" style="padding-left: 38pt;text-indent: 0pt;text-align: justify;">
      <a name="a40">Suma Asegurada o Límite Máximo de Responsabilidad</a>
    </p>
    <p style="padding-left: 180pt;text-indent: 0pt;text-align: justify;">Es el importe máximo por cada cobertura contratada y que <b>L A T I N O </b>está obligada a pagar como máximo al momento de suscitarse la pérdida o el <b>Siniestro </b>amparado por la Póliza, que incluye los impuestos correspondientes, como IVA y cualquiera que la ley imponga. La determinación de la <b>Suma Asegurada </b>por cada cobertura debe regirse por lo establecido en la misma, así como en lo dispuesto en la Cláusula &quot;Sumas Aseguradas y Bases de Indemnización&quot;, de las presentes <b>Condiciones Generales</b>. </p>
    <p class="s13" style="padding-top: 11pt;padding-left: 38pt;text-indent: 0pt;text-align: center;">Solicitud de Seguro <span class="p">Es un formato que utiliza </span>L A T I N O <span class="p">, para que el solicitante de un</span>
    </p>
    <p style="padding-left: 180pt;text-indent: 0pt;text-align: center;">seguro proporcione información correspondiente al vehículo que se pretenda asegurar y se pueda determinar el costo de la <b>Prima</b>. </p>
    <p style="padding-left: 180pt;text-indent: 0pt;line-height: 11pt;text-align: center;">Dicha solicitud no constituye una aceptación del riesgo por parte de</p>
    <p class="s13" style="padding-left: 180pt;text-indent: 0pt;text-align: center;">L A T I N O <span class="p">.</span>
    </p>
    <h2 style="padding-top: 11pt;padding-left: 38pt;text-indent: 0pt;text-align: center;">
      <a name="a41">T</a>
    </h2>
    <p class="s13" style="padding-left: 180pt;text-indent: -141pt;text-align: justify;">Terceros <span class="p">Se refiere a los bienes o personas involucrados directa o indirectamente en el </span>Siniestro <span class="p">, que da lugar a la reclamación bajo el amparo de esta </span>Póliza <span class="p">y que no son: ni el </span>Contratante <span class="p">, ni el </span>Asegurado <span class="p">, ni los </span>Ocupantes <span class="p">, ni el </span>Vehículo Asegurado <span class="p">, ni el </span>Conductor <span class="p">del </span>Vehículo Asegurado <span class="p">al momento del </span>Siniestro <span class="p">.</span>
    </p>
    <p class="s13" style="padding-top: 11pt;padding-left: 38pt;text-indent: 0pt;text-align: center;">Tipo de vehículo <span class="p">Es la clasificación que por sus características físicas se tiene del</span>
    </p>
    <p class="s13" style="padding-left: 180pt;text-indent: 0pt;text-align: center;">Vehículo Asegurado <span class="p">, y para efectos de este </span>Contrato <span class="p">el tipo de vehículo es Automóvil, camioneta o pick up.</span>
    </p>
    <p style="padding-left: 180pt;text-indent: 0pt;text-align: center;">Por lo que se considera que dos vehículos son de diferente tipo, cuando por sus características puedan ser definidos bajo diferente</p>
    <p style="padding-top: 7pt;padding-left: 180pt;text-indent: 0pt;text-align: center;">clasificación. vehículo es Automóvil, camioneta o pick up</p>
    <h2 style="padding-left: 38pt;text-indent: 0pt;text-align: center;">
      <a name="a42">U</a>
    </h2>
    <p class="s13" style="padding-left: 38pt;text-indent: 0pt;text-align: justify;">
      <a name="a43">Unidad de Medida y Actualización (UMA)</a>
    </p>
    <p style="padding-left: 180pt;text-indent: 0pt;text-align: justify;">La <b>Unidad de Medida y Actualización (UMA) </b>es la referencia económica en pesos para determinar la cuantía del pago de las obligaciones y supuestos previstos en las leyes federales y de las entidades federativas, así como en las disposiciones jurídicas que emanen de todas las anteriores. Para efectos de estas <b>Condiciones Generales</b>, la <b>Unidad de Medida y Actualización </b>será utilizada para determinar la cuantía del pago de las obligaciones contraídas mediante el presente <b>Contrato de Seguro</b>, las cuales se consideran en monto determinado y serán solventadas entregando su equivalente en moneda nacional, multiplicándose el monto de la obligación, expresado en esta unidad, por el valor diario de dicha unidad a la fecha en que ocurra el <b>Siniestro </b>amparado por este <b>Contrato</b>. </p>
    <p style="padding-top: 11pt;text-indent: 0pt;text-align: center;">
      <br />
    </p>
    <p class="s13" style="padding-left: 38pt;text-indent: 0pt;text-align: justify;">Uso del Vehículo Asegurado <span class="p">Es la utilización que se le da al vehículo objeto del seguro.</span>
    </p>
    <p style="padding-left: 180pt;text-indent: 0pt;text-align: justify;">El <b>Uso del Vehículo Asegurado </b>será el uso particular y determina el tipo de riesgo asumido por <b>L A T I N O </b>con el que se calcula la <b>Prima</b>. </p>
    <p style="text-indent: 0pt;text-align: center;">
      <br />
    </p>
    <p class="s15" style="padding-left: 180pt;text-indent: 0pt;text-align: justify;">La utilización del Vehículo Asegurado para cualquier otro Uso distinto al uso particular, incluso de manera temporal, por días u horas como lo es cuando se brinda un servicio de transporte de personas con modelos de negocio basados en aplicaciones móviles o cualquier otro, se considera agravación del riesgo, por lo que LATINO está facultada para determinar la improcedencia del Siniestro por esta circunstancia de conformidad con lo previsto en el artículo 52 y 53 fracción I de la Ley Sobre el Contrato de Seguro.</p>
    <p class="s17" style="padding-top: 13pt;padding-left: 180pt;text-indent: 0pt;text-align: justify;">Artículo 52 <span class="s16">: “El Asegurado deberá comunicar a la empresa Aseguradora las agravaciones esenciales que tenga el riesgo durante el curso del seguro, dentro de las veinticuatro horas siguientes al momento en que las conozca. Si el Asegurado omitiere el aviso o si él provoca una agravación esencial del riesgo, cesarán de pleno derecho las obligaciones de la empresa en lo sucesivo”.</span>
    </p>
    <p style="text-indent: 0pt;text-align: center;">
      <br />
    </p>
    <p class="s17" style="padding-left: 180pt;text-indent: 0pt;text-align: justify;">Artículo 53 <span class="s16">: “Para los efectos del artículo anterior se presumirá siempre:</span>
    </p>
    <p style="text-indent: 0pt;text-align: center;">
      <br />
    </p>
    <p class="s16" style="padding-left: 180pt;text-indent: 0pt;text-align: justify;">I.- Que la agravación es esencial, cuando se refiera a un hecho importante para la apreciación de un riesgo, de tal suerte que la empresa habría contratado en condiciones diversas si al celebrar el contrato hubiere conocido una agravación análoga;</p>
    <p style="text-indent: 0pt;text-align: center;">
      <br />
    </p>
    <p class="s16" style="padding-left: 180pt;text-indent: 0pt;text-align: justify;">II.- Que el <b>Asegurado </b>conoce o debe conocer toda agravación que emane de actos u omisiones de inquilinos, cónyuge, descendientes </p>
    <p class="s16" style="padding-top: 7pt;padding-left: 180pt;text-indent: 0pt;text-align: justify;">o cualquier otra persona que, con el consentimiento del <b>Asegurado</b>, habite el edificio o tenga en su poder el mueble que fuere materia del seguro”. </p>
    <p style="text-indent: 0pt;text-align: center;">
      <br />
    </p>
    <p class="s16" style="padding-left: 180pt;text-indent: 0pt;text-align: justify;">A continuación, se incluyen las definiciones de los usos de vehículos:</p>
    <p style="text-indent: 0pt;text-align: center;">
      <br />
    </p>
    <ol id="l2">
      <li data-list-text="1.">
        <p class="s17" style="padding-left: 195pt;text-indent: -14pt;text-align: justify;">Uso particular <span class="s16">. Es aquél que se destina al transporte de personas o transporte de enseres domésticos o mercancías sin fines comerciales y de lucro.</span>
        </p>
        <p style="text-indent: 0pt;text-align: center;">
          <br />
        </p>
      </li>
      <li data-list-text="2.">
        <p class="s17" style="padding-left: 195pt;text-indent: -14pt;text-align: justify;">Uso comercial <span class="s16">. Es aquél que es utilizado para el transporte de una o varias personas, mercancías y/o insumos, con fines industriales y/o comerciales y/o de prestación de servicios.</span>
        </p>
      </li>
    </ol>
    <p style="text-indent: 0pt;text-align: center;">
      <br />
    </p>
    <p class="s18" style="padding-left: 180pt;text-indent: 0pt;text-align: center;">El uso comercial, NO está cubierto en este Contrato de Seguro.</p>
    <p style="text-indent: 0pt;text-align: center;">
      <br />
    </p>
    <h2 style="padding-left: 38pt;text-indent: 0pt;text-align: center;">
      <a name="a44">V</a>
    </h2>
    <p class="s13" style="padding-left: 38pt;text-indent: 0pt;text-align: justify;">Valor Comercial <span class="p">Tratándose de vehículos residentes es el valor más alto que tenga</span>
    </p>
    <p style="padding-left: 180pt;text-indent: 0pt;text-align: justify;">
      <a href="http://www.libroazul.com/)" class="a" target="_blank">la unidad en la publicación de la Guía EBC (https://www.l</a>ibroazul.com/) al momento de la realización del <b>Siniestro</b>. Para vehículos denominados como último modelo o de cero kilómetros, el <b>Valor Comercial </b>del vehículo se determinará como el <b>Valor Factura </b>menos el <b>Deducible </b>y menos la depreciación que por uso le corresponda entre la fecha de compra del vehículo y la fecha del <b>Siniestro</b>. El porcentaje de depreciación que se aplicará será del 1.66% por cada mes de uso.
    </p>
    <p style="padding-top: 11pt;padding-left: 180pt;text-indent: 0pt;text-align: justify;">Tratándose de vehículos de procedencia extranjera legalmente importados al territorio nacional, se usarán las guías del país que corresponda.</p>
    <p style="text-indent: 0pt;text-align: center;">
      <br />
    </p>
    <p style="padding-left: 180pt;text-indent: 0pt;text-align: justify;">En ausencia de guías y para efecto de determinar el valor del vehículo, <b>L A T I N O </b>podrá determinar el valor mediante un perito valuador que designe ésta y quien deberá tener en cuenta las características de la unidad y las referencias promedio del mercado. </p>
    <p style="text-indent: 0pt;text-align: center;">
      <br />
    </p>
    <p style="padding-left: 180pt;text-indent: 0pt;text-align: justify;">El <b>Valor Comercial </b>ya incluye los impuestos correspondientes, tales como ISAN, IVA, tenencias, adquisición de bienes muebles y cualquier otro que la ley imponga, de un vehículo de la misma marca, tipo y modelo descrito en la <b>Carátula de la Póliza</b>. </p>
    <p style="text-indent: 0pt;text-align: center;">
      <br />
    </p>
    <p class="s13" style="padding-left: 38pt;text-indent: 0pt;text-align: justify;">Valor Convenido <span class="p">Para efectos de este contrato, se entenderá por </span>Valor Convenido </p>
    <p style="padding-left: 180pt;text-indent: 0pt;text-align: justify;">del <b>Vehículo Asegurado </b>el que acuerden L A T I N O y el Asegurado, el cual será especificado en la <b>Carátula de la Póliza </b>y funcionará como <b>Límite Máximo de Responsabilidad</b>. </p>
    <p class="s13" style="padding-top: 11pt;padding-left: 38pt;text-indent: 0pt;text-align: justify;">Valor de Nuevo <span class="p">Para los vehículos nuevos o los denominados cero kilómetros, es el</span>
    </p>
    <p style="padding-left: 180pt;text-indent: 0pt;text-align: justify;">valor de venta que el distribuidor o el concesionario autorizado ofrece al público en la fecha del <b>Siniestro </b>para un vehículo de la misma marca, tipo y modelo al descrito en la <b>Póliza</b>, el cual incluye los impuestos correspondientes, tales como ISAN, IVA y cualquier otro que la ley imponga. </p>
    <p style="padding-top: 7pt;text-indent: 0pt;text-align: center;">
      <br />
    </p>
    <p class="s13" style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">Valor Factura <span class="p">Es el precio de facturación del vehículo incluyendo el impuesto al</span>
    </p>
    <p style="padding-left: 180pt;text-indent: 0pt;text-align: justify;">valor agregado (IVA), establecido por agencias distribuidoras reconocidas por las plantas nacionales armadoras de vehículos. Dicho valor en ningún caso incluirá los gastos de financiamiento, de traslado o cualquier erogación no propia del costo real del vehículo.</p>
    <p style="text-indent: 0pt;text-align: center;">
      <br />
    </p>
    <p style="padding-left: 180pt;text-indent: 0pt;text-align: justify;">El <b>Valor factura </b>podrá asignarse siempre y cuando las unidades sean de nueva adquisición o último modelo, y considerando que la fecha de expedición de la factura no deberá ser superior a 60 días de la fecha de inicio de vigencia de la <b>Póliza</b>. Siendo requisito indispensable para la emisión, copia de la factura que contenga el número de la misma, así como la fecha de expedición. </p>
    <p class="s13" style="padding-top: 11pt;padding-left: 38pt;text-indent: 0pt;text-align: justify;">Valuación o Peritación <span class="p">Es la verificación y cuantificación en tiempo, magnitud y</span>
    </p>
    <p style="padding-left: 180pt;text-indent: 0pt;text-align: justify;">responsabilidad, del <b>Daño </b>sufrido por un <b>Siniestro </b>a los bienes objeto de este <b>Contrato de Seguro</b>, realizada por un especialista de <b>L A T I N O</b>. </p>
    <p style="text-indent: 0pt;text-align: center;">
      <br />
    </p>
    <p class="s13" style="padding-left: 38pt;text-indent: 0pt;text-align: justify;">Vandalismo <span class="p">Conducta maliciosa e intencional manifestada en espacio público,</span>
    </p>
    <p style="padding-left: 180pt;text-indent: 0pt;text-align: justify;">destinada a destruir o dañar mediante la violencia, los bienes que le pertenecen a un tercero.</p>
    <p style="text-indent: 0pt;text-align: center;">
      <br />
    </p>
    <p class="s13" style="padding-left: 38pt;text-indent: 0pt;text-align: justify;">Vehículos Antiguos <span class="p">Se entiende por </span>Vehículos Antiguos <span class="p">a las unidades de fabricación</span>
    </p>
    <p style="padding-left: 180pt;text-indent: 0pt;text-align: justify;">nacional o extranjera con antigüedad mayor a 15 años, que por su cuidado o reacondicionamiento son sujetos de aseguramiento.</p>
    <p style="text-indent: 0pt;text-align: center;">
      <br />
    </p>
    <p class="s13" style="padding-left: 38pt;text-indent: 0pt;text-align: justify;">Vehículos Clásicos <span class="p">Son vehículos de uso particular de fabricación nacional o extranjera</span>
    </p>
    <p style="padding-left: 180pt;text-indent: 0pt;text-align: justify;">(debidamente legalizados), cuya antigüedad es superior a 20 años y que al paso del tiempo han mantenido la originalidad en sus partes y accesorios y su buen cuidado los lleva a ser considerados como piezas de colección.</p>
    <p style="text-indent: 0pt;text-align: center;">
      <br />
    </p>
    <p class="s13" style="padding-left: 38pt;text-indent: 0pt;text-align: justify;">Vehículo Asegurado <span class="p">La unidad automotriz descrita en la Carátula de la Póliza, incluyendo</span>
    </p>
    <p style="padding-left: 180pt;text-indent: 0pt;text-align: justify;">las partes o accesorios que el fabricante adapta originalmente para cada modelo y tipo específico que presenta al mercado.</p>
    <p style="text-indent: 0pt;text-align: center;">
      <br />
    </p>
    <p style="padding-left: 180pt;text-indent: 0pt;text-align: justify;">Cualquier otra parte, accesorio, rótulo, <b>Conversión, Adaptación </b>o modificación a la estructura, instalada a petición del comprador o propietario o por las agencias, distribuidoras, o por <b>Terceros</b>, no se considerará equipo adaptado por el fabricante, por tanto, requerirá de cobertura específica y se anotará en la <b>Carátula </b>y/o especificación de la <b>Póliza</b>. </p>
    <p class="s13" style="padding-top: 11pt;padding-left: 38pt;text-indent: 0pt;text-align: justify;">Vehículos Fronterizos <span class="p">Son aquellos vehículos de armadoras extranjeras, con una</span>
    </p>
    <p style="padding-left: 180pt;text-indent: 0pt;text-align: justify;">antigüedad mínima de 5 años, los cuales circulan en la franja fronteriza de la República Mexicana y los Estados Unidos de Norteamérica, mismos que se encuentran legalmente internados en nuestro país portando placas de <b>Vehículo Fronterizo</b>. Estos vehículos deben contar con un Título de propiedad y el Pedimento de importación a zonas libres. </p>
    <p style="text-indent: 0pt;text-align: center;">
      <br />
    </p>
    <p class="s13" style="padding-left: 38pt;text-indent: 0pt;text-align: justify;">
      <a name="a45">Vehículos legalmente importados</a>
    </p>
    <p style="padding-left: 180pt;text-indent: 0pt;text-align: justify;">Son aquellos que cuentan con factura original, expedida por</p>
    <p style="padding-top: 7pt;padding-left: 180pt;text-indent: 0pt;text-align: justify;">distribuidora autorizada, en la que se hace constar, mediante el número de pedimento de importación y aduana por la que se internó el vehículo, además del pago de impuestos respectivos por su importación, que efectivamente se encuentran legalmente en el país.</p>
    <p style="text-indent: 0pt;text-align: center;">
      <br />
    </p>
    <p class="s13" style="padding-left: 38pt;text-indent: 0pt;text-align: justify;">
      <a name="a46">Vehículo Recuperado o de Salvamento</a>
    </p>
    <p style="padding-left: 180pt;text-indent: 0pt;text-align: justify;">Son vehículos que han sido siniestrados y posteriormente comercializados por compañías aseguradoras, quienes los reparan y los venden por medio de subastas virtuales o presenciales, a un costo menor de su <b>Valor Comercial</b>. La factura de origen es cambiada por una factura procedente de aseguradora. </p>
    <p class="s13" style="padding-top: 11pt;padding-left: 38pt;text-indent: 0pt;text-align: justify;">
      <a name="a47">Vehículos Regularizados/Legalizados</a>
    </p>
    <p style="padding-left: 180pt;text-indent: 0pt;text-align: justify;">Vehículos con una antigüedad mínima de 10 años que cuentan con un título de propiedad en el que se describen las características del mismo, expedido por el país o ciudad de origen de la unidad con el cual se acredita la propiedad de la misma, el documento correspondiente al pedimento de importación expedido por la aduana por donde se está internando el vehículo y además cuentan con Certificado de Inscripción sobre la base de decreto de la Secretaría de Hacienda y Crédito Público con su correspondiente pago de derechos.</p>
    <p style="text-indent: 0pt;text-align: center;">
      <br />
    </p>
    <p class="s13" style="text-indent: 0pt;text-align: right;">Vehículos Residentes <span class="p">Los vehículos de fabricación nacional o importada que sean</span>
    </p>
    <p style="text-indent: 0pt;text-align: right;">comercializados a través de una distribuidora nacional autorizada.</p>
    <p style="text-indent: 0pt;text-align: center;">
      <br />
    </p>
    <p class="s13" style="padding-left: 180pt;text-indent: -141pt;text-align: justify;">Vuelco <span class="p">Es el </span>Evento <span class="p">durante el cual, por la pérdida de control, el </span>Vehículo Asegurado <span class="p">gira, voltea o se levanta, todo o en parte, sobre la superficie que transita o circula.</span>
    </p>
    <h4 style="padding-top: 7pt;padding-left: 38pt;text-indent: 0pt;text-align: justify;">
      <a name="a48">Cláusula 2ª. Coberturas</a>
    </h4>
    <p style="text-indent: 0pt;text-align: center;">
      <br />
    </p>
    <div class="textbox" style="background:#DEEAF6;">
      <p class="s19" style="text-indent: 0pt;line-height: 11pt;text-align: right;">Sección: Daños Materiales</p>
      <p class="s19" style="text-indent: 0pt;line-height: 11pt;text-align: right;">Cobertura Básica</p>
      <p class="s20" style="padding-left: 5pt;text-indent: 0pt;line-height: 13pt;text-align: center;">CLÁUSULA 2.1. Daños Materiales.</p>
      <p class="s19" style="padding-left: 5pt;text-indent: 0pt;line-height: 11pt;text-align: center;">(Pérdida Total y Parcial)</p>
    </div>
    <p style="padding-left: 39pt;text-indent: 0pt;text-align: center;" />
    <ol id="l3">
      <li data-list-text="A)">
        <p class="s21" style="padding-top: 15pt;padding-left: 74pt;text-indent: -17pt;text-align: center;">Alcance.</p>
        <p style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">Siempre que se haga constar la contratación de esta cobertura, <b>L A T I N O </b>se obliga a amparar los <b>Daños </b>o pérdidas materiales, tanto parciales como totales, que sufra el <b>Vehículo Asegurado </b>a consecuencia de los siguientes riesgos: </p>
        <ol id="l4">
          <li data-list-text="1.">
            <p style="padding-left: 74pt;text-indent: -17pt;line-height: 11pt;text-align: center;">Colisiones y <b>Vuelco</b>s. </p>
          </li>
          <li data-list-text="2.">
            <p style="padding-left: 75pt;text-indent: -18pt;text-align: center;">Rotura y desprendimiento de cristales como son: parabrisas, laterales, aletas, quemacocos y medallón, quedando excluido los espejos.</p>
          </li>
          <li data-list-text="3.">
            <p class="s13" style="padding-left: 74pt;text-indent: -17pt;line-height: 11pt;text-align: center;">Incendio <span class="p">, rayo y explosión.</span>
            </p>
          </li>
          <li data-list-text="4.">
            <p style="padding-left: 75pt;text-indent: -18pt;text-align: justify;">Ciclón, huracán, tornado, vendavales, granizo, terremoto, erupción volcánica, alud, derrumbe de tierra o piedras, caída o derrumbe de construcciones, edificaciones, estructuras u otros objetos, caída de árboles o sus ramas e inundación.</p>
          </li>
          <li data-list-text="5.">
            <p style="padding-left: 75pt;text-indent: -18pt;text-align: justify;">Actos de personas que tomen parte en paros, huelgas, disturbios de carácter obrero, mítines, alborotos populares, motines o de personas mal intencionadas durante la realización de tales actos, o bien ocasionados por las medidas de represión tomadas por las autoridades legalmente reconocidas con motivo de sus funciones que intervengan en dichos actos.</p>
          </li>
          <li data-list-text="6.">
            <p class="s13" style="padding-left: 75pt;text-indent: -18pt;text-align: justify;">Daños <span class="p">por su Transportación. Ampara varadura, hundimiento, </span>Incendio <span class="p">, explosión, </span>Colisión <span class="p">o </span>Vuelco <span class="p">, descarrilamiento o caída del medio de transporte en que el </span>Vehículo Asegurado <span class="p">sea trasladado; caída del vehículo sujeto a aseguramiento durante las maniobras de carga, transbordo o descarga, así como la contribución por </span>Avería Gruesa <span class="p">o por cargos de </span>Salvamento <span class="p">.</span>
            </p>
          </li>
          <li data-list-text="7.">
            <p style="padding-left: 74pt;text-indent: -17pt;line-height: 11pt;text-align: justify;">Los <b>Daños </b>ocasionados a consecuencia de <b>Vandalismo</b>. </p>
          </li>
          <li data-list-text="8.">
            <p class="s13" style="padding-left: 74pt;text-indent: -17pt;text-align: justify;">Desbielamiento <span class="p">por inundación.</span>
            </p>
            <p style="text-indent: 0pt;text-align: center;">
              <br />
            </p>
            <p style="padding-left: 39pt;text-indent: 0pt;text-align: center;">En caso de contratar esta cobertura, no podrá contratarse la cobertura Solo pérdida total, ya que son excluyentes.</p>
            <p style="padding-top: 10pt;padding-left: 39pt;text-indent: 0pt;text-align: justify;">Para el caso de rotura de cristales, sin importar el año de fabricación del <b>Vehículo Asegurado</b>, la reparación, el cambio, reposición o el pago del o de los cristales afectados se efectuará a través de los Proveedores Especializados denominados Cristaleras autorizados por <b>L A T I N O </b>y con quienes tenga convenio. </p>
            <p style="padding-top: 11pt;padding-left: 39pt;text-indent: 0pt;text-align: justify;">Si el cristal que resulte afectado es el parabrisas, en los casos en que sea susceptible de ser reparado, según determinación realizada por <b>L A T I N O</b>, se procederá a efectuar la reparación correspondiente, garantizando la funcionalidad que tenía éste antes de ocurrir el <b>Daño </b>amparado por este seguro. En caso de que la reparación, una vez efectuada, no haya proporcionado la total funcionalidad con la que contaba el parabrisas antes de que el <b>Daño </b>amparado por este seguro ocurriera, <b>L A T I N O </b>realizará el cambio o reposición del mismo. </p>
            <p style="text-indent: 0pt;text-align: center;">
              <br />
            </p>
            <p class="s11" style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">
              <a name="a49">Queda entendido y convenido que los </a>
              <b>Daños </b>o pérdidas materiales que sufra el vehículo, a consecuencia de los riesgos arriba mencionados, quedarán amparados aún en el caso de que se produzcan cuando dicho vehículo haya sido objeto de hechos que constituyan <span class="s15">el delito de Abuso de Confianza</span>, excepto cuando dicho delito sea cometido por: <b>a) </b>Familiar(es) del <b>Asegurado </b>o persona(s) que dependa(n) económicamente de él. <b>b) </b>Persona(s) que aparezca(n) como asegurada(s) en la <b>Carátula de la Póliza</b>.
            </p>
            <p style="padding-top: 12pt;padding-left: 38pt;text-indent: 0pt;text-align: center;">Será requisito indispensable que el <b>Asegurado </b>levante la denuncia o querella correspondiente ante </p>
            <p style="padding-top: 7pt;padding-left: 39pt;text-indent: 0pt;text-align: center;">la autoridad que corresponda, a fin de colaborar con <b>L A T I N O </b>para la recuperación de <b>Daños</b>
            </p>
            <p style="padding-left: 39pt;text-indent: 0pt;text-align: center;">sufridos.</p>
            <p style="text-indent: 0pt;text-align: center;">
              <br />
            </p>
            <p style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">Para efectos de este apartado, cuando el <b>Asegurado </b>sea una persona moral, se entenderá por Familiar del <b>Asegurado </b>aquel que lo sea de los socios o accionistas, o de quienes tengan la titularidad de los derechos de dicha persona moral. </p>
            <p style="text-indent: 0pt;text-align: center;">
              <br />
            </p>
            <p style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">De conformidad con lo previsto en la Cláusula &quot;Definiciones&quot;, se considerará <b>Pérdida Total </b>cuando el importe de la reparación de los <b>Daños </b>sufridos por el <b>Vehículo Asegurado</b>, incluyendo mano de obra, refacciones y materiales necesarios para su reparación conforme a presupuesto validado, realizado y/o autorizado por <b>L A T I N O</b>, exceda del 75% de valor contratado para el <b>Vehículo Asegurado </b>al momento del <b>Siniestro</b>, de conformidad con lo establecido en la <b>Carátula de la Póliza</b>. </p>
            <p style="padding-top: 11pt;padding-left: 39pt;text-indent: 0pt;text-align: justify;">Adicionalmente, a lo mencionado en el párrafo anterior, se considerará <b>Pérdida Total </b>a petición del <b>Asegurado</b>, si el importe total que se requiere para la reparación del <b>Daño </b>causado al <b>Vehículo Asegurado</b>, incluyendo mano de obra, refacciones y materiales necesarios para su reparación conforme a presupuesto validado, realizado y/o autorizado por <b>L A T I N O </b>es mayor al 50% y menor al 75% de la <b>Suma Asegurada </b>o del <b>Valor Comercial </b>a la fecha del <b>Siniestro</b>. </p>
            <p style="text-indent: 0pt;text-align: center;">
              <br />
            </p>
            <p style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">De forma independiente a los porcentajes de los <b>Daños</b>, cuando se emita dictamen del perito y avalúo realizado y validado por <b>L A T I N O</b>, que determine técnicamente la inviabilidad de la reparación del <b>Vehículo Asegurado.</b>
            </p>
          </li>
        </ol>
      </li>
      <li data-list-text="B)">
        <p class="s21" style="padding-top: 11pt;padding-left: 74pt;text-indent: -17pt;text-align: justify;">Límite Máximo de Responsabilidad</p>
        <p style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">Dependiendo del tipo de <b>Vehículo Asegurado</b>, esta cobertura podrá operar bajo el concepto de <span class="s9">Valor Convenido, Valor Comercial </span>
          <span class="s11">o </span>
          <span class="s9">Valor Factura</span>, por lo tanto, <b>L A T I N O</b>, se compromete a pagar conforme a lo establecido en la <b>Carátula de la Póliza </b>y en la Cláusula “Sumas Aseguradas y Bases de Indemnización”.
        </p>
        <p style="text-indent: 0pt;text-align: center;">
          <br />
        </p>
        <p style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">El <b>Límite Máximo de Responsabilidad </b>de <b>L A T I N O </b>para esta cobertura se establece en la <b>Carátula de la Póliza </b>y opera como <b>Suma Asegurada </b>única para los diversos riesgos que se amparan en esta cobertura. En ningún caso la suma de las indemnizaciones excederá de la <b>Suma Asegurada </b>contratada por <b>Evento</b>. </p>
        <p style="text-indent: 0pt;text-align: center;">
          <br />
        </p>
      </li>
      <li data-list-text="C)">
        <p class="s21" style="padding-left: 74pt;text-indent: -17pt;line-height: 14pt;text-align: justify;">Deducible.</p>
        <p style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">La cobertura Daños Materiales se contrata con la aplicación invariable en cada <b>Siniestro </b>de una cantidad a cargo del <b>Asegurado</b>, denominada <b>Deducible</b>. </p>
        <p style="padding-top: 11pt;padding-left: 39pt;text-indent: 0pt;text-align: justify;">El procedimiento para obtener el monto del <b>Deducible </b>aplicable es el siguiente: </p>
        <p style="text-indent: 0pt;text-align: center;">
          <br />
        </p>
        <ol id="l5">
          <li data-list-text="1.">
            <p style="padding-left: 75pt;text-indent: -18pt;text-align: justify;">
              <span class="s22">Tanto para Pérdidas Parciales como Pérdidas Totales</span>: El <b>Deducible </b>resulta de la aplicación del porcentaje de <b>Deducible </b>estipulado en la <b>Carátula de la Póliza </b>sobre la <b>Suma Asegurada </b>contratada e indicada en la misma.
            </p>
          </li>
          <li data-list-text="2.">
            <p style="padding-left: 75pt;text-indent: -18pt;text-align: justify;">
              <span class="s22">Responsabilidad de un Tercero: </span>En caso de que la responsabilidad de la ocurrencia del <b>Siniestro </b>corresponda a un tercero, el <b>Asegurado </b>afectado, deberá invariablemente pagar a <b>L A T I N O </b>el <b>Deducible </b>correspondiente. Si <b>L A T I N O </b>recupera del tercero responsable el importe total o parcial del <b>Daño </b>ocasionado al <b>Vehículo Asegurado</b>, <b>L A T I N O </b>reembolsará a éste el importe del <b>Deducible </b>en la proporción que guarde el monto recuperado respecto del importe total del <b>Daño, excepto si se tiene contratada la Cláusula 2.3 Quédate conmigo</b>.
            </p>
          </li>
          <li data-list-text="3.">
            <p style="padding-left: 75pt;text-indent: -18pt;text-align: justify;">
              <span class="s22">Desbielamiento: </span>En caso de <b>Desbielamiento </b>por inundación, el <b>Deducible </b>a cargo del <b>Asegurado </b>en caso de <b>Pérdida</b>s <b>Parcial</b>es será el equivalente al 25% del costo total de la reparación, en caso de <b>Pérdida Total </b>será el 25% sobre el <b>Límite Máximo de Responsabilidad </b>establecido en la <b>Carátula de la Póliza</b>.
            </p>
          </li>
          <li data-list-text="4.">
            <p class="s9" style="padding-top: 3pt;padding-left: 75pt;text-indent: -18pt;text-align: justify;">
              <span class="s22">Rotura de Cristales</span>
              <span class="s23">: </span>
              <span class="p">En reclamaciones por rotura de cristales, si se efectúa un cambio o </span>
              <span class="s24">reposición, quedará a cargo del </span>Asegurado <span class="s11">el pago del </span>Deducible <span class="s11">, mismo que corresponde al 20% (veinte por ciento) del monto total que resulte de sumar el valor del o de los cristales afectados y el costo de su instalación.</span>
            </p>
            <p style="padding-top: 11pt;padding-left: 74pt;text-indent: 0pt;text-align: justify;">En los casos en los que se efectúe la reparación de parabrisas, el <b>Asegurado </b>quedará exento del pago de <b>Deducible </b>indicado en el párrafo anterior. Si se efectúa cambio o reposición, el <b>Asegurado </b>deberá cumplir con su obligación de pago de <b>Deducible </b>aplicable para las reclamaciones por rotura de cristales. </p>
          </li>
          <li data-list-text="5.">
            <p style="padding-left: 75pt;text-indent: -18pt;text-align: justify;">
              <span class="s22">Estado de Ebriedad: </span>En aquellos <b>Siniestro</b>s en los que, al momento de su ocurrencia, el <b>Conductor </b>del <b>Vehículo Asegurado </b>se encuentre en <b>Estado de Ebriedad o </b>bajo la influencia de estupefacientes o drogas que no hayan sido previamente prescritas por un médico, invariablemente el <b>Deducible </b>señalado en la <b>Carátula de la Póliza </b>para esta cobertura se duplicará, y en caso de que el <b>Deducible </b>una vez duplicado sea menor al 10%, se aplicará como mínimo un 10%.
            </p>
          </li>
          <li data-list-text="6.">
            <p class="s13" style="padding-left: 75pt;text-indent: -18pt;text-align: justify;">
              <span style=" color: #1F4E79;">Conductor No Declarado</span>: <span class="p">Cuando el tipo de </span>Conductor <span class="p">declarado en </span>Carátula de la Póliza <span class="p">sea </span>Conductor Habitual <span class="p">y al momento del </span>Siniestro <span class="p">, el </span>Vehículo Asegurado <span class="p">sea conducido por un </span>Conductor <span class="p">de alto riesgo, entendiéndose por éste al </span>Conductor <span class="p">menor de 26 años cumplidos al momento de la fecha de emisión de la </span>Póliza <span class="p">, y dicho </span>Conductor <span class="p">sea determinado como responsable del accidente por la autoridad competente, el </span>Deducible <span class="p">se duplicará, y en caso que una vez duplicado sea menor al 10%, se aplicará como mínimo un 10%. Para efectos de este punto, </span>NO <span class="p">se considerará el incremento cuando el tipo de </span>Conductor <span class="p">declarado sea </span>Conductor Universal <span class="p">o </span>Conductor Indeterminado.
            </p>
          </li>
          <li data-list-text="7.">
            <p class="s22" style="padding-left: 75pt;text-indent: -18pt;text-align: justify;">Inspección vehicular obligatoria: <span class="p">en caso de no realizar la inspección del vehículo asegurado señalada en la cláusula 5.16, se adicionarán al deducible contratado 30 puntos porcentuales.</span>
            </p>
          </li>
        </ol>
        <p style="padding-top: 11pt;text-indent: 0pt;text-align: center;">
          <br />
        </p>
        <p class="s15" style="padding-left: 74pt;text-indent: 0pt;text-align: justify;">Queda entendido por el Asegurado que en el caso de que así proceda, los porcentajes de Deducible señalados en los puntos 5, 6 y 7 del párrafo que antecede, constituyen una agravación del riesgo, por lo que, son acumulativos en caso de verificarse las circunstancias mencionadas.</p>
        <p style="text-indent: 0pt;text-align: center;">
          <br />
        </p>
      </li>
      <li data-list-text="D)">
        <p class="s21" style="padding-left: 74pt;text-indent: -17pt;text-align: center;">Exclusiones</p>
      </li>
    </ol>
    <p class="s15" style="padding-left: 39pt;text-indent: 0pt;text-align: center;">Queda entendido que, la cobertura de 2.1. Daños Materiales y la cobertura</p>
    <p class="s15" style="padding-left: 39pt;text-indent: 0pt;text-align: center;">2.2. Solo Pérdida Total son excluyentes entre sí y solo podrá contratarse una de las dos.</p>
    <p style="text-indent: 0pt;text-align: center;">
      <br />
    </p>
    <p class="s15" style="padding-left: 39pt;text-indent: 0pt;text-align: center;">Asimismo, en adición a lo aplicable respecto a la Cláusula Exclusiones Generales, esta cobertura en ningún caso ampara:</p>
    <ol id="l6">
      <li data-list-text="1.">
        <p class="s25" style="padding-top: 11pt;padding-left: 81pt;text-indent: -24pt;text-align: justify;">Daños cuyo costo sea menor al monto a pagar por concepto de Deducible.</p>
      </li>
      <li data-list-text="2.">
        <p class="s25" style="padding-left: 81pt;text-indent: -24pt;text-align: justify;">El Desbielamiento del motor del Vehículo Asegurado por cualquier causa, incluyendo desgaste natural, introducción de objetos extraños, fuga de aceite y/o agua y/o líquidos, salvo inundación o Daños en las Partes Bajas a consecuencia de los riesgos amparados en la cobertura conforme a las definiciones de las presentes Condiciones Generales.</p>
        <p class="s25" style="padding-left: 81pt;text-indent: 0pt;text-align: justify;">Asimismo, salvo fuerzas de causa mayor que pongan en peligro la vida o la integridad personal, no está cubierto el Desbielamiento</p>
        <p class="s25" style="padding-top: 3pt;padding-left: 81pt;text-indent: 0pt;text-align: justify;">causado como consecuencia de Daños sufridos en las Partes Bajas del Vehículo Asegurado o al sistema de enfriamiento del motor, siempre que el Conductor del mismo no haya detenido y apagado la marcha del vehículo y esto haya sido la causa de dichos Daños, así como el ocasionado por otras causas distintas a las señaladas en la cobertura de Daños Materiales.</p>
      </li>
      <li data-list-text="3.">
        <p class="s25" style="padding-left: 81pt;text-indent: -24pt;text-align: justify;">Pérdidas o Daños causados por la acción normal de la marea, aun cuando ésta provoque inundación.</p>
      </li>
      <li data-list-text="4.">
        <p class="s15" style="padding-left: 81pt;text-indent: -24pt;text-align: justify;">Daños o pérdidas materiales que sufra el vehículo como consecuencia del delito de Abuso de Confianza cometido por:</p>
        <p class="s15" style="padding-left: 81pt;text-indent: 0pt;text-align: justify;">Familiares del Asegurado o personas que dependan económicamente del mismo.</p>
        <ol id="l7">
          <li data-list-text="4.1.">
            <p class="s15" style="padding-left: 110pt;text-indent: -28pt;text-align: justify;">Personas que aparezcan como Aseguradas en la Carátula de la Póliza.</p>
          </li>
          <li data-list-text="4.2.">
            <p class="s15" style="padding-left: 109pt;text-indent: -28pt;text-align: justify;">Empleados o personas que presten servicio al Asegurado.</p>
          </li>
          <li data-list-text="4.3.">
            <p class="s15" style="padding-left: 110pt;text-indent: -28pt;text-align: justify;">Personas cuyas acciones sean tendientes a la compraventa, arrendamiento o financiamiento del Vehículo Asegurado.</p>
          </li>
          <li data-list-text="4.4.">
            <p class="s15" style="padding-left: 110pt;text-indent: -28pt;text-align: justify;">Personas cuyas acciones tengan su origen o sea consecuencia de cualquier tipo de contrato o convenio mercantil de compraventa, financiamiento o renta diaria del Vehículo Asegurado.</p>
          </li>
          <li data-list-text="4.5.">
            <p class="s15" style="padding-left: 110pt;text-indent: -28pt;text-align: justify;">Cuando el Asegurado sea una persona moral, se entenderá por familiar del Asegurado aquel que lo sea de los socios o accionistas, o de quienes tengan la titularidad de los derechos de dicha persona moral.</p>
          </li>
        </ol>
      </li>
      <li data-list-text="5.">
        <p class="s15" style="padding-left: 81pt;text-indent: -21pt;text-align: justify;">Daños a la pintura del Vehículo Asegurado, ocasionados por riesgos diferentes a los amparados en esta Cobertura.</p>
      </li>
      <li data-list-text="6.">
        <p class="s15" style="padding-left: 81pt;text-indent: -21pt;text-align: justify;">Daños Materiales al Vehículo Asegurado ocasionados por riña, ya sea entre particulares y/o callejeras, en que el Asegurado, Conductor y/u Ocupantes participen sin importar su grado de participación.</p>
      </li>
      <li data-list-text="7.">
        <p class="s15" style="padding-left: 81pt;text-indent: -21pt;text-align: justify;">La rotura, descompostura mecánica o la falta de resistencia de cualquier pieza del vehículo como consecuencia de su uso, a menos que fueren causados por alguno de los riesgos amparados en esta Cobertura.</p>
      </li>
      <li data-list-text="8.">
        <p class="s15" style="padding-left: 81pt;text-indent: -21pt;text-align: justify;">Las pérdidas o Daños que sufra el Vehículo Asegurado en forma intencional por el Asegurado o cualquier Conductor que con su consentimiento expreso o tácito use el vehículo.</p>
      </li>
      <li data-list-text="9.">
        <p class="s15" style="padding-left: 81pt;text-indent: -21pt;text-align: justify;">Las pérdidas o Daños que sufra el Vehículo Asegurado al transitar fuera de Caminos o en Caminos Intransitables.</p>
      </li>
      <li data-list-text="10.">
        <p class="s15" style="padding-left: 81pt;text-indent: -21pt;text-align: justify;">Los Daños que sufra el Vehículo Asegurado en caso de que L A T I N O demuestre que el Conductor y/o Asegurado efectuaron un cambio de Conductor.</p>
      </li>
      <li data-list-text="11.">
        <p class="s15" style="padding-left: 81pt;text-indent: -21pt;text-align: justify;">El servicio de reparación para cristales blindados.</p>
      </li>
    </ol>
    <p style="padding-top: 1pt;text-indent: 0pt;text-align: center;">
      <br />
    </p>
    <p style="text-indent: 0pt;text-align: center;">
      <br />
    </p>
    <div class="textbox" style="background:#DEEAF6;">
      <p class="s20" style="padding-left: 44pt;text-indent: 0pt;text-align: center;">
        CLÁUSULA 2.2. Solo Pérdida Total
      </p>
      <p class="s19" style="padding-top: 4pt;text-indent: 0pt;text-align: right;">
        Sección: Daños Materiales
      </p>
      <p class="s19" style="text-indent: 0pt;text-align: right;">Cobertura Básica</p>
      <p style="padding-top: 5pt;text-indent: 0pt;text-align: center;">
        <br />
      </p>
    </div>
    <ol id="l8">
      <li data-list-text="A)">
        <p class="s21" style="padding-left: 74pt;text-indent: -17pt;text-align: justify;">Alcance.</p>
        <p style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">Siempre que se haga constar la contratación de esta cobertura, <b>L A T I N O </b>se obliga a amparar los <b>Daños </b>o pérdidas materiales totales que sufra el <b>Vehículo Asegurado</b>, a consecuencia de cualesquiera de los riesgos amparados por la cobertura básica de Daños Materiales, <b>solamente </b>serán indemnizados cuando se trate de <b>Pérdida Total </b>hasta el <b>Límite Máximo de Responsabilidad </b>establecidos en la <b>Carátula de la Póliza</b>. </p>
        <p style="text-indent: 0pt;text-align: center;">
          <br />
        </p>
        <p style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">De conformidad con lo previsto en la Cláusula &quot;Definiciones&quot;, se considerará <b>Pérdida Total </b>cuando el importe de la reparación de los <b>Daños </b>sufridos por el <b>Vehículo Asegurado</b>, incluyendo mano de obra, refacciones y materiales necesarios, exceda del 75% de valor contratado para el <b>Vehículo</b>
        </p>
        <p style="text-indent: 0pt;text-align: center;">
          <br />
        </p>
        <p class="s13" style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">Asegurado <span class="p">al momento del </span>Siniestro <span class="p">, de conformidad con lo establecido en la </span>Carátula de la Póliza <span class="p">.</span>
        </p>
        <p style="padding-top: 11pt;padding-left: 39pt;text-indent: 0pt;text-align: justify;">La contratación de esta cobertura se hará constar en la <b>Carátula de la Póliza</b>, quedando por tanto <span class="s15">excluidos los Daños parciales que sufra el Vehículo Asegurado, cuyo costo de reparación incluyendo mano de obra, refacciones y materiales necesarios, no exceda el 75% del valor contratado al momento del Siniestro.</span>
        </p>
        <p style="text-indent: 0pt;text-align: center;">
          <br />
        </p>
        <p style="padding-left: 39pt;text-indent: 0pt;text-align: center;">En caso de contratar esta cobertura, no podrá contratarse la cobertura Daños Materiales, ya que son excluyentes.</p>
        <p style="text-indent: 0pt;text-align: center;">
          <br />
        </p>
      </li>
      <li data-list-text="B)">
        <p class="s21" style="padding-left: 74pt;text-indent: -17pt;text-align: justify;">Límite Máximo de Responsabilidad</p>
        <p style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">Dependiendo del tipo de <b>Vehículo Asegurado</b>, esta cobertura podrá operar bajo el concepto de <span class="s9">Valor Convenido, Valor Comercial </span>
          <span class="s11">o </span>
          <span class="s9">Valor Factura</span>, por lo tanto, <b>L A T I N O </b>se compromete a pagar conforme a lo establecido en la <b>Carátula de la Póliza </b>y en la Cláusula “Sumas Aseguradas y Bases de Indemnización”.
        </p>
        <p style="padding-top: 11pt;padding-left: 39pt;text-indent: 0pt;text-align: justify;">El <b>Límite Máximo de Responsabilidad </b>de <b>L A T I N O </b>en esta cobertura se establece en la <b>Carátula de la Póliza </b>y opera como <b>Suma Asegurada </b>única para los diversos riesgos que se amparan en esta cobertura. </p>
        <p style="text-indent: 0pt;text-align: center;">
          <br />
        </p>
      </li>
      <li data-list-text="C)">
        <p class="s21" style="padding-left: 74pt;text-indent: -17pt;line-height: 14pt;text-align: justify;">Deducible</p>
        <p style="padding-left: 39pt;text-indent: 0pt;text-align: center;">La cobertura Solo Pérdida Total se contrata con la aplicación invariable en cada <b>Siniestro </b>de una cantidad a cargo del <b>Asegurado</b>, denominada <b>Deducible</b>. </p>
        <p style="text-indent: 0pt;text-align: center;">
          <br />
        </p>
        <p style="padding-left: 39pt;text-indent: 0pt;text-align: center;">El procedimiento para obtener el monto del <b>Deducible </b>aplicable es el siguiente: </p>
        <p style="text-indent: 0pt;text-align: center;">
          <br />
        </p>
        <ol id="l9">
          <li data-list-text="1.">
            <p style="padding-left: 81pt;text-indent: -21pt;text-align: justify;">
              <span class="s22">Para Pérdida Total</span>: El <b>Deducible </b>resulta de la aplicación del porcentaje de <b>Deducible </b>estipulado en la <b>Carátula de la Póliza </b>sobre la <b>Suma Asegurada </b>contratada e indicada en la misma.
            </p>
          </li>
          <li data-list-text="2.">
            <p style="padding-left: 81pt;text-indent: -21pt;text-align: justify;">
              <span class="s22">Responsabilidad de un Tercero: </span>En caso de que la responsabilidad de la ocurrencia del <b>Siniestro </b>corresponda a un tercero, el <b>Asegurado </b>afectado, deberá invariablemente pagar a <b>L A T I N O </b>el <b>Deducible </b>correspondiente. Si <b>L A T I N O </b>recupera del tercero responsable el importe total o parcial del <b>Daño </b>ocasionado al <b>Vehículo Asegurado</b>, <b>L A T I N O </b>reembolsará a éste el importe del <b>Deducible </b>en la proporción que guarde el monto recuperado respecto del importe total del <b>Daño</b>.
            </p>
          </li>
          <li data-list-text="3.">
            <p style="padding-left: 81pt;text-indent: -21pt;text-align: justify;">
              <span class="s22">Desbielamiento: </span>En caso de <b>Desbielamiento </b>por inundación, el <b>Deducible </b>a cargo del <b>Asegurado </b>será el equivalente al 25% sobre el <b>Límite Máximo de Responsabilidad </b>establecido en la <b>Carátula de la Póliza</b>.
            </p>
          </li>
          <li data-list-text="4.">
            <p style="padding-left: 81pt;text-indent: -21pt;text-align: justify;">
              <span class="s22">Estado de Ebriedad: </span>En aquellos <b>Siniestro</b>s en los que, al momento de su ocurrencia, el <b>Conductor </b>del <b>Vehículo Asegurado </b>se encuentre en <b>Estado de Ebriedad </b>o bajo la influencia de estupefacientes o drogas que no hayan sido previamente prescritas por un médico, invariablemente el <b>Deducible </b>señalado en la <b>Carátula de la Póliza </b>para esta
            </p>
            <p style="padding-top: 3pt;padding-left: 81pt;text-indent: 0pt;text-align: justify;">cobertura se duplicará, y en caso de que el <b>Deducible </b>una vez duplicado sea menor al 10%, se aplicará como mínimo un 10%. </p>
          </li>
          <li data-list-text="5.">
            <p class="s13" style="padding-top: 4pt;padding-left: 81pt;text-indent: -21pt;text-align: justify;">
              <span style=" color: #1F4E79;">Conductor No Declarado</span>: <span class="p">Cuando el tipo de </span>Conductor <span class="p">declarado en </span>Carátula de la Póliza <span class="p">sea </span>Conductor Habitual <span class="p">y al momento del </span>Siniestro <span class="p">, el </span>Vehículo Asegurado <span class="p">sea conducido por un </span>Conductor <span class="p">de alto riesgo, entendiéndose por éste al </span>Conductor <span class="p">menor </span>
              <span class="s24">de 26 años cumplidos al momento de la fecha de emisión de la </span>
              <span class="s9">Póliza</span>
              <span class="s11">, y dicho </span>
              <span class="s9">Conductor </span>
              <span class="s11">sea determinado como responsable del accidente por la autoridad competente, el </span>
              <span class="s9">Deducible </span>
              <span class="s11">se duplicará, y en caso que una vez duplicado sea menor al 10%, se aplicará como mínimo un 10%. Para efectos de este punto, </span>
              <span class="s9">NO </span>
              <span class="s11">se considerará el incremento cuando el tipo de </span>
              <span class="s9">Conductor </span>
              <span class="s11">declarado sea </span>
              <span class="s9">Conductor Universal </span>
              <span class="s11">o </span>
              <span class="s9">Conductor Indeterminado.</span>
            </p>
          </li>
          <li data-list-text="6.">
            <p class="s22" style="padding-left: 81pt;text-indent: -21pt;text-align: justify;">Inspección vehicular obligatoria: <span class="p">en caso de no realizar la inspección del vehículo asegurado señalada en la cláusula 5.16, se adicionarán al deducible contratado 30 puntos porcentuales.</span>
            </p>
          </li>
        </ol>
        <p style="padding-top: 2pt;text-indent: 0pt;text-align: center;">
          <br />
        </p>
        <p class="s15" style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">Queda entendido por el Asegurado que en el caso de que así proceda, los porcentajes de Deducible señalados en los puntos 4, 5 y 6 del párrafo que antecede, constituyen una agravación del riesgo, por lo que, son acumulativos en caso de verificarse las circunstancias mencionadas.</p>
        <p style="text-indent: 0pt;text-align: center;">
          <br />
        </p>
      </li>
      <li data-list-text="D)">
        <p class="s15" style="padding-left: 74pt;text-indent: -17pt;text-align: justify;">Exclusiones</p>
      </li>
    </ol>
    <p class="s15" style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">Queda entendido que, la cobertura de 2.1. Daños Materiales y la cobertura 2.2. Solo Pérdida Total son excluyentes entre sí y solo podrá contratarse una de las dos.</p>
    <p class="s15" style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">Asimismo, en adición a lo aplicable respecto a la Cláusula Exclusiones Generales y las Exclusiones de la cobertura de Daños Materiales, se excluye:</p>
    <ol id="l10">
      <li data-list-text="1.">
        <p class="s25" style="padding-left: 81pt;text-indent: -21pt;text-align: justify;">Todo Daño distinto a la Pérdida Total del Vehículo Asegurado.</p>
      </li>
      <li data-list-text="2.">
        <p class="s25" style="padding-left: 81pt;text-indent: -21pt;text-align: justify;">Todo Siniestro cuyo costo de reparación <span style=" color: #000;">incluyendo mano de obra, refacciones y materiales necesarios</span>, de acuerdo con avalúo practicado, no exceda el 75% del valor contratado al momento del Siniestro. </p>
      </li>
    </ol>
    <p style="text-indent: 0pt;text-align: center;">
      <br />
    </p>
    <div class="textbox" style="background:#DEEAF6;">
      <p class="s19" style="padding-left: 345pt;text-indent: -26pt;text-align: right;">Sección: Daños Materiales Cobertura Accesoria</p>
      <p class="s20" style="padding-left: 5pt;text-indent: 0pt;line-height: 12pt;text-align: center;">CLÁUSULA 2.3. Quédate Conmigo.</p>
      <p class="s19" style="padding-left: 5pt;text-indent: 0pt;text-align: center;">(Eliminación de Deducible por Daños provocados por un Tercero sin seguro)</p>
    </div>
    <p style="padding-left: 33pt;text-indent: 0pt;text-align: center;" />
    <p class="s12" style="padding-top: 10pt;padding-left: 39pt;text-indent: 0pt;text-align: justify;">
      <a name="a52">Requisitos de contratación</a>
    </p>
    <p style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">Esta es una cobertura accesoria; por lo que su contratación requiere que se tenga amparada una cobertura básica de la sección de Daños Materiales.</p>
    <p style="text-indent: 0pt;text-align: center;">
      <br />
    </p>
    <ol id="l11">
      <li data-list-text="A)">
        <p class="s21" style="padding-left: 74pt;text-indent: -17pt;text-align: justify;">Alcances</p>
        <p style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">Siempre que se hagan constar la contratación de esta cobertura y de la cobertura básica que corresponda, <b>L A T I N O </b>se obliga a cubrir la eliminación del pago del <b>Deducible </b>a favor del <b>Asegurado </b>o <b>Conductor </b>del <b>Vehículo Asegurado </b>que, al ocurrir el <b>Siniestro</b>, tenga contratada la cobertura básica de la sección de Daños Materiales en donde se afecte ésta última, <span class="s26">siempre</span>
          <span class="s27"></span>
          <span class="s26">que quede plenamente demostrado</span>
          <span class="s27"></span>que el <b>Conductor </b>del <b>Vehículo Asegurado</b>, <u>
            <i>NO tiene</i>
          </u>
          <i></i>
          <u>
            <i>responsabilidad en los </i>
          </u>
          <u>
            <b>Daños </b>
          </u>
          <u>
            <i>provocados</i>
          </u>, bajo la siguiente condición:
        </p>
        <p style="padding-top: 3pt;padding-left: 39pt;text-indent: 0pt;text-align: justify;">Cuando exista un <b>Tercero </b>responsable, y no cuente con seguro, dicho <b>Tercero </b>deberá estar presente al momento y en el lugar del ajuste del <b>Siniestro</b>. </p>
        <p style="text-indent: 0pt;text-align: center;">
          <br />
        </p>
        <p style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">En este caso, la responsabilidad la determinará la autoridad competente, mediante un dictamen pericial en hechos de tránsito, el cual deberá ser en favor del <b>Conductor </b>del <b>Vehículo Asegurado</b>. </p>
        <p style="padding-top: 11pt;padding-left: 39pt;text-indent: 0pt;text-align: justify;">Excepción de lo anterior cuando:</p>
        <p style="text-indent: 0pt;text-align: center;">
          <br />
        </p>
        <ol id="l12">
          <ol id="l13">
            <li data-list-text="1.1.">
              <p style="padding-left: 81pt;text-indent: -21pt;text-align: justify;">El tercero se haga responsable del pago de los <b>Daños </b>causados, entonces, <b>L A T I N O </b>procederá a la reparación del <b>Vehículo Asegurado </b>sin la aplicación del <b>Deducible </b>correspondiente. </p>
            </li>
            <li data-list-text="1.2.">
              <p style="padding-top: 4pt;padding-left: 81pt;text-indent: -21pt;text-align: justify;">En los casos en que los <b>Daños </b>estén valuados por debajo de los 156 UMAS (ciento cincuenta y seis Unidades de Medida y Actualización) <b>L A T I N O </b>podrá proceder a la reparación del <b>Vehículo Asegurado </b>sin esperar el dictamen de la autoridad competente en favor del <b>Conductor </b>del <b>Vehículo Asegurado</b>. </p>
            </li>
          </ol>
        </ol>
        <p style="padding-top: 11pt;padding-left: 39pt;text-indent: 0pt;text-align: justify;">Para efectos de los incisos anteriores el <b>Asegurado </b>y/o <b>Conductor </b>quedan obligados a colaborar con <b>L A T I N O </b>en el proceso de recuperación de <b>Daños </b>materiales correspondiente, por lo que deberán: </p>
        <p style="text-indent: 0pt;text-align: center;">
          <br />
        </p>
        <ol id="l14">
          <li data-list-text="1.">
            <p style="padding-left: 81pt;text-indent: -21pt;line-height: 11pt;text-align: center;">Dar aviso a <b>L A T I N O </b>y esperar al Ajustador en el lugar del accidente. </p>
          </li>
          <li data-list-text="2.">
            <p style="padding-left: 81pt;text-indent: -21pt;text-align: center;">Presentar formal querella o denuncia ante la autoridad correspondiente, en caso de proceder.</p>
          </li>
          <li data-list-text="3.">
            <p style="padding-left: 81pt;text-indent: -21pt;line-height: 11pt;text-align: center;">Comparecer ante la autoridad las veces que sean requeridos por la misma.</p>
          </li>
          <li data-list-text="4.">
            <p style="padding-left: 81pt;text-indent: -21pt;text-align: justify;">A solicitud de <b>L A T I N O</b>, otorgar el perdón legal al <b>Tercero </b>responsable, aún y cuando se le haya exentado del pago de <b>Deducible </b>de la cobertura básica de la sección de Daños Materiales e ingresar a <b>L A T I N O </b>la cantidad recibida por concepto de pago de <b>Daños</b>. </p>
          </li>
          <li data-list-text="5.">
            <p style="padding-left: 81pt;text-indent: -21pt;text-align: justify;">Extender poder notarial por parte del <b>Asegurado </b>y a costa de <b>L A T I N O </b>para el seguimiento y, en su caso, efectuar la recuperación de los <b>Daños</b>. </p>
          </li>
        </ol>
      </li>
      <li data-list-text="B)">
        <p class="s21" style="padding-top: 11pt;padding-left: 74pt;text-indent: -17pt;text-align: center;">Límite Máximo de Responsabilidad</p>
        <p style="padding-left: 39pt;text-indent: 0pt;line-height: 12pt;text-align: center;">El <b>Límite Máximo de Responsabilidad </b>de <b>L A T I N O </b>para esta cobertura es el pago del <span class="s9">Deducible</span>
        </p>
        <p class="s11" style="padding-left: 39pt;text-indent: 0pt;line-height: 12pt;text-align: center;">
          <a name="a53">que se tenga contratado en la cobertura básica de la sección de Daños Materiales.</a>
        </p>
      </li>
      <li data-list-text="C)">
        <p class="s21" style="padding-top: 8pt;padding-left: 74pt;text-indent: -17pt;line-height: 14pt;text-align: center;">Deducible</p>
        <p style="padding-left: 39pt;text-indent: 0pt;line-height: 12pt;text-align: center;">No opera</p>
        <p style="padding-top: 2pt;text-indent: 0pt;text-align: center;">
          <br />
        </p>
      </li>
      <li data-list-text="D)">
        <p class="s21" style="padding-left: 74pt;text-indent: -17pt;text-align: justify;">Exclusiones</p>
        <p class="s15" style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">Queda entendido que, en adición a lo aplicable respecto a la Cláusula Exclusiones Generales y las Exclusiones de la cobertura básica de la sección de Daños Materiales, esta cobertura:</p>
        <ol id="l15">
          <li data-list-text="1.">
            <p class="s15" style="padding-top: 13pt;padding-left: 81pt;text-indent: -21pt;text-align: justify;">No procede, en caso de que el Siniestro no sea atendido en el lugar de los hechos.</p>
            <div class="textbox" style="background:#DEEAF6;">
              <p class="s30" style="padding-left: 343pt;text-indent: -27pt;text-align: right;">Sección: Daños Materiales Cobertura Accesoria</p>
              <p class="s20" style="padding-left: 5pt;text-indent: 0pt;line-height: 12pt;text-align: center;">CLÁUSULA 2.4. Rueda Segura.</p>
              <p class="s30" style="padding-left: 5pt;text-indent: 0pt;text-align: center;">(Daños materiales a llantas y rines)</p>
            </div>
          </li>
        </ol>
      </li>
    </ol>
    <p style="text-indent: 0pt;text-align: center;" />
    <ol id="l16">
      <ol id="l17">
        <li data-list-text="2.">
          <p class="s15" style="padding-left: 81pt;text-indent: -21pt;text-align: justify;">No quedan amparados los Daños y lesiones que sufra el Tercero en sus bienes o personas, en ninguna de las coberturas de la sección de Responsabilidad Civil.</p>
        </li>
      </ol>
    </ol>
    <p class="s12" style="padding-top: 3pt;padding-left: 39pt;text-indent: 0pt;text-align: center;">
      <a name="a54">Requisito de contratación:</a>
    </p>
    <p style="padding-left: 39pt;text-indent: 0pt;text-align: center;">Esta es una cobertura accesoria; por lo que su contratación requiere que se tenga amparada una cobertura básica de la sección de Daños Materiales.</p>
    <p class="s12" style="padding-top: 11pt;padding-left: 39pt;text-indent: 0pt;text-align: center;">Periodo de Espera:</p>
    <p class="s15" style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">El período de espera para esta cobertura es de 45 (cuarenta y cinco) días naturales a partir de la fecha de la contratación o rehabilitación de la cobertura. Este plazo no se reiniciará en caso de renovación de la cobertura.</p>
    <p style="padding-top: 4pt;text-indent: 0pt;text-align: center;">
      <br />
    </p>
    <ol id="l18">
      <li data-list-text="A)">
        <p class="s21" style="padding-left: 74pt;text-indent: -17pt;line-height: 14pt;text-align: center;">Alcance</p>
        <p style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">Siempre que se haga constar la contratación de esta cobertura y de la cobertura básica que corresponda, <b>L A T I N O </b>cubrirá la reparación o sustitución por los <b>Daños </b>que sufra cualquiera de los neumáticos y/o rines instalados en el <b>Vehículo Asegurado </b>a consecuencia de un impacto directo en baches, topes irregularidades en el pavimento, asfalto y/o concreto hidráulico, banquetazo, pinchadura o <b>Daño </b>por objetos filosos que se encuentren en la vía pública, incluyendo el costo de la lineación y el balanceo, hasta por 2 (dos) <b>Eventos </b>durante la vigencia anual de la <b>Póliza </b>y por un máximo en cada <b>Evento </b>de hasta 4 (cuatro) neumáticos y/o rines. </p>
        <p style="text-indent: 0pt;text-align: center;">
          <br />
        </p>
        <p class="s15" style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">No se cubren los Daños en los neumáticos o rines causados por Incendio, robo, o intento de robo o Vandalismo.</p>
        <p style="padding-top: 11pt;padding-left: 39pt;text-indent: 0pt;text-align: justify;">En caso de sustitución, el neumático y/o rin dañado será reemplazado por uno con las mismas características de tamaño, alto y ancho <span class="s31">del originalmente instalado por el fabricante</span>
          <span class="s15"></span>del <b>Vehículo Asegurado </b>o con otro neumático y/o rin similar en características y en precio, en caso de no contar con el mismo.
        </p>
        <p style="text-indent: 0pt;text-align: center;">
          <br />
        </p>
        <p style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">De no contarse con ninguno de los dos anteriores, se indemnizará el monto equivalente al costo del neumático y/o rin dañado, incluyendo el costo de la alineación y el balanceo; si el costo total excede el <b>Límite Máximo de Responsabilidad </b>de la cobertura, se considerará a este último como la base de indemnización. </p>
      </li>
      <li data-list-text="B)">
        <p class="s21" style="padding-top: 11pt;padding-left: 74pt;text-indent: -17pt;line-height: 14pt;text-align: center;">Límite Máximo de Responsabilidad</p>
        <p style="padding-left: 39pt;text-indent: 0pt;line-height: 11pt;text-align: justify;">El <b>Límite Máximo de Responsabilidad </b>de <b>L A T I N O </b>para esta cobertura se establece en la </p>
        <p class="s13" style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">Carátula de la Póliza <span class="p">como </span>Suma Asegurada <span class="p">única para </span>TODOS <span class="p">los </span>Eventos <span class="p">cubiertos.</span>
        </p>
        <p style="text-indent: 0pt;text-align: center;">
          <br />
        </p>
        <p style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">Toda indemnización que <b>L A T I N O </b>pague, se reducirá en igual cantidad de la <b>Suma Asegurada</b>. Cuando sean varias las pérdidas ocasionadas durante el periodo de vigencia de la <b>Póliza</b>, en uno o varios <b>Evento</b>s, <b>L A T I N O </b>pagará la suma de las indemnizaciones correspondientes hasta agotar la <b>Suma Asegurada </b>contratada como <b>Límite Máximo de Responsabilidad</b>, éste no se rehabilita. </p>
        <p style="padding-top: 10pt;padding-left: 39pt;text-indent: 0pt;text-align: justify;">Para los periodos de vigencia continua de la <b>Póliza </b>mayores a un año, la cobertura se reinstalará anualmente. </p>
        <p style="padding-top: 2pt;text-indent: 0pt;text-align: center;">
          <br />
        </p>
      </li>
      <li data-list-text="C)">
        <p class="s21" style="padding-left: 74pt;text-indent: -17pt;text-align: center;">Deducible</p>
        <p style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">La cobertura Rueda Segura se contrata con la aplicación invariable en cada <b>Siniestro </b>de una cantidad a cargo del <b>Asegurado</b>, denominada <b>Deducible.</b>
        </p>
        <p style="padding-top: 2pt;text-indent: 0pt;text-align: center;">
          <br />
        </p>
        <p style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">El procedimiento para obtener el monto del <b>Deducible </b>aplicable es el siguiente: </p>
        <p style="text-indent: 0pt;text-align: center;">
          <br />
        </p>
        <p style="padding-left: 78pt;text-indent: -18pt;text-align: justify;">
          <span class="s32">1. </span>El <b>Deducible </b>resulta de la aplicación del 25% (veinticinco porciento) sobre el monto total que resulte de sumar el valor del o de los neumáticos y/o rines afectados y el costo de su instalación, alineación y balanceo.
        </p>
        <p style="text-indent: 0pt;text-align: center;">
          <br />
        </p>
      </li>
      <li data-list-text="D)">
        <p class="s21" style="padding-left: 74pt;text-indent: -17pt;text-align: center;">Exclusiones</p>
        <p class="s15" style="padding-top: 3pt;padding-left: 39pt;text-indent: 0pt;text-align: justify;">Queda entendido que, en adición a lo aplicable respecto a la Cláusula Exclusiones Generales y las Exclusiones de la cobertura básica de la sección de Daños Materiales, esta cobertura en ningún caso ampara:</p>
        <ol id="l19">
          <li data-list-text="1.">
            <p class="s15" style="padding-left: 81pt;text-indent: -21pt;text-align: justify;">Daños causados al neumático y/o rin por una incorrecta alineación o balanceo, o por encontrarse la dirección o suspensión del Vehículo Asegurado en mal estado.</p>
          </li>
          <li data-list-text="2.">
            <p class="s15" style="padding-top: 4pt;padding-left: 81pt;text-indent: -21pt;text-align: justify;">Daños causados por Incendio, robo, o intento de robo.</p>
          </li>
          <li data-list-text="3.">
            <p class="s15" style="padding-left: 81pt;text-indent: -21pt;text-align: justify;">Daños causados al neumático y/o rin por Vandalismo.</p>
          </li>
          <li data-list-text="4.">
            <p class="s15" style="padding-left: 81pt;text-indent: -21pt;text-align: justify;">Daños causados al neumático y/o rin por cualquier Daño causado antes de la entrada en vigor de esta cobertura o por defecto de fabricación.</p>
          </li>
          <li data-list-text="5.">
            <p class="s15" style="padding-left: 81pt;text-indent: -21pt;text-align: justify;">Daños causados al neumático y/o rin, en caso de que el Vehículo Asegurado haya sido utilizado después de una Avería inicial, independientemente de si dicho Daño estaba cubierto. Lo anterior, no aplica para llantas RUNFLAT.</p>
          </li>
          <li data-list-text="6.">
            <p class="s15" style="padding-left: 81pt;text-indent: -21pt;text-align: justify;">Daños causados al neumático, si se supera la caducidad del caucho especificada por el fabricante, y hasta un máximo de 5 años.</p>
          </li>
          <li data-list-text="7.">
            <p class="s15" style="padding-left: 81pt;text-indent: -21pt;text-align: justify;">Daños causados al neumático y/o rin por su desgaste normal, incluyendo desgaste irregular de los neumáticos y falta de mantenimiento.</p>
          </li>
          <li data-list-text="8.">
            <p class="s15" style="padding-left: 81pt;text-indent: -21pt;text-align: justify;">Daños causados al neumático y/o rin por circular fuera del camino o cuando éstos se encuentren en condiciones intransitables.</p>
          </li>
          <li data-list-text="9.">
            <p class="s15" style="padding-left: 81pt;text-indent: -21pt;text-align: justify;">Reparación o sustitución de neumáticos y/o rines diseñados para circular especialmente fuera del camino o en la nieve.</p>
          </li>
          <li data-list-text="10.">
            <p class="s15" style="padding-left: 81pt;text-indent: -21pt;text-align: justify;">Reparación o sustitución de neumáticos a los que se les haya sustituido la cubierta de rodamiento.</p>
          </li>
          <li data-list-text="11.">
            <p class="s15" style="padding-left: 81pt;text-indent: -21pt;text-align: justify;">Reparación o sustitución de neumáticos con un desgaste igual o superior al 75% de su vida útil, según informe técnico.</p>
          </li>
          <li data-list-text="12.">
            <p class="s15" style="padding-left: 81pt;text-indent: -21pt;text-align: justify;">Daños causados al neumático de repuesto (en caso de que sea de menor dimensión a las de uso regular) cuando se exceda el límite máximo de rodamiento determinado por el fabricante.</p>
            <p style="text-indent: 0pt;text-align: center;">
              <br />
            </p>
            <div class="textbox" style="background:#DEEAF6;">
              <p class="s19" style="padding-left: 360pt;text-indent: 13pt;text-align: right;">Sección: Robo Cobertura Básica</p>
              <p class="s20" style="padding-left: 5pt;text-indent: 0pt;line-height: 12pt;text-align: center;">CLÁUSULA 2.5. Robo Total.</p>
            </div>
          </li>
        </ol>
      </li>
    </ol>
    <p style="padding-left: 39pt;text-indent: 0pt;text-align: center;" />
    <ol id="l20">
      <ol id="l21">
        <ol id="l22">
          <li data-list-text="A)">
            <p class="s21" style="padding-top: 13pt;padding-left: 74pt;text-indent: -17pt;text-align: justify;">Alcance</p>
            <p style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">Siempre que se haga constar la contratación de esta cobertura, <b>L A T I N O </b>se obliga a amparar el <b>Robo Total </b>del <b>Vehículo Asegurado </b>y las pérdidas o <b>Daños </b>materiales que sufra a consecuencia de su <b>Robo Total</b>. </p>
            <p style="padding-top: 2pt;text-indent: 0pt;text-align: center;">
              <br />
            </p>
            <p style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">En adición, aun cuando no se contrate la cobertura de Daños Materiales quedarán amparados los</p>
            <p class="s13" style="padding-left: 39pt;text-indent: 0pt;line-height: 11pt;text-align: justify;">Daños <span class="p">ocasionados por los siguientes riesgos:</span>
            </p>
            <ol id="l23">
              <li data-list-text="1.">
                <p class="s13" style="padding-left: 81pt;text-indent: -21pt;line-height: 14pt;text-align: justify;">Incendio <span class="p">, rayo y explosión;</span>
                </p>
              </li>
              <li data-list-text="2.">
                <p style="padding-left: 81pt;text-indent: -21pt;text-align: justify;">Ciclón, huracán, tornado, vendavales, granizo, terremoto, erupción volcánica, alud, derrumbe de tierra o piedras, caída o derrumbe de construcciones, edificaciones, estructuras u otros objetos, caída de árboles o sus ramas e inundación;</p>
                <p style="padding-left: 2pt;text-indent: -3pt;text-align: center;">o, a</p>
                <p style="text-indent: 0pt;text-align: center;" />
              </li>
              <li data-list-text="3.">
                <p style="padding-left: 81pt;text-indent: -21pt;text-align: justify;">Actos de personas que tomen parte en paros, huelgas, disturbios de carácter obrer mítines, alborotos populares, motines o de personas mal intencionadas durante l</p>
                <p style="padding-top: 3pt;padding-left: 81pt;text-indent: 0pt;text-align: justify;">realización de tales actos, o bien ocasionados por las medidas de represión tomadas por las autoridades legalmente reconocidas con motivo de sus funciones que intervengan en dichos actos.</p>
              </li>
              <li data-list-text="4.">
                <p class="s13" style="padding-left: 81pt;text-indent: -21pt;text-align: justify;">Daños <span class="p">por transportación, varadura, hundimiento, </span>Incendio <span class="p">, explosión, </span>Colisión <span class="p">o </span>Vuelco <span class="p">, descarrilamiento o caída del medio de transporte en que el </span>Vehículo Asegurado <span class="p">sea trasladado; caída del vehículo sujeto a aseguramiento durante las maniobras de carga, transbordo o descarga, así como la contribución por </span>Avería gruesa <span class="p">o por cargos de Salvamento.</span>
                </p>
              </li>
            </ol>
          </li>
          <li data-list-text="B)">
            <p class="s21" style="padding-left: 81pt;text-indent: -21pt;line-height: 14pt;text-align: justify;">Límite Máximo de Responsabilidad</p>
            <p style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">Dependiendo del tipo de <b>Vehículo Asegurado</b>, esta cobertura podrá operar bajo el concepto de <span class="s9">Valor Convenido, Valor Comercial </span>
              <span class="s11">o </span>
              <span class="s9">Valor Factura</span>, por lo tanto, <b>L A T I N O</b>, se compromete a pagar conforme a lo establecido en la <b>Carátula de la Póliza </b>y en la Cláusula “Sumas Aseguradas y Bases de Indemnización”.
            </p>
            <p style="text-indent: 0pt;text-align: center;">
              <br />
            </p>
            <p style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">El <b>Límite Máximo de Responsabilidad </b>de <b>L A T I N O </b>para esta cobertura se establece en la <b>Carátula de la Póliza </b>y opera como <b>Suma Asegurada </b>única para los diversos riesgos que se amparan en esta cobertura. En ningún caso la suma de las indemnizaciones excederá de la <b>Suma Asegurada </b>contratada. </p>
            <p style="padding-top: 2pt;text-indent: 0pt;text-align: center;">
              <br />
            </p>
          </li>
          <li data-list-text="C)">
            <p class="s21" style="padding-left: 81pt;text-indent: -21pt;text-align: center;">Deducible</p>
            <p style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">La cobertura de Robo Total, se contrata con la aplicación invariable en cada <b>Siniestro </b>de una cantidad a cargo del <b>Asegurado</b>, denominada <b>Deducible</b>. </p>
            <p style="padding-top: 11pt;padding-left: 39pt;text-indent: 0pt;text-align: justify;">El procedimiento para obtener el monto del <b>Deducible </b>aplicable es el siguiente: </p>
            <p style="text-indent: 0pt;text-align: center;">
              <br />
            </p>
            <ol id="l24">
              <li data-list-text="1.">
                <p style="padding-left: 81pt;text-indent: -21pt;text-align: justify;">
                  <span class="s22">Tanto para Pérdidas Parciales como Pérdidas Totales: </span>ocasionadas con motivo del <b>Robo Total </b>del <b>Vehículo Asegurado</b>, el <b>Deducible </b>resulta de la aplicación del porcentaje de <b>Deducible </b>estipulado en la <b>Carátula de la Póliza </b>sobre la <b>Suma Asegurada </b>contratada e indicada en la misma.
                </p>
              </li>
              <li data-list-text="2.">
                <p style="padding-left: 81pt;text-indent: -21pt;text-align: justify;">
                  <span class="s22">En los casos de que haya recuperación </span>
                  <span class="s33">después de perpetrado el robo: </span>solamente se aplicará el <b>Deducible </b>contratado cuando <b>L A T I N O </b>realice algún pago por pérdidas o <b>Daños </b>parciales o totales ocasionados al <b>Vehículo Asegurado</b>.
                </p>
                <p style="padding-left: 81pt;text-indent: 0pt;text-align: justify;">El costo que se tenga que erogar por la pensión, piso o resguardo del <b>Vehículo Asegurado </b>en un corralón o lugar destinado para este fin, correrá a cargo del <b>Asegurado </b>y, por otra parte, el costo del traslado del <b>Vehículo Asegurado </b>correrá a cargo de <b>L A T I N O</b>, si ella efectuase la reparación. </p>
              </li>
              <li data-list-text="3.">
                <p class="s22" style="padding-left: 81pt;text-indent: -21pt;text-align: justify;">Inspección vehicular obligatoria: <span class="p">en caso de no realizar la inspección del vehículo asegurado señalada en la cláusula 5.16, se adicionarán al deducible contratado 30 puntos porcentuales.</span>
                </p>
              </li>
            </ol>
          </li>
          <li data-list-text="D)">
            <p class="s21" style="padding-top: 11pt;padding-left: 81pt;text-indent: -21pt;text-align: center;">Exclusiones</p>
            <p class="s15" style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">Queda entendido que, en adición a lo aplicable respecto a la Cláusula Exclusiones Generales, esta cobertura en ningún caso ampara:</p>
            <ol id="l25">
              <li data-list-text="1.">
                <p class="s25" style="padding-top: 11pt;padding-left: 81pt;text-indent: -21pt;text-align: justify;">El robo parcial cuando no sea a consecuencia del Robo Total, entendiéndose por tal, el robo de partes o accesorios del Vehículo Asegurado.</p>
              </li>
              <li data-list-text="2.">
                <p class="s15" style="padding-top: 10pt;padding-left: 81pt;text-indent: -21pt;text-align: center;">Cuando el Robo sea cometido por:</p>
                <ol id="l26">
                  <li data-list-text="2.1.">
                    <p class="s15" style="padding-left: 145pt;text-indent: -63pt;text-align: center;">Familiares del Asegurado o personas que dependan económicamente del mismo.</p>
                  </li>
                  <li data-list-text="2.2.">
                    <p class="s15" style="padding-left: 110pt;text-indent: -28pt;text-align: center;">Personas que aparezcan como Aseguradas en la Carátula de la Póliza.</p>
                  </li>
                  <li data-list-text="2.3.">
                    <p class="s15" style="padding-top: 3pt;padding-left: 109pt;text-indent: -28pt;text-align: justify;">Empleados o personas que presten servicio al Asegurado.</p>
                  </li>
                  <li data-list-text="2.4.">
                    <p class="s15" style="padding-left: 110pt;text-indent: -28pt;text-align: justify;">Personas cuyas acciones sean tendientes a la compraventa, arrendamiento o financiamiento del Vehículo Asegurado y/o,</p>
                  </li>
                  <li data-list-text="2.5.">
                    <p class="s15" style="padding-left: 110pt;text-indent: -28pt;text-align: justify;">Personas cuyas acciones tengan su origen o sea consecuencia de cualquier tipo de contrato o convenio mercantil de compraventa, financiamiento o renta diaria del Vehículo Asegurado.</p>
                  </li>
                  <li data-list-text="2.6.">
                    <p class="s15" style="padding-top: 4pt;padding-left: 110pt;text-indent: -28pt;text-align: justify;">Cuando el Asegurado sea una persona moral, se entenderá por familiar del Asegurado aquel que lo sea de los socios o accionistas, o de quienes tengan la titularidad de los derechos de dicha persona moral.</p>
                  </li>
                </ol>
              </li>
              <li data-list-text="3.">
                <p class="s15" style="padding-left: 81pt;text-indent: -21pt;text-align: justify;">Cuando el robo tenga su origen o sea consecuencia del delito de Fraude.</p>
              </li>
              <li data-list-text="4.">
                <p class="s15" style="padding-left: 81pt;text-indent: -21pt;text-align: justify;">El incendio cuando sea a consecuencia de una Colisión y/o Vuelco y no exista Robo Total previo.</p>
              </li>
              <li data-list-text="5.">
                <p class="s15" style="padding-left: 81pt;text-indent: -21pt;text-align: justify;">La entrega física del vehículo o partes de éste o documentos que acrediten la propiedad como pago de algún acto ilícito como los delitos de secuestro o extorsión.</p>
              </li>
            </ol>
          </li>
        </ol>
      </ol>
    </ol>
    <p style="text-indent: 0pt;text-align: center;">
      <br />
    </p>
    <div class="textbox" style="background:#DEEAF6;">
      <p class="s19" style="padding-left: 345pt;text-indent: 28pt;text-align: right;">Sección: Robo Cobertura Accesoria</p>
      <p class="s20" style="padding-left: 5pt;text-indent: 0pt;line-height: 12pt;text-align: center;">CLÁUSULA 2.6. Robo Parcial.</p>
    </div>
    <p style="padding-left: 39pt;text-indent: 0pt;text-align: center;" />
    <p class="s12" style="padding-top: 10pt;padding-left: 39pt;text-indent: 0pt;text-align: justify;">
      <a name="a55">Requisitos de contratación:</a>
    </p>
    <p style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">Esta es una cobertura accesoria; por lo que su contratación requiere que se tenga amparada la cobertura básica de Robo Total.</p>
    <p style="text-indent: 0pt;text-align: center;">
      <br />
    </p>
    <ol id="l27">
      <li data-list-text="A)">
        <p class="s21" style="padding-left: 74pt;text-indent: -17pt;text-align: center;">Alcance</p>
        <p style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">Siempre que se hagan constar la contratación de esta cobertura y de la cobertura básica que corresponde, <b>L A T I N O </b>se obliga a cubrir el robo parcial de las partes y componentes interiores y exteriores del <b>Vehículo Asegurado </b>instados de planta, de acuerdo con la definición de <b>Vehículo Asegurado </b>especificada en la Cláusula “Definiciones” de las <b>Condiciones Generales</b>, y que éste no se derive de un <b>Robo Total </b>del <b>Vehículo Asegurado</b>. </p>
        <p style="text-indent: 0pt;text-align: center;">
          <br />
        </p>
      </li>
      <li data-list-text="B)">
        <p class="s21" style="padding-left: 74pt;text-indent: -17pt;line-height: 14pt;text-align: center;">Límite Máximo de Responsabilidad</p>
        <p style="padding-left: 39pt;text-indent: 0pt;line-height: 11pt;text-align: justify;">El <b>Límite Máximo de Responsabilidad </b>de <b>L A T I N O </b>será del 10% (diez por ciento) sobre el </p>
        <p class="s13" style="padding-left: 39pt;text-indent: 0pt;line-height: 11pt;text-align: justify;">Límite Máximo de Responsabilidad <span class="p">para la cobertura de </span>Robo Total <span class="p">sin exceder el monto de</span>
        </p>
        <p class="s11" style="padding-left: 39pt;text-indent: 0pt;line-height: 94%;text-align: justify;">
          <a name="a56">$100,000 pesos (cien mil 00/100 M.N.) y se indemnizará de conformidad a lo establecido en la Cláusula &quot;Sumas Aseguradas y Bases de Indemnización&quot;, en la sección correspondiente a pérdidas parciales, de las </a>
          <b>Condiciones Generales</b>.
        </p>
        <p style="padding-top: 11pt;padding-left: 39pt;text-indent: 0pt;text-align: justify;">Toda indemnización que <b>L A T I N O </b>pague, se reducirá en igual cantidad de la <b>Suma Asegurada</b>. En ningún caso la suma de las indemnizaciones excederá de la <b>Suma Asegurada </b>contratada. </p>
        <p style="padding-top: 1pt;text-indent: 0pt;text-align: center;">
          <br />
        </p>
        <p style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">
          <span class="s22">AVISO A LAS AUTORIDADES</span>
          <span style=" color: #1F4E79;">. </span>En adición a lo pactado en la Cláusula &quot;Obligaciones del <b>Asegurado </b>en caso de <b>Siniestro</b>&quot;, como requisito invariable para el pago de las reclamaciones relacionadas a esta cobertura, el <b>Asegurado </b>deberá presentar formal querella o denuncia ante las autoridades competentes, tan pronto como tenga conocimiento del robo parcial del <b>Vehículo Asegurado </b>que sea motivo de la reclamación o, derivado de impedimentos por causa mayor para
        </p>
        <p style="padding-top: 3pt;padding-left: 39pt;text-indent: 0pt;text-align: justify;">hacerlo, a más tardar 5 (cinco) días posteriores a la ocurrencia del mismo. Adicional a lo especificado en esta cobertura, se aplicarán todos los términos y condiciones que se estipulan en las <b>Condiciones Generales </b>que correspondan. </p>
      </li>
      <li data-list-text="C)">
        <p class="s21" style="padding-top: 11pt;padding-left: 74pt;text-indent: -17pt;text-align: justify;">Deducible</p>
        <p style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">La cobertura de Robo Parcial se contrata con la aplicación invariable en cada <b>Siniestro </b>de una cantidad a cargo del <b>Asegurado</b>, denominada <b>Deducible</b>. </p>
        <p style="padding-top: 4pt;padding-left: 39pt;text-indent: 0pt;text-align: justify;">El procedimiento para obtener el monto del <b>Deducible </b>aplicable es el siguiente: </p>
        <p style="text-indent: 0pt;text-align: center;">
          <br />
        </p>
        <ol id="l28">
          <li data-list-text="1.">
            <p style="padding-left: 81pt;text-indent: -21pt;line-height: 93%;text-align: justify;">El <b>Deducible </b>resulta de la aplicación del porcentaje del <b>Deducible </b>de la cobertura de Robo Total estipulado en la <b>Carátula de la Póliza </b>sobre el monto de la indemnización. </p>
          </li>
          <li data-list-text="2.">
            <p style="padding-left: 81pt;text-indent: -21pt;text-align: justify;">En reclamaciones por robo de cristales, el monto que corresponda al 20% del costo total del valor del o de los cristales afectados.</p>
          </li>
        </ol>
      </li>
      <li data-list-text="D)">
        <p class="s21" style="padding-top: 11pt;padding-left: 74pt;text-indent: -17pt;text-align: justify;">Exclusiones</p>
        <p class="s15" style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">Queda entendido que, en adición a lo aplicable respecto a la Cláusula Exclusiones Generales y las Exclusiones de la cobertura de Robo Total, esta cobertura no cubre:</p>
        <ol id="l29">
          <li data-list-text="1.">
            <p class="s15" style="padding-left: 81pt;text-indent: -21pt;text-align: justify;">Equipo Especial que tenga instalado el Vehículo Asegurado. Cualquier otro, accesorio, rótulo, Conversión, Adaptación, parte o modificación a la estructura, instalada a petición del comprador o propietario o por las Agencias, distribuidoras, auto instalados o por terceros.</p>
          </li>
          <li data-list-text="2.">
            <p class="s15" style="padding-left: 81pt;text-indent: -21pt;text-align: justify;">El equipo que carezca de factura que cumpla con los requisitos fiscales o que siendo de procedencia extranjera no cuente con los comprobantes de propiedad y/o pedimento de importación, así como el pago de los aranceles de acuerdo con la legislación vigente en la fecha de adquisición del bien.</p>
          </li>
          <li data-list-text="3.">
            <p class="s15" style="padding-left: 81pt;text-indent: -21pt;text-align: justify;">Los Daños materiales que sufra la llave del Vehículo Asegurado.</p>
          </li>
        </ol>
      </li>
    </ol>
    <p style="padding-top: 8pt;text-indent: 0pt;text-align: center;">
      <br />
    </p>
    <div class="textbox" style="background:#DEEAF6;">
      <p class="s19" style="text-indent: 0pt;line-height: 11pt;text-align: right;">Sección: Daños Materiales y Robo</p>
      <p class="s19" style="text-indent: 0pt;line-height: 11pt;text-align: right;">Cobertura Accesoria</p>
      <p class="s20" style="padding-left: 5pt;text-indent: 0pt;line-height: 13pt;text-align: center;">CLÁUSULA 2.7. Agencia + 5</p>
      <p class="s20" style="padding-left: 5pt;text-indent: 0pt;text-align: center;">(Reparación en Agencia).</p>
    </div>
    <p style="padding-left: 39pt;text-indent: 0pt;text-align: center;" />
    <p class="s12" style="padding-top: 10pt;padding-left: 39pt;text-indent: 0pt;text-align: justify;">
      <a name="a57">Requisitos de contratación:</a>
    </p>
    <p style="padding-left: 39pt;text-indent: 0pt;text-align: center;">Esta es una cobertura accesoria; por lo que su contratación requiere que se tenga amparada la cobertura básica de Daños Materiales, o las coberturas básicas de Daños Materiales y Robo Total.</p>
    <p style="text-indent: 0pt;text-align: center;">
      <br />
    </p>
    <ol id="l30">
      <li data-list-text="A)">
        <p class="s21" style="padding-left: 74pt;text-indent: -17pt;text-align: justify;">Alcance</p>
        <p style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">Siempre que se haga constar la contratación de esta cobertura y de la(s) cobertura(s) básica(s) que corresponde(n) y en caso de <b>Siniestro </b>procedente en términos de este seguro, en el que el <b>Vehículo Asegurado </b>sea determinado por <b>L A T I N O </b>como <b>Pérdida Parcial</b>, de conformidad con lo establecido en la Cláusula &quot;Definiciones&quot; de estas <b>Condiciones Generales</b>, <b>L A T I N O </b>se obliga a realizar la reparación del <b>Vehículo Asegurado </b>en la agencia distribuidora de la marca, elegida por el <b>Asegurado </b>y con la que <b>L A T I N O </b>tenga convenio, por los <b>Daños </b>que sufra el <b>Vehículo Asegurado </b>ocasionados por algunos de los riesgos que se mencionan en las coberturas de Daños Materiales y/o Robo Total, de acuerdo con lo establecido en la Cláusula de “Sumas Aseguradas y Bases de Indemnización”. </p>
        <p style="text-indent: 0pt;text-align: center;">
          <br />
        </p>
        <p style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">Excepción hecha al párrafo anterior, para el caso de rotura de cristales, sin importar el año de fabricación del <b>Vehículo Asegurado</b>, la reparación, el cambio o reposición del o de los cristales afectados se efectuará a través de los Proveedores Especializados denominados Cristaleras </p>
        <p style="padding-top: 3pt;padding-left: 39pt;text-indent: 0pt;text-align: justify;">autorizados por <b>L A T I N O </b>y con quienes tenga convenio. </p>
        <p style="padding-top: 11pt;padding-left: 39pt;text-indent: 0pt;text-align: justify;">En caso de que en el lugar de residencia del <b>Asegurado </b>no exista agencia distribuidora de la marca o <b>L A T I N O </b>no tenga convenio con la Agencia distribuidora, los centros de reparación serán los talleres más cercanos que presten servicio de manera supletoria a la marca y que estén reconocidos y autorizados por la misma. </p>
        <p style="padding-top: 4pt;padding-left: 39pt;text-indent: 0pt;text-align: justify;">Esta cobertura aplica para vehículos con una antigüedad máxima de <b>5 (cinco) años </b>contados a partir de la fecha de facturación de origen. </p>
        <p style="padding-top: 11pt;padding-left: 39pt;text-indent: 0pt;text-align: justify;">En caso de las renovaciones, esta cobertura estará vigente máximo hasta la anualidad en la que el <b>Vehículo Asegurado </b>cumpla 5 (cinco) años de antigüedad de acuerdo con la fecha de facturación de origen. </p>
        <p style="text-indent: 0pt;text-align: center;">
          <br />
        </p>
      </li>
      <li data-list-text="B)">
        <p class="s21" style="padding-left: 74pt;text-indent: -17pt;text-align: justify;">Límite Máximo de Responsabilidad</p>
        <p style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">El <b>Límite Máximo de Responsabilidad </b>de <b>L A T I N O </b>para esta cobertura se establece dentro de la cobertura de Daños Materiales para el caso de que los <b>Daños </b>sufridos por el <b>Vehículo Asegurado </b>hayan sido ocasionados por alguno de los riesgos amparados por dicha cobertura, sean determinados por <b>L A T I N O </b>como <b>Pérdida Parcial </b>y sean susceptibles de reparación, y dentro de la cobertura de Robo Total para el caso de que el <b>Vehículo Asegurado </b>sea recuperado y presente <b>Daños </b>materiales los cuales sean susceptibles de reparación y se amparen mediante la cobertura de Robo Total. </p>
        <p style="padding-top: 2pt;text-indent: 0pt;text-align: center;">
          <br />
        </p>
      </li>
      <li data-list-text="C)">
        <p class="s21" style="padding-left: 74pt;text-indent: -17pt;line-height: 14pt;text-align: justify;">Deducible</p>
        <p style="padding-left: 39pt;text-indent: 0pt;line-height: 12pt;text-align: justify;">No opera</p>
        <p style="padding-top: 2pt;text-indent: 0pt;text-align: center;">
          <br />
        </p>
      </li>
      <li data-list-text="D)">
        <p class="s21" style="padding-left: 74pt;text-indent: -17pt;text-align: justify;">Exclusiones</p>
      </li>
    </ol>
    <p class="s15" style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">Queda entendido que, en adición a lo aplicable respecto a la Cláusula Exclusiones Generales, aplican las Exclusiones de la cobertura de Daños Materiales y las Exclusiones de la cobertura de Robo Total.</p>
    <p style="text-indent: 0pt;text-align: center;">
      <br />
    </p>
    <div class="textbox" style="background:#DEEAF6;">
      <p class="s19" style="text-indent: 0pt;line-height: 11pt;text-align: right;">Sección: Daños Materiales y Robo.</p>
      <p class="s19" style="text-indent: 0pt;line-height: 11pt;text-align: right;">Cobertura Accesoria</p>
      <p class="s20" style="padding-left: 5pt;text-indent: 0pt;line-height: 13pt;text-align: center;">CLÁUSULA 2.8. + Valor</p>
      <p class="s20" style="padding-left: 5pt;text-indent: 0pt;text-align: center;">(Beneficio en caso de Pérdida Total)</p>
    </div>
    <p style="padding-left: 39pt;text-indent: 0pt;text-align: center;" />
    <p class="s12" style="padding-top: 12pt;padding-left: 39pt;text-indent: 0pt;text-align: justify;">
      <a name="a58">Requisitos de contratación:</a>
    </p>
    <p style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">Esta es una cobertura accesoria; por lo que su contratación requiere que se tenga(n) amparada(s) la(s) cobertura(s) básica(s) de la(s) sección(es) de Daños Materiales y/o Robo.</p>
    <p style="padding-top: 2pt;text-indent: 0pt;text-align: center;">
      <br />
    </p>
    <ol id="l31">
      <li data-list-text="A)">
        <p class="s21" style="padding-left: 74pt;text-indent: -17pt;text-align: justify;">Alcance</p>
        <p style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">Siempre que se haga constar la contratación de esta cobertura y de la(s) cobertura(s) básica(s) que corresponde(n), y que <b>L A T I N O </b>haya decretado la <b>Pérdida Total </b>del <b>Vehículo Asegurado </b>en la cobertura básica de la sección de Daños Materiales o Robo, la cobertura Recuperación del Daño: </p>
        <ol id="l32">
          <li data-list-text="1.">
            <p style="padding-top: 11pt;padding-left: 81pt;text-indent: -21pt;text-align: justify;">Cubre el pago del 10% (diez por ciento) del <b>Valor Comercial </b>del <b>Vehículo Asegurado</b>. </p>
          </li>
          <li data-list-text="2.">
            <p style="padding-left: 81pt;text-indent: -21pt;text-align: justify;">Aplica para vehículos con una antigüedad máxima de <b>10 (diez) años </b>contados a partir de la fecha de facturación de origen del <b>Vehículo Asegurado</b>, y hasta el momento de la contratación o renovación. </p>
            <ol id="l33">
              <li data-list-text="3.">
                <p class="s15" style="padding-left: 81pt;text-indent: -21pt;text-align: justify;">No se cubren Vehículos de Salvamento o Vehículos Recuperados de robo.</p>
              </li>
            </ol>
          </li>
        </ol>
      </li>
      <li data-list-text="B)">
        <p class="s21" style="padding-top: 11pt;padding-left: 81pt;text-indent: -21pt;text-align: justify;">Límite Máximo de Responsabilidad</p>
        <p style="padding-top: 3pt;padding-left: 39pt;text-indent: 0pt;text-align: justify;">El <b>Límite Máximo de Responsabilidad </b>de <b>L A T I N O </b>para esta cobertura es el pago del 10% (diez por ciento) del <b>Valor Comercial </b>del <b>Vehículo Asegurado </b>al momento de la ocurrencia del <b>Siniestro</b>. </p>
        <p style="padding-top: 2pt;text-indent: 0pt;text-align: center;">
          <br />
        </p>
      </li>
      <li data-list-text="C)">
        <p class="s21" style="padding-left: 81pt;text-indent: -21pt;text-align: justify;">Deducible</p>
        <p style="padding-top: 4pt;padding-left: 39pt;text-indent: 0pt;text-align: justify;">La cobertura de Recuperación del Daño se contrata con la aplicación invariable en cada <b>Siniestro</b>
        </p>
        <p style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">de una cantidad a cargo del <b>Asegurado</b>, denominada <b>Deducible</b>. </p>
        <p style="text-indent: 0pt;text-align: center;">
          <br />
        </p>
        <p style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">El procedimiento para obtener el monto del <b>Deducible </b>aplicable es descrito en la cobertura básica de la sección de Daños Materiales o Robo, que se afecte. </p>
        <p style="text-indent: 0pt;text-align: center;">
          <br />
        </p>
      </li>
      <li data-list-text="D)">
        <p class="s21" style="padding-left: 81pt;text-indent: -21pt;text-align: justify;">Exclusiones</p>
        <p class="s15" style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">Queda entendido que, en adición a lo aplicable respecto a la Cláusula Exclusiones Generales y las Exclusiones de las coberturas básicas de las secciones de Daños Materiales y Robo, esta cobertura:</p>
        <ol id="l34">
          <li data-list-text="1.">
            <p class="s15" style="padding-left: 81pt;text-indent: -21pt;text-align: justify;">No aplica para vehículos de más de diez años de antigüedad, según datos de la factura de origen del Vehículo Asegurado al momento de la contratación de la Póliza.</p>
          </li>
          <li data-list-text="2.">
            <p class="s15" style="padding-left: 81pt;text-indent: -21pt;text-align: justify;">No aplica para Vehículos Asegurados a Valor Convenido o Valor Factura.</p>
          </li>
          <li data-list-text="3.">
            <p class="s15" style="padding-left: 81pt;text-indent: -21pt;text-align: justify;">No se cubren Vehículos de Salvamento o Vehículos Recuperados de robo.</p>
          </li>
        </ol>
      </li>
    </ol>
    <p style="text-indent: 0pt;text-align: center;">
      <br />
    </p>
    <div class="textbox" style="background:#DEEAF6;">
      <p class="s19" style="text-indent: 0pt;line-height: 11pt;text-align: right;">Sección: Daños Materiales y Robo.</p>
      <p class="s19" style="text-indent: 0pt;line-height: 11pt;text-align: right;">Cobertura Accesoria</p>
      <p class="s20" style="padding-left: 5pt;text-indent: 0pt;line-height: 13pt;text-align: center;">CLÁUSULA 2.9. Deducible 0</p>
      <p class="s20" style="padding-left: 5pt;text-indent: 0pt;text-align: center;">(Eliminación de Deducible por Pérdida Total).</p>
    </div>
    <p style="padding-left: 39pt;text-indent: 0pt;text-align: center;" />
    <p class="s12" style="padding-top: 12pt;padding-left: 39pt;text-indent: 0pt;text-align: justify;">
      <a name="a59">Requisitos de contratación:</a>
    </p>
    <p style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">Esta es una cobertura accesoria; por lo que su contratación requiere que se tenga(n) amparada(s) la(s) cobertura(s) básica(s) de la sección(es) de Daños Materiales y/o Robo.</p>
    <p style="padding-top: 2pt;text-indent: 0pt;text-align: center;">
      <br />
    </p>
    <ol id="l35">
      <li data-list-text="A)">
        <p class="s21" style="padding-left: 74pt;text-indent: -17pt;text-align: justify;">Alcance</p>
        <p style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">Siempre que se haga constar la contratación de esta cobertura y de la(s) cobertura(s) básica(s) que corresponde(n), <b>L A T I N O </b>se obliga a cubrir la exención del <b>Deducible </b>al <b>Asegurado </b>al momento del <b>Siniestro</b>, en caso de que el <b>Vehículo Asegurado </b>sea declarado e indemnizado como <b>Pérdida Total</b>. </p>
        <p style="padding-top: 11pt;padding-left: 39pt;text-indent: 0pt;text-align: justify;">Para efectos de la presente cobertura se considerará <b>Pérdida Total</b>: </p>
        <p style="text-indent: 0pt;text-align: center;">
          <br />
        </p>
        <ol id="l36">
          <li data-list-text="1.">
            <p style="padding-left: 81pt;text-indent: -21pt;text-align: justify;">Cuando el importe de la reparación de los <b>Daños </b>sufridos por el <b>Vehículo Asegurado</b>, incluyendo mano de obra, refacciones y materiales necesarios para su reparación conforme a presupuesto validado, realizado y/o autorizado por <b>L A T I N O</b>, a consecuencia de los riesgos amparados en la cobertura de Daños Materiales exceda del 75% del valor contratado para el <b>Vehículo Asegurado </b>al momento del <b>Siniestro</b>, o a petición del <b>Asegurado </b>cuando los <b>Daños </b>sean mayores al 50% y menores al 75% del <b>Límite Máximo de Responsabilidad </b>a la fecha del <b>Siniestro</b>, o; </p>
          </li>
          <li data-list-text="2.">
            <p style="padding-left: 81pt;text-indent: -21pt;text-align: justify;">De forma independiente a los porcentajes de los <b>Daños</b>, cuando se emita dictamen del perito y avalúo realizado y validado por <b>L A T I N O</b>, que determine técnicamente la inviabilidad de la reparación del <b>Vehículo Asegurado </b>o; </p>
          </li>
          <li data-list-text="3.">
            <p style="padding-left: 81pt;text-indent: -21pt;line-height: 11pt;text-align: justify;">El <b>Robo Total </b>del <b>Vehículo Asegurado </b>o; </p>
          </li>
          <li data-list-text="4.">
            <p style="padding-top: 3pt;padding-left: 81pt;text-indent: -21pt;text-align: center;">Cuando las pérdidas o <b>Daños </b>sufridos por el <b>Vehículo Asegurado </b>a consecuencia del </p>
          </li>
        </ol>
        <p class="s13" style="padding-left: 81pt;text-indent: 0pt;text-align: center;">Robo Total <span class="p">excedan del 75% del valor contratado del </span>Vehículo Asegurado <span class="p">.</span>
        </p>
        <p style="text-indent: 0pt;text-align: center;">
          <br />
        </p>
        <p style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">La eliminación de <b>Deducible </b>se aplicará en las siguientes <b>coberturas</b>: </p>
        <p class="s8" style="padding-top: 4pt;padding-left: 109pt;text-indent: -49pt;text-align: justify;">2.9.1 Exención de Deducible por Pérdida Total de las coberturas básicas de la sección Daños Materiales. <span class="p">A consecuencia de los riesgos amparados por la cobertura básica de la sección de Daños Materiales.</span>
        </p>
        <p style="padding-left: 109pt;text-indent: -49pt;text-align: justify;">
          <span class="s8">2.9.2. Exención de Deducible por Pérdida Total de la cobertura de Robo Total. </span>A consecuencia del <b>Robo Total </b>o <b>Pérdida Total </b>del <b>Vehículo Asegurado </b>a consecuencia de los riesgos amparados por la cobertura de Robo Total.
        </p>
        <p style="text-indent: 0pt;text-align: center;">
          <br />
        </p>
        <p class="s13" style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">L A T I N O <span class="p">, indemnizará al momento de pagar la </span>Pérdida Total <span class="p">del </span>Vehículo Asegurado <span class="p">, mediante la NO aplicación del </span>Deducible <span class="p">correspondiente a la cobertura afectada, siempre y cuando se tenga contratada la cobertura 2.9.1. Exención de Deducible por Pérdida Total de la cobertura básica de la sección Daños Materiales y/o 2.9.2. Exención de Deducible por Pérdida Total de la cobertura básica de Robo Total.</span>
        </p>
        <p style="padding-top: 2pt;text-indent: 0pt;text-align: center;">
          <br />
        </p>
      </li>
      <li data-list-text="B)">
        <p class="s21" style="padding-left: 81pt;text-indent: -21pt;line-height: 14pt;text-align: center;">Límite Máximo de Responsabilidad</p>
        <p style="padding-left: 39pt;text-indent: 0pt;line-height: 11pt;text-align: center;">El <b>Límite Máximo de Responsabilidad </b>de <b>L A T I N O </b>para esta cobertura es el pago del </p>
        <p class="s9" style="padding-left: 39pt;text-indent: 0pt;line-height: 12pt;text-align: center;">
          <a name="a60">Deducible </a>
          <span class="s11">que se tenga contratado en la cobertura afectada correspondiente.</span>
        </p>
      </li>
      <li data-list-text="C)">
        <p class="s21" style="padding-top: 8pt;padding-left: 81pt;text-indent: -21pt;line-height: 14pt;text-align: center;">Deducible</p>
        <p style="padding-left: 39pt;text-indent: 0pt;line-height: 11pt;text-align: center;">No opera</p>
      </li>
      <li data-list-text="D)">
        <p class="s21" style="padding-top: 9pt;padding-left: 81pt;text-indent: -21pt;text-align: justify;">Exclusiones</p>
        <p class="s15" style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">Queda entendido que, en adición a lo aplicable respecto a la Cláusula Exclusiones Generales y las Exclusiones de la cobertura básica de las secciones de Daños Materiales y Robo, esta cobertura:</p>
        <ol id="l37">
          <li data-list-text="1.">
            <p class="s15" style="padding-top: 11pt;padding-left: 81pt;text-indent: -21pt;text-align: justify;">No exenta al Asegurado de la aplicación del Deducible si el Vehículo Asegurado NO es declarado e indemnizado como Pérdida Total a consecuencia de los riesgos de Daños materiales o Robo Total.</p>
          </li>
          <li data-list-text="2.">
            <p class="s15" style="padding-left: 81pt;text-indent: -21pt;text-align: justify;">No exenta al Asegurado de la aplicación del Deducible si se efectúa por parte de LATINO un pago de Daños.</p>
          </li>
          <li data-list-text="3.">
            <p class="s15" style="padding-left: 81pt;text-indent: -21pt;text-align: justify;">No exenta al Asegurado de la aplicación del Deducible en cualquier otra cobertura distinta a la cobertura básica de la sección de Daños Materiales o Robo.</p>
          </li>
          <li data-list-text="4.">
            <p class="s15" style="padding-left: 81pt;text-indent: -21pt;text-align: justify;">No opera en caso de que el Vehículo Asegurado sea recuperado y presente Daños materiales y/o desvalijamiento.</p>
          </li>
        </ol>
      </li>
    </ol>
    <p style="padding-top: 7pt;text-indent: 0pt;text-align: center;">
      <br />
    </p>
    <div class="textbox" style="background:#DEEAF6;">
      <p class="s19" style="text-indent: 0pt;line-height: 11pt;text-align: right;">Sección: Daños Materiales, Robo y Responsabilidad Civil</p>
      <p class="s19" style="text-indent: 0pt;line-height: 11pt;text-align: right;">Cobertura Accesoria</p>
      <p class="s20" style="padding-left: 5pt;text-indent: 0pt;line-height: 13pt;text-align: center;">CLÁUSULA 2.10. Adaptaciones, Conversiones y Equipo Especial.</p>
    </div>
    <p style="padding-left: 39pt;text-indent: 0pt;text-align: center;" />
    <p style="text-indent: 0pt;text-align: center;">
      <br />
    </p>
    <p class="s12" style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">
      <a name="a61">Requisitos de contratación:</a>
    </p>
    <p style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">Esta es una cobertura accesoria; por lo que su contratación requiere que se tenga(n) amparada(s) la(s) cobertura(s) básica(s) de la sección(es) de Daños Materiales y/o Robo y/o Responsabilidad Civil.</p>
    <p style="padding-top: 3pt;text-indent: 0pt;text-align: center;">
      <br />
    </p>
    <ol id="l38">
      <li data-list-text="A)">
        <p class="s21" style="padding-left: 81pt;text-indent: -24pt;line-height: 14pt;text-align: center;">Alcance</p>
        <p style="padding-left: 39pt;text-indent: 0pt;line-height: 12pt;text-align: center;">Siempre que se haga constar la contratación de esta cobertura y de las coberturas básicas que</p>
        <p style="padding-top: 3pt;padding-left: 39pt;text-indent: 0pt;text-align: justify;">corresponden, <b>L A T I N O </b>se obliga a cubrir uno, varios o todos los siguientes riesgos, de acuerdo con lo que quede estipulado en la <b>Carátula de la Póliza</b>. </p>
        <p style="padding-top: 3pt;text-indent: 0pt;text-align: center;">
          <br />
        </p>
        <ol id="l39">
          <ol id="l40">
            <ol id="l41">
              <li data-list-text="2.10.1.">
                <p class="s11" style="padding-left: 102pt;text-indent: -42pt;text-align: justify;">
                  <span class="s12">Los Daños materiales </span>
                  <span class="p">que sufran la(s) </span>
                  <span class="s13">Adaptación(es)</span>
                  <span class="p">, </span>
                  <span class="s13">Conversión(es) </span>
                  <span class="p">y/o </span>
                  <span class="s13">Equipo </span>
                  <b>Especial </b>siempre y cuando se encuentre(n) instalado(s) en el <b>Vehículo Asegurado </b>al momento del <b>Siniestro</b>, a consecuencia de los riesgos descritos en la cobertura básica de la sección de Daños Materiales, siempre y cuando la cobertura básica sea contratada, aplicándose la misma base del <b>Deducible </b>y <b>Exclusiones </b>de dicha cobertura, y/o;
                </p>
              </li>
              <li data-list-text="2.10.2.">
                <p style="padding-top: 11pt;padding-left: 102pt;text-indent: -42pt;text-align: justify;">
                  <span class="s12">El Robo Total </span>que sufran la(s) <b>Adaptación(es), Conversión(es) </b>y/o <b>Equipo Especial </b>siempre y cuando se encuentre(n) instalado(s) en el <b>Vehículo Asegurado </b>al momento del <b>Siniestro</b>, a consecuencia de los riesgos descritos en la cobertura de Robo Total, siempre y cuando esta cobertura sea contratada, aplicándose la misma base del <b>Deducible </b>y <b>Exclusiones </b>de dicha cobertura, y/o;
                </p>
                <p style="text-indent: 0pt;text-align: center;">
                  <br />
                </p>
              </li>
              <li data-list-text="2.10.3.">
                <p style="padding-left: 102pt;text-indent: -42pt;text-align: justify;">
                  <span class="s12">La responsabilidad civil </span>por <b>Daños </b>a <b>Terceros </b>en sus bienes y personas que ocasione(n) la(s) siguiente(s) <b>Adaptación(es)</b>, <b>Conversión(es) </b>y/o <b>Equipo Especial</b>, siempre y cuando se encuentre(n) instalado(s) en el <b>Vehículo Asegurado </b>al momento del <b>Siniestro</b>, a consecuencia de los riesgos descritos en la cobertura de
                </p>
              </li>
            </ol>
          </ol>
        </ol>
        <p style="padding-left: 102pt;text-indent: 0pt;text-align: justify;">R.C. Terceros, siempre y cuando esta cobertura sea contratada, aplicándose la misma base del <b>Deducible </b>y <b>Exclusiones </b>de dicha cobertura, y hasta el mismo <b>Límite Máximo de Responsabilidad </b>contratado en esta cobertura. </p>
        <p style="text-indent: 0pt;text-align: center;">
          <br />
        </p>
        <ol id="l42">
          <li data-list-text="1.">
            <p class="s36" style="padding-left: 124pt;text-indent: -21pt;text-align: center;">Tumbaburros</p>
          </li>
          <li data-list-text="2.">
            <p class="s36" style="padding-left: 124pt;text-indent: -21pt;text-align: center;">Malacate (Winch)</p>
          </li>
          <li data-list-text="3.">
            <p class="s36" style="padding-left: 124pt;text-indent: -21pt;text-align: center;">Bola de Arrastre</p>
          </li>
          <li data-list-text="4.">
            <p class="s36" style="padding-left: 124pt;text-indent: -21pt;text-align: center;">Cola de pato/alerón/spoiler</p>
          </li>
          <li data-list-text="5.">
            <p class="s36" style="padding-left: 124pt;text-indent: -21pt;text-align: center;">Estribos</p>
          </li>
          <li data-list-text="6.">
            <p class="s36" style="padding-left: 124pt;text-indent: -21pt;text-align: center;">Faldones</p>
          </li>
          <li data-list-text="7.">
            <p class="s36" style="padding-left: 124pt;text-indent: -21pt;text-align: center;">Tirones</p>
          </li>
          <li data-list-text="8.">
            <p class="s36" style="padding-left: 124pt;text-indent: -21pt;text-align: center;">Faros superiores</p>
          </li>
          <li data-list-text="9.">
            <p class="s36" style="padding-left: 124pt;text-indent: -21pt;text-align: center;">Cantoneras</p>
          </li>
          <li data-list-text="10.">
            <p class="s36" style="padding-left: 123pt;text-indent: -21pt;text-align: center;">Roll bar</p>
          </li>
          <li data-list-text="11.">
            <p class="s36" style="padding-left: 123pt;text-indent: -21pt;text-align: center;">Canastilla de equipaje de toldo</p>
          </li>
          <li data-list-text="12.">
            <p class="s36" style="padding-left: 123pt;text-indent: -21pt;text-align: center;">Extensores de platón</p>
          </li>
          <li data-list-text="13.">
            <p class="s36" style="padding-left: 123pt;text-indent: -21pt;text-align: center;">Rack para bicicletas</p>
          </li>
        </ol>
        <p style="text-indent: 0pt;text-align: center;">
          <br />
        </p>
        <p class="s36" style="padding-left: 102pt;text-indent: 0pt;text-align: justify;">Salvo pacto en contrario, <span class="s37">NO estará amparada la responsabilidad civil por Daños a Terceros en sus bienes y/o en sus personas por la carga que transporta(n) la(s) Adaptación(es), Conversión(es) y/o Equipo Especial anteriormente listado</span>
          <span class="s38">.</span>
        </p>
        <p style="padding-top: 10pt;padding-left: 39pt;text-indent: 0pt;text-align: justify;">La descripción de los bienes asegurados y la <b>Suma Asegurada </b>para cada uno de ellos deberán asentarse mediante anexo o endoso a la <b>Carátula de la Póliza </b>y en ningún caso la suma de las indemnizaciones excederá a la <b>Suma Asegurada </b>de los bienes. </p>
        <p style="padding-top: 11pt;text-indent: 0pt;text-align: center;">
          <br />
        </p>
        <p style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">Así mismo, para el cálculo de las indemnizaciones se considerará la correspondiente depreciación de la <b>Adaptación</b>, <b>Conversión </b>o <b>Equipo Especial </b>de acuerdo con la tabla anexa, la cual se aplica de acuerdo con los Años de Uso, es decir, los años transcurridos desde la fecha en que fue emitida la factura de origen de la <b>Adaptación</b>, <b>Conversión </b>o <b>Equipo Especial </b>hasta la fecha en que ocurra el <b>Siniestro</b>. El resultado de restar esta depreciación a la <b>Suma Asegurada </b>será el monto para indemnizar: </p>
        <p style="padding-top: 7pt;text-indent: 0pt;text-align: center;">
          <br />
        </p>
        <table style="border-collapse:collapse;margin-left:186.02pt" cellspacing="0">
          <tr style="height:23pt">
            <td style="width:63pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt" bgcolor="#DEEAF6">
              <p class="s39" style="padding-left: 22pt;padding-right: 11pt;text-indent: -10pt;line-height: 94%;text-align: center;">Años de Uso</p>
            </td>
            <td style="width:85pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt" bgcolor="#DEEAF6">
              <p class="s39" style="padding-left: 8pt;text-indent: 9pt;line-height: 94%;text-align: center;">% sobre la indemnización</p>
            </td>
          </tr>
          <tr style="height:12pt">
            <td style="width:63pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
              <p class="s40" style="padding-left: 1pt;text-indent: 0pt;line-height: 11pt;text-align: center;">0</p>
            </td>
            <td style="width:85pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
              <p class="s40" style="padding-left: 1pt;text-indent: 0pt;line-height: 11pt;text-align: center;">100%</p>
            </td>
          </tr>
          <tr style="height:12pt">
            <td style="width:63pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
              <p class="s40" style="padding-left: 1pt;text-indent: 0pt;line-height: 11pt;text-align: center;">1</p>
            </td>
            <td style="width:85pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
              <p class="s40" style="padding-left: 1pt;text-indent: 0pt;line-height: 11pt;text-align: center;">74%</p>
            </td>
          </tr>
          <tr style="height:12pt">
            <td style="width:63pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
              <p class="s40" style="padding-left: 1pt;text-indent: 0pt;line-height: 11pt;text-align: center;">2</p>
            </td>
            <td style="width:85pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
              <p class="s40" style="padding-left: 1pt;text-indent: 0pt;line-height: 11pt;text-align: center;">63%</p>
            </td>
          </tr>
          <tr style="height:12pt">
            <td style="width:63pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
              <p class="s40" style="padding-left: 1pt;text-indent: 0pt;line-height: 11pt;text-align: center;">3</p>
            </td>
            <td style="width:85pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
              <p class="s40" style="padding-left: 1pt;text-indent: 0pt;line-height: 11pt;text-align: center;">53%</p>
            </td>
          </tr>
          <tr style="height:12pt">
            <td style="width:63pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
              <p class="s40" style="padding-left: 1pt;text-indent: 0pt;line-height: 11pt;text-align: center;">4</p>
            </td>
            <td style="width:85pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
              <p class="s40" style="padding-left: 1pt;text-indent: 0pt;line-height: 11pt;text-align: center;">45%</p>
            </td>
          </tr>
          <tr style="height:12pt">
            <td style="width:63pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
              <p class="s40" style="padding-left: 1pt;text-indent: 0pt;line-height: 11pt;text-align: center;">5</p>
            </td>
            <td style="width:85pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
              <p class="s40" style="padding-left: 1pt;text-indent: 0pt;line-height: 11pt;text-align: center;">40%</p>
            </td>
          </tr>
          <tr style="height:12pt">
            <td style="width:63pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
              <p class="s40" style="padding-left: 1pt;text-indent: 0pt;line-height: 11pt;text-align: center;">6</p>
            </td>
            <td style="width:85pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
              <p class="s40" style="padding-left: 1pt;text-indent: 0pt;line-height: 11pt;text-align: center;">36%</p>
            </td>
          </tr>
          <tr style="height:12pt">
            <td style="width:63pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
              <p class="s40" style="padding-left: 1pt;text-indent: 0pt;line-height: 11pt;text-align: center;">7</p>
            </td>
            <td style="width:85pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
              <p class="s40" style="padding-left: 1pt;text-indent: 0pt;line-height: 11pt;text-align: center;">32%</p>
            </td>
          </tr>
          <tr style="height:12pt">
            <td style="width:63pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
              <p class="s40" style="padding-left: 1pt;text-indent: 0pt;line-height: 11pt;text-align: center;">8</p>
            </td>
            <td style="width:85pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
              <p class="s40" style="padding-left: 1pt;text-indent: 0pt;line-height: 11pt;text-align: center;">29%</p>
            </td>
          </tr>
          <tr style="height:12pt">
            <td style="width:63pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
              <p class="s40" style="padding-left: 1pt;text-indent: 0pt;line-height: 11pt;text-align: center;">9</p>
            </td>
            <td style="width:85pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
              <p class="s40" style="padding-left: 1pt;text-indent: 0pt;line-height: 11pt;text-align: center;">26%</p>
            </td>
          </tr>
          <tr style="height:12pt">
            <td style="width:63pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
              <p class="s40" style="padding-left: 1pt;text-indent: 0pt;line-height: 11pt;text-align: center;">10</p>
            </td>
            <td style="width:85pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
              <p class="s40" style="padding-left: 1pt;text-indent: 0pt;line-height: 11pt;text-align: center;">23%</p>
            </td>
          </tr>
          <tr style="height:12pt">
            <td style="width:63pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
              <p class="s40" style="padding-left: 1pt;text-indent: 0pt;line-height: 11pt;text-align: center;">11</p>
            </td>
            <td style="width:85pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
              <p class="s40" style="padding-left: 1pt;text-indent: 0pt;line-height: 11pt;text-align: center;">21%</p>
            </td>
          </tr>
          <tr style="height:12pt">
            <td style="width:63pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
              <p class="s40" style="padding-left: 1pt;text-indent: 0pt;line-height: 11pt;text-align: center;">12</p>
            </td>
            <td style="width:85pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
              <p class="s40" style="padding-left: 1pt;text-indent: 0pt;line-height: 11pt;text-align: center;">19%</p>
            </td>
          </tr>
          <tr style="height:12pt">
            <td style="width:63pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
              <p class="s40" style="padding-left: 1pt;text-indent: 0pt;line-height: 11pt;text-align: center;">13</p>
            </td>
            <td style="width:85pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
              <p class="s40" style="padding-left: 1pt;text-indent: 0pt;line-height: 11pt;text-align: center;">17%</p>
            </td>
          </tr>
          <tr style="height:12pt">
            <td style="width:63pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
              <p class="s40" style="padding-left: 1pt;text-indent: 0pt;line-height: 11pt;text-align: center;">14 o más</p>
            </td>
            <td style="width:85pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
              <p class="s40" style="padding-left: 1pt;text-indent: 0pt;line-height: 11pt;text-align: center;">15%</p>
            </td>
          </tr>
        </table>
        <p class="s12" style="padding-top: 11pt;padding-left: 39pt;text-indent: 0pt;text-align: center;">
          <a name="a62">Blindaje</a>
        </p>
        <p style="padding-left: 39pt;text-indent: 0pt;text-align: center;">Para efectos de esta <b>Cobertura</b>, el blindaje se considerará como <b>Adaptación </b>y/o <b>Conversión</b>. </p>
        <p style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">Los cristales blindados solamente quedan cubiertos en el caso de <b>Pérdida Total </b>al amparo de la cobertura básica de la sección de Daños Materiales siempre y cuando ésta se encuentre contratada en la <b>Carátula de la Póliza</b>. </p>
        <p class="s15" style="padding-top: 11pt;padding-left: 39pt;text-indent: 0pt;text-align: justify;">En ningún caso se cubren robos parciales de las partes blindadas.</p>
        <p style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">En lo que respecta a blindajes, cuando <b>L A T I N O </b>declare la <b>Pérdida Total </b>del <b>Vehículo Asegurado</b>, la indemnización que se hará al <b>Asegurado </b>se calculará sobre el valor de la factura de dicho blindaje, descontando la depreciación de acuerdo con los porcentajes estipulados en la siguiente tabla. Esta indemnización no podrá exceder el <b>Límite Máximo de Responsabilidad </b>descrito en la <b>Carátula de la Póliza</b>. </p>
        <p style="text-indent: 0pt;text-align: center;">
          <br />
        </p>
        <table style="border-collapse:collapse;margin-left:143.39pt" cellspacing="0">
          <tr style="height:23pt">
            <td style="width:63pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt" bgcolor="#DEEAF6">
              <p class="s39" style="padding-left: 22pt;padding-right: 11pt;text-indent: -10pt;line-height: 94%;text-align: center;">Años de Uso</p>
            </td>
            <td style="width:86pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt" bgcolor="#DEEAF6">
              <p class="s39" style="padding-left: 12pt;text-indent: 18pt;line-height: 94%;text-align: center;">% de depreciación</p>
            </td>
            <td style="width:85pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt" bgcolor="#DEEAF6">
              <p class="s39" style="padding-left: 8pt;text-indent: 9pt;line-height: 94%;text-align: center;">% sobre la indemnización</p>
            </td>
          </tr>
          <tr style="height:12pt">
            <td style="width:63pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
              <p class="s40" style="padding-left: 1pt;text-indent: 0pt;line-height: 11pt;text-align: center;">0</p>
            </td>
            <td style="width:86pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
              <p class="s40" style="padding-left: 2pt;text-indent: 0pt;line-height: 11pt;text-align: center;">15%</p>
            </td>
            <td style="width:85pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
              <p class="s40" style="text-indent: 0pt;line-height: 11pt;text-align: center;">85%</p>
            </td>
          </tr>
          <tr style="height:12pt">
            <td style="width:63pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
              <p class="s40" style="padding-left: 1pt;text-indent: 0pt;line-height: 11pt;text-align: center;">1</p>
            </td>
            <td style="width:86pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
              <p class="s40" style="padding-left: 2pt;text-indent: 0pt;line-height: 11pt;text-align: center;">15%</p>
            </td>
            <td style="width:85pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
              <p class="s40" style="text-indent: 0pt;line-height: 11pt;text-align: center;">85%</p>
            </td>
          </tr>
          <tr style="height:12pt">
            <td style="width:63pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
              <p class="s40" style="padding-left: 1pt;text-indent: 0pt;line-height: 11pt;text-align: center;">2</p>
            </td>
            <td style="width:86pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
              <p class="s40" style="padding-left: 2pt;text-indent: 0pt;line-height: 11pt;text-align: center;">30%</p>
            </td>
            <td style="width:85pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
              <p class="s40" style="text-indent: 0pt;line-height: 11pt;text-align: center;">70%</p>
            </td>
          </tr>
          <tr style="height:12pt">
            <td style="width:63pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
              <p class="s40" style="padding-left: 1pt;text-indent: 0pt;line-height: 11pt;text-align: center;">3</p>
            </td>
            <td style="width:86pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
              <p class="s40" style="padding-left: 2pt;text-indent: 0pt;line-height: 11pt;text-align: center;">45%</p>
            </td>
            <td style="width:85pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
              <p class="s40" style="text-indent: 0pt;line-height: 11pt;text-align: center;">55%</p>
            </td>
          </tr>
          <tr style="height:12pt">
            <td style="width:63pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
              <p class="s40" style="padding-left: 1pt;text-indent: 0pt;line-height: 11pt;text-align: center;">4</p>
            </td>
            <td style="width:86pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
              <p class="s40" style="padding-left: 2pt;text-indent: 0pt;line-height: 11pt;text-align: center;">60%</p>
            </td>
            <td style="width:85pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
              <p class="s40" style="text-indent: 0pt;line-height: 11pt;text-align: center;">40%</p>
            </td>
          </tr>
          <tr style="height:12pt">
            <td style="width:63pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
              <p class="s40" style="padding-left: 1pt;text-indent: 0pt;line-height: 11pt;text-align: center;">5</p>
            </td>
            <td style="width:86pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
              <p class="s40" style="padding-left: 2pt;text-indent: 0pt;line-height: 11pt;text-align: center;">70%</p>
            </td>
            <td style="width:85pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
              <p class="s40" style="text-indent: 0pt;line-height: 11pt;text-align: center;">30%</p>
            </td>
          </tr>
          <tr style="height:12pt">
            <td style="width:63pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
              <p class="s40" style="padding-left: 1pt;text-indent: 0pt;line-height: 11pt;text-align: center;">6</p>
            </td>
            <td style="width:86pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
              <p class="s40" style="padding-left: 2pt;text-indent: 0pt;line-height: 11pt;text-align: center;">80%</p>
            </td>
            <td style="width:85pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
              <p class="s40" style="text-indent: 0pt;line-height: 11pt;text-align: center;">20%</p>
            </td>
          </tr>
          <tr style="height:12pt">
            <td style="width:63pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
              <p class="s40" style="padding-left: 1pt;text-indent: 0pt;line-height: 11pt;text-align: center;">7</p>
            </td>
            <td style="width:86pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
              <p class="s40" style="padding-left: 2pt;text-indent: 0pt;line-height: 11pt;text-align: center;">90%</p>
            </td>
            <td style="width:85pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
              <p class="s40" style="text-indent: 0pt;line-height: 11pt;text-align: center;">10%</p>
            </td>
          </tr>
          <tr style="height:12pt">
            <td style="width:63pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
              <p class="s40" style="padding-left: 1pt;text-indent: 0pt;line-height: 11pt;text-align: center;">8 o más</p>
            </td>
            <td style="width:86pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
              <p class="s40" style="padding-left: 2pt;text-indent: 0pt;line-height: 11pt;text-align: center;">100%</p>
            </td>
            <td style="width:85pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
              <p class="s40" style="text-indent: 0pt;line-height: 11pt;text-align: center;">0%</p>
            </td>
          </tr>
        </table>
        <p style="padding-top: 11pt;padding-left: 39pt;text-indent: 0pt;text-align: justify;">Para el caso de <b>Vehículos Asegurados </b>cuyo blindaje total o parcial no haya sido realizado directamente por el fabricante del vehículo, se deberá presentar a <b>L A T I N O </b>las facturas con los requisitos fiscales que demuestren su validez legal y que acrediten dicho blindaje. </p>
      </li>
      <li data-list-text="B)">
        <p class="s21" style="padding-top: 11pt;padding-left: 81pt;text-indent: -21pt;text-align: center;">Límite Máximo de Responsabilidad</p>
        <p style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">El <b>Límite Máximo de Responsabilidad </b>que en su caso cubrirá <b>L A T I N O </b>no será mayor al valor de los bienes siniestrados y soportados por avaluó o factura, ni excederá del <b>Valor Comercial </b>de los mismos al momento del <b>Siniestro</b>. </p>
        <p style="text-indent: 0pt;text-align: center;">
          <br />
        </p>
        <p style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">Toda indemnización que <b>L A T I N O </b>pague, se reducirá en igual cantidad de la <b>Suma Asegurada</b>, pudiendo ser reinstalada a solicitud del <b>Asegurado </b>y previa aceptación de <b>L A T I N O, </b>en cuyo </p>
        <p style="padding-top: 3pt;padding-left: 39pt;text-indent: 0pt;text-align: center;">caso, el <b>Asegurado </b>deberá pagar la <b>Prima </b>que corresponda. </p>
        <p style="text-indent: 0pt;text-align: center;">
          <br />
        </p>
      </li>
      <li data-list-text="C)">
        <p class="s21" style="padding-left: 81pt;text-indent: -24pt;line-height: 14pt;text-align: justify;">Deducible</p>
        <p style="padding-left: 39pt;text-indent: 0pt;text-align: center;">La cobertura Adaptaciones, Conversiones y Equipo Especial se contrata con la aplicación invariable en cada <b>Siniestro </b>de una cantidad a cargo del <b>Asegurado</b>, denominada <b>Deducible</b>. </p>
        <p style="padding-top: 11pt;padding-left: 39pt;text-indent: 0pt;text-align: center;">El procedimiento para obtener el monto del <b>Deducible </b>aplicable es el siguiente: </p>
        <p style="text-indent: 0pt;text-align: center;">
          <br />
        </p>
        <p style="padding-left: 81pt;text-indent: -21pt;text-align: justify;">
          <span class="s32">1. </span>
          <span class="s41">Tanto para Pérdidas Parciales como Pérdidas Totales</span>: El <b>Deducible </b>resulta de la aplicación del porcentaje de <b>Deducible </b>estipulado en la <b>Carátula de la Póliza </b>para la cobertura afectada, sobre la <b>Suma Asegurada </b>contratada del bien <b>Asegurado </b>dañado.
        </p>
      </li>
      <li data-list-text="D)">
        <p class="s21" style="padding-top: 11pt;padding-left: 81pt;text-indent: -24pt;text-align: justify;">Exclusiones</p>
        <p class="s15" style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">Queda entendido que, en adición a lo aplicable a la Cláusula Exclusiones Generales y las Exclusiones de las coberturas básicas de las secciones de Daños Materiales, Robo y Responsabilidad Civil, esta cobertura:</p>
        <ol id="l43">
          <li data-list-text="1.">
            <p class="s15" style="padding-top: 13pt;padding-left: 81pt;text-indent: -21pt;text-align: justify;">No ampara en ningún caso la Adaptación, Conversión y/o Equipo Especial que carezca de factura que cumpla con los requisitos fiscales, o que siendo de procedencia extranjera no cuente con los comprobantes de propiedad y/o pedimentos de importación, así como el pago de los aranceles de acuerdo con la legislación vigente en la fecha de adquisición del bien.</p>
          </li>
          <li data-list-text="2.">
            <p class="s15" style="padding-left: 81pt;text-indent: -21pt;text-align: justify;">En ningún caso se cubren robos parciales de las partes blindadas.</p>
            <p style="text-indent: 0pt;text-align: center;">
              <br />
            </p>
            <div class="textbox" style="background:#DEEAF6;">
              <p class="s19" style="text-indent: 0pt;line-height: 11pt;text-align: right;">Sección: Responsabilidad Civil</p>
              <p class="s19" style="text-indent: 0pt;line-height: 11pt;text-align: right;">Cobertura Básica</p>
              <p class="s20" style="padding-left: 5pt;text-indent: 0pt;line-height: 13pt;text-align: center;">CLÁUSULA 2.11. R.C. Terceros</p>
              <p class="s19" style="padding-left: 5pt;text-indent: 0pt;text-align: center;">(Responsabilidad Civil por Daños a Terceros en sus personas y bienes Límite Único y Combinado).</p>
            </div>
          </li>
        </ol>
      </li>
    </ol>
    <p style="padding-left: 39pt;text-indent: 0pt;text-align: center;" />
    <ol id="l44">
      <ol id="l45">
        <ol id="l46">
          <li data-list-text="A)">
            <p class="s21" style="padding-top: 12pt;padding-left: 74pt;text-indent: -17pt;text-align: justify;">Alcance</p>
            <p style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">Siempre que se haga constar la contratación de esta cobertura, <b>LATINO </b>se obliga a amparar hasta el <b>Límite Máximo de Responsabilidad </b>establecido en la <b>Carátula de la Póliza</b>, la responsabilidad civil en que incurra el <b>Asegurado </b>o cualquier persona que con su consentimiento expreso o tácito use el <b>Vehículo Asegurado </b>y que a consecuencia de dicho uso cause a <b>Terceros</b>, <b>Daños </b>materiales en sus bienes, lesiones corporales, incapacidades temporales y/o permanentes o la muerte, <span class="s9">excepto cuando éstos hayan sido Ocupantes del Vehículo Asegurado al momento del Siniestro</span>. </p>
            <p style="text-indent: 0pt;text-align: center;">
              <br />
            </p>
            <p style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">Asimismo, esta cobertura ampara:</p>
            <ol id="l47">
              <li data-list-text="1.">
                <p style="padding-left: 81pt;text-indent: -21pt;text-align: justify;">En caso de juicio civil seguido en su contra con motivo de su responsabilidad civil, hasta el <b>Límite Máximo de Responsabilidad </b>establecido en la <b>Carátula de la Póliza</b>, los gastos costas a que fuere condenado el <b>Asegurado </b>o cualquier persona que con su consentimiento expreso o tácito use el <b>Vehículo Asegurado</b>; </p>
                <p style="text-indent: 0pt;text-align: center;">
                  <br />
                </p>
              </li>
              <li data-list-text="2.">
                <p style="padding-left: 81pt;text-indent: -21pt;text-align: justify;">La obligación de cubrir el porcentaje señalado a continuación por concepto de Daño Moral al que fuere condenado el <b>Asegurado </b>o <b>Conductor </b>autorizado para usar el <b>Vehículo Asegurado</b>, bajo los siguientes supuestos: </p>
                <ol id="l48">
                  <li data-list-text="a)">
                    <p style="padding-top: 4pt;padding-left: 95pt;text-indent: -14pt;text-align: justify;">Exista una sentencia firme que condene al <b>Asegurado </b>y/o <b>Conductor </b>autorizado al pago de cantidad líquida por ese concepto. </p>
                  </li>
                  <li data-list-text="b)">
                    <p style="padding-left: 95pt;text-indent: -13pt;line-height: 11pt;text-align: justify;">El monto máximo al que se obliga <b>L A T I N O</b>, en ningún caso superará el 25% </p>
                    <p style="padding-top: 3pt;padding-left: 95pt;text-indent: 0pt;text-align: justify;">(veinticinco por ciento) de la <b>Suma Asegurada </b>por concepto de Responsabilidad Civil. </p>
                  </li>
                  <li data-list-text="c)">
                    <p style="padding-left: 95pt;text-indent: -14pt;text-align: justify;">En caso de que el <b>Asegurado </b>como consecuencia del mismo siniestro fuera condenado a pagar cantidad alguna por concepto de Responsabilidad Civil, se entiende que, el remanente no pagado, será la base para calcular el 25% (veinticinco por ciento) de la obligación por Daño Moral de <b>L A T I N O</b>. </p>
                    <p style="text-indent: 0pt;text-align: center;">
                      <br />
                    </p>
                  </li>
                </ol>
              </li>
              <li data-list-text="3.">
                <p style="padding-left: 81pt;text-indent: -21pt;text-align: justify;">En caso de que se contrate la cobertura de Adaptaciones, Conversiones y Equipo Especial, la responsabilidad civil por <b>Daños </b>a <b>Terceros </b>en sus bienes y personas que ocasione(n) la(s) <b>Adaptación(es)</b>, <b>Conversión(es) </b>y/o <b>Equipo Especial </b>cubiertos y siempre y cuando se encuentre(n) instalado(s) en el <b>Vehículo Asegurado </b>al momento del <b>Siniestro</b>, y hasta el mismo <b>Límite Máximo de Responsabilidad </b>contratado y señalado en la <b>Carátula de la Póliza</b>. </p>
                <ol id="l49">
                  <li data-list-text="a)">
                    <p style="padding-left: 109pt;text-indent: -13pt;line-height: 11pt;text-align: center;">Tumbaburros</p>
                  </li>
                  <li data-list-text="b)">
                    <p style="padding-left: 109pt;text-indent: -13pt;text-align: center;">Malacate (Winch)</p>
                  </li>
                  <li data-list-text="c)">
                    <p style="padding-left: 109pt;text-indent: -13pt;line-height: 11pt;text-align: center;">Bola de arrastre</p>
                  </li>
                  <li data-list-text="d)">
                    <p style="padding-left: 109pt;text-indent: -13pt;line-height: 11pt;text-align: center;">Cola de pato/alerón/spoiler</p>
                  </li>
                  <li data-list-text="e)">
                    <p style="padding-left: 109pt;text-indent: -13pt;line-height: 11pt;text-align: center;">Estribos</p>
                  </li>
                  <li data-list-text="f)">
                    <p style="padding-left: 109pt;text-indent: -13pt;line-height: 11pt;text-align: center;">Faldones</p>
                  </li>
                  <li data-list-text="g)">
                    <p style="padding-left: 109pt;text-indent: -13pt;text-align: center;">Tirones</p>
                  </li>
                  <li data-list-text="h)">
                    <p style="padding-left: 109pt;text-indent: -13pt;line-height: 11pt;text-align: center;">Faros superiores</p>
                  </li>
                  <li data-list-text="i)">
                    <p style="padding-left: 109pt;text-indent: -13pt;line-height: 11pt;text-align: center;">Cantoneras</p>
                  </li>
                  <li data-list-text="j)">
                    <p style="padding-left: 109pt;text-indent: -14pt;line-height: 11pt;text-align: center;">Roll bar</p>
                  </li>
                  <li data-list-text="k)">
                    <p style="padding-left: 109pt;text-indent: -13pt;line-height: 11pt;text-align: center;">Canastilla de equipaje de toldo</p>
                  </li>
                  <li data-list-text="l)">
                    <p style="padding-left: 109pt;text-indent: -13pt;line-height: 11pt;text-align: center;">Extensores de platón</p>
                  </li>
                  <li data-list-text="m)">
                    <p style="padding-left: 109pt;text-indent: -14pt;line-height: 11pt;text-align: center;">Rack para bicicletas</p>
                    <p style="text-indent: 0pt;text-align: center;">
                      <br />
                    </p>
                    <p style="padding-left: 81pt;text-indent: 0pt;text-align: justify;">Salvo pacto en contrario, <span class="s15">NO estará amparada la responsabilidad civil por Daños a Terceros en sus bienes y/o en sus personas por la carga que transporta(n) la(s) Adaptación(es), Conversión(es) y/o Equipo Especial anteriormente listado</span>. </p>
                  </li>
                </ol>
              </li>
              <li data-list-text="4.">
                <p style="padding-top: 11pt;padding-left: 81pt;text-indent: -21pt;text-align: justify;">Si el <b>Vehículo Asegurado </b>es del tipo eléctrico o híbrido queda amparada la Responsabilidad Civil en que incurra el <b>Asegurado</b>, o cualquier persona que con consentimiento expreso o tácito utilice el <b>Vehículo Asegurado</b>, cuando con motivo del reabastecimiento de carga de la(s) batería(s) del mismo se causen <b>Daños </b>a <b>Terceros </b>en sus bienes y/o cause lesiones corporales o la muerte a <b>Terceros</b>, si la causa del <b>Daño </b>tiene su origen dentro del vehículo o de sus componentes de conexión, siempre y cuando, el motor de fuerza motriz se encuentre apagado y el <b>Vehículo Asegurado </b>se encuentre conectado a un cargador público fijo. </p>
              </li>
            </ol>
          </li>
          <li data-list-text="B)">
            <p class="s21" style="padding-top: 10pt;padding-left: 81pt;text-indent: -21pt;text-align: center;">Límite Máximo de Responsabilidad</p>
            <p style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">El <b>Límite Máximo de Responsabilidad </b>de <b>L A T I N O </b>para esta cobertura se establece en la <b>Carátula de la Póliza </b>y se indemnizará de conformidad a lo establecido en la Cláusula &quot;Sumas Aseguradas y Bases de Indemnización&quot;. </p>
            <p style="padding-top: 2pt;text-indent: 0pt;text-align: center;">
              <br />
            </p>
            <p style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">Para el caso de que exista una cobertura de Responsabilidad Civil vigente en otra compañía aseguradora, que haya sido contratada por el <b>Contratante </b>o <b>Asegurado</b>, con anterioridad al presente contrato, aquella se considerará prioritaria, no concurrente, y por lo tanto, la <b>Suma Asegurada </b>de esta <b>Póliza </b>operará en exceso de aquel seguro o por su inexistencia. </p>
            <p style="padding-top: 2pt;text-indent: 0pt;text-align: center;">
              <br />
            </p>
          </li>
          <li data-list-text="C)">
            <p class="s21" style="padding-left: 74pt;text-indent: -17pt;text-align: center;">Deducible</p>
            <p style="padding-top: 4pt;padding-left: 39pt;text-indent: 0pt;text-align: justify;">No opera</p>
          </li>
          <li data-list-text="D)">
            <p class="s21" style="padding-left: 74pt;text-indent: -17pt;text-align: center;">Excusiones</p>
          </li>
        </ol>
      </ol>
    </ol>
    <p class="s15" style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">Queda entendido que, en adición a lo aplicable en la Cláusula Exclusiones</p>
    <p class="s15" style="padding-top: 3pt;padding-left: 39pt;text-indent: 0pt;text-align: center;">Generales, esta cobertura NO ampara:</p>
    <p style="text-indent: 0pt;text-align: center;">
      <br />
    </p>
    <ol id="l50">
      <li data-list-text="1.">
        <p class="s15" style="padding-left: 81pt;text-indent: -21pt;text-align: justify;">La responsabilidad civil del Asegurado por Daños materiales a bienes que se encuentren en el Vehículo Asegurado.</p>
      </li>
      <li data-list-text="2.">
        <p class="s15" style="padding-left: 81pt;text-indent: -21pt;text-align: justify;">La responsabilidad civil en que se incurra cuando el Vehículo Asegurado haya sido robado.</p>
      </li>
      <li data-list-text="3.">
        <p class="s15" style="padding-left: 81pt;text-indent: -21pt;text-align: justify;">La responsabilidad civil del Asegurado por Daños a Terceros en sus bienes que sean propiedad de personas que tengan un Parentesco, ya sea por consanguinidad, afinidad o civil con el Asegurado, o que estén a su servicio en el momento del Siniestro.</p>
      </li>
      <li data-list-text="4.">
        <p class="s15" style="padding-left: 81pt;text-indent: -21pt;text-align: justify;">La responsabilidad civil por Daños a Terceros en sus personas cuando dependan civilmente del Asegurado y/o Conductor, o cuando estén a su servicio al momento del Siniestro.</p>
      </li>
      <li data-list-text="5.">
        <p class="s15" style="padding-left: 81pt;text-indent: -21pt;text-align: justify;">La responsabilidad civil del Asegurado por Daños a Terceros en sus bienes que sean propiedad de empleados, agentes o representantes del Asegurado, mientras se encuentren dentro de los predios de este último.</p>
      </li>
      <li data-list-text="6.">
        <p class="s15" style="padding-left: 78pt;text-indent: -18pt;text-align: justify;">Salvo pacto en contrario, la responsabilidad civil del Asegurado por Daños materiales a bienes de su propiedad.</p>
      </li>
      <li data-list-text="7.">
        <p class="s15" style="padding-left: 81pt;text-indent: -18pt;text-align: justify;">La responsabilidad civil del Asegurado por Daños materiales a bienes que se encuentren bajo su custodia o responsabilidad.</p>
      </li>
      <li data-list-text="8.">
        <p class="s15" style="padding-left: 81pt;text-indent: -18pt;text-align: justify;">Los gastos de defensa jurídica, así como el pago de fianzas, cauciones o multas de cualquier índole.</p>
      </li>
      <li data-list-text="9.">
        <p class="s15" style="padding-left: 81pt;text-indent: -18pt;text-align: justify;">Cualquier reconocimiento de adeudos, transacciones o cualesquiera otros actos de naturaleza semejante celebrados o concertados sin el consentimiento de L A T I N O. La confesión de la materialidad de un hecho no podrá ser asimilada al reconocimiento de una responsabilidad.</p>
      </li>
      <li data-list-text="10.">
        <p class="s15" style="padding-left: 81pt;text-indent: -18pt;text-align: justify;">La responsabilidad civil del Asegurado o Conductor por los Daños al medio ambiente, así como cualquier obligación derivada de Daños a los ecosistemas.</p>
      </li>
      <li data-list-text="11.">
        <p class="s15" style="padding-left: 81pt;text-indent: -21pt;text-align: justify;">Cuando el Vehículo Asegurado participe en competencias automovilísticas de velocidad y/o resistencia, ya sea de aficionados o de profesionales.</p>
      </li>
      <li data-list-text="12.">
        <p class="s15" style="padding-left: 81pt;text-indent: -21pt;text-align: justify;">Perjuicio, gasto, pérdida, indemnización o Daño, siempre y cuando estas afectaciones patrimoniales sean indirectas.</p>
      </li>
      <li data-list-text="13.">
        <p class="s15" style="padding-left: 81pt;text-indent: -21pt;text-align: justify;">Lesiones ocasionadas a los Ocupantes del Vehículo Asegurado.</p>
      </li>
      <li data-list-text="14.">
        <p class="s15" style="padding-top: 10pt;padding-left: 78pt;text-indent: -18pt;text-align: justify;">La responsabilidad civil por Daños a Terceros en sus bienes y/o personas ocasionados, cuando:</p>
        <ol id="l51">
          <li data-list-text="14.1.">
            <p class="s15" style="padding-left: 110pt;text-indent: -28pt;text-align: justify;">El Asegurado no haya cumplido con las instrucciones para carga de batería que se indique en el Manual del fabricante del Vehículo Asegurado;</p>
          </li>
          <li data-list-text="14.2.">
            <p class="s15" style="padding-top: 4pt;padding-left: 110pt;text-indent: -28pt;text-align: justify;">Se hayan suscitado por defecto o rotura del cable para carga de batería proporcionado o recomendado por el fabricante de la marca del Vehículo Asegurado;</p>
          </li>
          <li data-list-text="14.3.">
            <p class="s15" style="padding-left: 109pt;text-indent: -28pt;text-align: justify;">Hayan sido ocasionados por una descarga eléctrica, ya sea de</p>
            <p class="s15" style="padding-top: 3pt;padding-left: 110pt;text-indent: 0pt;text-align: justify;">menor o mayor voltaje a la permitida o indicada por el fabricante para la carga de la batería del Vehículo Asegurado;</p>
          </li>
          <li data-list-text="14.4.">
            <p class="s15" style="padding-left: 110pt;text-indent: -28pt;text-align: justify;">El Asegurado haya utilizado equipos para carga de batería no autorizados por la marca del fabricante del Vehículo Asegurado.</p>
          </li>
          <li data-list-text="14.5.">
            <p class="s15" style="padding-left: 110pt;text-indent: -28pt;text-align: justify;">La carga de batería sea efectuada directamente en las instalaciones del fabricante o agencia distribuidora de la marca del Vehículo Asegurado.</p>
          </li>
        </ol>
      </li>
    </ol>
    <p style="text-indent: 0pt;text-align: center;">
      <br />
    </p>
    <div class="textbox" style="background:#DEEAF6;">
      <p class="s19" style="text-indent: 0pt;line-height: 11pt;text-align: right;">Sección: Responsabilidad Civil</p>
      <p class="s19" style="text-indent: 0pt;text-align: right;">Cobertura Accesoria</p>
      <p class="s20" style="padding-left: 5pt;text-indent: 0pt;text-align: center;">CLÁUSULA 2.12. R.C. Otros vehículos. (Extensión de R.C.)</p>
    </div>
    <p style="padding-left: 39pt;text-indent: 0pt;text-align: center;" />
    <p class="s12" style="padding-top: 12pt;padding-left: 39pt;text-indent: 0pt;text-align: justify;">
      <a name="a63">Requisitos de contratación:</a>
    </p>
    <p style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">Esta es una cobertura accesoria; por lo que su contratación requiere que se tenga amparada la cobertura básica R.C. Terceros.</p>
    <p style="padding-top: 1pt;text-indent: 0pt;text-align: center;">
      <br />
    </p>
    <ol id="l52">
      <li data-list-text="A)">
        <p class="s8" style="padding-left: 81pt;text-indent: -21pt;text-align: justify;">
          <a name="a64">Alcance</a>
        </p>
        <p style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">Siempre que se hagan constar la contratación de esta cobertura y de la cobertura básica que corresponde, <b>L A T I N O </b>se obliga a extender la cobertura de R.C. Terceros al <b>Conductor Habitual </b>que se indica en la <b>Carátula de la Póliza</b>, contra los mismos riesgos y bajo las mismas bases, límites, <b>Deducible</b>s, <b>Exclusiones </b>y condiciones estipuladas según sea el caso, cuando se encuentre como <b>Conductor </b>de cualquier otro vehículo con el mismo uso, clase y características similares al amparado en este seguro y descrito en la <b>Carátula de la Póliza</b>, y que no implique una agravación de riesgo, en todos los casos el uso debe ser particular. </p>
        <p style="padding-top: 11pt;padding-left: 39pt;text-indent: 0pt;text-align: justify;">Para los efectos de esta cobertura, la extensión de cobertura nunca será substitutiva, ni concurrente a cualquier otro seguro, que contra los mismos riesgos se tenga en vigor sobre el vehículo siniestrado, ya que la presente operará sólo en exceso o por inexistencia de lo amparado por aquel seguro.</p>
        <p style="text-indent: 0pt;text-align: center;">
          <br />
        </p>
        <p style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">Si el seguro obligatorio de responsabilidad civil por <b>Daños </b>a <b>Terceros </b>en sus personas y/o bienes es exigible; para tal caso, el límite de responsabilidad de <b>L A T I N O </b>opera en exceso hasta el monto establecido en la <b>Carátula de la Póliza</b>. </p>
        <p style="text-indent: 0pt;text-align: center;">
          <br />
        </p>
      </li>
      <li data-list-text="B)">
        <p class="s8" style="padding-left: 81pt;text-indent: -21pt;text-align: justify;">
          <a name="a65">Límite Máximo de Responsabilidad</a>
        </p>
        <p style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">El <b>Límite Máximo de Responsabilidad </b>de <b>L A T I N O </b>para esta cobertura será el que se establece para la cobertura de <b>R.C. Terceros </b>y se indemnizará de conformidad a lo establecido en la Cláusula &quot;Sumas Aseguradas y Bases de Indemnización&quot;. </p>
      </li>
      <li data-list-text="C)">
        <p class="s8" style="padding-top: 11pt;padding-left: 74pt;text-indent: -17pt;line-height: 13pt;text-align: justify;">
          <a name="a66">Deducible</a>
        </p>
        <p style="padding-left: 39pt;text-indent: 0pt;line-height: 11pt;text-align: justify;">No opera</p>
        <p style="padding-top: 1pt;text-indent: 0pt;text-align: center;">
          <br />
        </p>
      </li>
      <li data-list-text="D)">
        <p class="s8" style="padding-left: 74pt;text-indent: -17pt;text-align: justify;">Exclusiones</p>
        <p class="s15" style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">Queda entendido que, en adición a lo aplicable en la Cláusula Exclusiones Generales y las Exclusiones de la cobertura de R.C. Terceros, esta cobertura no cubre:</p>
        <ol id="l53">
          <li data-list-text="1.">
            <p class="s15" style="padding-top: 4pt;padding-left: 81pt;text-indent: -21pt;text-align: justify;">Cuando el Conductor Habitual descrito en la Carátula de la Póliza se encuentre conduciendo un automóvil, camioneta o pick up de uso diferente al particular o un vehículo mayor a 3.5 toneladas, un autobús o algún otro vehículo comercial de transporte de pasajeros o de carga.</p>
          </li>
          <li data-list-text="2.">
            <p class="s15" style="padding-top: 3pt;padding-left: 81pt;text-indent: -21pt;text-align: justify;">Los Daños materiales que sufra el vehículo conducido.</p>
          </li>
        </ol>
      </li>
    </ol>
    <p class="s15" style="padding-left: 81pt;text-indent: 0pt;text-align: justify;">Cuando el Asegurado o Contratante se encuentre conduciendo un vehículo con tipo de uso de renta diaria, servicio particular de transporte de personas, taxi uso público o diferente al uso contratado.</p>
    <p style="text-indent: 0pt;text-align: center;">
      <br />
    </p>
    <div class="textbox" style="background:#DEEAF6;">
      <p class="s19" style="text-indent: 0pt;line-height: 11pt;text-align: right;">Sección: Responsabilidad Civil</p>
      <p class="s19" style="text-indent: 0pt;line-height: 11pt;text-align: right;">Cobertura Accesoria</p>
      <p class="s20" style="padding-left: 5pt;text-indent: 0pt;text-align: center;">CLÁUSULA 2.13. R.C. Muerte 3º.</p>
      <p class="s20" style="padding-left: 5pt;text-indent: 0pt;text-align: center;">(Responsabilidad Civil Catastrófica por muerte a Terceros NO Ocupantes)</p>
    </div>
    <p style="padding-left: 39pt;text-indent: 0pt;text-align: center;" />
    <p style="padding-top: 12pt;text-indent: 0pt;text-align: center;">
      <br />
    </p>
    <p class="s12" style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">
      <a name="a67">Requisitos de contratación:</a>
    </p>
    <p style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">Esta es una cobertura accesoria que opera en exceso; por lo que su contratación requiere que se tenga amparada la cobertura básica R.C. Terceros.</p>
    <p style="text-indent: 0pt;text-align: center;">
      <br />
    </p>
    <ol id="l54">
      <li data-list-text="A)">
        <p class="s12" style="padding-left: 81pt;text-indent: -21pt;line-height: 11pt;text-align: justify;">
          <a name="a68">Alcance</a>
        </p>
        <p style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">Siempre que se hagan constar la contratación de esta cobertura y de la cobertura básica que corresponde, <b>L A T I N O </b>se obliga en exceso de la cobertura de R.C. Terceros, a amparar la responsabilidad civil en que incurra el <b>Asegurado </b>o cualquier persona que con su consentimiento expreso o tácito use el <b>Vehículo Asegurado </b>y que a consecuencia de dicho uso cause la muerte a <b>Terceros</b>. </p>
      </li>
      <li data-list-text="B)">
        <p class="s12" style="padding-top: 11pt;padding-left: 81pt;text-indent: -21pt;text-align: justify;">
          <a name="a69">Límite Máximo de Responsabilidad</a>
        </p>
        <p style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">El <b>Límite Máximo de Responsabilidad </b>de <b>L A T I N O </b>para esta cobertura se establece en la <b>Carátula de la Póliza </b>y opera una vez agotada la <b>Suma Asegurada </b>de la cobertura R.C. Terceros y se indemnizará de conformidad a lo establecido en la Cláusula &quot;Sumas Aseguradas y Bases de Indemnización&quot;. </p>
        <p style="text-indent: 0pt;text-align: center;">
          <br />
        </p>
      </li>
      <li data-list-text="C)">
        <p class="s12" style="padding-left: 81pt;text-indent: -21pt;text-align: justify;">
          <a name="a70">Deducible</a>
        </p>
        <p style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">No opera</p>
        <p style="text-indent: 0pt;text-align: center;">
          <br />
        </p>
      </li>
      <li data-list-text="D)">
        <p class="s21" style="padding-left: 74pt;text-indent: -17pt;text-align: justify;">Exclusiones</p>
        <p class="s15" style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">Queda entendido que, en adición a lo aplicable en la Cláusula Exclusiones Generales y las Exclusiones de la cobertura de R.C. Terceros, esta cobertura no cubre:</p>
        <p style="padding-top: 10pt;text-indent: 0pt;text-align: center;">
          <br />
        </p>
        <ol id="l55">
          <li data-list-text="1.">
            <p class="s15" style="padding-left: 81pt;text-indent: -21pt;text-align: justify;">Cualquier reconocimiento de adeudos, transacciones o cualesquiera otros actos de naturaleza semejante celebrados o concertados sin el consentimiento de L A T I N O. La confesión de un hecho no podrá ser asimilada al reconocimiento de una responsabilidad.</p>
          </li>
          <li data-list-text="2.">
            <p class="s15" style="padding-left: 81pt;text-indent: -21pt;text-align: justify;">La muerte de Terceros derivada de accidentes, cuando el Vehículo Asegurado participe en carreras o pruebas de seguridad, resistencia o velocidad.</p>
          </li>
          <li data-list-text="3.">
            <p class="s15" style="padding-left: 81pt;text-indent: -21pt;text-align: justify;">La muerte de Terceros derivada de Accidentes, cuando el Vehículo Asegurado sea destinado a un uso o servicio diferente al estipulado</p>
            <p class="s15" style="padding-top: 7pt;padding-left: 81pt;text-indent: 0pt;text-align: justify;">en la Carátula de la Póliza.</p>
          </li>
          <li data-list-text="4.">
            <p class="s15" style="padding-left: 81pt;text-indent: -21pt;text-align: justify;">La muerte que resulte por el uso del Vehículo Asegurado durante actos de guerra, revolución y por medidas de represión tomadas por las autoridades legalmente reconocidas con motivo de sus funciones.</p>
          </li>
          <li data-list-text="5.">
            <p class="s15" style="padding-left: 81pt;text-indent: -21pt;text-align: justify;">Perjuicios, gastos o cualquier otra obligación distinta de la indemnización que resulte a cargo del Contratante, Asegurado o Conductor, con motivo de su responsabilidad civil por la muerte a terceras personas.</p>
          </li>
          <li data-list-text="6.">
            <p class="s15" style="padding-left: 81pt;text-indent: -21pt;text-align: justify;">Daños a terceras personas en sus bienes.</p>
          </li>
          <li data-list-text="7.">
            <p class="s15" style="padding-left: 81pt;text-indent: -21pt;text-align: justify;">Los gastos de defensa jurídica del Conductor del Vehículo Asegurado con motivo de los procedimientos penales, civiles o de cualquier índole, originados por el Accidente.</p>
          </li>
          <li data-list-text="8.">
            <p class="s15" style="padding-left: 81pt;text-indent: -21pt;text-align: justify;">Costo de fianzas o cauciones de cualquier clase, así como las sanciones, perjuicios o cualesquiera otras obligaciones distintas de la indemnización que resulte a cargo del Contratante, Asegurado o Conductor con motivo de su responsabilidad civil.</p>
          </li>
          <li data-list-text="9.">
            <p class="s15" style="padding-left: 81pt;text-indent: -21pt;text-align: justify;">La muerte de Terceros que ocasione el Vehículo Asegurado a consecuencia de Vandalismo.</p>
          </li>
          <li data-list-text="10.">
            <p class="s15" style="padding-left: 81pt;text-indent: -21pt;text-align: justify;">La muerte de Terceros que ocasione el Vehículo Asegurado dentro de instalaciones aeroportuarias.</p>
          </li>
          <li data-list-text="11.">
            <p class="s15" style="padding-left: 81pt;text-indent: -21pt;text-align: justify;">La muerte por acto intencional o negligencia inexcusable de la víctima.</p>
          </li>
        </ol>
      </li>
    </ol>
    <p style="text-indent: 0pt;text-align: center;">
      <br />
    </p>
    <div class="textbox" style="background:#DEEAF6;">
      <p class="s19" style="text-indent: 0pt;line-height: 11pt;text-align: right;">Sección: Responsabilidad Civil</p>
      <p class="s19" style="text-indent: 0pt;text-align: right;">Cobertura Accesoria</p>
      <p class="s20" style="padding-left: 5pt;text-indent: 0pt;text-align: center;">CLÁUSULA 2.14. Cuidando tus Bienes. (R.C. Cruzada)</p>
    </div>
    <p style="padding-left: 39pt;text-indent: 0pt;text-align: center;" />
    <p class="s12" style="padding-top: 12pt;padding-left: 39pt;text-indent: 0pt;text-align: center;">
      <a name="a71">Requisitos de contratación:</a>
    </p>
    <p style="padding-left: 39pt;text-indent: 0pt;text-align: center;">Esta es una cobertura accesoria; por lo que su contratación requiere que se tenga amparada la cobertura básica R.C. Terceros.</p>
    <p style="text-indent: 0pt;text-align: center;">
      <br />
    </p>
    <ol id="l56">
      <li data-list-text="A)">
        <p class="s12" style="padding-left: 74pt;text-indent: -17pt;text-align: center;">
          <a name="a72">Alcance</a>
        </p>
        <p style="padding-left: 39pt;text-indent: 0pt;text-align: center;">Esta es una cobertura accesoria; por lo que su contratación requiere que se tenga amparada la cobertura básica R.C. Terceros.</p>
        <p style="text-indent: 0pt;text-align: center;">
          <br />
        </p>
      </li>
      <li data-list-text="B)">
        <p class="s12" style="padding-left: 74pt;text-indent: -17pt;text-align: center;">
          <a name="a73">Sub Límite Máximo de Responsabilidad</a>
        </p>
        <p style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">Queda entendido que esta cobertura opera como sublímite de la cobertura R.C. Terceros; este sublímite NO incrementa el <b>Límite Máximo de Responsabilidad </b>de la cobertura R.C. Terceros. </p>
        <p style="padding-top: 1pt;text-indent: 0pt;text-align: center;">
          <br />
        </p>
        <p style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">El Sublímite Máximo de Responsabilidad de <b>L A T I N O </b>para esta cobertura es del 50% del <b>Límite Máximo de Responsabilidad </b>contratado en la cobertura de R.C. Terceros, y opera como <b>Suma Asegurada </b>única para los diversos <b>Riesgos </b>amparados. </p>
        <p style="padding-top: 1pt;text-indent: 0pt;text-align: center;">
          <br />
        </p>
        <p style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">Toda indemnización que <b>L A T I N O </b>pague, se reducirá en igual cantidad de la <b>Suma Asegurada </b>para la cobertura de R.C. Terceros. En ningún caso la suma de las indemnizaciones excederá el sublímite. </p>
        <p style="text-indent: 0pt;text-align: center;">
          <br />
        </p>
      </li>
      <li data-list-text="C)">
        <p class="s12" style="padding-left: 74pt;text-indent: -17pt;text-align: center;">
          <a name="a74">Deducible</a>
        </p>
        <p style="padding-top: 7pt;padding-left: 39pt;text-indent: 0pt;text-align: center;">No opera</p>
      </li>
      <li data-list-text="D)">
        <p class="s21" style="padding-left: 74pt;text-indent: -17pt;text-align: justify;">Exclusiones</p>
        <p class="s15" style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">Queda entendido que, en adición a lo aplicable en la Cláusula Exclusiones Generales y las Exclusiones de la cobertura de R.C. Terceros, esta cobertura no cubre:</p>
        <p style="text-indent: 0pt;text-align: center;">
          <br />
        </p>
        <ol id="l57">
          <li data-list-text="1.">
            <p class="s15" style="padding-left: 81pt;text-indent: -21pt;text-align: justify;">Cualquier reconocimiento de adeudos, transacciones o cualesquiera otros actos de naturaleza semejante celebrados o concertados sin el consentimiento de LATINO.</p>
          </li>
          <li data-list-text="2.">
            <p class="s15" style="padding-left: 81pt;text-indent: -21pt;text-align: justify;">Agravamiento o complicación del padecimiento originado por el Accidente, derivados del alcoholismo, toxicomanías, así como de un descuido o imprudencia del lesionado, y/o de la persona o personas que lo cuiden, no acatando las indicaciones médicas prescritas.</p>
          </li>
          <li data-list-text="3.">
            <p class="s15" style="padding-left: 81pt;text-indent: -21pt;text-align: justify;">Padecimientos preexistentes o que no sean consecuencia del Accidente.</p>
            <p class="s15" style="padding-left: 81pt;text-indent: 0pt;text-align: justify;">Se entiende por padecimientos preexistentes aquellos cuyos síntomas o signos se manifiestan antes de la fecha del Accidente, o bien, aquellos hallazgos que, durante la atención del lesionado, ya sea por valoración clínica, estudios de laboratorio y/o gabinete indiquen lesiones y Enfermedades Preexistentes o crónico-degenerativas sin que éstas se hayan manifestado ni puesto en evidencia.</p>
          </li>
          <li data-list-text="4.">
            <p class="s15" style="padding-left: 81pt;text-indent: -21pt;text-align: justify;">La responsabilidad civil del Asegurado por la muerte y/o lesiones causadas a Terceros cuando sean Ocupantes del Vehículo Asegurado.</p>
          </li>
          <li data-list-text="5.">
            <p class="s15" style="padding-left: 81pt;text-indent: -21pt;text-align: justify;">Los Daños a bienes que no sean propiedad del Asegurado.</p>
          </li>
          <li data-list-text="6.">
            <p class="s15" style="padding-left: 81pt;text-indent: -21pt;text-align: justify;">Las lesiones y/o muerte cuando se trate del Contratante, Asegurado, y/o el Conductor del Vehículo Asegurado.</p>
          </li>
          <li data-list-text="7.">
            <p class="s15" style="padding-left: 81pt;text-indent: -21pt;text-align: justify;">Las prestaciones que deba solventar el Asegurado por Accidentes que sufran las personas ocupantes del vehículo de los que resulten obligaciones laborales, accidentes de trabajo o de riesgos profesionales determinados por la autoridad competente.</p>
          </li>
          <li data-list-text="8.">
            <p class="s15" style="padding-left: 81pt;text-indent: -21pt;text-align: center;">La responsabilidad civil a consecuencia de los Daños ocasionados por la carga.</p>
          </li>
          <li data-list-text="9.">
            <p class="s15" style="padding-left: 81pt;text-indent: -21pt;text-align: center;">La responsabilidad civil por Daños a Terceros en sus bienes y/o personas que se ocasionen fuera de la República Mexicana.</p>
          </li>
          <li data-list-text="10.">
            <p class="s15" style="padding-left: 81pt;text-indent: -21pt;text-align: center;">Daños originados por acciones intencionales o delitos dolosos.</p>
          </li>
        </ol>
      </li>
    </ol>
    <p style="text-indent: 0pt;text-align: center;">
      <br />
    </p>
    <div class="textbox" style="background:#DEEAF6;">
      <p class="s19" style="text-indent: 0pt;line-height: 11pt;text-align: right;">Sección: Responsabilidad Civil</p>
      <p class="s19" style="text-indent: 0pt;text-align: right;">Cobertura Accesoria</p>
      <p class="s20" style="padding-left: 5pt;text-indent: 0pt;line-height: 13pt;text-align: center;">CLÁUSULA 2.15. R.C. Remolque.</p>
    </div>
    <p style="padding-left: 39pt;text-indent: 0pt;text-align: center;" />
    <p class="s12" style="padding-top: 12pt;padding-left: 39pt;text-indent: 0pt;text-align: center;">
      <a name="a75">Requisitos de contratación:</a>
    </p>
    <p style="padding-left: 39pt;text-indent: 0pt;text-align: center;">Esta es una cobertura accesoria; por lo que su contratación requiere que se tenga amparada la cobertura básica R.C. Terceros.</p>
    <p style="padding-top: 2pt;text-indent: 0pt;text-align: center;">
      <br />
    </p>
    <ol id="l58">
      <li data-list-text="A)">
        <p class="s12" style="padding-left: 75pt;text-indent: -17pt;text-align: center;">
          <a name="a76">Alcance</a>
        </p>
        <p style="padding-left: 39pt;text-indent: 0pt;text-align: center;">Siempre que se hagan constar la contratación de esta cobertura y de la cobertura básica que</p>
        <p style="padding-top: 7pt;padding-left: 39pt;text-indent: 0pt;text-align: justify;">corresponde, <b>L A T I N O </b>se obliga a amparar los <b>Daños </b>a <b>Terceros </b>en sus bienes y personas que se ocasionen con el remolque, arrastrado por el <b>Vehículo Asegurado </b>mediante los mecanismos y dispositivos adecuados para tal fin. </p>
        <p style="padding-top: 2pt;text-indent: 0pt;text-align: center;">
          <br />
        </p>
      </li>
      <li data-list-text="B)">
        <p class="s12" style="padding-left: 74pt;text-indent: -17pt;line-height: 11pt;text-align: center;">
          <a name="a77">Límite Máximo de Responsabilidad</a>
        </p>
        <p style="padding-left: 39pt;text-indent: 0pt;line-height: 11pt;text-align: center;">El <b>Límite Máximo de Responsabilidad </b>de <b>L A T I N O </b>será del 30% (treinta por ciento) sobre el </p>
        <p class="s13" style="padding-left: 39pt;text-indent: 0pt;text-align: center;">Límite Máximo de Responsabilidad <span class="p">para la cobertura de </span>R.C. Terceros <span class="p">sin exceder el monto de</span>
        </p>
        <p style="padding-left: 39pt;text-indent: 0pt;text-align: center;">$2,000,000 de pesos (dos millones 00/100 M.N.) y se indemnizará de conformidad a lo establecido en la Cláusula &quot;Sumas Aseguradas y Bases de Indemnización&quot;.</p>
      </li>
      <li data-list-text="C)">
        <p class="s12" style="padding-top: 11pt;padding-left: 74pt;text-indent: -17pt;text-align: justify;">
          <a name="a78">Deducible</a>
        </p>
        <p style="padding-left: 39pt;text-indent: 0pt;text-align: center;">No opera</p>
        <p style="text-indent: 0pt;text-align: center;">
          <br />
        </p>
      </li>
      <li data-list-text="D)">
        <p class="s21" style="padding-left: 74pt;text-indent: -17pt;text-align: justify;">Exclusiones</p>
        <p class="s15" style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">Queda entendido que, en adición a lo aplicable en la Cláusula Exclusiones Generales y las Exclusiones de la cobertura de R.C. Terceros, esta cobertura no cubre:</p>
        <p style="text-indent: 0pt;text-align: center;">
          <br />
        </p>
        <ol id="l59">
          <li data-list-text="1.">
            <p class="s15" style="padding-left: 81pt;text-indent: -21pt;text-align: justify;">Remolques desenganchados.</p>
          </li>
          <li data-list-text="2.">
            <p class="s15" style="padding-left: 81pt;text-indent: -21pt;text-align: justify;">Las lesiones, muerte y/o Daños a bienes cuando se trate del Contratante, Asegurado o Conductor del Vehículo Asegurado. Personas que se encuentren dentro del remolque y este se encuentre enganchado y en circulación el Vehículo Asegurado.</p>
          </li>
        </ol>
      </li>
    </ol>
    <p style="text-indent: 0pt;text-align: center;">
      <br />
    </p>
    <div class="textbox" style="background:#DEEAF6;">
      <p class="s19" style="text-indent: 0pt;line-height: 11pt;text-align: right;">Sección: Responsabilidad Civil</p>
      <p class="s19" style="text-indent: 0pt;line-height: 11pt;text-align: right;">Cobertura Accesoria</p>
      <p class="s20" style="padding-left: 5pt;text-indent: 0pt;text-align: center;">CLÁUSULA 2.16. R.C. Carga.</p>
    </div>
    <p style="padding-left: 39pt;text-indent: 0pt;text-align: center;" />
    <p class="s12" style="padding-top: 12pt;padding-left: 39pt;text-indent: 0pt;text-align: center;">
      <a name="a79">Requisitos de contratación:</a>
    </p>
    <p style="padding-left: 39pt;text-indent: 0pt;text-align: center;">Esta es una cobertura accesoria; por lo que su contratación requiere que se tenga amparada la cobertura básica R.C. Terceros.</p>
    <p style="padding-top: 2pt;text-indent: 0pt;text-align: center;">
      <br />
    </p>
    <ol id="l60">
      <li data-list-text="A)">
        <p class="s12" style="padding-left: 75pt;text-indent: -17pt;text-align: justify;">
          <a name="a80">Alcance</a>
        </p>
        <p style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">Siempre que se haga constar la contratación de esta cobertura, <b>L A T I N O </b>ampara la responsabilidad civil en que incurra el <b>Asegurado </b>por <b>Daños </b>a <b>Terceros </b>en sus bienes y/o personas, causados por la carga que transporta el <b>Vehículo Asegurado</b>, ya sea en la cabina, en la batea o en el remolque cuando sea arrastrado por el <b>Vehículo Asegurado </b>con los mecanismos y dispositivos adecuado para tal fin. </p>
        <p style="text-indent: 0pt;text-align: center;">
          <br />
        </p>
        <p style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">El tipo de carga transportada en el <b>Vehículo Asegurado</b>, será de Uso particular, entendiendo dicho uso, como un transporte sin fin de lucro o ánimo comercial, mencionando de forma enunciativa y no limitativa, las siguientes mercancías, mismas que deberán ser acordes con actividades privadas: bebidas embotelladas, hielo, abarrotes y vinos, carnes y lácteos, muebles domésticos, plásticos, vidriería, equipo de prácticas deportivas, equipo electrónico y electrodomésticos. </p>
        <p style="text-indent: 0pt;text-align: center;">
          <br />
        </p>
      </li>
      <li data-list-text="B)">
        <p class="s12" style="padding-left: 75pt;text-indent: -17pt;text-align: center;">
          <a name="a81">Sub Límite Máximo de Responsabilidad</a>
        </p>
        <p style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">Queda entendido que esta cobertura opera como sublímite de la cobertura R.C. Terceros; este sublímite NO incrementa el límite máximo de responsabilidad de la cobertura R.C. Terceros.</p>
        <p style="text-indent: 0pt;text-align: center;">
          <br />
        </p>
        <p style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">El Sublímite Máximo de Responsabilidad de <b>L A T I N O </b>para esta cobertura es del 50% del <b>Límite Máximo de Responsabilidad </b>contratado en la cobertura de R.C. Terceros, y opera como <b>Suma Asegurada </b>única para los diversos <b>Riesgos </b>amparados. </p>
        <p style="padding-top: 8pt;text-indent: 0pt;text-align: center;">
          <br />
        </p>
        <p style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">Toda indemnización que <b>L A T I N O </b>pague, se reducirá en igual cantidad de la <b>Suma Asegurada </b>para la cobertura de R.C. Terceros. En ningún caso la suma de las indemnizaciones excederá el sublímite. </p>
        <p style="text-indent: 0pt;text-align: center;">
          <br />
        </p>
      </li>
      <li data-list-text="C)">
        <p class="s12" style="padding-left: 74pt;text-indent: -17pt;text-align: justify;">
          <a name="a82">Deducible</a>
        </p>
        <p style="padding-left: 39pt;text-indent: 0pt;text-align: center;">No opera</p>
        <p style="text-indent: 0pt;text-align: center;">
          <br />
        </p>
      </li>
      <li data-list-text="D)">
        <p class="s21" style="padding-left: 74pt;text-indent: -17pt;text-align: justify;">Exclusiones</p>
        <p class="s15" style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">Queda entendido que, en adición a lo aplicable en la Cláusula Exclusiones Generales y las Exclusiones de la cobertura de R.C. Terceros, esta cobertura no cubre:</p>
        <p style="text-indent: 0pt;text-align: center;">
          <br />
        </p>
        <ol id="l61">
          <li data-list-text="1.">
            <p class="s15" style="padding-left: 81pt;text-indent: -21pt;text-align: justify;">Los Daños causados por la carga en Accidentes cuando el Vehículo Asegurado se encuentre efectuando maniobras de carga y descarga, o el remolque se encuentre desenganchado del mismo.</p>
          </li>
          <li data-list-text="2.">
            <p class="s15" style="padding-left: 81pt;text-indent: -21pt;text-align: justify;">Cualquier Daño que sufra o se cause a la mercancía transportada y/o a sus contenedores o medio de transporte.</p>
          </li>
          <li data-list-text="3.">
            <p class="s15" style="padding-left: 81pt;text-indent: -21pt;text-align: justify;">Cualquier Daño que cause la carga o su medio de transporte al Vehículo Asegurado.</p>
          </li>
          <li data-list-text="4.">
            <p class="s15" style="padding-left: 81pt;text-indent: -21pt;text-align: justify;">De comprobarse que al momento de ocurrir el Siniestro el Asegurado transportaba una mercancía cuyo exceso de peso sea superior al tipo de carga cubierta, cesarán de pleno las obligaciones de L A T I N O para esta cobertura.</p>
          </li>
          <li data-list-text="5.">
            <p class="s15" style="padding-left: 81pt;text-indent: -21pt;text-align: justify;">Daños ocasionados por mercancías altamente peligrosas tales como sustancias y/o productos químicos, tóxicos y/o corrosivos, inflamables y/o explosivos, cualquier sustancia clasificada como clase o división I o clase o división 7 de acuerdo con lo establecido en la Norma Oficial Mexicana NOM-002-SCT/2011.</p>
          </li>
          <li data-list-text="6.">
            <p class="s15" style="padding-left: 81pt;text-indent: -21pt;text-align: justify;">Daños al medio ambiente, así como también los gastos de limpieza y/o remoción que por contaminación se ocasionen.</p>
          </li>
          <li data-list-text="7.">
            <p class="s15" style="padding-left: 81pt;text-indent: -21pt;text-align: justify;">La responsabilidad civil por Daños a Terceros en sus bienes y personas que se ocasione con el exceso de dimensiones de la carga transportada por el Vehículo Asegurado con respecto a las dimensiones del Vehículo Asegurado.</p>
          </li>
          <li data-list-text="8.">
            <p class="s15" style="padding-left: 81pt;text-indent: -21pt;text-align: justify;">Las lesiones, muerte y/o Daños a bienes de las siguientes personas: el Contratante, el Asegurado y el Conductor del Vehículo Asegurado.</p>
          </li>
        </ol>
      </li>
    </ol>
    <p style="text-indent: 0pt;text-align: center;">
      <br />
    </p>
    <div class="textbox" style="background:#DEEAF6;">
      <p class="s19" style="text-indent: 0pt;line-height: 11pt;text-align: right;">Sección: Responsabilidad Civil y Gastos Médicos</p>
      <p class="s19" style="text-indent: 0pt;text-align: right;">Cobertura Accesoria</p>
      <p class="s20" style="padding-left: 5pt;text-indent: 0pt;text-align: center;">CLÁUSULA 2.17. Protección Ocupantes. (Responsabilidad Civil por Daños a Ocupantes).</p>
    </div>
    <p style="padding-left: 39pt;text-indent: 0pt;text-align: center;" />
    <p class="s12" style="padding-top: 12pt;padding-left: 39pt;text-indent: 0pt;text-align: center;">
      <a name="a83">Requisitos de contratación:</a>
    </p>
    <p style="padding-left: 39pt;text-indent: 0pt;text-align: center;">Esta es una cobertura accesoria; por lo que su contratación requiere que se tengan amparadas las coberturas de R.C. Terceros y Gastos Médicos Ocupantes.</p>
    <p style="padding-top: 2pt;text-indent: 0pt;text-align: center;">
      <br />
    </p>
    <ol id="l62">
      <li data-list-text="A)">
        <p class="s12" style="padding-left: 74pt;text-indent: -17pt;text-align: justify;">
          <a name="a84">Alcance</a>
        </p>
        <p style="padding-top: 7pt;padding-left: 39pt;text-indent: 0pt;text-align: justify;">Siempre que se haga constar la contratación de esta cobertura y de las <b>coberturas </b>que correspondan, y en el entendido que, esta cobertura aplicará exclusivamente cuando el <b>Asegurado </b>o <b>Conductor </b>del <b>Vehículo Asegurado </b>sea determinado como responsable del <b>Siniestro</b>, por la autoridad competente, <b>L A T I N O </b>ampara los siguientes riesgos: </p>
        <p style="text-indent: 0pt;text-align: center;">
          <br />
        </p>
        <ol id="l63">
          <li data-list-text="1.">
            <p style="padding-left: 81pt;text-indent: -21pt;text-align: justify;">Gastos Legales y las indemnizaciones que deriven de la responsabilidad civil en que incurra el <b>Asegurado </b>o cualquier persona que con su consentimiento expreso o tácito use el <b>Vehículo Asegurado</b>, respecto a los ocupantes del <b>Vehículo Asegurado</b>. </p>
          </li>
          <li data-list-text="2.">
            <p style="padding-left: 81pt;text-indent: -21pt;text-align: justify;">El pago derivado de la incapacidad temporal; incapacidad total y permanente o la muerte que resulte por <b>Daños </b>corporales efectivamente causados a la o las personas que viajen en el <b>Vehículo Asegurado </b>en calidad de <b>Ocupantes</b>, incluyendo a aquellas que tengan algún Parentesco con el Asegurado, Contratante y/o Conductor del Vehículo <b>Asegurado</b>, siempre y cuando dichas lesiones sean a consecuencia de un hecho de tránsito terrestre que no se encuentre expresamente excluido por este Contrato. </p>
          </li>
          <li data-list-text="3.">
            <p style="padding-left: 81pt;text-indent: -21pt;line-height: 94%;text-align: justify;">El Daño Moral al que fuere condenado el <b>Asegurado </b>o <b>Conductor </b>autorizado para usar el <b>Vehículo Asegurado</b>, bajo los siguientes supuestos: </p>
            <ol id="l64">
              <li data-list-text="3.1.">
                <p style="padding-left: 102pt;text-indent: -21pt;text-align: justify;">Exista una sentencia firme que condene al <b>Asegurado </b>y/o <b>Conductor </b>autorizado al pago de cantidad liquida por este concepto; </p>
              </li>
              <li data-list-text="3.2.">
                <p style="padding-left: 102pt;text-indent: -21pt;text-align: justify;">El monto máximo al que se obliga <b>L A T I N O</b>, en ningún caso superará el 25% (veinticinco por ciento) de la <b>Suma Asegurada </b>descrita en la <b>Carátula de la Póliza </b>para la cobertura de Protección Ocupantes; </p>
              </li>
              <li data-list-text="3.3.">
                <p style="padding-left: 102pt;text-indent: -21pt;text-align: justify;">En caso de que el <b>Asegurado </b>y/o <b>Conductor </b>como consecuencia del mismo <b>Siniestro </b>fuera condenado a pagar alguna cantidad por concepto de responsabilidad civil <b>Ocupantes</b>, se entiende que el remanente no pagado, será la base para calcular el 25% (veinticinco por ciento) de la obligación por Daño Moral por parte de <b>L A T I N O</b>. </p>
              </li>
            </ol>
          </li>
          <li data-list-text="4.">
            <p style="padding-left: 81pt;text-indent: -21pt;text-align: justify;">Extensión de Gastos Médicos Ocupantes y gastos de entierro por pérdida de la vida. La cobertura de Protección Ocupantes se extiende y ampara los gastos médicos <b>Ocupantes </b>del <b>Vehículo Asegurado </b>y gastos de entierro por pérdida de la vida, en el entendido de que esta extensión de cobertura nunca será sustitutiva ni concurrente a cualquier otro seguro, que contra los mismos riesgos se tenga en vigor sobre la unidad siniestrada, ya que la presente operará solo en exceso de lo estipulado en la cobertura Gastos Médicos Ocupantes de las presentes <b>Condiciones Generales</b>
            </p>
            <p style="text-indent: 0pt;text-align: center;">
              <br />
            </p>
          </li>
        </ol>
      </li>
      <li data-list-text="B)">
        <p class="s12" style="padding-left: 81pt;text-indent: -21pt;text-align: justify;">
          <a name="a85">Límite Máximo de Responsabilidad</a>
        </p>
        <p style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">El <b>Límite Máximo de Responsabilidad </b>de <b>L A T I N O </b>para esta cobertura se establece en la <b>Carátula de la Póliza </b>y opera como <b>Límite Único y Combinado </b>para todos los riesgos amparados por ella. El <b>Límite Máximo de Responsabilidad </b>inicial por persona para esta cobertura se determinará en forma proporcional con base en el número de <b>Ocupantes </b>que resulten lesionados, sin sobrepasar la <b>Suma Asegurada </b>contratada. </p>
        <p style="padding-top: 11pt;padding-left: 39pt;text-indent: 0pt;text-align: justify;">La <b>Suma Asegurada </b>por responsabilidad civil por muerte o incapacidad del ocupante, será la que corresponda o determine cada legislación de la entidad federativa en que se haya realizado la eventualidad prevista en esta cobertura sin exceder de la <b>Suma Asegurada </b>establecida en la <b>Carátula de la Póliza</b>. </p>
        <p style="text-indent: 0pt;text-align: center;">
          <br />
        </p>
        <p style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">El pago del monto al que ascienda la responsabilidad en que incurra el <b>Asegurado </b>y/o <b>Conductor </b>que exceda a la <b>Suma Asegurada </b>para esta cobertura estipulada en la <b>Carátula de la Póliza</b>, ya sea por la ocurrencia de uno o más <b>Siniestro</b>s, será responsabilidad del propio <b>Asegurado </b>y/o <b>Conductor</b>, limitándose la responsabilidad de <b>L A T I N O </b>a la cantidad correspondiente a la <b>Suma Asegurada </b>estipulada en la <b>Carátula de la Póliza</b>. </p>
      </li>
      <li data-list-text="C)">
        <p class="s12" style="padding-top: 11pt;padding-left: 81pt;text-indent: -21pt;line-height: 13pt;text-align: justify;">
          <a name="a86">Deducible</a>
        </p>
        <p style="padding-left: 39pt;text-indent: 0pt;line-height: 11pt;text-align: justify;">No opera</p>
      </li>
      <li data-list-text="D)">
        <p class="s21" style="padding-top: 7pt;padding-left: 81pt;text-indent: -21pt;text-align: justify;">Exclusiones</p>
        <p class="s15" style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">Queda entendido que, en adición a lo aplicable en la Cláusula Exclusiones Generales y las Exclusiones de las coberturas de R.C. Terceros y Gastos Médicos Ocupantes, esta cobertura no cubre:</p>
        <p style="text-indent: 0pt;text-align: center;">
          <br />
        </p>
        <ol id="l65">
          <li data-list-text="1.">
            <p class="s15" style="padding-left: 81pt;text-indent: -21pt;text-align: justify;">Los Daños a personas cuando se trate de; el Conductor del vehículo Asegurado, el Asegurado y el Contratante.</p>
          </li>
          <li data-list-text="2.">
            <p class="s15" style="padding-left: 81pt;text-indent: -21pt;text-align: justify;">Si el Conductor responsable del Vehículo Asegurado resulta ser el Beneficiario de la indemnización a pagar por esta cobertura, exceptuando la indemnización de gastos médicos.</p>
          </li>
          <li data-list-text="3.">
            <p class="s15" style="padding-left: 81pt;text-indent: -21pt;text-align: justify;">Esta cobertura no ampara la responsabilidad en que incurra el Asegurado y/o Conductor del Vehículo Asegurado por los Daños en bienes de Terceros o Daños diversos a los estipulados en esta cobertura, aún cuando éstos pertenezcan a Ocupantes del Vehículo Asegurado.</p>
          </li>
          <li data-list-text="4.">
            <p class="s15" style="padding-left: 81pt;text-indent: -21pt;text-align: justify;">Cuando el Vehículo Asegurado participe en competencias automovilísticas de velocidad y/o resistencia, ya sea de aficionados o de profesionales.</p>
          </li>
          <li data-list-text="5.">
            <p class="s15" style="padding-left: 81pt;text-indent: -21pt;text-align: justify;">Cualquier reconocimiento de adeudos, transacciones o cualesquiera otros actos de naturaleza semejante celebrados o concertados sin el consentimiento de L A T I N O. La confesión de la materialidad de un hecho no podrá ser asimilada al reconocimiento de una responsabilidad.</p>
          </li>
          <li data-list-text="6.">
            <p class="s15" style="padding-left: 81pt;text-indent: -21pt;text-align: justify;">Cualquier perjuicio, gasto, pérdida, indemnización y Daño, siempre y cuando estas afectaciones patrimoniales sean indirectas.</p>
          </li>
          <li data-list-text="7.">
            <p class="s15" style="padding-left: 81pt;text-indent: -21pt;text-align: justify;">Los gastos médicos en que se incurra con motivo de lesiones que sufran los Ocupantes del Vehículo Asegurado, derivados de riña, sin importar el grado de participación de los Ocupantes en la misma.</p>
          </li>
          <li data-list-text="8.">
            <p class="s15" style="padding-left: 81pt;text-indent: -21pt;text-align: justify;">Los gastos médicos derivados de Enfermedades Congénitas y/o Preexistentes.</p>
          </li>
        </ol>
      </li>
    </ol>
    <p style="text-indent: 0pt;text-align: center;">
      <br />
    </p>
    <div class="textbox" style="background:#DEEAF6;">
      <p class="s19" style="text-indent: 0pt;line-height: 11pt;text-align: right;">Sección: Responsabilidad Civil Familiar</p>
      <p class="s19" style="text-indent: 0pt;line-height: 11pt;text-align: right;">Cobertura Básica</p>
      <p class="s20" style="padding-left: 5pt;text-indent: 0pt;line-height: 13pt;text-align: center;">CLÁUSULA 2.18. Protección Familiar.</p>
      <p class="s19" style="padding-left: 5pt;text-indent: 0pt;line-height: 11pt;text-align: center;">(RC Familiar)</p>
    </div>
    <p style="padding-left: 39pt;text-indent: 0pt;text-align: center;" />
    <ol id="l66">
      <li data-list-text="A)">
        <p class="s12" style="padding-top: 10pt;padding-left: 81pt;text-indent: -21pt;text-align: justify;">
          <a name="a87">Alcance de la cobertura</a>
        </p>
        <p style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">Siempre que se haga constar la contratación de esta cobertura, <b>L A T I N O </b>se obliga a amparar el pago de los <b>Daños</b>, perjuicios y Daño Moral Consecuencial, por los que sea responsable el <b>Asegurado</b>, conforme a la legislación aplicable en materia de Responsabilidad Civil vigente en la República Mexicana o legislación extranjera en el caso de viajes familiares en el extranjero, y a lo previsto en la presente sección. </p>
        <p style="text-indent: 0pt;text-align: center;">
          <br />
        </p>
        <p style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">La obligación de cubrir el porcentaje señalado a continuación por concepto de:</p>
        <p style="text-indent: 0pt;text-align: center;">
          <br />
        </p>
        <ol id="l67">
          <li data-list-text="1.">
            <p style="padding-left: 81pt;text-indent: -21pt;text-align: justify;">Daño Moral Consecuencial al que fuere condenado el <b>Asegurado</b>, bajo los siguientes supuestos: </p>
            <ol id="l68">
              <li data-list-text="a)">
                <p style="padding-left: 95pt;text-indent: -14pt;text-align: center;">Exista una sentencia firme que condene al <b>Asegurado </b>al pago de cantidad líquida por ese concepto. </p>
              </li>
              <li data-list-text="b)">
                <p style="padding-top: 7pt;padding-left: 95pt;text-indent: -14pt;text-align: justify;">El monto máximo al que se obliga <b>L A T I N O</b>, en ningún caso superará el 25% (veinticinco por ciento) del <b>Límite Máximo de Responsabilidad </b>contratado en la cobertura de Protección Familiar (Responsabilidad Civil Familiar), y opera como <b>Suma Asegurada </b>única para los diversos <b>Riesgos </b>amparados. </p>
              </li>
            </ol>
          </li>
          <li data-list-text="2.">
            <p style="padding-top: 10pt;padding-left: 81pt;text-indent: -21pt;text-align: justify;">El pago de los gastos de defensa del <b>Asegurado </b>incluyen: </p>
            <ol id="l69">
              <li data-list-text="a)">
                <p style="padding-left: 95pt;text-indent: -14pt;text-align: justify;">El pago del importe de las <b>Prima</b>s por fianzas judiciales que el <b>Asegurado </b>deba otorgar en garantía del pago de las sumas que le sean reclamadas a título de Responsabilidad Civil amparada por esta cobertura. </p>
              </li>
              <li data-list-text="b)">
                <p style="padding-left: 95pt;text-indent: -13pt;line-height: 11pt;text-align: justify;">El pago de los gastos, costas e intereses legales que deba pagar el <b>Asegurado</b>
                </p>
                <p style="padding-left: 95pt;text-indent: 0pt;line-height: 11pt;text-align: justify;">por resolución judicial o arbitral ejecutoriada.</p>
              </li>
              <li data-list-text="c)">
                <p style="padding-left: 95pt;text-indent: -14pt;text-align: justify;">El pago de los gastos en que incurra el <b>Asegurado </b>con motivo de la tramitación y liquidación de las reclamaciones. </p>
              </li>
            </ol>
          </li>
          <li data-list-text="3.">
            <p style="padding-top: 11pt;padding-left: 81pt;text-indent: -21pt;line-height: 13pt;text-align: justify;">Arrendatario de uno o varios condominios y/o departamentos y/o casa habitación:</p>
            <ol id="l70">
              <li data-list-text="a)">
                <p style="padding-left: 95pt;text-indent: -14pt;text-align: justify;">El monto máximo al que se obliga <b>L A T I N O</b>, en ningún caso superará el 50% (cincuenta por ciento) del <b>Límite Máximo de Responsabilidad </b>contratado en la cobertura de Protección Familiar (Responsabilidad Civil Familiar), y opera como <b>Suma Asegurada </b>única para los diversos <b>Riesgos </b>amparados. </p>
              </li>
            </ol>
          </li>
          <li data-list-text="4.">
            <p style="padding-top: 11pt;padding-left: 81pt;text-indent: -21pt;line-height: 13pt;text-align: justify;">Actividades de Trabajadores Domésticos:</p>
            <ol id="l71">
              <li data-list-text="a)">
                <p style="padding-left: 95pt;text-indent: -14pt;text-align: justify;">El monto máximo al que se obliga <b>L A T I N O</b>, en ningún caso será mayor a $50,000 pesos (cincuenta mil M.N.), y opera como <b>Suma Asegurada </b>única para los diversos <b>Riesgos </b>amparados. </p>
              </li>
            </ol>
          </li>
        </ol>
        <p style="padding-top: 11pt;padding-left: 39pt;text-indent: 0pt;text-align: justify;">Toda indemnización que <b>L A T I N O </b>pague, se reducirá en igual cantidad de la <b>Suma Asegurada </b>para la cobertura de Protección Familiar. En ningún caso la suma de las indemnizaciones excederá el sublímite ni el <b>Límite Máximo de Responsabilidad </b>contratado. </p>
        <p style="text-indent: 0pt;text-align: center;">
          <br />
        </p>
      </li>
      <li data-list-text="B)">
        <p class="s12" style="padding-left: 81pt;text-indent: -21pt;text-align: justify;">
          <a name="a88">Funcionamiento de la cobertura</a>
        </p>
        <p style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">Se otorga esta cobertura de acuerdo con lo siguiente:</p>
        <p style="text-indent: 0pt;text-align: center;">
          <br />
        </p>
        <ol id="l72">
          <li data-list-text="1.">
            <p class="s12" style="padding-left: 81pt;text-indent: -21pt;text-align: justify;">
              <a name="a89">Actividades familiares e inmuebles</a>
            </p>
            <p style="padding-left: 60pt;text-indent: 0pt;text-align: justify;">Queda cubierta la Responsabilidad Civil del <b>Asegurado </b>por los <b>Daños </b>que cause a <b>Terceros </b>derivados de las actividades privadas familiares en su carácter de propietario y/o arrendatario y/o condómino de departamento o casa habitación y, en especial, pero sin limitarse, a los siguientes supuestos: </p>
            <ol id="l73">
              <li data-list-text="a)">
                <p style="padding-top: 10pt;padding-left: 95pt;text-indent: -13pt;text-align: justify;">Como jefe de familia.</p>
              </li>
              <li data-list-text="b)">
                <p style="padding-left: 95pt;text-indent: -14pt;text-align: justify;">Como propietario y/o arrendatario de uno o varios condominios y/o departamentos y/o casa habitación (incluye los inmuebles propios habitados los fines de semana o en vacaciones) como sus garajes, jardines, piscinas, antenas, instalaciones de seguridad y demás pertenencias y accesorios.</p>
              </li>
              <li data-list-text="c)">
                <p style="padding-left: 95pt;text-indent: -13pt;text-align: justify;">Por <b>Daños </b>a consecuencia de un derrame de agua, accidental o imprevisto. </p>
              </li>
              <li data-list-text="d)">
                <p style="padding-top: 1pt;padding-left: 95pt;text-indent: -13pt;text-align: justify;">Por la práctica de deportes como aficionado.</p>
              </li>
              <li data-list-text="e)">
                <p style="padding-left: 95pt;text-indent: -14pt;text-align: justify;">Por el uso de bicicletas, patines, embarcaciones de pedal o remo y vehículos no motorizados que no requieran placa para circular.</p>
              </li>
              <li data-list-text="f)">
                <p style="padding-left: 95pt;text-indent: -14pt;text-align: justify;">Por la tenencia o uso de armas blancas, de aire o de fuego para fines de cacería o de tiro al blanco, siempre y cuando el <b>Asegurado </b>esté legalmente autorizado para su uso y posesión. </p>
              </li>
              <li data-list-text="g)">
                <p style="padding-left: 95pt;text-indent: -14pt;text-align: justify;">Como propietario de animales domésticos, de caza y guardianes, dentro y fuera del Domicilio Permanente del <b>Asegurado</b>. </p>
              </li>
              <li data-list-text="h)">
                <p style="padding-left: 95pt;text-indent: -13pt;text-align: justify;">Durante viajes de estudio, de vacaciones o de placer dentro de la República Mexicana.</p>
              </li>
              <li data-list-text="i)">
                <p style="padding-left: 95pt;text-indent: -14pt;text-align: justify;">Durante actividades culturales y de esparcimiento en cines, teatros y espectáculos públicos, visitas a tiendas y centros comerciales, visitas sociales a parientes y amigos,</p>
                <p style="padding-top: 7pt;padding-left: 95pt;text-indent: 0pt;text-align: justify;">y demás actividades privadas fuera del domicilio del <b>Asegurado</b>. </p>
              </li>
              <li data-list-text="j)">
                <p style="padding-left: 95pt;text-indent: -14pt;text-align: justify;">Por <b>Daños </b>ocasionados a las áreas comunes del condominio, en caso de que el <b>Asegurado </b>sea condómino, pero descontado el porcentaje de indiviso que le corresponda como propietario de dichas áreas comunes. </p>
              </li>
              <li data-list-text="k)">
                <p style="padding-left: 95pt;text-indent: -14pt;text-align: justify;">Por accidentes ocasionados a sus trabajadores domésticos con motivo de <b>Culpa Grave </b>o descuidos no intencionales, en relación con las obligaciones que imponen los artículos 473 y 487 de la Ley Federal del Trabajo. </p>
                <p style="text-indent: 0pt;text-align: center;">
                  <br />
                </p>
              </li>
            </ol>
          </li>
          <li data-list-text="2.">
            <p class="s12" style="padding-left: 81pt;text-indent: -21pt;text-align: justify;">
              <a name="a90">Viajes familiares en el extranjero</a>
            </p>
            <p style="padding-left: 60pt;text-indent: 0pt;text-align: justify;">Esta cobertura asegura además la Responsabilidad Civil legal en que incurriere el <b>Asegurado </b>por <b>Daños </b>a <b>Terceros </b>derivada de <b>Siniestro</b>s ocurridos durante viajes privados de estudio o vacaciones de placer, fuera de la República Mexicana. </p>
          </li>
          <li data-list-text="3.">
            <p class="s12" style="padding-top: 11pt;padding-left: 81pt;text-indent: -21pt;line-height: 11pt;text-align: justify;">
              <a name="a91">Trabajadores domésticos</a>
            </p>
            <p style="padding-left: 60pt;text-indent: 0pt;text-align: justify;">Se amparan las siguientes responsabilidades civiles que se deriven de las actividades de trabajadores domésticos:</p>
            <ol id="l74">
              <li data-list-text="a)">
                <p style="padding-left: 81pt;text-indent: -14pt;text-align: justify;">Por accidentes que sufran sus trabajadores domésticos durante el desempeño de sus funciones y que les ocasione lesiones corporales o la muerte.</p>
              </li>
              <li data-list-text="b)">
                <p style="padding-left: 81pt;text-indent: -14pt;line-height: 11pt;text-align: justify;">Por <b>Daños </b>a <b>Terceros </b>causados por los trabajadores domésticos, siempre y cuando el </p>
                <p class="s13" style="padding-left: 81pt;text-indent: 0pt;line-height: 11pt;text-align: justify;">Daño <span class="p">ocurra durante el desempeño de sus labores de trabajo al servicio del </span>Asegurado <span class="p">.</span>
                </p>
              </li>
              <li data-list-text="c)">
                <p style="padding-left: 81pt;text-indent: -14pt;text-align: justify;">Por <b>Daños </b>a <b>Terceros </b>causados por los trabajadores eventuales contratados por el <b>Asegurado</b>, siempre y cuando el <b>Daño </b>ocurra durante el desempeño de sus labores de trabajo al servicio del <b>Asegurado</b>. </p>
                <p style="text-indent: 0pt;text-align: center;">
                  <br />
                </p>
              </li>
            </ol>
          </li>
          <li data-list-text="4.">
            <p class="s12" style="padding-left: 81pt;text-indent: -21pt;text-align: justify;">
              <a name="a92">Responsabilidad Civil Arrendatario</a>
            </p>
            <p style="padding-left: 60pt;text-indent: 0pt;text-align: justify;">Se cubre la Responsabilidad Civil del <b>Asegurado </b>por <b>Daños </b>al inmueble que ocupe como casa habitación en calidad de arrendatario, siempre y cuando tales <b>Daños </b>hayan sido causados por Incendio y/o explosión y de los cuales resulte civilmente responsable. </p>
          </li>
        </ol>
      </li>
      <li data-list-text="C)">
        <p class="s12" style="padding-top: 11pt;padding-left: 81pt;text-indent: -21pt;text-align: justify;">
          <a name="a93">Personas y domicilios asegurados</a>
        </p>
        <p style="padding-left: 60pt;text-indent: 0pt;text-align: justify;">La persona Titular de esta cobertura es:</p>
        <p style="text-indent: 0pt;text-align: center;">
          <br />
        </p>
        <ol id="l75">
          <li data-list-text="1.">
            <p style="padding-left: 81pt;text-indent: -14pt;text-align: justify;">El <b>Contratante </b>del seguro, cuando sea persona física. </p>
          </li>
          <li data-list-text="2.">
            <p style="padding-left: 81pt;text-indent: -14pt;text-align: justify;">El <b>Conductor Habitual </b>declarado, en caso de que el <b>Contratante </b>del seguro sea persona moral. En caso de no señalarse <b>Conductor Habitual</b>, la cobertura no podrá ser contratada. </p>
            <p style="padding-top: 11pt;padding-left: 60pt;text-indent: 0pt;text-align: justify;">El domicilio asegurado para esta cobertura será el señalado en la <b>Carátula de la Póliza</b>. </p>
            <p style="text-indent: 0pt;text-align: center;">
              <br />
            </p>
            <p style="padding-left: 60pt;text-indent: 0pt;text-align: center;">Se otorga esta cobertura a la persona asegurada, con respecto a su Responsabilidad Civil privada y familiar por:</p>
            <ol id="l76">
              <li data-list-text="a)">
                <p style="padding-left: 95pt;text-indent: -13pt;line-height: 11pt;text-align: center;">Actos propios.</p>
              </li>
              <li data-list-text="b)">
                <p style="padding-left: 95pt;text-indent: -13pt;line-height: 11pt;text-align: center;">Actos de los hijos sujetos a su patria potestad.</p>
              </li>
              <li data-list-text="c)">
                <p style="padding-left: 95pt;text-indent: -13pt;line-height: 11pt;text-align: center;">Actos de los incapacitados sujetos a su tutela.</p>
                <p style="text-indent: 0pt;text-align: center;">
                  <br />
                </p>
                <p style="padding-left: 60pt;text-indent: 0pt;line-height: 11pt;text-align: center;">Este seguro se amplía a cubrir la Responsabilidad Civil personal de:</p>
                <ol id="l77">
                  <li data-list-text="a)">
                    <p style="padding-left: 95pt;text-indent: -13pt;line-height: 11pt;text-align: center;">El cónyuge o concubino(a) del <b>Asegurado</b>. </p>
                  </li>
                  <li data-list-text="b)">
                    <p style="padding-left: 95pt;text-indent: -13pt;text-align: center;">Los hijos, pupilos e incapacitados sujetos a la patria potestad del <b>Asegurado</b>. </p>
                  </li>
                  <li data-list-text="c)">
                    <p style="padding-left: 95pt;text-indent: -14pt;text-align: center;">Los padres del <b>Asegurado </b>o los de su cónyuge o concubino(a), solo si viven permanentemente con el <b>Asegurado </b>y bajo la dependencia económica de él. </p>
                  </li>
                  <li data-list-text="d)">
                    <p style="padding-left: 95pt;text-indent: -14pt;text-align: center;">Los hijos mayores de edad que, por estudios o soltería, siguen viviendo permanentemente con el <b>Asegurado </b>y/o bajo la dependencia económica de él. </p>
                  </li>
                </ol>
                <p style="text-indent: 0pt;text-align: center;">
                  <br />
                </p>
                <p style="padding-left: 60pt;text-indent: 0pt;text-align: center;">Las personas citadas anteriormente, a excepción de los trabajadores domésticos, en ningún caso podrán ser consideradas como <b>Terceros </b>dañados para efecto de esta cobertura. </p>
              </li>
            </ol>
          </li>
        </ol>
      </li>
      <li data-list-text="D)">
        <p class="s12" style="padding-top: 7pt;padding-left: 81pt;text-indent: -21pt;text-align: justify;">
          <a name="a94">Límite Máximo de Responsabilidad</a>
        </p>
        <p style="padding-left: 60pt;text-indent: 0pt;text-align: justify;">El <b>Límite Máximo de Responsabilidad </b>de <b>L A T I N O </b>para esta cobertura se establece en la <b>Carátula de la Póliza </b>y opera como <b>Suma Asegurada </b>única a Primer Riesgo para los diversos riesgos que se amparan por uno o todos los <b>Siniestro</b>s que puedan ocurrir durante la vigencia de la <b>Póliza</b>. </p>
        <p style="text-indent: 0pt;text-align: center;">
          <br />
        </p>
        <p style="padding-left: 60pt;text-indent: 0pt;text-align: justify;">Para los efectos de esta cobertura, por Primer Riesgo se entenderá: el <b>Daño </b>o pérdida que a consecuencia de un riesgo cubierto se indemniza por completo, sin importar el valor total de los bienes en forma individual o en su conjunto, pero con el límite de la <b>Suma Asegurada </b>contratada. </p>
        <p style="text-indent: 0pt;text-align: center;">
          <br />
        </p>
        <p style="padding-left: 60pt;text-indent: 0pt;text-align: justify;">El pago de gastos de defensa del <b>Asegurado </b>realizados en la República Mexicana está cubierto como sublímite, pero sin exceder del 50% (cincuenta por ciento) de la <b>Suma Asegurada </b>estipulada en la <b>Carátula de la Póliza</b>. </p>
        <p style="padding-top: 11pt;padding-left: 60pt;text-indent: 0pt;text-align: justify;">La ocurrencia de varios <b>Daños </b>durante la vigencia de la <b>Carátula de la Póliza </b>y procedentes de la misma causa será considerada como un solo <b>Evento</b>, el cual se tendrá como realizado en el momento en el que se produzca el primer <b>Daño </b>de la serie. </p>
      </li>
      <li data-list-text="E)">
        <p class="s12" style="padding-top: 11pt;padding-left: 81pt;text-indent: -21pt;text-align: justify;">
          <a name="a95">Deducible</a>
        </p>
        <p style="padding-left: 57pt;text-indent: 0pt;text-align: justify;">No opera</p>
        <p style="text-indent: 0pt;text-align: center;">
          <br />
        </p>
      </li>
      <li data-list-text="F)">
        <p class="s21" style="padding-left: 81pt;text-indent: -21pt;text-align: justify;">Exclusiones</p>
        <p class="s15" style="padding-left: 60pt;text-indent: 0pt;text-align: justify;">Queda entendido que, en adición a lo aplicable respecto a la Cláusula Exclusiones Generales, esta cobertura en ningún caso ampara:</p>
        <ol id="l78">
          <li data-list-text="1.">
            <p class="s15" style="padding-left: 102pt;text-indent: -21pt;text-align: justify;">Responsabilidades provenientes del incumplimiento de contratos o convenios y sus correspondientes prestaciones sustitutorias.</p>
          </li>
          <li data-list-text="2.">
            <p class="s15" style="padding-left: 102pt;text-indent: -21pt;text-align: justify;">Responsabilidades derivadas del uso, propiedad o posesión de embarcaciones, aeronaves y vehículos terrestres de motor.</p>
          </li>
          <li data-list-text="3.">
            <p class="s15" style="padding-left: 102pt;text-indent: -21pt;text-align: justify;">La exclusión anterior no aplica en el caso de vehículos terrestres de motor cuyo uso se circunscribe al interior del domicilio del Asegurado y que no requieren placas para su utilización en espacios abiertos.</p>
          </li>
          <li data-list-text="4.">
            <p class="s15" style="padding-left: 102pt;text-indent: -21pt;text-align: justify;">Daños a Terceros por participación activa en apuestas, carreras, concursos o competencias deportivas de cualquier clase o de sus pruebas preparatorias.</p>
          </li>
          <li data-list-text="5.">
            <p class="s15" style="padding-left: 102pt;text-indent: -21pt;text-align: justify;">Daños a Terceros derivados de la explotación de una industria, negocio, del ejercicio de un oficio, profesión, servicio retribuido, de un cargo aun cuando sean honoríficos.</p>
          </li>
          <li data-list-text="6.">
            <p class="s15" style="padding-left: 102pt;text-indent: -21pt;text-align: justify;">Responsabilidades provenientes de obras de restauración y remodelación.</p>
          </li>
          <li data-list-text="7.">
            <p class="s15" style="padding-left: 102pt;text-indent: -21pt;text-align: justify;">Pago de primas por fianza o caución que deba otorgarse para que el Asegurado alcance la libertad.</p>
          </li>
          <li data-list-text="8.">
            <p class="s15" style="padding-left: 102pt;text-indent: -21pt;text-align: justify;">Toda reclamación que tenga o represente el carácter de multa, de una pena o de un castigo, como aquellas llamadas por Daños punitivos o “punitive damages”, Daños por venganza o “vindictive damages”, Daños ejemplares o “exemplary damages”, u otras con terminología parecida. Daño físico.</p>
          </li>
          <li data-list-text="9.">
            <p class="s15" style="padding-left: 102pt;text-indent: -21pt;text-align: justify;">Responsabilidades derivadas de Daños ocasionados dolosamente por el Asegurado o con su complicidad.</p>
          </li>
          <li data-list-text="10.">
            <p class="s15" style="padding-top: 7pt;padding-left: 102pt;text-indent: -21pt;text-align: justify;">Responsabilidades de Daños ocasionados al cónyuge, los padres, hijos, hermanos, padres o hermanos políticos u otros parientes del Asegurado que habiten permanentemente con él.</p>
          </li>
          <li data-list-text="11.">
            <p class="s15" style="padding-left: 102pt;text-indent: -21pt;text-align: justify;">Responsabilidades laborales imputables al Asegurado de acuerdo con la Ley del Seguro Social u otras disposiciones complementarias de esta materia, a excepción de las obligaciones que imponen los artículos 473 y 487 de la Ley Federal del Trabajo.</p>
          </li>
          <li data-list-text="12.">
            <p class="s15" style="padding-left: 102pt;text-indent: -21pt;text-align: justify;">Responsabilidades por Daños causados por inconsistencia o hundimiento o asentamiento de suelo o subsuelo.</p>
          </li>
          <li data-list-text="13.">
            <p class="s15" style="padding-left: 102pt;text-indent: -21pt;text-align: justify;">No se ampara al Contratante de la Carátula de la Póliza en caso de ser una persona moral.</p>
          </li>
        </ol>
      </li>
    </ol>
    <p style="text-indent: 0pt;text-align: center;">
      <br />
    </p>
    <div class="textbox" style="background:#DEEAF6;">
      <p class="s19" style="padding-left: 345pt;text-indent: -21pt;text-align: right;">Sección: Gastos Médicos Cobertura Accesoria</p>
      <p class="s20" style="padding-left: 5pt;text-indent: 0pt;line-height: 12pt;text-align: center;">CLÁUSULA 2.19. Gastos Médicos Ocupantes</p>
      <p class="s19" style="padding-left: 5pt;text-indent: 0pt;text-align: center;">(Gastos médicos otorgados al Conductor y Ocupantes)</p>
    </div>
    <p style="padding-left: 39pt;text-indent: 0pt;text-align: center;" />
    <ol id="l79">
      <li data-list-text="A)">
        <p class="s12" style="padding-top: 13pt;padding-left: 74pt;text-indent: -17pt;text-align: justify;">
          <a name="a96">Alcance de cobertura Conductor y Ocupantes:</a>
        </p>
        <p style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">Siempre que se haga constar la contratación de esta cobertura, <b>L A T I N O </b>se obliga a cubrir el pago de los gastos médicos por concepto de hospitalización, medicinas, <b>Atención Médica</b>, enfermeros, servicio de ambulancia y gastos de entierro, originados por lesiones corporales que sufra el <b>Asegurado</b>, <b>Conductor </b>o cualquier persona <b>Ocupante </b>del <b>Vehículo Asegurado</b>, en <b>Accidentes Automovilísticos </b>o por cualquiera de los riesgos mencionados en la cobertura de Daños Materiales, siempre que las lesiones corporales ocurran mientras se encuentren dentro del compartimiento, caseta o cabina destinados al transporte de personas. </p>
        <p style="padding-top: 11pt;padding-left: 39pt;text-indent: 0pt;text-align: justify;">También quedarán amparados los gastos médicos por la atención que se dé al <b>Conductor </b>y los <b>Ocupantes </b>del <b>Vehículo Asegurado </b>que, al encontrarse dentro de la cabina destinada para transporte de personas del <b>Vehículo Asegurado </b>al momento del <b>Siniestro</b>, sufran lesiones ocurridas a consecuencia del robo con violencia de dicho vehículo y/o asalto y/o intento, lo cual se debe acreditar mediante la denuncia o querella correspondiente. </p>
        <p style="text-indent: 0pt;text-align: center;">
          <br />
        </p>
        <p style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">Los conceptos de gastos médicos al <b>Conductor </b>y <b>Ocupantes</b>, cubiertos por la <b>Póliza </b>amparan lo siguiente: </p>
        <ol id="l80">
          <li data-list-text="a)">
            <p class="s22" style="padding-top: 11pt;padding-left: 81pt;text-indent: -21pt;text-align: justify;">Hospitalización. <span class="p">Alimentos y cuarto en el hospital, fisioterapia, gastos inherentes a la hospitalización y en general, drogas y medicinas que sean prescritas por un médico.</span>
            </p>
          </li>
          <li data-list-text="b)">
            <p class="s22" style="padding-left: 81pt;text-indent: -21pt;text-align: justify;">Atención Médica. <span class="p">Únicamente están cubiertos los servicios de médicos generales y especialistas, cirujanos, osteópatas o fisioterapistas legalmente autorizados para ejercer sus respectivas profesiones.</span>
            </p>
          </li>
          <li data-list-text="c)">
            <p class="s22" style="padding-left: 81pt;text-indent: -21pt;text-align: justify;">Enfermeros <span class="p">. El costo de los servicios de enfermeros o enfermeras titulados o que tengan licencia para ejercer.</span>
            </p>
          </li>
          <li data-list-text="d)">
            <p class="s22" style="padding-left: 81pt;text-indent: -21pt;text-align: justify;">Servicios de Ambulancia <span class="p">. Únicamente están cubiertos los gastos erogados por servicios de ambulancia terrestre por emergencia.</span>
            </p>
          </li>
          <li data-list-text="e)">
            <p class="s12" style="padding-left: 81pt;text-indent: -21pt;text-align: justify;">Aparatos y Prótesis Ortopédicos y/o Dentales. <span class="p">Se cubrirán cuando sea necesaria la utilización y el médico tratante lo prescriba.</span>
            </p>
          </li>
          <li data-list-text="f)">
            <p style="padding-left: 81pt;text-indent: -21pt;text-align: justify;">
              <span class="s22">Gastos de Entierro</span>. En caso de fallecimiento de alguno(s) de los <b>Ocupantes </b>del <b>Vehículo Asegurado</b>, los gastos funerarios se consideran hasta por un máximo de 500 (quinientas) UMA´s por <b>Ocupante </b>a la fecha de ocurrencia del <b>Siniestro</b>. Dicho límite aplica siempre que haya <b>Suma Asegurada </b>disponible. Estos gastos solo son cubiertos dentro de la República Mexicana y comprenden la urna, el ataúd, la cremación, costos de embalsamamiento, el servicio de velación impuestos por entierro y los traslados de los
            </p>
            <p style="padding-top: 7pt;padding-left: 81pt;text-indent: 0pt;text-align: center;">occisos, y opera mediante el procedimiento de reembolso.</p>
            <p style="padding-top: 4pt;text-indent: 0pt;text-align: center;">
              <br />
            </p>
          </li>
        </ol>
      </li>
      <li data-list-text="B)">
        <p class="s22" style="padding-left: 81pt;text-indent: -21pt;text-align: justify;">
          <a name="a97">Límite Máximo de Responsabilidad</a>
        </p>
        <p style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">El <b>Límite Máximo de Responsabilidad </b>de <b>L A T I N O </b>para esta cobertura se establece en la <b>Carátula de la Póliza </b>y opera como <b>Suma Asegurada </b>única para los diversos riesgos que se amparan en esta cobertura. </p>
        <p style="text-indent: 0pt;text-align: center;">
          <br />
        </p>
        <p class="s15" style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">En ningún caso la suma de las indemnizaciones excederá de la Suma Asegurada contratada por Evento <span class="p">.</span>
        </p>
        <p style="padding-top: 11pt;padding-left: 39pt;text-indent: 0pt;text-align: justify;">El límite inicial de responsabilidad de <b>L A T I N O </b>por cada <b>Ocupante </b>del <b>Vehículo Asegurado </b>que haya resultado lesionado en el <b>Accidente Automovilístico </b>es el monto que resulte de dividir en mismas proporciones la <b>Suma Asegurada </b>contratada especificada en la <b>Carátula de la Póliza </b>para esta cobertura, entre el número total de <b>Ocupantes </b>del <b>Vehículo Asegurado </b>que hayan resultado lesionados. </p>
        <p style="text-indent: 0pt;text-align: center;">
          <br />
        </p>
        <p style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">Si el importe de los gastos médicos de uno o más <b>Ocupantes </b>rebasa el límite inicial de responsabilidad por persona y existe <b>Suma Asegurada </b>por distribuir en virtud de que el límite inicial de responsabilidad de los demás lesionados no se haya agotado, se ampliará dicho límite para los lesionados que así lo requieran de la siguiente forma: el restante de la <b>Suma Asegurada </b>de aquellos <b>Ocupantes </b>lesionados que no agotaron el límite inicialmente establecido se dividirá entre el número de lesionados cuyos gastos médicos amparados hayan rebasado dicho límite inicial. </p>
        <p class="s33" style="padding-top: 11pt;padding-left: 39pt;text-indent: 0pt;text-align: justify;">
          <a name="a98">FORMA DE PAGO POR ATENCIÓN MÉDICA Y/O HOSPITALARIA.</a>
        </p>
        <p style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">El <b>Asegurado </b>puede elegir entre los médicos y hospitales incluidos en la relación que para tal efecto le proporcione el ajustador de <b>L A T I N O</b>, en cuyo caso aplicará el pago directo de <b>L A T I N O </b>al(los) médico(s) y/o hospital(es) que corresponda. </p>
        <p style="padding-top: 2pt;text-indent: 0pt;text-align: center;">
          <br />
        </p>
        <p style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">Si el <b>Asegurado </b>opta por atenderse con otro médico u hospital que no sea el asignado en el pase para el servicio médico, se aplicará el procedimiento de Reembolso de gastos, establecido por <b>L A T I N O</b>, apegándose al <b>Costo Usual y Acostumbrado</b>. Para el Reembolso de cualquier gasto procedente bajo esta cobertura, se deberá entregar a <b>L A T I N O</b>, dentro de los 10 (diez) días naturales siguientes de haber recibido la <b>Atención Médica </b>y/o hospitalaria, los informes médicos, ordenes de estudios y las interpretaciones que correspondan, así como los comprobantes de los gastos correspondientes, mismos que deben cumplir con todos los requisitos fiscales vigentes a la fecha de facturación. </p>
        <p style="padding-top: 2pt;text-indent: 0pt;text-align: center;">
          <br />
        </p>
      </li>
      <li data-list-text="C)">
        <p class="s22" style="padding-left: 81pt;text-indent: -21pt;text-align: justify;">
          <a name="a99">Deducible</a>
        </p>
        <p style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">No opera</p>
        <p style="padding-top: 2pt;text-indent: 0pt;text-align: center;">
          <br />
        </p>
      </li>
      <li data-list-text="D)">
        <p class="s42" style="padding-left: 81pt;text-indent: -21pt;text-align: justify;">Exclusiones</p>
      </li>
    </ol>
    <p class="s15" style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">Queda entendido que, en adición a lo aplicable respecto a la Cláusula Exclusiones Generales, esta cobertura en ningún caso ampara:</p>
    <ol id="l81">
      <li data-list-text="1.">
        <p class="s25" style="padding-left: 81pt;text-indent: -21pt;text-align: justify;">Los hechos que deriven de actos intencionales y/o dolosos.</p>
      </li>
      <li data-list-text="2.">
        <p class="s15" style="padding-left: 81pt;text-indent: -21pt;text-align: justify;">Los gastos médicos en que se incurra con motivo de lesiones que sufran los Ocupantes del Vehículo Asegurado, derivados de riña, aun cuando sean a consecuencia del Accidente Automovilístico y/o cuando la participación de los Ocupantes fuera en defensa propia, <span style=" color: #161616;">ya sea sujeto activo o pasivo, dentro o fuera del Vehículo Asegurado.</span>
        </p>
      </li>
      <li data-list-text="3.">
        <p class="s15" style="padding-left: 81pt;text-indent: -21pt;text-align: justify;">Enfermedades Congénitas y/o Preexistentes.</p>
      </li>
      <li data-list-text="4.">
        <p class="s25" style="padding-left: 81pt;text-indent: -21pt;text-align: justify;">Los gastos que deriven de cirugías estéticas o reconstructivas que no estén avaladas o recomendadas por los médicos tratantes.</p>
      </li>
      <li data-list-text="5.">
        <p class="s25" style="padding-top: 3pt;padding-left: 81pt;text-indent: -21pt;text-align: justify;">La indemnización de cualquier enfermedad, tratamiento médico,</p>
        <p class="s25" style="padding-top: 4pt;padding-left: 81pt;text-indent: 0pt;text-align: justify;">intervención quirúrgica o lesión preexistente, crónica o recurrente o estados patológicos, que no se deriven del Accidente Automovilístico, robo consumado, asalto o intento de éstos, fuera del Vehículo Asegurado.</p>
      </li>
      <li data-list-text="6.">
        <p class="s25" style="padding-left: 81pt;text-indent: -21pt;text-align: justify;">Tratamientos odontológicos que no sean problemas agudos de emergencia, tales como, prótesis, endodoncias, limpiezas, tratamientos de embellecimiento, y demás similares.</p>
      </li>
      <li data-list-text="7.">
        <p class="s25" style="padding-left: 81pt;text-indent: -21pt;text-align: justify;">Cualquier tipo de tratamiento complementario, alternativo o experimental tales como acupuntura, homeopático o herbolario.</p>
        <p style="text-indent: 0pt;text-align: center;">
          <br />
        </p>
        <div class="textbox" style="background:#DEEAF6;">
          <p class="s19" style="text-indent: 0pt;line-height: 11pt;text-align: right;">Sección: Accidentes Personales</p>
          <p class="s19" style="text-indent: 0pt;line-height: 11pt;text-align: right;">Cobertura Accesoria</p>
          <p class="s20" style="padding-left: 5pt;text-indent: 0pt;text-align: center;">CLÁUSULA 2.20. Accidentes al Conductor</p>
        </div>
      </li>
    </ol>
    <p style="padding-left: 39pt;text-indent: 0pt;text-align: center;" />
    <p style="text-indent: 0pt;text-align: center;">
      <br />
    </p>
    <ol id="l82">
      <ol id="l83">
        <li data-list-text="A)">
          <p class="s22" style="padding-left: 81pt;text-indent: -21pt;text-align: justify;">
            <a name="a100">Alcance</a>
          </p>
          <p style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">Siempre que se haga constar la contratación de esta cobertura, <b>L A T I N O </b>se obliga a cubrir la pérdida de la vida o de miembros que sufra el <b>Conductor Habitual </b>del <b>Vehículo Asegurado </b>descrito en la <b>Carátula de la Póliza</b>, o de aquella persona que con el consentimiento expreso o tácito del <b>Asegurado</b>, use el vehículo, siempre y cuando se haya ocasionado por un <b>Accidente Automovilístico </b>o por cualquiera de los riesgos mencionados en la cobertura de Daños Materiales de las presentes <b>Condiciones Generales</b>, siempre que las lesiones corporales o la pérdida de la vida ocurran mientras se encuentren dentro del compartimiento, caseta o cabina destinada al transporte de personas. </p>
          <p style="text-indent: 0pt;text-align: center;">
            <br />
          </p>
          <p style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">La procedencia de esta cobertura se encuentra condicionada a que el <b>Conductor </b>use el <b>Vehículo Asegurado </b>con el consentimiento expreso o tácito del <b>Asegurado</b>. </p>
          <p style="text-indent: 0pt;text-align: center;">
            <br />
          </p>
          <p style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">Si durante la vigencia de la <b>Póliza</b>, y como resultado directo del <b>Accidente Automovilístico </b>sufrido por el <b>Conductor</b>, desde la fecha de ocurrencia del <b>Siniestro </b>y dentro de los noventa días siguientes a la fecha del mismo, la lesión produjera cualquiera de las pérdidas a continuación enumeradas, entonces <b>L A T I N O </b>pagará como máximo los siguientes porcentajes de la <b>Suma Asegurada </b>contratada e indicada en <b>Carátula de la Póliza</b>
          </p>
          <p style="padding-top: 4pt;text-indent: 0pt;text-align: center;">
            <br />
          </p>
          <table style="border-collapse:collapse;margin-left:69.35pt" cellspacing="0">
            <tr style="height:26pt">
              <td style="width:276pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                <p class="s43" style="padding-top: 6pt;padding-left: 5pt;text-indent: 0pt;text-align: center;">Por pérdida de:</p>
              </td>
              <td style="width:107pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                <p class="s43" style="padding-left: 6pt;text-indent: 0pt;line-height: 12pt;text-align: center;">Porcentaje de la Suma Asegurada</p>
              </td>
            </tr>
            <tr style="height:12pt">
              <td style="width:276pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                <p class="s40" style="padding-left: 5pt;text-indent: 0pt;line-height: 11pt;text-align: center;">La vida</p>
              </td>
              <td style="width:107pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                <p class="s40" style="padding-right: 18pt;text-indent: 0pt;line-height: 11pt;text-align: right;">100%</p>
              </td>
            </tr>
            <tr style="height:12pt">
              <td style="width:276pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                <p class="s40" style="padding-left: 5pt;text-indent: 0pt;line-height: 11pt;text-align: center;">Ambas manos o ambos pies o la vista de ambos ojos</p>
              </td>
              <td style="width:107pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                <p class="s40" style="padding-right: 18pt;text-indent: 0pt;line-height: 11pt;text-align: right;">100%</p>
              </td>
            </tr>
            <tr style="height:12pt">
              <td style="width:276pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                <p class="s40" style="padding-left: 5pt;text-indent: 0pt;line-height: 11pt;text-align: center;">Una mano y un pie</p>
              </td>
              <td style="width:107pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                <p class="s40" style="padding-right: 18pt;text-indent: 0pt;line-height: 11pt;text-align: right;">100%</p>
              </td>
            </tr>
            <tr style="height:12pt">
              <td style="width:276pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                <p class="s40" style="padding-left: 5pt;text-indent: 0pt;line-height: 11pt;text-align: center;">Una mano y la vista de un ojo o un pie y la vista de un ojo</p>
              </td>
              <td style="width:107pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                <p class="s40" style="padding-right: 18pt;text-indent: 0pt;line-height: 11pt;text-align: right;">100%</p>
              </td>
            </tr>
            <tr style="height:12pt">
              <td style="width:276pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                <p class="s40" style="padding-left: 5pt;text-indent: 0pt;line-height: 11pt;text-align: center;">Una mano o un pie</p>
              </td>
              <td style="width:107pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                <p class="s40" style="padding-right: 18pt;text-indent: 0pt;line-height: 11pt;text-align: right;">50%</p>
              </td>
            </tr>
            <tr style="height:12pt">
              <td style="width:276pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                <p class="s40" style="padding-left: 5pt;text-indent: 0pt;line-height: 11pt;text-align: center;">La vista de un ojo</p>
              </td>
              <td style="width:107pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                <p class="s40" style="padding-right: 18pt;text-indent: 0pt;line-height: 11pt;text-align: right;">30%</p>
              </td>
            </tr>
            <tr style="height:23pt">
              <td style="width:276pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                <p class="s40" style="padding-left: 5pt;padding-right: 9pt;text-indent: 0pt;line-height: 12pt;text-align: center;">Tres dedos, comprendiendo el dedo pulgar o el dedo índice de cualquier mano</p>
              </td>
              <td style="width:107pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                <p class="s40" style="padding-right: 18pt;text-indent: 0pt;line-height: 11pt;text-align: right;">30%</p>
              </td>
            </tr>
            <tr style="height:23pt">
              <td style="width:276pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                <p class="s40" style="padding-left: 5pt;text-indent: 0pt;line-height: 11pt;text-align: center;">Amputación parcial de un pie, comprendiendo todos los dedos</p>
              </td>
              <td style="width:107pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                <p class="s40" style="padding-right: 18pt;text-indent: 0pt;line-height: 11pt;text-align: right;">30%</p>
              </td>
            </tr>
            <tr style="height:23pt">
              <td style="width:276pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                <p class="s40" style="padding-left: 5pt;text-indent: 0pt;line-height: 12pt;text-align: center;">Tres dedos que no sea el dedo pulgar o el dedo índice de cualquier mano</p>
              </td>
              <td style="width:107pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                <p class="s40" style="padding-right: 18pt;text-indent: 0pt;line-height: 11pt;text-align: right;">25%</p>
              </td>
            </tr>
            <tr style="height:12pt">
              <td style="width:276pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                <p class="s40" style="padding-left: 5pt;text-indent: 0pt;line-height: 11pt;text-align: center;">Sordera completa de ambos oídos</p>
              </td>
              <td style="width:107pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                <p class="s40" style="padding-right: 18pt;text-indent: 0pt;line-height: 11pt;text-align: right;">25%</p>
              </td>
            </tr>
            <tr style="height:23pt">
              <td style="width:276pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                <p class="s40" style="padding-left: 5pt;padding-right: 9pt;text-indent: 0pt;line-height: 11pt;text-align: center;">El dedo índice y otro dedo que no sea el pulgar de cualquier mano</p>
              </td>
              <td style="width:107pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                <p class="s40" style="padding-right: 18pt;text-indent: 0pt;line-height: 11pt;text-align: right;">20%</p>
              </td>
            </tr>
          </table>
          <p style="text-indent: 0pt;text-align: center;">
            <br />
          </p>
          <table style="border-collapse:collapse;margin-left:69.35pt" cellspacing="0">
            <tr style="height:12pt">
              <td style="width:276pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                <p class="s40" style="padding-left: 5pt;text-indent: 0pt;line-height: 11pt;text-align: center;">El dedo pulgar de cualquier mano</p>
              </td>
              <td style="width:107pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                <p class="s40" style="padding-right: 18pt;text-indent: 0pt;line-height: 11pt;text-align: right;">15%</p>
              </td>
            </tr>
            <tr style="height:23pt">
              <td style="width:276pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                <p class="s40" style="padding-left: 5pt;text-indent: 0pt;line-height: 11pt;text-align: center;">Acortamiento de un miembro inferior, por lo menos de 5 centímetros</p>
              </td>
              <td style="width:107pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                <p class="s40" style="padding-right: 18pt;text-indent: 0pt;line-height: 11pt;text-align: right;">15%</p>
              </td>
            </tr>
            <tr style="height:12pt">
              <td style="width:276pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                <p class="s40" style="padding-left: 5pt;text-indent: 0pt;line-height: 11pt;text-align: center;">El dedo índice de cualquier mano</p>
              </td>
              <td style="width:107pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                <p class="s40" style="padding-right: 18pt;text-indent: 0pt;line-height: 11pt;text-align: right;">10%</p>
              </td>
            </tr>
            <tr style="height:12pt">
              <td style="width:276pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                <p class="s40" style="padding-left: 5pt;text-indent: 0pt;line-height: 11pt;text-align: center;">El dedo medio, el anular o el meñique</p>
              </td>
              <td style="width:107pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                <p class="s40" style="padding-right: 18pt;text-indent: 0pt;line-height: 11pt;text-align: right;">5%</p>
              </td>
            </tr>
          </table>
          <p style="padding-top: 8pt;text-indent: 0pt;text-align: center;">
            <br />
          </p>
          <p style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">Se entiende por <span class="s22">pérdida de la mano</span>, su anquilosis o separación completa desde la articulación de puño o arriba de ella; por <span class="s22">pérdida de pie</span>, su anquilosis o separación completa desde la articulación del tobillo o arriba de él; por <span class="s22">pérdida de la vista de un ojo</span>, la desaparición completa e irreparable de esta función en ese ojo; por <span class="s22">pérdida de pulgar o índice</span>, la anquilosis o separación de dos falanges completas en cada dedo, situación que debe coincidir con lo señalado en el expediente o resumen clínico presentado por el <b>Asegurado</b>. </p>
          <p style="text-indent: 0pt;text-align: center;">
            <br />
          </p>
          <p style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">En caso de existir varias pérdidas derivadas del mismo accidente, la cantidad total no excederá la <b>Suma Asegurada </b>contratada para esta cobertura. En caso de muerte la indemnización correspondiente se pagará a la sucesión legal (herederos) del <b>Conductor</b>, misma que podrá acreditarse mediante la presentación de copia certificada de la audiencia de aceptación y protesta de cargo de albacea. Todas las demás indemnizaciones bajo esta cobertura se cubrirán al <b>Conductor </b>del <b>Vehículo Asegurado</b>. </p>
          <p style="text-indent: 0pt;text-align: center;">
            <br />
          </p>
        </li>
        <li data-list-text="B)">
          <p class="s22" style="padding-left: 81pt;text-indent: -21pt;text-align: justify;">
            <a name="a101">Límite Máximo de Responsabilidad</a>
          </p>
          <p style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">El <b>Límite Máximo de Responsabilidad </b>de <b>L A T I N O </b>para esta cobertura se establece en la <b>Carátula de la Póliza </b>y opera como <b>Suma Asegurada </b>única para los diversos riesgos que se amparan en esta cobertura. En ningún caso la suma de las indemnizaciones excederá de la <b>Suma Asegurada </b>contratada. </p>
          <p style="text-indent: 0pt;text-align: center;">
            <br />
          </p>
        </li>
        <li data-list-text="C)">
          <p class="s22" style="padding-left: 81pt;text-indent: -21pt;text-align: justify;">
            <a name="a102">Deducible</a>
          </p>
          <p style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">No opera</p>
          <p style="text-indent: 0pt;text-align: center;">
            <br />
          </p>
        </li>
        <li data-list-text="D)">
          <p class="s42" style="padding-left: 81pt;text-indent: -21pt;text-align: justify;">Exclusiones</p>
          <p class="s15" style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">Queda entendido que, en adición a lo aplicable respecto a la Cláusula Exclusiones Generales, esta cobertura en ningún caso ampara:</p>
          <ol id="l84">
            <li data-list-text="1.">
              <p class="s15" style="padding-left: 103pt;text-indent: -18pt;text-align: justify;">Cuando el Vehículo Asegurado sea utilizado por el Conductor para suicidio o cualquier intento del mismo, o mutilación voluntaria, aún cuando el Conductor se encuentre en estado de enajenación mental.</p>
            </li>
            <li data-list-text="2.">
              <p class="s15" style="padding-left: 103pt;text-indent: -18pt;text-align: justify;">Cuando el Vehículo Asegurado participe en competencias automovilísticas de velocidad y/o resistencia, ya sea de aficionados o de profesionales, salvo pacto en contrario.</p>
            </li>
            <li data-list-text="3.">
              <p class="s15" style="padding-left: 103pt;text-indent: -18pt;text-align: justify;">Lesiones o muerte que el Conductor sufra cuando el Vehículo Asegurado sea utilizado en servicio militar de cualquier clase, actos de guerra, insurrección, rebelión, revolución, riña o actos delictuosos intencionales en que participe directamente.</p>
            </li>
            <li data-list-text="4.">
              <p class="s15" style="padding-left: 103pt;text-indent: -18pt;text-align: justify;">Lesiones o muerte que el Conductor sufra cuando el Asegurado no le hubiera otorgado su consentimiento expreso o tácito para utilizar el Vehículo Asegurado.</p>
            </li>
            <li data-list-text="5.">
              <p class="s15" style="padding-left: 103pt;text-indent: -18pt;text-align: justify;">Atención Médica, hospitalización, enfermeros, servicio de ambulancia, gastos de entierro y cualquier clase de gastos médicos.</p>
            </li>
            <li data-list-text="6.">
              <p class="s15" style="padding-left: 103pt;text-indent: -17pt;text-align: justify;">Cuando el Vehículo Asegurado haya sido robado o cuando se use</p>
              <p class="s15" style="padding-top: 3pt;padding-left: 139pt;text-indent: 0pt;text-align: justify;">como instrumento para cualquier otro ilícito.</p>
            </li>
            <li data-list-text="7.">
              <p class="s15" style="padding-top: 4pt;padding-left: 103pt;text-indent: -18pt;text-align: justify;">Cuando la muerte del Conductor o la pérdida de miembros ocurra después de los 90 (noventa) días siguientes a la fecha del Siniestro.</p>
            </li>
          </ol>
        </li>
      </ol>
    </ol>
    <h3 style="padding-top: 11pt;padding-left: 39pt;text-indent: 0pt;text-align: justify;">
      <a name="a103">Cláusula 3ª. Servicios y Asistencias</a>
    </h3>
    <p style="padding-top: 10pt;padding-left: 39pt;text-indent: 0pt;text-align: justify;">Siempre se debe llamar a <b>L A T I N O </b>a los teléfonos 55 5130 2801 en la Ciudad de México, o al 800 685 1170 para el resto de la República ante la necesidad de requerir algún servicio o asistencia contratada. </p>
    <p style="text-indent: 0pt;text-align: center;">
      <br />
    </p>
    <h3 style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">
      <a name="a104">Cláusula 3.1. Asistencia Legal</a>
    </h3>
    <p class="s21" style="padding-left: 39pt;text-indent: 0pt;text-align: center;">Asesoría y Defensa Legal Automovilística. Condiciones Particulares</p>
    <p style="padding-top: 11pt;padding-left: 39pt;text-indent: 0pt;text-align: justify;">La Asistencia Legal, podrá ser contratada en adición a las coberturas básicas de las secciones de Daños Materiales, Robo y Responsabilidad Civil.</p>
    <p style="text-indent: 0pt;text-align: center;">
      <br />
    </p>
    <p style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">Cuando en la Carátula de la Póliza se haga constar su contratación, <b>L A T I N O </b>otorgará los servicios consistentes en: </p>
    <p style="text-indent: 0pt;text-align: center;">
      <br />
    </p>
    <ol id="l85">
      <li data-list-text="1.">
        <p class="s21" style="padding-left: 81pt;text-indent: -21pt;text-align: center;">Defensa Legal</p>
        <ol id="l86">
          <li data-list-text="A)">
            <p class="s12" style="padding-top: 13pt;padding-left: 60pt;text-indent: -21pt;text-align: center;">
              <a name="a105">Definiciones</a>
            </p>
            <p style="padding-left: 39pt;text-indent: 0pt;text-align: center;">Para la debida interpretación de la presente cobertura de Asistencia, se acuerda establecer tanto en lo singular como en lo plural las siguientes definiciones:</p>
            <p class="s13" style="padding-left: 39pt;text-indent: 0pt;text-align: center;">
              <span style=" color: #2C5293;">Beneficiario: </span>Asegurado <span class="p">, </span>Contratante <span class="p">o </span>Conductor <span class="p">del </span>Vehículo Asegurado <span class="p">que se vea beneficiado.</span>
            </p>
            <p style="padding-top: 2pt;text-indent: 0pt;text-align: center;">
              <br />
            </p>
          </li>
          <li data-list-text="B)">
            <p class="s12" style="padding-left: 60pt;text-indent: -21pt;text-align: justify;">
              <a name="a106">Alcance</a>
            </p>
            <p style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">
              <b>L A T I N O </b>otorgará los servicios consistentes en: <span class="s12">Asesoría y Defensa Legal Automovilística </span>para automóviles particulares de hasta 3.5 toneladas, en los casos de <b>Accidentes Automovilísticos </b>que se deduzcan de delitos de tipo imprudencial, ocurridos sólo dentro del territorio de los Estados Unidos Mexicanos.
            </p>
            <p style="text-indent: 0pt;text-align: center;">
              <br />
            </p>
            <p style="padding-left: 39pt;text-indent: 0pt;text-align: center;">Se considerarán como <b>Beneficiario</b>s de estos servicios al <b>Asegurado</b>, <b>Contratante </b>o <b>Conductor</b>
            </p>
            <p style="padding-left: 39pt;text-indent: 0pt;text-align: center;">del <b>Vehículo Asegurado</b>. </p>
            <p class="s15" style="padding-left: 39pt;text-indent: 0pt;text-align: center;">Esta cobertura no opera mediante reembolsos, por lo tanto, deberá reportar inmediatamente cualquier situación de asistencia.</p>
            <p class="s13" style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">L A T I N O, <span class="p">a través del proveedor que tenga contratado para este fin, se compromete a prestarle al </span>Beneficiario <span class="p">, durante las 24 horas, los 365 días del año, en el lugar donde sea requerida su presencia (lugar de ocurrencia del siniestro, ministerio público o dependencia de autoridad competente) los servicios profesionales de abogados designados y contratados para tal efecto, cuando le ocurra un accidente conduciendo el </span>Vehículo Asegurado <span class="p">u otro similar en clase, tipo, uso o servicio y tonelaje y esté en peligro de perder su libertad con motivo de los </span>Daños <span class="p">ocasionados a </span>Terceros <span class="p">, en su persona o en sus bienes.</span>
            </p>
            <p style="padding-top: 11pt;padding-left: 39pt;text-indent: 0pt;text-align: justify;">La prestación de estos servicios en caso de accidente se hará a través de los abogados designados por <b>L A T I N O</b>, para reclamar sus <b>Daños </b>mediante la presentación de querella en contra de quien resulte responsable o tramitar la libertad del <b>Beneficiario </b>ante las autoridades correspondientes, de acuerdo con la legislación aplicable, así como la obtención del oficio de liberación del automóvil involucrado en el accidente. </p>
            <p class="s15" style="padding-top: 3pt;padding-left: 39pt;text-indent: 0pt;text-align: center;">Este beneficio se otorgará siempre y cuando el Beneficiario pueda demostrar la propiedad y legal estancia del Vehículo Asegurado en el país.</p>
            <p class="s13" style="padding-top: 11pt;padding-left: 39pt;text-indent: 0pt;text-align: justify;">L A T I N O <span class="p">se responsabilizará igualmente de la garantía de dinero en efectivo o, en su caso, la fianza cuando así lo determine la autoridad judicial para obtener la libertad provisional del </span>Beneficiario <span class="p">. También liquidará cualquier otra erogación que legalmente proceda relacionada con el proceso penal, incluyendo la garantía que fije la autoridad con motivo de la responsabilidad civil (reparación de </span>Daños <span class="p">) que se derive del </span>Siniestro <span class="p">, la cual será otorgada conforme a las condiciones y los límites de la cobertura de R.C. Terceros contratada. En caso que el monto de la caución sea mayor al de la </span>Suma Asegurada <span class="p">, el diferencial correspondiente será cubierto por el </span>Conductor <span class="p">del vehículo o titular de la </span>Póliza <span class="p">.</span>
            </p>
            <p style="text-indent: 0pt;text-align: center;">
              <br />
            </p>
            <p style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">Si a consecuencia del accidente, el <b>Beneficiario </b>es enjuiciado, <b>L A T I N O </b>a través de sus abogados especialistas, se constituirá en su defensa, aportando en el proceso todos aquellos elementos y pruebas que favorezcan a la defensa del <b>Beneficiario</b>, interponiendo los recursos necesarios, aún el juicio de amparo, hasta obtener el fallo final de los jueces. </p>
            <p style="padding-top: 2pt;text-indent: 0pt;text-align: center;">
              <br />
            </p>
            <p style="padding-left: 39pt;text-indent: 0pt;text-align: center;">También en este caso <b>L A T I N O </b>absorberá los honorarios y gastos legales que origine el proceso penal, hasta su terminación <span class="s24">.</span>
            </p>
            <p style="padding-top: 1pt;text-indent: 0pt;text-align: center;">
              <br />
            </p>
          </li>
          <li data-list-text="C)">
            <p class="s12" style="padding-left: 60pt;text-indent: -21pt;text-align: center;">Límite Máximo de Responsabilidad</p>
            <p class="s15" style="padding-left: 39pt;text-indent: 0pt;text-align: center;">Esta cobertura no opera mediante reembolsos, por lo tanto, deberá reportar inmediatamente cualquier situación de asistencia.</p>
            <p class="s15" style="padding-left: 39pt;text-indent: 0pt;text-align: center;">Este beneficio se otorgará siempre y cuando el Beneficiario pueda demostrar la propiedad y legal estancia de la Vehículo Asegurado en el país.</p>
          </li>
          <li data-list-text="D)">
            <p class="s12" style="padding-top: 13pt;padding-left: 60pt;text-indent: -21pt;text-align: center;">
              <a name="a107">Obligaciones del Asegurado</a>
            </p>
            <p style="padding-top: 11pt;padding-left: 39pt;text-indent: 0pt;text-align: justify;">En caso de <b>Siniestro </b>el <b>Asegurado </b>se obliga a cumplir con los siguientes requisitos: </p>
            <ol id="l87">
              <li data-list-text="1.">
                <p style="padding-left: 81pt;text-indent: -21pt;text-align: justify;">Al ocurrir el <b>Accidente Automovilístico </b>dará aviso, salvo caso fortuito o de fuerza mayor, de inmediato y a más tardar dentro de las siguientes 24 hrs. por sí o por interpósita persona, a cualquiera de las oficinas más cercanas de <b>L A T I N O, </b>o bien, a la oficina matriz. </p>
              </li>
              <li data-list-text="2.">
                <p style="padding-left: 81pt;text-indent: -21pt;text-align: justify;">Concurrir y presentar al <b>Conductor </b>a todas las diligencias de la autoridad que requieran su presencia y a enterar y entregar a <b>L A T I N O</b>, con toda oportunidad los citatorios, requerimientos, demandas, órdenes o notificaciones judiciales, así como cualquier otra documentación legal que reciba de parte de las autoridades y que se relacionen con el Accidente Automovilístico amparado por este <b>Contrato</b>. </p>
              </li>
              <li data-list-text="3.">
                <p style="padding-left: 81pt;text-indent: -21pt;text-align: justify;">Otorgar todas las facilidades y documentación a los abogados designados, para la agilización de los servicios legales.</p>
              </li>
              <li data-list-text="4.">
                <p style="padding-left: 81pt;text-indent: -21pt;text-align: justify;">Otorgada la prima de fianza o la caución, el <b>Asegurado </b>y el <b>Conductor</b>, según corresponda, se obliga a cumplir todas y cada una de las prevenciones establecidas por la legislación penal, a fin de evitar la revocación de la libertad del <b>Conductor </b>procesado y que la autoridad judicial o administrativa haga efectiva la fianza o caución. </p>
              </li>
              <li data-list-text="5.">
                <p style="padding-left: 81pt;text-indent: -21pt;text-align: justify;">En caso de hacerse efectiva la garantía exhibida por causas imputables al procesado o al <b>Asegurado</b>, éste último reembolsará a <b>L A T I N O </b>en cuanto esta lo requiera, el monto de la garantía que por ese motivo se haya pagado, quien podrá ejercer las acciones legales que estime pertinentes para la recuperación de dicho adeudo. </p>
                <p class="s13" style="padding-left: 81pt;text-indent: 0pt;text-align: justify;">L A T I N O <span class="p">no tendrá en este supuesto la obligación de otorgar una fianza o caución nueva por el mismo </span>Siniestro <span class="p">. Tampoco responderá por la cantidad que como pena conmutativa deberá pagar el </span>Asegurado <span class="p">o </span>Conductor <span class="p">en el caso de una sentencia condenatoria.</span>
                </p>
                <p style="text-indent: 0pt;text-align: center;">
                  <br />
                </p>
                <p class="s15" style="padding-left: 38pt;text-indent: 0pt;text-align: center;">El incumplimiento de cualquiera de los puntos anteriores trae como consecuencia que L A T I N O quede liberada de sus obligaciones sin</p>
                <p class="s15" style="padding-top: 3pt;padding-left: 38pt;text-indent: 0pt;text-align: justify;">responsabilidad alguna.</p>
                <p style="padding-top: 13pt;padding-left: 39pt;text-indent: 0pt;text-align: justify;">En caso de exceder los límites de los montos pactados, éstos correrán a cargo del <b>Beneficiario</b>
                </p>
                <p style="padding-top: 2pt;text-indent: 0pt;text-align: center;">
                  <br />
                </p>
              </li>
            </ol>
          </li>
          <li data-list-text="E)">
            <p class="s21" style="padding-left: 60pt;text-indent: -21pt;text-align: justify;">Exclusiones</p>
            <p class="s25" style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">En adición a lo estipulado en la Cláusula Exclusiones Generales, esta cobertura de servicios, no ampara y no se estará obligado a efectuar pago alguno:</p>
            <ol id="l88">
              <li data-list-text="1.">
                <p class="s15" style="padding-left: 81pt;text-indent: -21pt;text-align: justify;">Cuando se trate de un delito intencional.</p>
              </li>
              <li data-list-text="2.">
                <p class="s25" style="padding-left: 81pt;text-indent: -21pt;text-align: justify;">Cuando el Beneficiario no obedezca las instrucciones que para su defensa le indiquen los abogados de L A T I N O, o haga arreglos personales sin consultar previamente a dichos profesionistas o contrate abogados o gestores por su cuenta.</p>
              </li>
              <li data-list-text="3.">
                <p class="s25" style="padding-left: 81pt;text-indent: -21pt;text-align: justify;">En el caso que el Beneficiario oculte a los abogados de L A T I N O cualquier información relacionada con el Accidente o el proceso.</p>
              </li>
              <li data-list-text="4.">
                <p class="s25" style="padding-left: 81pt;text-indent: -21pt;text-align: justify;">Cuando el Beneficiario no comparezca ante las autoridades que lo citen y que previamente le haya sido notificado por L A T I N O.</p>
              </li>
              <li data-list-text="5.">
                <p class="s25" style="padding-left: 81pt;text-indent: -21pt;text-align: justify;">Cuando el Beneficiario otorgue un poder a alguno de los abogados sin el conocimiento y aprobación expresa de L A T I N O.</p>
              </li>
              <li data-list-text="6.">
                <p class="s25" style="padding-left: 81pt;text-indent: -21pt;text-align: justify;">Cuando el Beneficiario no compruebe la propiedad o legal estancia en el país del automóvil involucrado en el Accidente.</p>
              </li>
              <li data-list-text="7.">
                <p class="s25" style="padding-left: 81pt;text-indent: -21pt;line-height: 13pt;text-align: justify;">No se incluye el pago de honorarios de peritajes de defensa.</p>
              </li>
              <li data-list-text="8.">
                <p class="s25" style="padding-left: 81pt;text-indent: -21pt;text-align: justify;">No se incluye el pago de Multa, derechos de piso, arrastre por Siniestro</p>
              </li>
            </ol>
          </li>
        </ol>
        <p style="text-indent: 0pt;text-align: center;">
          <br />
        </p>
      </li>
      <li data-list-text="2.">
        <p class="s21" style="padding-left: 88pt;text-indent: -28pt;text-align: justify;">Asesoría telefónica</p>
      </li>
    </ol>
    <ol id="l89">
      <li data-list-text="A)">
        <p class="s12" style="padding-top: 11pt;padding-left: 60pt;text-indent: -21pt;text-align: justify;">
          <a name="a108">Alcance</a>
        </p>
        <p class="s13" style="padding-top: 11pt;padding-left: 39pt;text-indent: 0pt;text-align: justify;">L A T I N O <span class="p">se compromete a resolver las consultas que, en materia legal, en todas las ramas del derecho que exponga el </span>Beneficiario <span class="p">, vía telefónica.</span>
        </p>
        <p style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">En caso de robo del <b>Vehículo Asegurado</b>, <b>L A T I N O </b>proporcionará información sobre los pasos a seguir, desde la búsqueda hasta la formulación de la denuncia ante las autoridades correspondientes. </p>
        <p style="padding-top: 2pt;text-indent: 0pt;text-align: center;">
          <br />
        </p>
      </li>
      <li data-list-text="B)">
        <p class="s21" style="padding-left: 60pt;text-indent: -21pt;text-align: justify;">Exclusiones</p>
      </li>
    </ol>
    <p class="s25" style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">En adición a lo estipulado en la Cláusula Exclusiones Generales, no se estará obligado a prestar el servicio, cuando el Beneficiario no proporcione <span style=" color: #000;">información veraz y oportuna.</span>
    </p>
    <h3 style="padding-top: 13pt;padding-left: 39pt;text-indent: 0pt;text-align: justify;">
      <a name="a109">Cláusula 3.2. Asistencia Vial</a>
    </h3>
    <p class="s22" style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">
      <a name="a110">Condiciones Particulares</a>
    </p>
    <p style="text-indent: 0pt;text-align: center;">
      <br />
    </p>
    <p style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">La Asistencia Vial, podrá ser contratada en adición a las coberturas básicas de las secciones de Daños Materiales, Robo y Responsabilidad Civil.</p>
    <p style="padding-top: 2pt;text-indent: 0pt;text-align: center;">
      <br />
    </p>
    <ol id="l90">
      <li data-list-text="A)">
        <p class="s12" style="padding-left: 60pt;text-indent: -21pt;text-align: justify;">
          <a name="a111">Definiciones</a>
        </p>
        <p style="padding-top: 4pt;padding-left: 39pt;text-indent: 0pt;text-align: justify;">Para la debida interpretación de la presente cobertura de Asistencia, se acuerda establecer tanto en lo singular como en lo plural las siguientes definiciones:</p>
        <p class="s13" style="padding-top: 3pt;padding-left: 39pt;text-indent: 0pt;text-align: justify;">
          <span style=" color: #2C5293;">Beneficiario: </span>Asegurado <span class="p">, </span>Contratante <span class="p">o </span>Conductor <span class="p">del </span>Vehículo Asegurado <span class="p">que se vea beneficiado.</span>
        </p>
        <p style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">
          <span class="s12">Kilometro &quot;0&quot;: </span>Derecho del <b>Beneficiario </b>a solicitar los servicios de auxilio vial, desde el lugar de su residencia hasta 50 Km si su domicilio permanente se encuentra en el interior de la República Mexicana y 80 Km si se encuentra en la Ciudad de México o área metropolitana
        </p>
        <p style="padding-top: 1pt;text-indent: 0pt;text-align: center;">
          <br />
        </p>
      </li>
      <li data-list-text="B)">
        <p class="s12" style="padding-left: 60pt;text-indent: -21pt;text-align: justify;">
          <a name="a112">Alcance</a>
        </p>
        <p style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">Cuando en la <b>Carátula de la Póliza </b>se haga constar su contratación, <b>L A T I N O </b>proporcionará a los <b>Beneficiario</b>s, así como a los <b>Ocupante</b>s del <b>Vehículo Asegurado</b>, los servicios de auxilio vial que a continuación se describen activándose desde el domicilio permanente del <b>Asegurado </b>o lugar de residencia, entendiéndose este por <b>Kilómetro &quot;0&quot; </b>y hasta 50 km si dicho domicilio permanente se encuentra en el interior de la República Mexicana y; 80 km. si se encuentra en la Ciudad de México o área metropolitana. </p>
        <p style="text-indent: 0pt;text-align: center;">
          <br />
        </p>
        <p style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">No se podrá contratar esta cobertura sí se cuenta con asistencia vial plus, ya que son excluyentes entre sí.</p>
        <ol id="l91">
          <li data-list-text="1.">
            <p style="padding-top: 11pt;padding-left: 75pt;text-indent: -18pt;text-align: justify;">
              <span class="s12">ARRASTRE DE GRUA: PARA VEHÍCULOS / KM “0”: </span>En caso de que el <b>Vehículo Asegurado </b>sufra alguna <b>Avería </b>y que le impida moverse por su propio impulso, <b>L A T I N O</b>, a través de su proveedor externo, trasladará el vehículo al taller más próximo autorizado o al domicilio designado de común acuerdo con el <b>Beneficiario</b>, limitado a 1 (un) <b>Evento </b>por año por <b>Póliza</b>, en caso de haber excedente este correrá a cargo del <b>Beneficiario</b>.
            </p>
            <p style="text-indent: 0pt;text-align: center;">
              <br />
            </p>
          </li>
          <li data-list-text="2.">
            <p style="padding-left: 75pt;text-indent: -18pt;text-align: justify;">
              <span class="s12">POR AVERÍA EN ASISTENCIA EN VIAJES: </span>En caso de <b>Avería </b>que no pueda ser reparada en el lugar mismo que se produzca, <b>L A T I N O </b>organizará y tomará a su cargo los servicios de remolque hasta la agencia o taller más cercano, designado de común acuerdo con el <b>Beneficiario.</b>
            </p>
            <p style="padding-left: 75pt;text-indent: 0pt;text-align: justify;">En caso de que el <b>Beneficiario </b>desee trasladar su vehículo a otro lugar, y llegue a haber excedente, éste correrá a cargo del <b>Beneficiario</b>. Se limita a 2 (dos) <b>Evento</b>s por año, por <b>Póliza.</b>
            </p>
            <p style="padding-left: 75pt;text-indent: 0pt;line-height: 11pt;text-align: justify;">En todos los casos, el <b>Beneficiario </b>deberá acompañar a la grúa durante su traslado. </p>
            <p style="text-indent: 0pt;text-align: center;">
              <br />
            </p>
          </li>
          <li data-list-text="3.">
            <p style="padding-left: 75pt;text-indent: -18pt;text-align: justify;">
              <span class="s12">PASO DE CORRIENTE: </span>En caso de que el <b>Vehículo Asegurado </b>se quedara con la batería descargada, <b>L A T I N O </b>asistirá al <b>Beneficiario </b>pasándole corriente a su batería, en función de que pueda arrancar el vehículo y continuar su trayecto.
            </p>
            <p style="padding-left: 75pt;text-indent: 0pt;text-align: justify;">Este servicio aplica para Km. &quot;0&quot; con límite de 2 (dos) <b>Evento</b>s por año por <b>Póliza</b>. En Viajes Nacionales con límite de 2 (dos) <b>Evento</b>s por año por <b>Póliza.</b>
            </p>
          </li>
          <li data-list-text="4.">
            <p style="padding-top: 11pt;padding-left: 75pt;text-indent: -18pt;text-align: justify;">
              <span class="s12">CAMBIO DE LLANTA: </span>En caso de que el <b>Vehículo Asegurado </b>se le ponche una llanta, <b>L A T I N O </b>asistirá al <b>Beneficiario </b>cambiando la llanta averiada por la de refacción en buen estado que deberá ser proporcionada por éste, en caso de que no cuente con ella se ofrecerá el servicio de grúa.
            </p>
            <p style="padding-left: 75pt;text-indent: 0pt;text-align: justify;">Este servicio aplica para Km. &quot;0&quot; con límite de 2 (dos) <b>Evento</b>s por año por <b>Póliza </b>y en Viajes Nacionales con límite de 2 (dos) <b>Evento</b>s por año. </p>
          </li>
          <li data-list-text="5.">
            <p style="padding-top: 11pt;padding-left: 75pt;text-indent: -18pt;text-align: justify;">
              <span class="s12">SUMINISTRO DE GASOLINA: </span>En el caso de que el <b>Beneficiario </b>requiera de envío de gasolina, <b>L A T I N O </b>se hará cargo del envío de 5 (cinco) litros del combustible sin costo para el <b>Beneficiario</b>, en caso de que se requiera una cantidad mayor, el <b>Beneficiario </b>deberá pagar el excedente de los litros solicitados, no superando el límite de 10 (diez) litros. En caso de que se llegara a presentar una situación relacionada con el desabasto de gasolina en el país, el servicio quedara sujeto a disponibilidad, sin responsabilidad para <b>L A T I N O</b>.
            </p>
          </li>
          <li data-list-text="6.">
            <p style="padding-top: 4pt;padding-left: 75pt;text-indent: -18pt;text-align: justify;">
              <span class="s12">REFERENCIAS MECÁNICAS: </span>A solicitud del <b>Beneficiario</b>, <b>L A T I N O </b>le proporcionará información actualizada sobre las agencias de servicio automotriz autorizados cercanos al lugar de la <b>Avería</b>, sin límite de <b>Evento</b>s durante la vigencia de la <b>Póliza</b>.
            </p>
            <p style="padding-top: 3pt;text-indent: 0pt;text-align: center;">
              <br />
            </p>
          </li>
        </ol>
      </li>
      <li data-list-text="C)">
        <p class="s22" style="padding-left: 60pt;text-indent: -21pt;line-height: 11pt;text-align: justify;">
          <a name="a113">Límite Máximo de Responsabilidad</a>
        </p>
        <p style="padding-left: 39pt;text-indent: 0pt;line-height: 11pt;text-align: center;">En caso de exceder los límites de los montos pactados, éstos correrán a cargo del <b>Beneficiario</b>. </p>
        <p style="text-indent: 0pt;text-align: center;">
          <br />
        </p>
        <p style="padding-left: 39pt;text-indent: 0pt;text-align: center;">En Asistencia Vial en Viajes Nacionales, no se cubren casetas, éstas correrán a cargo del</p>
        <p class="s13" style="padding-left: 39pt;text-indent: 0pt;text-align: center;">
          <a name="a114">Beneficiario</a>
          <span class="p">.</span>
        </p>
      </li>
      <li data-list-text="D)">
        <p class="s42" style="padding-top: 11pt;padding-left: 60pt;text-indent: -21pt;text-align: justify;">Exclusiones</p>
        <p class="s25" style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">Queda entendido que, la cobertura de 3.2. Asistencia Vial y la cobertura 3.3. Asistencia Vial Plus se excluyen entre sí, por lo que solo se podrá contrata una de las dos.</p>
        <p class="s25" style="padding-top: 13pt;padding-left: 39pt;text-indent: 0pt;text-align: justify;">En adición a lo estipulado en la Cláusula Exclusiones Generales, en esta cobertura de servicios, <span style=" color: #000;">en ningún caso ampara:</span>
        </p>
        <p style="text-indent: 0pt;text-align: center;">
          <br />
        </p>
        <ol id="l92">
          <li data-list-text="1.">
            <p class="s15" style="padding-left: 74pt;text-indent: -17pt;text-align: justify;">Los servicios de grúas por Siniestro automovilístico.</p>
          </li>
          <li data-list-text="2.">
            <p class="s15" style="padding-left: 74pt;text-indent: -17pt;text-align: justify;">Casetas, peajes, maniobras, blindaje, tiempos de espera.</p>
          </li>
          <li data-list-text="3.">
            <p class="s15" style="padding-left: 75pt;text-indent: -18pt;text-align: justify;">Las situaciones de asistencia que sean consecuencia de: Huelgas, guerras, invasión, actos de enemigos extranjeros, hostilidades (se haya declarado la guerra o no), rebelión, guerra civil, insurrección, terrorismo, piratería, pronunciamientos, manifestaciones, movimientos populares.</p>
          </li>
          <li data-list-text="4.">
            <p class="s15" style="padding-left: 74pt;text-indent: -17pt;text-align: justify;">Autolesiones o participación del Beneficiario en actos criminales.</p>
          </li>
          <li data-list-text="5.">
            <p class="s15" style="padding-left: 75pt;text-indent: -18pt;text-align: justify;">La participación del Beneficiario en riñas, salvo en caso de defensa propia.</p>
          </li>
          <li data-list-text="6.">
            <p class="s15" style="padding-left: 75pt;text-indent: -18pt;text-align: justify;">La práctica de deportes como profesional, la participación en competiciones oficiales y en exhibiciones.</p>
          </li>
          <li data-list-text="7.">
            <p class="s15" style="padding-left: 75pt;text-indent: -18pt;text-align: justify;">La participación del Beneficiario y/o del automóvil en cualquier clase de carreras, competiciones o exhibiciones.</p>
          </li>
          <li data-list-text="8.">
            <p class="s15" style="padding-left: 75pt;text-indent: -18pt;text-align: justify;">Los automóviles que tengan cualquier modificación de cualquier tipo, diferente a las especificaciones del fabricante, consideradas peligrosas, que hayan influido en la Avería o Accidente, a juicio de peritos.</p>
          </li>
        </ol>
      </li>
    </ol>
    <h3 style="padding-top: 13pt;padding-left: 39pt;text-indent: 0pt;text-align: justify;">
      <a name="a115">Cláusula 3.2. Asistencia Vial Plus</a>
    </h3>
    <p class="s22" style="padding-left: 39pt;text-indent: 0pt;text-align: center;">
      <a name="a116">Condiciones Particulares</a>
    </p>
    <p style="padding-top: 2pt;text-indent: 0pt;text-align: center;">
      <br />
    </p>
    <ol id="l93">
      <li data-list-text="A)">
        <p class="s12" style="padding-left: 60pt;text-indent: -21pt;text-align: justify;">Definiciones</p>
        <p style="padding-left: 39pt;text-indent: 0pt;text-align: center;">Para la debida interpretación de la presente cobertura de Asistencia, se acuerda establecer tanto en lo singular como en lo plural las siguientes definiciones:</p>
        <p style="text-indent: 0pt;text-align: center;">
          <br />
        </p>
        <p class="s12" style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">Zona de cobertura: <span class="p">República Mexicana.</span>
        </p>
        <p style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">
          <span class="s12">Arrastre de grúa: </span>Realizar maniobras menores necesarias e indispensables para enganchar a las grúas <b>Vehículo</b>s <b>Asegurado</b>s que, estando sobre sus propias ruedas, deban ser trasladados por caminos y puentes.
        </p>
        <p style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">
          <span class="s12">Asistencia en Viajes Nacionales: </span>Servicios que serán proporcionados en la República Mexicana, siempre y cuando el <b>Beneficiario </b>se encuentre a más de 50 Km. del domicilio permanente del
        </p>
        <p class="s13" style="padding-top: 7pt;padding-left: 39pt;text-indent: 0pt;text-align: justify;">Beneficiario <span class="p">en el caso de ser este último en el Interior de la República Mexicana y; 80 Km. de su domicilio permanente si éste se encuentra en la Ciudad de México o área metropolitana.</span>
        </p>
        <p class="s12" style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">Asistencia Médica Telefónica: <span class="p">Consulta que necesitamos con un amplio cuadro médico, sin salir de casa y durante las 24 horas de los 365 días del año.</span>
        </p>
        <p style="padding-left: 124pt;text-indent: -85pt;text-align: justify;">
          <span class="s12">Asistencia vial: </span>1) Servicio proporcionado a los <b>Conductor </b>cuyos <b>Vehículo Asegurado</b>, con límite de hasta 3.5 toneladas, han sufrido de una falla o problema mecánico lo suficientemente significativo como para inmovilizar temporalmente al vehículo.
        </p>
        <p style="padding-left: 124pt;text-indent: 0pt;text-align: justify;">2) Proporcionar a los <b>Beneficiarios</b>, así como a los <b>Ocupantes </b>del <b>Vehículo Asegurado</b>, los servicios de auxilio vial activándose desde el domicilio permanente del <b>Asegurado </b>o lugar de residencia, entendiéndose este por kilómetro &quot;0&quot; y hasta 50 km si dicho domicilio permanente se encuentra en el interior de la República Mexicana y; 80 km. si se encuentra en la Ciudad de México o área metropolitana. </p>
        <p class="s12" style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">Auto compacto: <span class="p">Es un vehículo motorizado, que, por su estructura y condiciones mecánicas, es apto específicamente para el transporte de personas, deberá tener el permiso o placa de circulación, otorgado por las autoridades competentes para el uso destinado del mismo. En este segmento encontramos autos que miden aproximadamente 4.5 metros de largo y que ofrecen habitabilidad razonable para 5 pasajeros de conformidad con la tarjeta de circulación.</span>
        </p>
        <p style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">
          <span class="s12">Cerrajero para auto: </span>Persona que cuenta con los conocimientos necesarios para abrir la cerradura de la puerta de un auto, con sus herramientas ya que las llaves originales que posee el dueño se extraviaron o quedaron dentro del vehículo. <span class="s15">(No aplica para apertura de cajuela o guantera)</span>.
        </p>
        <p class="s12" style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">Dolly: <span class="p">Tipo de llantas que usan solo las grúas que tienen herramienta de remolque y se usan para ponerlas debajo de las llantas traseras o delanteras del vehículo para hacer el traslado.</span>
        </p>
        <p style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">
          <span class="s12">Maniobras mayores: </span>Cuando se trata de una volcadura, consiste en retirar el vehículo de un atascamiento en playa, lodo, barranco o inundación, etc. Si se sale la flecha de dirección o la llanta. <span class="s12">Maniobras menores: </span>Remolque con <b>Dolly </b>para vehículos parqueados, Desparqueo con conocimiento y autorización del <b>Beneficiario </b>y Desfleche en vehículos de carga.
        </p>
        <p class="s12" style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">Rescate: <span class="p">Acción que sucede cuando el vehículo se encuentra en estacionamientos techados o en diferentes niveles o desniveles para sus maniobras.</span>
        </p>
        <p style="padding-top: 2pt;text-indent: 0pt;text-align: center;">
          <br />
        </p>
      </li>
      <li data-list-text="B)">
        <p class="s22" style="padding-left: 60pt;text-indent: -21pt;text-align: center;">
          <a name="a117">Alcance</a>
        </p>
        <p style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">No se podrá contratar esta cobertura sí se cuenta con Asistencia vial, ya que son excluyentes entre sí.</p>
        <p style="padding-top: 11pt;padding-left: 39pt;text-indent: 0pt;text-align: justify;">La Asistencia Vial Plus, podrá ser contratada en adición a las coberturas básicas de las secciones de Daños Materiales, Robo y -responsabilidad Civil.</p>
        <p style="text-indent: 0pt;text-align: center;">
          <br />
        </p>
        <p style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">Cuando en la <b>Carátula de la Póliza </b>se haga constar su contratación, <b>L A T I N O </b>proporcionará, las siguientes asistencias: </p>
        <p style="padding-top: 2pt;text-indent: 0pt;text-align: center;">
          <br />
        </p>
        <ol id="l94">
          <li data-list-text="1.">
            <p class="s22" style="padding-left: 81pt;text-indent: -21pt;text-align: center;">
              <a name="a118">Asistencia Vial (Km. &quot;0&quot;) y en Viajes Nacionales</a>
            </p>
            <p class="s13" style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">
              <span style=" color: #2C5293;">Beneficiario: </span>Asegurado <span class="p">, </span>Contratante <span class="p">y/o </span>Conductor <span class="p">del </span>Vehículo Asegurado <span class="p">que se vea beneficiado.</span>
            </p>
            <ol id="l95">
              <li data-list-text="1.1.">
                <p style="padding-top: 11pt;padding-left: 60pt;text-indent: -21pt;text-align: justify;">
                  <span class="s12">Arrastre de grúa para vehículos en Asistencia Vial (Km. “0”): </span>En caso de que el <b>Vehículo Asegurado </b>sufra alguna avería y que le impida moverse por su propio impulso, <b>L A T I N O</b>, a través de su proveedor externo, trasladará el vehículo al taller autorizado más próximo sin límite de <b>Evento</b>s y sin límite de kilometraje.
                </p>
                <p style="text-indent: 0pt;text-align: center;">
                  <br />
                </p>
              </li>
              <li data-list-text="1.2.">
                <p style="padding-left: 60pt;text-indent: -21pt;text-align: justify;">
                  <span class="s12">Suministro de gasolina: </span>En el caso de que el <b>Beneficiario </b>requiera de envío de gasolina, <b>L A T I N O</b>, a través de su proveedor externo, se hará cargo del envío de 5 (cinco) litros del combustible sin costo para el <b>Beneficiario</b>, en caso de que se requiera una cantidad mayor, el <b>Beneficiario </b>deberá pagar el excedente de los litros solicitados, no superando el límite de 10 (diez) litros.
                </p>
                <p style="padding-top: 6pt;text-indent: 0pt;text-align: center;">
                  <br />
                </p>
                <p style="padding-left: 60pt;text-indent: 0pt;text-align: justify;">Este servicio aplica para <b>Km. “0” </b>con límite de 2 (dos) <b>Evento</b>s por año y en <b>Asistencia en Viajes Nacionales </b>con límite de 2 eventos por año, incluyendo el costo de la gasolina hasta 5 (cinco) litros y el servicio de asistencia, en caso de haber excedente este correrá a cargo del <b>Beneficiario</b>. </p>
                <p style="text-indent: 0pt;text-align: center;">
                  <br />
                </p>
                <p style="padding-left: 60pt;text-indent: 0pt;text-align: justify;">En caso de que se llegara a presentar una situación relacionada con el desabasto de gasolina en el país, el servicio quedara sujeto a disponibilidad, sin responsabilidad para <b>L A T I N O </b>. </p>
                <p style="padding-top: 1pt;text-indent: 0pt;text-align: center;">
                  <br />
                </p>
              </li>
              <li data-list-text="1.3.">
                <p style="padding-left: 60pt;text-indent: -21pt;text-align: justify;">
                  <span class="s12">Cambio de llanta: </span>En caso de que el <b>Vehículo Asegurado </b>se le ponche una llanta, <b>L A T I N O</b>, a través de su proveedor externo, asistirá al <b>Beneficiario </b>cambiando la llanta averiada por la de refacción en buen estado que deberá ser proporcionada por el <b>Beneficiario</b>, en caso de que no cuente con ella, se ofrecerá el servicio de grúa.
                </p>
                <p style="padding-top: 10pt;padding-left: 60pt;text-indent: 0pt;text-align: justify;">Este servicio aplica para <b>Km. “0” </b>con límite de 2 (dos) <b>Evento</b>s por año y en <b>Asistencia en Viajes Nacionales </b>con límite de 2 (dos) <b>Evento</b>s por año. </p>
                <p style="text-indent: 0pt;text-align: center;">
                  <br />
                </p>
                <ol id="l96">
                  <ol id="l97">
                    <li data-list-text="1.4">
                      <p style="padding-left: 60pt;text-indent: -21pt;text-align: justify;">
                        <span class="s12">Paso de corriente: </span>En caso de que el <b>Vehículo Asegurado </b>se quedara con la batería descargada, <b>L A T I N O</b>, a través de su proveedor externo, asistirá al <b>Beneficiario </b>pasándole corriente a su batería, en función de que pueda arrancar el vehículo y continuar su trayecto.
                      </p>
                      <p style="padding-top: 11pt;padding-left: 60pt;text-indent: 0pt;text-align: justify;">Este servicio aplica para Km. “0” con límite de 2 (dos) <b>Evento</b>s por año y en <b>Asistencia en Viajes Nacionales </b>con límite de 2 (dos) <b>Evento</b>s por año. </p>
                      <p style="text-indent: 0pt;text-align: center;">
                        <br />
                      </p>
                    </li>
                    <li data-list-text="1.5">
                      <p style="padding-left: 60pt;text-indent: -21pt;text-align: justify;">
                        <span class="s12">Referencias mecánicas en Asistencia Vial (Km. “0”): </span>A solicitud del <b>Beneficiario</b>, <b>L A T I N O </b>le proporcionará información actualizada sobre las agencias de servicio automotriz autorizados cercanos al lugar de la <b>Avería</b>, sin límite de <b>Evento</b>s.
                      </p>
                      <p style="text-indent: 0pt;text-align: center;">
                        <br />
                      </p>
                    </li>
                    <li data-list-text="1.6">
                      <p style="padding-left: 60pt;text-indent: -21pt;text-align: justify;">
                        <span class="s12">Envío de Cerrajero para Auto: </span>En caso de que el <b>Beneficiario </b>extraviara las llaves del <b>Vehículo Asegurado</b>, <b>L A T I N O </b>coordinará el envío de un técnico cerrajero hasta el lugar donde se encuentre. El pago de los honorarios del técnico correrá por cuenta del <b>Beneficiario</b>, sin límite de eventos. <span class="s15">No se cubren, ni se realizan duplicados de llaves.</span>
                      </p>
                      <p style="text-indent: 0pt;text-align: center;">
                        <br />
                      </p>
                      <p class="s21" style="padding-left: 39pt;text-indent: 0pt;text-align: center;">Exclusiones.</p>
                      <p class="s25" style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">Queda entendido que, la cobertura de 3.2. Asistencia Vial y la cobertura 3.3. Asistencia Vial Plus se excluyen entre sí, por lo que solo se podrá contrata una de las dos.</p>
                      <p style="text-indent: 0pt;text-align: center;">
                        <br />
                      </p>
                      <p class="s42" style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">Asimismo para estas coberturas quedan excluidos:</p>
                      <p style="text-indent: 0pt;text-align: center;">
                        <br />
                      </p>
                      <ol id="l98">
                        <li data-list-text="1.">
                          <p class="s15" style="padding-left: 81pt;text-indent: -21pt;text-align: justify;">Quedan excluidos los servicios de grúas por Siniestro automovilístico.</p>
                        </li>
                        <li data-list-text="2.">
                          <p class="s15" style="padding-top: 1pt;padding-left: 81pt;text-indent: -21pt;line-height: 108%;text-align: justify;">En ningún caso se cubren casetas, maniobras, blindaje, tiempos de espera, cualquier gasto por estos conceptos serán cubiertos por el Beneficiario.</p>
                        </li>
                        <li data-list-text="3.">
                          <p class="s15" style="padding-left: 81pt;text-indent: -21pt;line-height: 108%;text-align: justify;">Quedan excluidos de la Asistencia Vial y Asistencia en Viajes Nacionales los vehículos cuyo modelo sea de más de 30 (treinta) años de antigüedad a la fecha de la avería.</p>
                        </li>
                        <li data-list-text="4.">
                          <p class="s15" style="padding-left: 81pt;text-indent: -21pt;line-height: 109%;text-align: justify;">Quedan excluidas las situaciones de asistencia que sean consecuencia de:</p>
                          <ol id="l99">
                            <li data-list-text="a)">
                              <p class="s15" style="padding-left: 102pt;text-indent: -21pt;line-height: 108%;text-align: justify;">Huelgas, guerras, invasión, actos de enemigos extranjeros, hostilidades (se haya declarado la guerra o no), rebelión, guerra</p>
                              <p class="s15" style="padding-top: 7pt;padding-left: 102pt;text-indent: 0pt;line-height: 109%;text-align: center;">civil, insurrección, terrorismo, piratería, pronunciamientos, manifestaciones, movimientos populares.</p>
                            </li>
                            <li data-list-text="b)">
                              <p class="s15" style="padding-left: 102pt;text-indent: -21pt;line-height: 13pt;text-align: center;">Autolesiones o participación del Beneficiario en actos criminales.</p>
                            </li>
                            <li data-list-text="c)">
                              <p class="s15" style="padding-top: 1pt;padding-left: 102pt;text-indent: -21pt;line-height: 108%;text-align: center;">La participación del Beneficiario en riñas, salvo en caso de defensa propia.</p>
                            </li>
                            <li data-list-text="d)">
                              <p class="s15" style="padding-left: 102pt;text-indent: -21pt;line-height: 108%;text-align: center;">La práctica de deportes como profesional, la participación en competiciones oficiales y en exhibiciones.</p>
                            </li>
                            <li data-list-text="e)">
                              <p class="s15" style="padding-left: 102pt;text-indent: -21pt;line-height: 108%;text-align: center;">La participación del Beneficiario y/o del Vehículo Asegurado en cualquier clase de carreras, competiciones o exhibiciones.</p>
                            </li>
                          </ol>
                        </li>
                        <li data-list-text="5.">
                          <p class="s15" style="padding-left: 67pt;text-indent: -21pt;line-height: 108%;text-align: justify;">Los vehículos que tengan cualquier modificación de cualquier tipo, diferente a las especificaciones del fabricante, consideradas peligrosas, que hayan influido en la Avería; cualquier gasto por estos conceptos serán cubiertos por el Beneficiario.</p>
                        </li>
                        <li data-list-text="6.">
                          <p class="s15" style="padding-left: 67pt;text-indent: -21pt;line-height: 108%;text-align: justify;">Golpes o choques intencionales, así como la participación del Vehículo Asegurado en actos criminales. Remolque del Vehículo Asegurado con carga o con heridos, así como sacar al Vehículo Asegurado atascado o atorado en baches o barrancos con motivo del tránsito del vehículo fuera de caminos o cuando éstos se encuentren en condiciones intransitables.</p>
                        </li>
                      </ol>
                    </li>
                  </ol>
                </ol>
              </li>
            </ol>
          </li>
          <li data-list-text="2.">
            <p class="s22" style="padding-top: 13pt;padding-left: 74pt;text-indent: -17pt;text-align: justify;">
              <a name="a119">Asistencia Médica</a>
            </p>
          </li>
        </ol>
      </li>
    </ol>
    <p class="s13" style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">
      <span style=" color: #2C5293;">Beneficiario: </span>Asegurado <span class="p">, </span>Contratante <span class="p">, </span>Conductor <span class="p">y/o </span>Ocupantes <span class="p">del </span>Vehículo Asegurado <span class="p">que se vea beneficiado.</span>
    </p>
    <ol id="l100">
      <ol id="l101">
        <li data-list-text="2.1">
          <p style="padding-top: 11pt;padding-left: 60pt;text-indent: -21pt;text-align: justify;">
            <span class="s12">Ambulancia terrestre por accidente: </span>En caso de accidente y sólo cuando fuese necesario, <b>L A T I N O</b>, a través de su proveedor externo, proporcionará al <b>Beneficiario </b>1 (un) servicio de ambulancia para trasladarse al centro hospitalario más cercano y apropiado, mediante una ambulancia de urgencias básicas. La recepción hospitalaria del paciente no es responsabilidad de <b>L A T I N O </b>ni de su proveedor externo.
          </p>
          <p style="text-indent: 0pt;text-align: center;">
            <br />
          </p>
          <p class="s21" style="padding-left: 39pt;text-indent: 0pt;text-align: center;">Exclusiones</p>
          <ol id="l102">
            <li data-list-text="1.">
              <p class="s15" style="padding-top: 11pt;padding-left: 81pt;text-indent: -21pt;text-align: justify;">Cuando el Beneficiario no proporcione información veraz y oportuna, o que incurra en falsedad de información en relación con el tipo de lesiones, mecanismo o parentesco.</p>
            </li>
            <li data-list-text="2.">
              <p class="s15" style="padding-left: 81pt;text-indent: -21pt;text-align: justify;">Quedan excluidos los traslados en caso de enfermedades mentales.</p>
            </li>
            <li data-list-text="3.">
              <p class="s15" style="padding-left: 81pt;text-indent: -21pt;text-align: justify;">Pacientes en Estado de Ebriedad o con abuso de alguna droga que se encuentren en estado agresivo o no deseen ser trasladados.</p>
            </li>
            <li data-list-text="4.">
              <p class="s15" style="padding-left: 81pt;text-indent: -21pt;text-align: justify;">En tramos carreteros, L AT I N O no podrá brindar el servicio.</p>
            </li>
            <li data-list-text="5.">
              <p class="s15" style="padding-left: 81pt;text-indent: -21pt;text-align: justify;">En caso de accidente o siniestro automovilístico, la ambulancia de L A T I N O no podrá realizar maniobras de rescate como por ejemplo liberar al Beneficiario de escombros o del vehículo en caso de encontrarse prensado.</p>
            </li>
            <li data-list-text="6.">
              <p class="s15" style="padding-left: 81pt;text-indent: -21pt;text-align: justify;">No se cubren segundos traslados, ni tiempos de espera.</p>
            </li>
          </ol>
        </li>
        <li data-list-text="2.2">
          <p style="padding-top: 11pt;padding-left: 60pt;text-indent: -21pt;text-align: justify;">
            <span class="s44">Asistencia Telefónica. </span>El <b>Beneficiario </b>podrá solicitar apoyo telefónico, las 24 horas los 365 días del año, al equipo del proveedor externo de <b>L A T I N O </b>, y se le orientará acerca de las medidas a seguir según el caso sin emitir un diagnóstico o tratamiento médico posterior a un
          </p>
          <p style="padding-left: 38pt;text-indent: 0pt;text-align: justify;">accidente automovilístico. <b>L A T I N O </b>, de a través de su proveedor externo, proporcionará </p>
          <p style="padding-top: 7pt;padding-left: 60pt;text-indent: 0pt;text-align: justify;">previa solicitud del <b>Beneficiario</b>, la información correspondiente a las sustancias contenidas en medicinas de patentes, así como todo lo relacionado con la información que se encuentre disponible en el VADEMÉCUM. Sin límite de eventos. <span class="s15">No se receta vía telefónica.</span>
          </p>
          <p style="text-indent: 0pt;text-align: center;">
            <br />
          </p>
          <p class="s45" style="padding-left: 39pt;text-indent: 0pt;text-align: center;">Exclusiones.</p>
          <ol id="l103">
            <li data-list-text="1.">
              <p class="s15" style="padding-left: 81pt;text-indent: -21pt;text-align: justify;">Cuando el Beneficiario no proporcione información veraz y oportuna, que por su naturaleza no permita llevar a cabo un interrogatorio adecuado, o bien, incurra en falsedad de declaraciones.</p>
            </li>
            <li data-list-text="2.">
              <p class="s15" style="padding-left: 81pt;text-indent: -21pt;text-align: justify;">Cuando el Beneficiario no se acredite como tal.</p>
            </li>
            <li data-list-text="3.">
              <p class="s15" style="padding-left: 81pt;text-indent: -21pt;text-align: justify;">Cuando el Beneficiario se encuentre bajo el efecto de bebidas alcohólicas o intoxicación por sustancias relacionadas con farmacodependencia.</p>
            </li>
            <li data-list-text="4.">
              <p class="s15" style="padding-left: 81pt;text-indent: -21pt;text-align: justify;">Cuando el Beneficiario haga el uso de palabras altisonantes.</p>
            </li>
            <li data-list-text="5.">
              <p class="s15" style="padding-left: 81pt;text-indent: -21pt;text-align: justify;">El equipo médico no receta, ni cambia tratamientos médicos, tampoco brinda tratamientos completos.</p>
            </li>
          </ol>
        </li>
      </ol>
    </ol>
    <p class="s44" style="padding-top: 13pt;padding-left: 39pt;text-indent: 0pt;text-align: center;">
      <a name="a120">Asistencia en Viajes Nacionales</a>
    </p>
    <p class="s13" style="padding-top: 11pt;padding-left: 39pt;text-indent: 0pt;text-align: center;">
      <span style=" color: #2C5293;">Beneficiario: </span>Asegurado <span class="p">, </span>Contratante <span class="p">, </span>Conductor <span class="p">y/o </span>Ocupantes <span class="p">del </span>Vehículo Asegurado <span class="p">que se vea beneficiado.</span>
    </p>
    <p style="padding-top: 11pt;padding-left: 39pt;text-indent: 0pt;line-height: 11pt;text-align: center;">Las siguientes coberturas de servicios no operan mediante reembolsos, por lo tanto, el</p>
    <p class="s13" style="padding-left: 39pt;text-indent: 0pt;line-height: 11pt;text-align: center;">Beneficiario <span class="p">deberá reportar inmediatamente cualquier situación de asistencia.</span>
    </p>
    <p style="text-indent: 0pt;text-align: center;">
      <br />
    </p>
    <ol id="l104">
      <ol id="l105">
        <li data-list-text="3.1">
          <p style="padding-left: 60pt;text-indent: -21pt;text-align: justify;">
            <span class="s12">Traslado para ocupantes por avería: </span>Si la reparación del <b>Vehículo Asegurado </b>requiere más de 8 (ocho) horas (a partir de la obtención del diagnóstico de la falla), <b>L A T I N O</b>, a través de su proveedor externo, le ofrecerá al <b>Beneficiario </b>el traslado de los <b>Ocupantes </b>del <b>Vehículo Asegurado </b>averiado hasta el lugar de destino, o bien, a su domicilio permanente. Para efectos de esta condición, el número de <b>Ocupantes </b>está limitado al número de pasajeros señalados en la tarjeta de circulación
          </p>
          <p style="padding-top: 2pt;text-indent: 0pt;text-align: center;">
            <br />
          </p>
          <p class="s21" style="padding-left: 39pt;text-indent: 0pt;text-align: center;">Exclusiones.</p>
          <ol id="l106">
            <li data-list-text="1.">
              <p class="s15" style="padding-left: 81pt;text-indent: -21pt;text-align: justify;">Después de los primeros 60 (sesenta) días naturales de duración del viaje, no habrá obligación por parte de LATINO de prestar los servicios de asistencia.</p>
            </li>
            <li data-list-text="2.">
              <p class="s15" style="padding-left: 81pt;text-indent: -21pt;text-align: justify;">Estas coberturas no operan mediante reembolsos, por lo tanto, el Beneficiario deberá reportar inmediatamente cualquier situación de asistencia.</p>
            </li>
          </ol>
        </li>
        <li data-list-text="3.2">
          <p style="padding-top: 13pt;padding-left: 60pt;text-indent: -21pt;text-align: justify;">
            <span class="s12">Ambulancia aérea, terrestre o avión en línea comercial (por accidente): </span>Si el <b>Beneficiario </b>sufre lesiones o traumatismos tales que el equipo médico del proveedor externo de <b>L A T I N O</b>, recomiende su hospitalización, éste último gestionará, 1 (un) <b>Evento </b>por año, cualquiera de los siguientes servicios:
          </p>
          <p style="text-indent: 0pt;text-align: center;">
            <br />
          </p>
          <ol id="l107">
            <li data-list-text="I.">
              <p style="padding-left: 81pt;text-indent: -21pt;text-align: justify;">Traslado médico por ACCIDENTE del <b>Beneficiario </b>al centro hospitalario más cercano y apropiado al lugar del accidente. El traslado se efectuará por los medios más adecuados, incluyéndose: ambulancia aérea, avión de línea comercial o ambulancia terrestre. </p>
              <p style="text-indent: 0pt;text-align: center;">
                <br />
              </p>
              <p class="s12" style="padding-left: 39pt;text-indent: 0pt;text-align: center;">
                <a name="a121">Condiciones de ambulancia aérea:</a>
              </p>
              <p style="text-indent: 0pt;text-align: center;">
                <br />
              </p>
              <ol id="l108">
                <li data-list-text="1.">
                  <p class="s12" style="padding-left: 81pt;text-indent: -21pt;text-align: justify;">Servicio Programado <span class="p">, siempre y cuando el estado de salud e historial médico del paciente lo permitan.</span>
                  </p>
                </li>
                <li data-list-text="2.">
                  <p class="s12" style="padding-top: 7pt;padding-left: 81pt;text-indent: -21pt;text-align: justify;">Ubicación del Paciente: <span class="p">El traslado aéreo se llevará a cabo siempre y cuando en la localidad en donde se encuentre el paciente, no se tenga la infraestructura necesaria para la atención médica y se requiera el desplazamiento a otra localidad que si cuente con todos los recursos físicos y personal médico requeridos según sea el caso.</span>
                  </p>
                </li>
                <li data-list-text="3.">
                  <p style="padding-left: 81pt;text-indent: -21pt;text-align: justify;">
                    <span class="s12">Estado de Salud del Paciente y Autorización de Vuelo: </span>Si las condiciones del paciente permiten el traslado por vía aérea, el médico tratante deberá de otorgar la autorización de vuelo por escrito. En caso de alta voluntaria el <b>Beneficiario </b>o su familiar permitirán que el paciente sea valorado por la tripulación médica y en caso de no existir las condiciones generales para su traslado, aceptarán la cancelación o reprogramación del traslado.
                  </p>
                </li>
                <li data-list-text="4.">
                  <p style="padding-left: 81pt;text-indent: -21pt;text-align: justify;">
                    <span class="s12">Reporte Médico: </span>El familiar responsable, médico tratante o representante legal designado, deberá de hacer llegar al equipo médico del proveedor externo de <b>L A T I N O </b>un reporte médico detallado, especificando antecedentes, condiciones actuales, diagnósticos y tratamientos, así como el pronóstico, con la finalidad de que el paciente sea trasladado con la infraestructura necesaria para garantizar su integridad.
                  </p>
                </li>
              </ol>
            </li>
          </ol>
          <p class="s12" style="padding-top: 11pt;padding-left: 39pt;text-indent: 0pt;text-align: center;">
            <a name="a122">Condiciones de avión línea comercial</a>
          </p>
          <p style="padding-top: 1pt;text-indent: 0pt;text-align: center;">
            <br />
          </p>
          <ol id="l109">
            <li data-list-text="1.">
              <p style="padding-left: 81pt;text-indent: -21pt;text-align: justify;">El traslado se efectuará por los medios más adecuados, incluyéndose avión de línea comercial.</p>
            </li>
            <li data-list-text="2.">
              <p style="padding-left: 81pt;text-indent: -21pt;text-align: justify;">Una vez que el familiar, <b>Beneficiario </b>o representante legal estén informados sobre las condiciones del vuelo y sus riesgos deberá de firmar el formato con la finalidad de dar a conocer que se deslinda de cualquier responsabilidad a la empresa de aerolínea y a <b>L A T I N O </b>y a sus proveedores del servicio de cualquier complicación presentada durante el traslado. </p>
            </li>
            <li data-list-text="3.">
              <p style="padding-left: 81pt;text-indent: -21pt;text-align: justify;">
                <span class="s12">Estado de Salud del Paciente y Autorización de Vuelo: </span>Si las condiciones del paciente permiten el traslado por vía aérea, el médico tratante deberá de otorgar la autorización de vuelo por escrito. En caso de alta voluntaria el <b>Beneficiario </b>o su familiar permitirán que el paciente sea valorado por la tripulación o médica y en caso de no existir las condiciones generales para su traslado, aceptarán la cancelación o reprogramación del traslado.
              </p>
            </li>
            <li data-list-text="4.">
              <p style="padding-left: 81pt;text-indent: -21pt;text-align: justify;">
                <span class="s12">Reporte Médico: </span>El familiar responsable, médico tratante o representante legal designado, deberá de hacer llegar al equipo médico del proveedor externo de <b>L A T I N O </b>un reporte médico detallado, especificando antecedentes, condiciones actuales, diagnósticos y tratamientos, así como el pronóstico, con la finalidad de que el paciente sea trasladado con la infraestructura necesaria para garantizar su integridad.
              </p>
            </li>
          </ol>
          <p style="text-indent: 0pt;text-align: center;">
            <br />
          </p>
          <p class="s12" style="padding-left: 39pt;text-indent: 0pt;text-align: center;">
            <a name="a123">Condiciones de ambulancia terrestre</a>
          </p>
          <p style="padding-top: 1pt;text-indent: 0pt;text-align: center;">
            <br />
          </p>
          <ol id="l110">
            <li data-list-text="1.">
              <p style="padding-left: 81pt;text-indent: -21pt;text-align: justify;">En caso de encontrarse de viaje dentro de territorio mexicano, se realizará el traslado médico en ambulancia terrestre sin costo para el <b>Beneficiario</b>. Los traslados que son por emergencia no se realizan con supervisión médica, únicamente se encuentran los paramédicos quienes realizan el traslado. </p>
            </li>
            <li data-list-text="2.">
              <p style="padding-left: 81pt;text-indent: -21pt;text-align: justify;">Una vez que el familiar, <b>Beneficiario </b>o representante legal estén informados sobre las condiciones del traslado y sus riesgos deberá de firmar el formato con la finalidad de dar a conocer que se deslinda de cualquier responsabilidad a <b>L A T I N O </b>y a sus proveedores de servicios de cualquier complicación presentada durante el traslado. </p>
            </li>
          </ol>
          <p style="padding-top: 1pt;text-indent: 0pt;text-align: center;">
            <br />
          </p>
          <p class="s21" style="padding-left: 39pt;text-indent: 0pt;text-align: center;">Exclusiones</p>
          <ol id="l111">
            <li data-list-text="1.">
              <p class="s15" style="padding-left: 81pt;text-indent: -21pt;text-align: justify;">Las situaciones de emergencia ocurridas durante viajes o vacaciones realizadas por el Beneficiario en contra de prescripción médica o durante viajes superiores a 60 (sesenta) días naturales, no dan derecho a los servicios de asistencia.</p>
            </li>
            <li data-list-text="2.">
              <p class="s15" style="padding-left: 81pt;text-indent: -21pt;text-align: justify;">Cuando por una acción intencional del Beneficiario resulte la comisión de un delito.</p>
            </li>
            <li data-list-text="3.">
              <p class="s15" style="padding-left: 81pt;text-indent: -21pt;text-align: justify;">Cuando el Beneficiario no proporcione información veraz y oportuna,</p>
              <p class="s15" style="padding-top: 7pt;padding-left: 81pt;text-indent: 0pt;text-align: justify;">que por su naturaleza no permita atender debidamente el asunto, o bien, incurra en falsedad de declaraciones.</p>
            </li>
            <li data-list-text="4.">
              <p class="s15" style="padding-left: 81pt;text-indent: -21pt;text-align: justify;">Quedan excluidas las situaciones de asistencia que sean consecuencia de:</p>
              <ol id="l112">
                <li data-list-text="a.">
                  <p class="s15" style="padding-left: 110pt;text-indent: -21pt;text-align: justify;">Huelgas, guerra, invasión, actos de enemigos extranjeros, hostilidades (se haya declarado la guerra o no), rebelión, guerra civil, insurrección, terrorismo, pronunciamientos, manifestaciones, movimientos populares, radioactividad o cualquier otra causa de fuerza mayor.</p>
                </li>
                <li data-list-text="b.">
                  <p class="s15" style="padding-left: 110pt;text-indent: -21pt;text-align: justify;">Autolesiones o participación del Beneficiario en actos delictivos intencionales.</p>
                </li>
                <li data-list-text="c.">
                  <p class="s15" style="padding-left: 110pt;text-indent: -21pt;text-align: justify;">La participación del Beneficiario en cualquier clase de carrera, competición o exhibición (automóviles, caballos, bicicleta).</p>
                </li>
                <li data-list-text="d.">
                  <p class="s15" style="padding-left: 110pt;text-indent: -21pt;text-align: justify;">Suicidio o enfermedades y lesiones resultantes del intento de suicidio.</p>
                </li>
                <li data-list-text="e.">
                  <p class="s15" style="padding-left: 110pt;text-indent: -21pt;text-align: justify;">Enfermedades mentales o alienación: cualquier tipo de accidente o enfermedad causado por radiaciones nucleares; cualquier enfermedad preexistente, crónica o recurrente y la convalecencia se consideran como parte de la enfermedad.</p>
                </li>
                <li data-list-text="f.">
                  <p class="s15" style="padding-left: 110pt;text-indent: -21pt;text-align: justify;">Las lesiones o enfermedades sobrevenidas en el ejercicio de deportes extremos, o en el ejercicio como deportistas amateurs o profesionales.</p>
                </li>
                <li data-list-text="g.">
                  <p class="s15" style="padding-left: 110pt;text-indent: -21pt;text-align: justify;">Hechos de la naturaleza tales como (pero no limitativos) inundación, huracán y terremoto.</p>
                </li>
                <li data-list-text="h.">
                  <p class="s15" style="padding-left: 109pt;text-indent: -21pt;text-align: justify;">En tramos carreteros, LATINO no podrá brindar el servicio.</p>
                </li>
                <li data-list-text="i.">
                  <p class="s15" style="padding-left: 110pt;text-indent: -21pt;text-align: justify;">Enfermedades o estados patológicos producidos por la ingestión intencionada o administración de tóxicos (drogas), embriaguez, narcóticos o por la utilización de medicamentos sin prescripción médica.</p>
                </li>
                <li data-list-text="j.">
                  <p class="s15" style="padding-left: 110pt;text-indent: -21pt;text-align: justify;">En caso de accidente o siniestro automovilístico, la ambulancia de L A T I N O no podrá realizar maniobras de rescate como por ejemplo liberar al Beneficiario de escombros o del vehículo en caso de encontrarse prensado.</p>
                </li>
              </ol>
            </li>
          </ol>
        </li>
        <li data-list-text="3.3">
          <p style="padding-top: 13pt;padding-left: 60pt;text-indent: -21pt;text-align: justify;">
            <span class="s12">Hotel por convalecencia</span>
            <span class="s46">: </span>Se pagarán los gastos necesarios para la prolongación de la estancia del <b>Beneficiario </b>en un hotel sugerido por <b>L A T I N O </b>, inmediatamente después de haber sido dado de alta del hospital, siempre y cuando esta prolongación haya sido prescrita por el médico tratante y por el personal médico del proveedor externo de <b>L A T I N O </b>, limitado a 1 (un) <b>Evento </b>al año con un monto de $650.00 (seiscientos cincuenta pesos 00/100 M.N.) por día, máximo 5 (cinco) días naturales consecutivos.
          </p>
          <p style="text-indent: 0pt;text-align: center;">
            <br />
          </p>
          <p class="s21" style="padding-left: 39pt;text-indent: 0pt;text-align: center;">Exclusiones.</p>
          <ol id="l113">
            <li data-list-text="1.">
              <p class="s15" style="padding-left: 81pt;text-indent: -21pt;text-align: justify;">Quedan excluidas las situaciones de asistencia ocurridas durante viajes realizados por los Beneficiarios en contra de la prescripción del médico de cabecera o después de los primeros 60 (sesenta) días naturales de duración del viaje.</p>
            </li>
            <li data-list-text="2.">
              <p class="s15" style="padding-left: 81pt;text-indent: -21pt;text-align: justify;">Las irradiaciones procedentes de la transmutación o desintegración nuclear, de la radioactividad o de cualquier tipo de accidente causado</p>
              <p class="s15" style="padding-top: 7pt;padding-left: 81pt;text-indent: 0pt;text-align: justify;">por combustibles nucleares.</p>
            </li>
            <li data-list-text="3.">
              <p class="s15" style="padding-left: 81pt;text-indent: -21pt;text-align: justify;">Cualquier enfermedad preexistente (entendiéndose por ésta, aquélla que se originó antes de la vigencia de esta Póliza y por la cual se hayan erogado gastos antes del inicio de la vigencia de esta cobertura de asistencia). La convalecencia se considerará como parte de la enfermedad.</p>
            </li>
            <li data-list-text="4.">
              <p class="s15" style="padding-left: 81pt;text-indent: -21pt;text-align: justify;">Enfermedades mentales o enajenación.</p>
            </li>
            <li data-list-text="5.">
              <p class="s15" style="padding-left: 81pt;text-indent: -21pt;text-align: justify;">Embarazo, parto, cesárea y prenatales.</p>
            </li>
            <li data-list-text="6.">
              <p class="s15" style="padding-left: 81pt;text-indent: -21pt;text-align: justify;">Exámenes de la vista con el fin de diagnosticar o corregir una graduación, así como procedimientos quirúrgicos como queratotomías radiales u otro tipo de cirugías con el fin de modificar errores refractarios, gastos de anteojos, lentes de contacto, etc.</p>
            </li>
            <li data-list-text="7.">
              <p class="s15" style="padding-left: 81pt;text-indent: -21pt;text-align: justify;">Trasplante de órganos o miembros de cualquier tipo.</p>
            </li>
            <li data-list-text="8.">
              <p class="s15" style="padding-left: 81pt;text-indent: -21pt;text-align: justify;">Enfermedades o estados patológicos producidos por la ingestión intencionada o administración de tóxicos (drogas), embriaguez, narcóticos o por la utilización de medicamentos sin prescripción médica.</p>
            </li>
            <li data-list-text="9.">
              <p class="s15" style="padding-left: 81pt;text-indent: -21pt;text-align: justify;">Suicidio o enfermedades y lesiones resultantes del intento de suicidio.</p>
            </li>
            <li data-list-text="10.">
              <p class="s15" style="padding-left: 81pt;text-indent: -21pt;text-align: justify;">Prótesis en general, gastos por muletas, silla de ruedas y aparatos ortopédicos.</p>
            </li>
            <li data-list-text="11.">
              <p class="s15" style="padding-left: 81pt;text-indent: -21pt;text-align: justify;">Tratamientos odontológicos que no sean problemas agudos de emergencia, tales como, prótesis, endodoncias, limpiezas, tratamientos de embellecimiento, etc.</p>
            </li>
            <li data-list-text="12.">
              <p class="s15" style="padding-left: 81pt;text-indent: -21pt;text-align: justify;">En caso de requerirse los servicios de gastos de hotel, L A T I N O no se hará responsable por los siguientes gastos: Alimentos y bebidas; Cualquier servicio de lavandería; limpieza o cortesía; Estacionamiento; Llamadas telefónicas; Eventos especiales; Propinas y Taxis.</p>
            </li>
          </ol>
        </li>
        <li data-list-text="3.4">
          <p style="padding-top: 11pt;padding-left: 60pt;text-indent: -21pt;text-align: justify;">
            <span class="s12">Traslado de familiar por convalecencia del Conductor del Vehículo Asegurado: </span>En caso de que el <b>Conductor </b>del <b>Vehículo Asegurado </b>sufra un accidente automovilístico viajando solo o en compañía de menores de edad, <b>L A T I N O </b>proporcionará un boleto redondo para un familiar en primer grado o la persona que el <b>Conductor </b>del <b>Vehículo Asegurado </b>designe para que lo acompañe, por el medio de transporte idóneo, desde su lugar de residencia y hasta el lugar en que se encuentre hospitalizado o atendido médicamente el <b>Conductor </b>del <b>Vehículo Asegurado</b>. Limitado a 1 (un) evento al año.
          </p>
          <p class="s21" style="padding-top: 11pt;padding-left: 39pt;text-indent: 0pt;text-align: center;">Exclusiones.</p>
          <ol id="l114">
            <li data-list-text="1.">
              <p class="s15" style="padding-left: 81pt;text-indent: -21pt;text-align: justify;">Quedan excluidas las situaciones de asistencia ocurridas durante viajes realizados por el Conductor del Vehículo Asegurado en contra de la prescripción del médico de cabecera o después de los primeros 60 (sesenta) días naturales de duración del viaje.</p>
            </li>
            <li data-list-text="2.">
              <p class="s15" style="padding-left: 81pt;text-indent: -21pt;text-align: justify;">Las irradiaciones procedentes de la transmutación o desintegración nuclear, de la radioactividad o de cualquier tipo de accidente causado por combustibles nucleares.</p>
            </li>
            <li data-list-text="3.">
              <p class="s15" style="padding-left: 81pt;text-indent: -21pt;text-align: justify;">Cualquier enfermedad preexistente (entendiéndose por ésta, aquélla que se originó antes de la vigencia de esta Póliza y por la cual se</p>
              <p class="s15" style="padding-top: 7pt;padding-left: 81pt;text-indent: 0pt;text-align: justify;">hayan erogado gastos antes del inicio de la vigencia de esta cobertura de asistencia). La convalecencia se considerará como parte de la enfermedad.</p>
              <ol id="l115">
                <li data-list-text="4">
                  <p class="s15" style="padding-left: 81pt;text-indent: -21pt;text-align: justify;">Enfermedades mentales o enajenación.</p>
                </li>
                <li data-list-text="5">
                  <p class="s15" style="padding-left: 81pt;text-indent: -21pt;text-align: justify;">Embarazo, parto, cesárea y prenatales.</p>
                </li>
                <li data-list-text="6">
                  <p class="s15" style="padding-left: 81pt;text-indent: -21pt;text-align: justify;">Exámenes de la vista con el fin de diagnosticar o corregir una graduación, así como procedimientos quirúrgicos como queratotomías radiales u otro tipo de cirugías con el fin de modificar errores refractorios, gastos de anteojos, lentes de contacto, etc.</p>
                </li>
                <li data-list-text="7">
                  <p class="s15" style="padding-left: 81pt;text-indent: -21pt;text-align: justify;">Trasplante de órganos o miembros de cualquier tipo.</p>
                </li>
                <li data-list-text="8">
                  <p class="s15" style="padding-left: 81pt;text-indent: -21pt;text-align: justify;">Enfermedades o estados patológicos producidos por la ingestión intencionada o administración de tóxicos (drogas), embriaguez, narcóticos o por la utilización de medicamentos sin prescripción médica.</p>
                </li>
                <li data-list-text="9">
                  <p class="s15" style="padding-left: 81pt;text-indent: -21pt;text-align: justify;">Suicidio o enfermedades y lesiones resultantes del intento de suicidio.</p>
                </li>
                <li data-list-text="10">
                  <p class="s15" style="padding-left: 81pt;text-indent: -21pt;text-align: justify;">Prótesis en general, gastos por muletas, silla de ruedas y aparatos ortopédicos.</p>
                </li>
                <li data-list-text="11">
                  <p class="s15" style="padding-left: 81pt;text-indent: -21pt;text-align: justify;">Tratamientos odontológicos que no sean problemas agudos de emergencia, tales como, prótesis, endodoncias, limpiezas, tratamientos de embellecimiento, etc.</p>
                </li>
              </ol>
              <p style="padding-top: 11pt;text-indent: 0pt;text-align: center;">
                <br />
              </p>
            </li>
          </ol>
        </li>
        <li data-list-text="3.5">
          <p style="padding-left: 60pt;text-indent: -21pt;text-align: justify;">
            <span class="s12">Repatriación por Fallecimiento del Conductor del Vehículo Asegurado: </span>En caso de fallecimiento del <b>Conductor </b>del <b>Vehículo Asegurado </b>por accidente automovilístico, encontrándose de viaje en territorio nacional <b>L A T I N O</b>, a través de su proveedor externo, realizará todas las formalidades necesarias (incluyendo cualquier trámite legal) y se hará cargo de:
          </p>
          <p style="text-indent: 0pt;text-align: center;">
            <br />
          </p>
          <ol id="l116">
            <li data-list-text="I.">
              <p style="padding-left: 81pt;text-indent: -21pt;text-align: center;">Traslado del cadáver o cenizas hasta el lugar de inhumación en la ciudad de residencia permanente del <b>Conductor </b>del <b>Vehículo Asegurado</b>; o, </p>
            </li>
            <li data-list-text="II.">
              <p style="padding-left: 81pt;text-indent: -21pt;text-align: center;">A petición de los familiares o representantes del <b>Conductor </b>del <b>Vehículo Asegurado</b>, inhumación en el lugar donde se haya producido el deceso. </p>
            </li>
            <li data-list-text="III.">
              <p class="s13" style="padding-left: 81pt;text-indent: -21pt;text-align: center;">L A T I N O <span class="p">, a través de su proveedor externo, se hará cargo de estos gastos sólo hasta el límite de 600 (seiscientas) UMAS. Limitado a 1 (un) </span>Evento <span class="p">por año.</span>
              </p>
            </li>
          </ol>
          <p class="s21" style="padding-top: 11pt;padding-left: 39pt;text-indent: 0pt;text-align: center;">Exclusiones.</p>
          <p class="s15" style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">Quedan excluidas las situaciones de asistencia ocurridas durante viajes realizados por el Conductor del Vehículo Asegurado en contra de la prescripción del médico de cabecera o después de los primeros 60 (sesenta) días naturales de duración del viaje.</p>
          <p style="text-indent: 0pt;text-align: center;">
            <br />
          </p>
        </li>
        <li data-list-text="3.6">
          <p style="padding-left: 60pt;text-indent: -21pt;text-align: justify;">
            <span class="s8">Pago de hotel a causa de fuerza mayor: </span>Se pagará la estancia en un hotel sugerido por <b>L A T I N O </b>, para el caso de que, por consecuencia de eventos de tipo natural o conflictos sociales declarados por las autoridades locales o federales no se permitiera el libre tránsito en carreteras ocasionando que el <b>Beneficiario </b>no pueda regresar a su residencia permanente en el <b>Vehículo Asegurado</b>, limitado a 2 (dos) <b>Eventos </b>al año por <b>Póliza</b>, hasta $480.00 (cuatrocientos ochenta pesos 00/100 M.N.) por <b>Evento</b>. Sin importar los días de estancia del <b>Beneficiario </b>o número de <b>Ocupantes</b>, el excedente corre a cargo del <b>Beneficiario.</b>
          </p>
          <p class="s42" style="padding-top: 7pt;padding-left: 39pt;text-indent: 0pt;text-align: center;">Exclusiones</p>
          <ol id="l117">
            <li data-list-text="1.">
              <p class="s15" style="padding-left: 81pt;text-indent: -21pt;text-align: justify;">LATINO no se hará responsable por los siguientes gastos: Alimentos y bebidas; Cualquier servicio de lavandería; limpieza o cortesía; Estacionamiento; Llamadas telefónicas; Eventos especiales; Propinas y Taxis.</p>
            </li>
            <li data-list-text="2.">
              <p class="s15" style="padding-left: 81pt;text-indent: -21pt;text-align: justify;">Estas coberturas no operan mediante reembolsos, por lo tanto, deberá reportar inmediatamente cualquier situación de asistencia.</p>
              <p style="padding-top: 8pt;text-indent: 0pt;text-align: center;">
                <br />
              </p>
            </li>
          </ol>
        </li>
        <li data-list-text="3.7">
          <p style="padding-left: 60pt;text-indent: -21pt;text-align: justify;">
            <span class="s12">Asesoría administrativa/información de trámites</span>
            <span class="s46">: </span>En caso de robo o pérdida de documentos esenciales para la continuación de viaje, como son: pasaporte, visa, boletos de avión, <b>L A T I N O </b>proveerá de la información necesaria al <b>Beneficiario </b>vía telefónica, así como del procedimiento a seguir con las autoridades locales o consulados mexicanos, con el fin de obtener la reposición de dichos documentos.
          </p>
          <p class="s21" style="padding-top: 11pt;padding-left: 39pt;text-indent: 0pt;text-align: center;">Exclusiones.</p>
          <p class="s15" style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">Para la correcta aplicación de esta cobertura el Beneficiario deberá proporcionar vía telefónica información veraz y oportuna que permita prestar debidamente la asistencia. El costo que se genere para la adquisición de los productos o servicios deberá de ser cubierto en su totalidad por el Beneficiario. Servicio sujeto a disponibilidad, términos y condiciones de los proveedores.</p>
          <p class="s15" style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">LATINO no tendrá ninguna responsabilidad con respecto al servicio recibido por parte de las referidas compañías o proveedores.</p>
          <p style="text-indent: 0pt;text-align: center;">
            <br />
          </p>
          <ol id="l118">
            <li data-list-text="1.">
              <p class="s15" style="padding-left: 81pt;text-indent: -21pt;text-align: justify;">Por ningún motivo los coordinadores telefónicos (concierges) se prestarán a peticiones fuera del marco de la ley, por ello quedan excluidas, las peticiones como compra, monitoreo o cualquier tipo de información acerca de narcóticos, mensajes eróticos, armas, o cualquier tipo de información fraudulenta o ilícita que afecte la integridad del servicio.</p>
            </li>
            <li data-list-text="2.">
              <p class="s15" style="padding-left: 81pt;text-indent: -21pt;text-align: justify;">L A T I N O no tendrá ninguna responsabilidad por los trabajos de Conserjería realizados, ni garantías ofrecidas por los proveedores.</p>
            </li>
            <li data-list-text="3.">
              <p class="s15" style="padding-left: 81pt;text-indent: -21pt;line-height: 14pt;text-align: justify;">Peticiones fuera del marco legal o ético.</p>
            </li>
            <li data-list-text="4.">
              <p class="s15" style="padding-left: 81pt;text-indent: -21pt;text-align: justify;">Servicio sujeto a disponibilidad, términos y condiciones de los proveedores.</p>
            </li>
          </ol>
        </li>
        <li data-list-text="3.8">
          <p class="s13" style="padding-top: 11pt;padding-left: 60pt;text-indent: -21pt;text-align: justify;">
            <span style=" color: #2C5293;">Mensajes urgentes</span>
            <span class="s46">: </span>L A T I N O <span class="p">, a través de su proveedor externo, se encargará de transmitir vía mensaje de texto, a petición del </span>Beneficiario <span class="p">, los mensajes urgentes que le soliciten derivados de una situación de asistencia.</span>
          </p>
          <p class="s21" style="padding-top: 11pt;padding-left: 39pt;text-indent: 0pt;text-align: center;">Exclusiones.</p>
          <ol id="l119">
            <li data-list-text="1.">
              <p class="s15" style="padding-left: 81pt;text-indent: -21pt;text-align: center;">Peticiones fuera del marco legal o ético.</p>
            </li>
            <li data-list-text="2.">
              <p class="s15" style="padding-left: 81pt;text-indent: -21pt;text-align: center;">No se harán conferencias ni habrá transferencia de llamadas.</p>
            </li>
            <li data-list-text="3.">
              <p class="s15" style="padding-left: 81pt;text-indent: -21pt;text-align: justify;">Cuando el Beneficiario no proporcione información veraz y oportuna que nos permita prestar debidamente la asistencia.</p>
            </li>
            <li data-list-text="4.">
              <p class="s15" style="padding-left: 81pt;text-indent: -21pt;text-align: justify;">Por ningún motivo la asistencia se prestará a peticiones fuera del marco de la ley o cualquier tipo de información fraudulenta o ilícita que afecte la integridad del servicio.</p>
              <h3 style="padding-top: 7pt;padding-left: 39pt;text-indent: 0pt;text-align: justify;">
                <a name="a124">Cláusula 3.4. Asistencia Funeraria al Conductor</a>
              </h3>
              <p class="s47" style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">
                <a name="a125">Condiciones Particulares</a>
              </p>
              <p style="padding-top: 13pt;padding-left: 39pt;text-indent: 0pt;text-align: center;">La siguiente Asistencia Funeraria al Conductor podrá ser contratada en adición a las coberturas básicas de las secciones de Daños Materiales y Robo.</p>
              <p style="padding-top: 2pt;text-indent: 0pt;text-align: center;">
                <br />
              </p>
              <ol id="l120">
                <li data-list-text="1.">
                  <p class="s12" style="padding-left: 81pt;text-indent: -21pt;text-align: center;">
                    <a name="a126">Definiciones.</a>
                  </p>
                  <p style="padding-left: 39pt;text-indent: 0pt;text-align: center;">Para la debida interpretación de la presente cobertura de Asistencia, se acuerda establecer tanto en lo singular como en lo plural las siguientes definiciones:</p>
                  <p style="text-indent: 0pt;text-align: center;">
                    <br />
                  </p>
                  <p class="s12" style="padding-left: 39pt;text-indent: 0pt;text-align: center;">Zona de Cobertura: <span class="p">República Mexicana.</span>
                  </p>
                  <p style="padding-top: 1pt;text-indent: 0pt;text-align: center;">
                    <br />
                  </p>
                </li>
                <li data-list-text="2.">
                  <p class="s12" style="padding-left: 81pt;text-indent: -21pt;text-align: center;">
                    <a name="a127">Alcance.</a>
                  </p>
                  <p style="text-indent: 0pt;text-align: center;">
                    <br />
                  </p>
                  <p style="padding-left: 39pt;text-indent: 0pt;text-align: center;">Cuando en la <b>Carátula de la Póliza </b>se haga constar su contratación, <b>L A T I N O</b>, a través de sus proveedores externos, proporcionará para el Conductor los siguientes servicios siempre que fueran necesarios a consecuencia de un accidente automovilístico: </p>
                  <ol id="l121">
                    <li data-list-text="1.">
                      <p style="padding-left: 109pt;text-indent: -28pt;line-height: 11pt;text-align: center;">Servicio de asistencia funeraria al <b>Conductor </b>del <b>Vehículo Asegurado</b>. </p>
                    </li>
                    <li data-list-text="2.">
                      <p style="padding-left: 110pt;text-indent: -28pt;text-align: center;">Servicio de asistencia legal telefónica personalizada las 24 horas, los 365 días del año.</p>
                    </li>
                    <li data-list-text="3.">
                      <p style="padding-left: 109pt;text-indent: -28pt;text-align: center;">Servicio de asistencia psicológica telefónica las 24 horas, los 365 días del año.</p>
                    </li>
                    <li data-list-text="4.">
                      <p style="padding-left: 109pt;text-indent: -28pt;text-align: center;">Servicio de Asistencia Legal en sitio en caso de fallecimiento.</p>
                    </li>
                    <li data-list-text="5.">
                      <p style="padding-left: 110pt;text-indent: -28pt;text-align: center;">Servicio de monitoreo de llamadas, informes y datos, capacidad y apoyo técnico y equipo de operación.</p>
                    </li>
                    <li data-list-text="6.">
                      <p style="padding-left: 110pt;text-indent: -28pt;line-height: 92%;text-align: center;">Servicio de primer traslado del lugar de fallecimiento dentro de la <b>Zona de Cobertura </b>
                        <span class="s11">hacia la agencia funeraria donde será velado.</span>
                      </p>
                    </li>
                    <li data-list-text="7.">
                      <p style="padding-left: 110pt;text-indent: -28pt;text-align: center;">Servicio de embalsamado con arreglo estético del cuerpo que incluye maquillaje y vestimenta.</p>
                    </li>
                    <li data-list-text="8.">
                      <p style="padding-left: 110pt;text-indent: -28pt;text-align: center;">Sala de velación o equipo para instalar velación a domicilio solo en la <b>Zona de Cobertura</b>. </p>
                    </li>
                    <li data-list-text="9.">
                      <p style="padding-left: 109pt;text-indent: -28pt;line-height: 11pt;text-align: center;">Carroza para primer traslado.</p>
                    </li>
                    <li data-list-text="10.">
                      <p style="padding-left: 109pt;text-indent: -28pt;line-height: 11pt;text-align: center;">Arreglo estético del cuerpo.</p>
                    </li>
                    <li data-list-text="11.">
                      <p style="padding-left: 109pt;text-indent: -28pt;text-align: center;">Ataúd metálico o de madera estándar.</p>
                    </li>
                    <li data-list-text="12.">
                      <p style="padding-left: 109pt;text-indent: -28pt;line-height: 11pt;text-align: center;">Equipo de velación.</p>
                    </li>
                    <li data-list-text="13.">
                      <p style="padding-left: 109pt;text-indent: -28pt;line-height: 11pt;text-align: center;">Sala de velación (con opción a velación en domicilio).</p>
                    </li>
                    <li data-list-text="14.">
                      <p style="padding-left: 109pt;text-indent: -28pt;line-height: 11pt;text-align: center;">Servicio de inhumación (no incluye fosa).</p>
                    </li>
                    <li data-list-text="15.">
                      <p style="padding-left: 109pt;text-indent: -28pt;line-height: 11pt;text-align: center;">Servicio de cremación (no incluye nicho).</p>
                    </li>
                    <li data-list-text="16.">
                      <p style="padding-left: 109pt;text-indent: -28pt;text-align: center;">Urna estándar.</p>
                    </li>
                    <li data-list-text="17.">
                      <p style="padding-left: 109pt;text-indent: -28pt;text-align: center;">Carroza para el cortejo.</p>
                    </li>
                    <li data-list-text="18.">
                      <p style="padding-left: 109pt;text-indent: -28pt;text-align: center;">Gestoría para obtención de permisos tales como:</p>
                      <ul id="l122">
                        <li data-list-text="•">
                          <p style="padding-top: 3pt;padding-left: 131pt;text-indent: -21pt;text-align: center;">Inhumación o cremación.</p>
                        </li>
                      </ul>
                    </li>
                    <li data-list-text="19.">
                      <p style="padding-left: 110pt;text-indent: -28pt;text-align: justify;">Segundo traslado del lugar de velación hacia el cementerio, o bien, a el panteón que sea señalado por los familiares dentro de la <b>Zona de Cobertura</b>. </p>
                    </li>
                    <li data-list-text="20.">
                      <p style="padding-left: 110pt;text-indent: -28pt;text-align: justify;">Servicio a elegir de inhumación en fosa propiedad del familiar responsable del servicio; o cremación en agencias integrantes de la red de asistencia funeraria, según sea la disponibilidad.</p>
                    </li>
                  </ol>
                </li>
                <li data-list-text="3.">
                  <p class="s21" style="padding-top: 11pt;padding-left: 60pt;text-indent: -21pt;text-align: justify;">Exclusiones</p>
                  <p class="s25" style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">Queda entendido que, la cobertura 3.4. Asistencia Funeraria al Conductor y la Cobertura 3.5. Asistencia Funeraria Ocupantes, se excluyen entre sí, por lo que solo podrá contratarse una de las dos.</p>
                  <ol id="l123">
                    <li data-list-text="1.">
                      <p class="s15" style="padding-left: 81pt;text-indent: -21pt;text-align: justify;">No se incluyen arreglos florales.</p>
                    </li>
                    <li data-list-text="2.">
                      <p class="s15" style="padding-left: 81pt;text-indent: -21pt;text-align: justify;">No se incluyen servicios religiosos.</p>
                    </li>
                    <li data-list-text="3.">
                      <p class="s15" style="padding-top: 7pt;padding-left: 81pt;text-indent: -21pt;text-align: center;">No se incluye el servicio de cafetería.</p>
                    </li>
                    <li data-list-text="4.">
                      <p class="s15" style="padding-left: 81pt;text-indent: -21pt;text-align: center;">En los servicios de inhumación, no se incluye la fosa.</p>
                    </li>
                    <li data-list-text="5.">
                      <p class="s15" style="padding-left: 81pt;text-indent: -21pt;text-align: center;">En los servicios de cremación no se incluye nicho.</p>
                    </li>
                  </ol>
                </li>
              </ol>
            </li>
          </ol>
        </li>
      </ol>
    </ol>
    <h3 style="padding-top: 13pt;padding-left: 39pt;text-indent: 0pt;text-align: justify;">
      <a name="a128">Cláusula 3.5. Asistencia Funeraria Ocupantes</a>
    </h3>
    <p class="s48" style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">Condiciones Particulares</p>
    <p style="padding-top: 1pt;text-indent: 0pt;text-align: center;">
      <br />
    </p>
    <p style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">La siguiente Asistencia Funeraria Ocupantes, podrá ser contratada en adición a las coberturas básicas de las secciones de Daños Materiales, Robo y Responsabilidad Civil.</p>
    <p style="padding-top: 2pt;text-indent: 0pt;text-align: center;">
      <br />
    </p>
    <ol id="l124">
      <li data-list-text="A)">
        <p class="s12" style="padding-left: 60pt;text-indent: -21pt;text-align: center;">
          <a name="a129">Definiciones</a>
        </p>
        <p style="padding-top: 10pt;padding-left: 39pt;text-indent: 0pt;text-align: justify;">Para la debida interpretación de la presente cobertura de Asistencia, se acuerda establecer tanto en lo singular como en lo plural las siguientes definiciones:</p>
        <p style="padding-top: 11pt;padding-left: 39pt;text-indent: 0pt;text-align: justify;">
          <span class="s12">Ocupante: </span>Toda persona física que se encuentre dentro del compartimiento, caseta o cabina, destinada al transporte de personas del <b>Vehículo Asegurado</b>, al momento de producirse un <b>Accidente Automovilístico</b>, <b>Descompostura </b>o <b>Falla Mecánica</b>, sin incluir al <b>Conductor </b>del vehículo. La edad de aceptación es de 0 a 99 años.
        </p>
        <p class="s12" style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">
          Asesoría Testamentaria Telefónica: <span class="p">Servicio profesional de información y consejo en materia testamentaria de manera telefónica.</span>
        </p>
        <p style="padding-left: 39pt;text-indent: 0pt;text-align: center;">
          <span class="s12">Beneficiario: </span>
          <b>Conductor </b>y/o <b>Ocupante </b>del <b>Vehículo Asegurado </b>que se vea beneficiado. <span class="s12">Conductor: </span>Persona que va al mando de un <b>Vehículo Asegurado</b>. La edad de aceptación es de 18 hasta 64 años.
        </p>
        <p class="s12" style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">Gestoría de Trámites: <span class="p">Gestión administrativa disponible para individuos o empresas que precisan de su trabajo para la elaboración de determinados servicios burocráticos, administrativos o fiscales relacionados con el fallecimiento de un ser querido.</span>
        </p>
        <p class="s12" style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">Responso: <span class="p">Oración que se realiza por los difuntos al momento de la velación entre el fallecimiento y entierro o cremación.</span>
        </p>
        <p class="s12" style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">Servicio Funerario: <span class="p">Asistencia diseñada para brindar a los familiares y seres queridos de una persona fallecida, la oportunidad de reunirse, apoyarse mutuamente y rendirle honor para sobrellevar el duelo de su pérdida de una mejor manera. Un servicio funerario implica la organización de un funeral y facilita la superación del dolor de la muerte de un ser querido.</span>
        </p>
        <p class="s12" style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">Tanatología: <span class="p">Es una disciplina científica que se encarga de encontrar el sentido al proceso de la muerte, sus ritos y significado concebido como disciplina profesional, que integra a la persona como un ser biológico, psicológico, social y espiritual para vivir en plenitud y buscar su transcendencia.</span>
        </p>
        <p class="s12" style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">Transporte de Acompañamiento: <span class="p">Se trata de un vehículo con chófer, que transporta a la familia o al entorno más cercano del fallecido hasta el crematorio o el cementerio. Hace el trayecto siguiendo al coche fúnebre y permite que los allegados puedan despreocuparse de su medio de transporte.</span>
        </p>
      </li>
      <li data-list-text="B)">
        <p class="s12" style="padding-top: 8pt;padding-left: 60pt;text-indent: -21pt;line-height: 14pt;text-align: center;">
          <a name="a130">Alcance.</a>
        </p>
        <p style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">Cuando en la <b>Carátula de la Póliza </b>se haga constar su contratación, <b>L A T I N O</b>, a través de sus proveedores externos, proporcionará los servicios de Asistencia Funeraria al <b>Conductor </b>del <b>Vehículo Asegurado </b>y hasta 8 (ocho) <b>Ocupantes </b>a bordo del <b>Vehículo Asegurado</b>, de conformidad con lo siguiente: </p>
        <ol id="l125">
          <li data-list-text="1.">
            <p style="padding-top: 11pt;padding-left: 81pt;text-indent: -21pt;text-align: center;">Edades de aceptación en esta asistencia funeraria son:</p>
            <p class="s13" style="padding-left: 81pt;text-indent: 0pt;text-align: center;">Conductor <span class="p">: de 18 a 69 años.</span>
            </p>
            <p class="s13" style="padding-left: 81pt;text-indent: 0pt;text-align: center;">Ocupantes <span class="p">: de 0 a 99 años.</span>
            </p>
          </li>
          <li data-list-text="2.">
            <p style="padding-left: 81pt;text-indent: -21pt;text-align: center;">El servicio se prestará las 24 horas del día los 365 días del año en la República Mexicana</p>
          </li>
          <li data-list-text="3.">
            <p style="padding-left: 81pt;text-indent: -21pt;line-height: 11pt;text-align: center;">La Asistencia estará conformada por:</p>
            <ol id="l126">
              <li data-list-text="3.1">
                <p style="padding-left: 109pt;text-indent: -28pt;line-height: 11pt;text-align: center;">Servicio Funerario;</p>
              </li>
              <li data-list-text="3.2">
                <p style="padding-left: 109pt;text-indent: -28pt;line-height: 11pt;text-align: center;">Carroza para primer traslado (hasta 50km);</p>
                <ol id="l127">
                  <ol id="l128">
                    <li data-list-text="3.3.">
                      <p style="padding-left: 109pt;text-indent: -28pt;text-align: center;">Arreglo estético del cuerpo;</p>
                    </li>
                    <li data-list-text="3.4.">
                      <p style="padding-top: 7pt;padding-left: 109pt;text-indent: -28pt;line-height: 11pt;text-align: center;">Ataúd metálico o de madera estándar (a elección);</p>
                    </li>
                    <li data-list-text="3.5.">
                      <p style="padding-left: 109pt;text-indent: -28pt;line-height: 11pt;text-align: center;">Equipo de velación;</p>
                    </li>
                    <li data-list-text="3.6.">
                      <p style="padding-left: 109pt;text-indent: -28pt;text-align: center;">Sala de velación (opción a velación en domicilio);</p>
                    </li>
                    <li data-list-text="3.7.">
                      <p style="padding-left: 110pt;text-indent: -28pt;text-align: center;">Referencias para adquirir arreglos florales (siempre que la funeraria preste este servicio);</p>
                    </li>
                    <li data-list-text="3.8.">
                      <p style="padding-left: 109pt;text-indent: -28pt;line-height: 11pt;text-align: center;">Servicio religioso, Responso (misa no incluida);</p>
                    </li>
                    <li data-list-text="3.9.">
                      <p style="padding-left: 109pt;text-indent: -28pt;line-height: 11pt;text-align: center;">Referencias para contratar servicio de cafetería;</p>
                    </li>
                    <li data-list-text="3.10.">
                      <p style="padding-left: 109pt;text-indent: -28pt;line-height: 11pt;text-align: center;">Servicio de inhumación (no incluye fosa);</p>
                    </li>
                    <li data-list-text="3.11.">
                      <p style="padding-left: 109pt;text-indent: -28pt;line-height: 11pt;text-align: center;">Servicio de cremación (no incluye nicho);</p>
                    </li>
                    <li data-list-text="3.12.">
                      <p style="padding-left: 109pt;text-indent: -28pt;text-align: center;">Urna estándar;</p>
                    </li>
                    <li data-list-text="3.13.">
                      <p style="padding-left: 109pt;text-indent: -28pt;text-align: center;">Carroza para el cortejo (hasta 50 km);</p>
                    </li>
                    <li data-list-text="3.14.">
                      <p style="padding-left: 110pt;text-indent: -28pt;text-align: center;">Referencias para contratar Transporte de Acompañamiento (siempre que la funeraria preste este servicio);</p>
                    </li>
                    <li data-list-text="3.15.">
                      <p style="padding-left: 109pt;text-indent: -28pt;line-height: 11pt;text-align: center;">Servicio de Tanatología, 2 sesiones;</p>
                    </li>
                    <li data-list-text="3.16.">
                      <p style="padding-left: 110pt;text-indent: -28pt;text-align: center;">Gestoría de Trámites, No se incluye casos legales; y Asesoría Testamentaria telefónica</p>
                    </li>
                  </ol>
                </ol>
                <p style="padding-top: 2pt;text-indent: 0pt;text-align: center;">
                  <br />
                </p>
              </li>
            </ol>
          </li>
        </ol>
      </li>
      <li data-list-text="C)">
        <p class="s42" style="padding-left: 60pt;text-indent: -21pt;text-align: justify;">Exclusiones</p>
        <p class="s25" style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">Queda entendido que, la cobertura 3.4. Asistencia Funeraria al Conductor y la Cobertura 3.5. Asistencia Funeraria Ocupantes, se excluyen entre sí, por lo que solo podrá contratarse una de las dos.</p>
        <ol id="l129">
          <li data-list-text="1.">
            <p class="s15" style="padding-left: 81pt;text-indent: -21pt;text-align: center;">No se incluyen arreglos florales.</p>
          </li>
          <li data-list-text="2.">
            <p class="s15" style="padding-left: 81pt;text-indent: -21pt;text-align: center;">No se incluyen misas.</p>
          </li>
          <li data-list-text="3.">
            <p class="s15" style="padding-left: 81pt;text-indent: -21pt;text-align: center;">No se incluye el servicio de cafetería.</p>
          </li>
          <li data-list-text="4.">
            <p class="s15" style="padding-left: 81pt;text-indent: -21pt;text-align: center;">En los servicios de inhumación, no se incluye la fosa.</p>
          </li>
          <li data-list-text="5.">
            <p class="s15" style="padding-left: 81pt;text-indent: -21pt;text-align: center;">En los servicios de cremación no se incluye nicho.</p>
          </li>
          <li data-list-text="6.">
            <p class="s15" style="padding-left: 81pt;text-indent: -21pt;text-align: center;">No se incluye el Transporte de Acompañamiento.</p>
          </li>
        </ol>
      </li>
    </ol>
    <h3 style="padding-top: 11pt;padding-left: 39pt;text-indent: 0pt;text-align: justify;">
      <a name="a131">Cláusula 3.6. Cuidando tu salud</a>
    </h3>
    <p class="s47" style="padding-left: 39pt;text-indent: 0pt;text-align: center;">
      <a name="a132">Asistencia médica Condiciones Particulares</a>
    </p>
    <p style="padding-top: 13pt;padding-left: 39pt;text-indent: 0pt;text-align: center;">La siguiente Asistencia Cuidando tu Salud, podrá ser contratada en adición a la cobertura de Gastos Médicos Ocupantes.</p>
    <p style="padding-top: 2pt;text-indent: 0pt;text-align: center;">
      <br />
    </p>
    <ol id="l130">
      <li data-list-text="A)">
        <p class="s12" style="padding-left: 60pt;text-indent: -21pt;text-align: center;">
          <a name="a133">Definiciones</a>
        </p>
        <p style="padding-left: 39pt;text-indent: 0pt;text-align: center;">Para la debida interpretación de la presente cobertura de Asistencia, se acuerda establecer tanto en lo singular como en lo plural las siguientes definiciones:</p>
        <ol id="l131">
          <li data-list-text="1.">
            <p class="s12" style="padding-left: 81pt;text-indent: -21pt;text-align: center;">Red: <span class="p">El conjunto de clínicas y profesionales mediante los cuales se proporcionarán los </span>
              <span style=" color: #000;">Servicios.</span>
            </p>
          </li>
          <li data-list-text="2.">
            <p class="s12" style="padding-left: 81pt;text-indent: -21pt;text-align: center;">Beneficiarios: <span style=" color: #000;">Conductor y ocupantes </span>
              <span class="p">que hayan sufrido un accidente automovilístico y tengan derecho a la asistencia.</span>
            </p>
            <p style="padding-top: 2pt;text-indent: 0pt;text-align: center;">
              <br />
            </p>
          </li>
        </ol>
      </li>
      <li data-list-text="B)">
        <p class="s12" style="padding-left: 60pt;text-indent: -21pt;text-align: center;">
          <a name="a134">Alcance</a>
        </p>
        <p style="padding-left: 39pt;text-indent: 0pt;text-align: center;">Cuando en la <b>Carátula de la Póliza </b>se haga constar su contratación, <b>LATINO </b>otorgará, los servicios siempre y cuando sean a consecuencia de un accidente automovilístico los cuales consistentes en: </p>
        <p style="padding-top: 1pt;text-indent: 0pt;text-align: center;">
          <br />
        </p>
        <ol id="l132">
          <li data-list-text="1.">
            <p class="s12" style="padding-left: 81pt;text-indent: -21pt;text-align: center;">Telemedicina <span class="p">. Orientación médica ilimitada por videollamada a través de una red de beneficios con médicos las 24 hrs, los 365 días del año.</span>
            </p>
          </li>
          <li data-list-text="2.">
            <p class="s12" style="padding-left: 81pt;text-indent: -21pt;text-align: center;">Telepsicología <span class="p">. Orientación psicológica ilimitada por videollamada a través de una red de beneficios con psicólogos de lunes a viernes de 9:00 a 18:00 hrs.</span>
            </p>
          </li>
          <li data-list-text="3.">
            <p class="s12" style="padding-left: 81pt;text-indent: -21pt;line-height: 11pt;text-align: center;">Asistencia médica telefónica ilimitada <span class="p">. Orientación médica ilimitada en centro de</span>
            </p>
            <p style="padding-top: 7pt;padding-left: 81pt;text-indent: 0pt;text-align: justify;">atención telefónica con médicos las 24 hrs, los 365 días del año.</p>
          </li>
          <li data-list-text="4.">
            <p style="padding-left: 81pt;text-indent: -21pt;text-align: justify;">
              <span class="s12">Servicio de asistencia médica a domicilio</span>. En este caso, el <b>Beneficiario </b>deberá realizar un copago correspondiente a la tarifa del momento en que se solicite. Este servicio se proporcionar a nivel nacional, las 24 hrs del día los 365 días del año.
            </p>
          </li>
          <li data-list-text="5.">
            <p style="padding-left: 81pt;text-indent: -21pt;text-align: justify;">
              <span class="s12">Asistencia de ambulancia terrestre por emergencia</span>. Con un límite de 2 (dos) <b>Evento</b>s durante la vigencia por <b>Póliza</b>. En caso de <b>Evento</b>s subsecuentes, el pago del servicio queda a cargo del <b>Beneficiario</b>.
            </p>
          </li>
          <li data-list-text="6.">
            <p class="s12" style="padding-left: 81pt;text-indent: -21pt;text-align: justify;">Asistencia psicológica <span class="p">. Orientación psicológica ilimitada en los centros de atención telefónica las 24 hrs, los 365 días del año.</span>
            </p>
          </li>
          <li data-list-text="7.">
            <p style="padding-left: 81pt;text-indent: -21pt;line-height: 11pt;text-align: justify;">Referencias de médicos generales.</p>
          </li>
          <li data-list-text="8.">
            <p style="padding-left: 81pt;text-indent: -21pt;text-align: justify;">Referencias con médicos especialistas.</p>
          </li>
          <li data-list-text="9.">
            <p style="padding-left: 81pt;text-indent: -21pt;text-align: center;">Referencias de lugares para realizarse estudios de laboratorio y gabinete, así como de ópticas.</p>
          </li>
          <li data-list-text="10.">
            <p style="padding-left: 81pt;text-indent: -21pt;line-height: 11pt;text-align: center;">Referencias sobre el servicio de enfermería general a domicilio.</p>
          </li>
          <li data-list-text="11.">
            <p style="padding-left: 81pt;text-indent: -21pt;line-height: 11pt;text-align: center;">Servicio de odontología, referencias.</p>
          </li>
        </ol>
      </li>
    </ol>
    <p style="padding-top: 10pt;padding-left: 39pt;text-indent: 0pt;text-align: center;">Los servicios antes mencionados, se proporcionarán siempre y cuando el asegurado o contratante los solicite y sean a consecuencia de un accidente automovilístico.</p>
    <p style="padding-top: 2pt;text-indent: 0pt;text-align: center;">
      <br />
    </p>
    <h3 style="padding-left: 39pt;text-indent: 0pt;text-align: center;">
      <a name="a135">Cláusula 3.7. + Cuidados</a>
    </h3>
    <p class="s49" style="padding-left: 39pt;text-indent: 0pt;text-align: center;">Asistencia en el hogar. Condiciones Particulares.</p>
    <p style="padding-top: 2pt;text-indent: 0pt;text-align: center;">
      <br />
    </p>
    <p style="padding-left: 39pt;text-indent: 0pt;text-align: center;">La siguiente Asistencia en el hogar, podrá ser contratada en adición a las cobertura básica de la sección Responsabilidad Civil Familiar.</p>
    <p style="padding-top: 1pt;text-indent: 0pt;text-align: center;">
      <br />
    </p>
    <ol id="l133">
      <li data-list-text="A)">
        <p class="s12" style="padding-left: 60pt;text-indent: -21pt;text-align: center;">
          <a name="a136">Definiciones.</a>
        </p>
        <p style="padding-left: 39pt;text-indent: 0pt;text-align: center;">Para la debida interpretación de la presente cobertura de Asistencia, se acuerda establecer tanto en lo singular como en lo plural las siguientes definiciones:</p>
        <p class="s12" style="padding-top: 11pt;padding-left: 39pt;text-indent: 0pt;text-align: center;">Beneficiario: <span class="p">Es la persona Titular de la cobertura de Protección Familiar.</span>
        </p>
        <p style="text-indent: 0pt;text-align: center;">
          <br />
        </p>
      </li>
      <li data-list-text="B)">
        <p class="s12" style="padding-left: 60pt;text-indent: -21pt;line-height: 14pt;text-align: center;">
          <a name="a137">Alcance.</a>
        </p>
        <p style="padding-left: 39pt;text-indent: 0pt;text-align: center;">Cuando en la <b>Carátula de la Póliza </b>se haga constar su contratación, <b>L A T I N O </b>otorgará a través de sus proveedores externos, los servicios consistentes en: </p>
        <p style="padding-top: 2pt;text-indent: 0pt;text-align: center;">
          <br />
        </p>
        <ol id="l134">
          <li data-list-text="1.">
            <p class="s21" style="padding-left: 81pt;text-indent: -21pt;text-align: center;">Asistencia en el Hogar</p>
          </li>
        </ol>
      </li>
    </ol>
    <ol id="l135">
      <li data-list-text="1.">
        <p style="padding-top: 11pt;padding-left: 60pt;text-indent: -18pt;text-align: justify;">
          <span class="s12">Servicio de información del centro de llamadas (Llamada de información): </span>24 horas del día los 365 días del año, el <b>Beneficiario </b>puede contactar el centro de llamadas, a través del cual podrá solicitar un servicio de asistencia o sólo solicitar información relacionado con esta asistencia. El número de eventos por <b>Póliza </b>es ilimitado.
        </p>
        <p style="text-indent: 0pt;text-align: center;">
          <br />
        </p>
      </li>
      <li data-list-text="2.">
        <p style="padding-left: 60pt;text-indent: -21pt;text-align: justify;">
          <span class="s12">Asistencia de emergencia en el hogar: </span>Un especialista acude al domicilio del <b>Beneficiario </b>y presta los siguientes servicios de reparación de <b>Urgencia</b>:
        </p>
        <ol id="l136">
          <li data-list-text="2.1">
            <p style="padding-top: 11pt;padding-left: 81pt;text-indent: -21pt;text-align: justify;">
              <span class="s12">Problemas de plomería / suministro de agua: </span>Avería o daños en el sistema de plomería o de drenaje que provocan daños por agua en el interior del domicilio del <b>Beneficiario</b>. Esto incluye la rotura de tuberías y el desbordamiento de los depósitos de agua. Adicional, están cubiertas las averías de la taza del inodoro o de la cisterna, de la bañera y de los lavabos que provoque la pérdida total del funcionamiento del único inodoro, bañera o lavabo o de todos los inodoros, bañeras o lavabos en el domicilio del <b>Beneficiario</b>.
            </p>
          </li>
        </ol>
      </li>
    </ol>
    <p style="padding-left: 81pt;text-indent: 0pt;text-align: justify;">Hasta un <b>Evento </b>durante la vigencia anual de la <b>Póliza </b>y por un monto máximo de </p>
    <p style="padding-left: 81pt;text-indent: 0pt;text-align: justify;">$700 pesos (setecientos 00/100 M.N.).</p>
    <ol id="l137">
      <ol id="l138">
        <li data-list-text="2.2.">
          <p style="padding-top: 7pt;padding-left: 81pt;text-indent: -21pt;text-align: justify;">
            <span class="s12">Fallo del sistema de suministro eléctrico: </span>Avería completa o rotura del sistema de suministro de electricidad dentro del domicilio del <b>Beneficiario</b>, lo que hace que éste sea inhabitable.
          </p>
          <p style="padding-left: 81pt;text-indent: 0pt;line-height: 11pt;text-align: justify;">Hasta un <b>Evento </b>durante la vigencia anual de la <b>Póliza </b>y por un monto máximo de </p>
          <p style="padding-left: 81pt;text-indent: 0pt;line-height: 11pt;text-align: justify;">$700 pesos (setecientos 00/100 M.N.).</p>
          <p style="text-indent: 0pt;text-align: center;">
            <br />
          </p>
        </li>
        <li data-list-text="2.3.">
          <p style="padding-left: 81pt;text-indent: -21pt;text-align: justify;">
            <span class="s12">Avería del sistema de suministro de gas: </span>Avería completa o rotura del sistema de suministro de gas en el interior del domicilio del <b>Beneficiario</b>, que hace que éste sea inhabitable.
          </p>
          <p style="padding-left: 81pt;text-indent: 0pt;line-height: 11pt;text-align: justify;">Hasta un <b>Evento </b>durante la vigencia anual de la <b>Póliza </b>y por un monto máximo de </p>
          <p style="padding-left: 81pt;text-indent: 0pt;text-align: justify;">$800 pesos (ochocientos 00/100 M.N.).</p>
          <p style="text-indent: 0pt;text-align: center;">
            <br />
          </p>
        </li>
        <li data-list-text="2.4.">
          <p style="padding-left: 81pt;text-indent: -21pt;text-align: justify;">
            <span class="s12">Daños causados por incendio, explosión, humo, condiciones meteorológicas adversas, robo o vandalismo: </span>Los daños al tejado o a las cerraduras externas, puertas o ventanas que no hayan sido causados por el <b>Beneficiario </b>o por otro integrante permanente del hogar y que supongan que éste deja de ser seguro. Cerrajero: hasta un <b>Evento </b>durante la vigencia anual de la <b>Póliza </b>y por un monto máximo de
          </p>
        </li>
      </ol>
    </ol>
    <p style="padding-left: 81pt;text-indent: 0pt;text-align: center;">$700 pesos (setecientos 00/100 M.N.).</p>
    <p style="padding-left: 81pt;text-indent: 0pt;text-align: center;">Cristales: hasta un <b>Evento </b>durante la vigencia anual de la <b>Póliza </b>y por un monto máximo de $700 pesos (setecientos 00/100 M.N.). </p>
    <p style="padding-left: 81pt;text-indent: 0pt;text-align: center;">Reparación del techo: hasta un <b>Evento </b>durante la vigencia anual de la <b>Póliza </b>y por un monto máximo de $1,300 pesos (mil trescientos 00/100 M.N.). </p>
    <p style="padding-top: 11pt;padding-left: 39pt;text-indent: 0pt;line-height: 11pt;text-align: center;">Se cubren los materiales y repuestos necesarios que requiera el especialista para atender la</p>
    <p class="s13" style="padding-left: 39pt;text-indent: 0pt;line-height: 11pt;text-align: center;">Emergencia <span class="p">; hasta los límites especificados.</span>
    </p>
    <p style="text-indent: 0pt;text-align: center;">
      <br />
    </p>
    <p class="s21" style="padding-left: 39pt;text-indent: 0pt;text-align: center;">EXCLUSIONES <span class="s50">.</span>
    </p>
    <p class="s15" style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">Las definiciones enumeradas a continuación están excluidas en general:</p>
    <ol id="l139">
      <li data-list-text="1.">
        <p class="s15" style="padding-left: 81pt;text-indent: -21pt;text-align: justify;">Mera interrupción temporal del suministro: Solicitud del servicio de asistencia derivados de la interrupción, fallo o desconexión de los servicios públicos del domicilio asegurado (incluyendo el suministro de electricidad, agua o gas), sea cual sea su causa.</p>
      </li>
      <li data-list-text="2.">
        <p class="s15" style="padding-left: 81pt;text-indent: -21pt;text-align: justify;">Actos intencionados o fraudulentos: Actos intencionados o fraudulentos causados por el Beneficiario y sus consecuencias.</p>
      </li>
      <li data-list-text="3.">
        <p class="s15" style="padding-left: 81pt;text-indent: -21pt;text-align: justify;">Fuera de los límites del domicilio asegurado: Muros, puertas, vallas, dependencias, cobertizos, garajes independientes o cualquier cosa que esté fuera de los límites del domicilio asegurado. Instalaciones que sean responsabilidad de un edificio de uso múltiple o de los correspondientes proveedores de agua, gas o electricidad.</p>
      </li>
      <li data-list-text="4.">
        <p class="s15" style="padding-left: 81pt;text-indent: -21pt;text-align: justify;">Daños anteriores a la fecha de inicio de vigencia de esta cobertura de Asistencia: Daños derivados de un acontecimiento del que el Beneficiario haya tenido conocimiento antes de la contratación de esta cobertura de Asistencia.</p>
      </li>
      <li data-list-text="5.">
        <p class="s15" style="padding-left: 81pt;text-indent: -21pt;text-align: justify;">Falta de mantenimiento: Los daños debidos a la negligencia o a la degradación gradual causada por la falta de mantenimiento por parte del Beneficiario.</p>
      </li>
      <li data-list-text="6.">
        <p class="s15" style="padding-left: 81pt;text-indent: -21pt;text-align: justify;">Error de construcción: Daños debidos a un error de construcción o a una instalación incorrecta.</p>
      </li>
      <li data-list-text="7.">
        <p class="s15" style="padding-left: 81pt;text-indent: -21pt;text-align: justify;">Daños causados por Acontecimientos externos: Los daños causados por o derivados de acontecimientos externos, como un desastre natural oficialmente declarado y catástrofes, incluido el pulso</p>
        <p class="s15" style="padding-top: 7pt;padding-left: 81pt;text-indent: 0pt;text-align: justify;">electromagnético (ya sea de origen humano o natural), la reacción nuclear o la contaminación por armas nucleares o radiactividad, la filtración, la contaminación o la polución, los daños causados por la guerra, la guerra civil, la invasión, la revolución, los disturbios, la conmoción civil, los actos de violencia política, los atentados o los actos de terrorismo, los cierres patronales o los conflictos laborales, la expropiación o interferencias similares, la confiscación, los decretos oficiales u otras interferencias de las autoridades públicas.</p>
      </li>
      <li data-list-text="8.">
        <p class="s15" style="padding-left: 81pt;text-indent: -21pt;text-align: justify;">Cualquier consumible utilizado para la reparación.</p>
      </li>
      <li data-list-text="9.">
        <p class="s15" style="padding-left: 81pt;text-indent: -21pt;text-align: justify;">Hogares/locales cuya cédula de habitabilidad no ha sido expedida o ha sido retirada por las autoridades locales.</p>
      </li>
    </ol>
    <p style="padding-top: 8pt;text-indent: 0pt;text-align: center;">
      <br />
    </p>
    <h3 style="padding-left: 39pt;text-indent: 0pt;text-align: center;">
      <a name="a138">Cláusula 3.8. Cuidando tu visión</a>
    </h3>
    <p class="s49" style="padding-left: 39pt;text-indent: 0pt;text-align: center;">Asistencia Visión Condiciones Particulares</p>
    <ol id="l140">
      <li data-list-text="A)">
        <p class="s12" style="padding-top: 10pt;padding-left: 60pt;text-indent: -21pt;text-align: center;">
          <a name="a139">Definiciones.</a>
        </p>
        <p style="padding-left: 39pt;text-indent: 0pt;text-align: center;">Para la debida interpretación de la presente cobertura de Asistencia, se acuerda establecer tanto en lo singular como en lo plural las siguientes definiciones:</p>
        <p style="padding-top: 1pt;text-indent: 0pt;text-align: center;">
          <br />
        </p>
        <p class="s13" style="padding-left: 39pt;text-indent: 0pt;text-align: center;">
          <span style=" color: #2C5293;">Beneficiario: </span>Asegurado <span class="p">o </span>Contratante <span class="p">que tengan derecho a la asistencia.</span>
        </p>
      </li>
      <li data-list-text="B)">
        <p class="s21" style="padding-top: 4pt;padding-left: 60pt;text-indent: -21pt;text-align: center;">Alcance</p>
        <p style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">Cuando en la <b>Carátula de la Póliza </b>se haga constar su contratación, <b>L A T I N O </b>otorgará a través de sus proveedores externos, los servicios mencionados, siempre y cuando a consecuencia de un accidente automovilístico sea necesaria la sustitución de anteojos: </p>
        <p style="text-indent: 0pt;text-align: center;">
          <br />
        </p>
        <ol id="l141">
          <li data-list-text="1.">
            <p class="s12" style="padding-left: 81pt;text-indent: -21pt;text-align: justify;">Examen completo de la vista: <span class="p">Consiste en la realización de una serie de test normalizados que permiten al optometrista evaluar las habilidades funcionales y percepto- visuales del paciente, con el objeto de conocer cómo está utilizando su visión y determinar si los valores obtenidos se corresponden con las necesidades visuales del mismo en diferentes entornos.</span>
            </p>
          </li>
          <li data-list-text="2.">
            <p class="s12" style="padding-left: 81pt;text-indent: -21pt;line-height: 11pt;text-align: justify;">Prescripción de anteojos: <span class="p">Ampara la consulta, prescripción y dotación de anteojos.</span>
            </p>
          </li>
          <li data-list-text="3.">
            <p class="s12" style="padding-left: 81pt;text-indent: -21pt;text-align: justify;">Armazón y lentes graduados (no cosméticos): <span class="p">Ampara el costo de armazones y lentes graduados (no cosméticos), con las siguientes características:</span>
            </p>
            <ol id="l142">
              <li data-list-text="3.1.">
                <p style="padding-left: 102pt;text-indent: -21pt;text-align: center;">Lentes blancas graduadas (micas) en materiales policarbonato y/o CR39, los diseños incluidos son monofocal, bifocal Flap top y progresivos.</p>
              </li>
              <li data-list-text="3.2.">
                <p style="padding-left: 102pt;text-indent: -21pt;text-align: center;">Tratamiento anti reflejante UV.</p>
              </li>
              <li data-list-text="3.3.">
                <p style="padding-left: 102pt;text-indent: -21pt;text-align: center;">Catálogo de armazones vigente en las ópticas con convenio.</p>
              </li>
              <li data-list-text="3.4.">
                <p style="padding-left: 102pt;text-indent: -21pt;text-align: center;">Está cubierto kit de estuche para anteojos y la solución al momento de ser entregados los lentes.</p>
              </li>
            </ol>
          </li>
        </ol>
      </li>
    </ol>
    <h3 style="padding-top: 11pt;padding-left: 39pt;text-indent: 0pt;text-align: justify;">
      <a name="a140">Cláusula 3.9. Traslado Seguro</a>
    </h3>
    <p class="s49" style="padding-left: 39pt;text-indent: 0pt;text-align: center;">Condiciones Particulares</p>
    <ol id="l143">
      <li data-list-text="A)">
        <p class="s12" style="padding-top: 11pt;padding-left: 60pt;text-indent: -21pt;text-align: center;">
          <a name="a141">Definiciones.</a>
        </p>
        <p style="padding-left: 39pt;text-indent: 0pt;text-align: center;">Para la debida interpretación de la presente cobertura de Asistencia, se acuerda establecer tanto en lo singular como en lo plural las siguientes definiciones:</p>
        <p class="s12" style="padding-top: 11pt;padding-left: 39pt;text-indent: 0pt;text-align: center;">Zona de cobertura: <span class="p">República Mexicana.</span>
        </p>
        <p style="padding-top: 3pt;padding-left: 39pt;text-indent: 0pt;text-align: justify;">
          <span class="s12">Arrastre de grúa: </span>Realizar maniobras menores necesarias e indispensables para enganchar a la grúa el <b>Vehículo Asegurado </b>que, estando sobre sus propias ruedas, deban ser trasladados por caminos y puentes.
        </p>
        <p style="padding-top: 4pt;text-indent: 0pt;text-align: center;">
          <br />
        </p>
      </li>
      <li data-list-text="B)">
        <p class="s12" style="padding-left: 60pt;text-indent: -21pt;text-align: center;">
          <a name="a142">Alcance</a>
        </p>
        <p style="padding-left: 39pt;text-indent: 0pt;text-align: center;">Cuando en la <b>Carátula de la Póliza </b>se haga constar su contratación, <b>L A T I N O </b>proporcionará a través de sus proveedores externos, el servicio de: </p>
        <ol id="l144">
          <li data-list-text="1.">
            <p style="padding-top: 11pt;padding-left: 81pt;text-indent: -21pt;text-align: justify;">
              <span class="s12">Conductor (Chofer) o Arrastre de grúa: </span>En caso de que el <b>Conductor </b>este imposibilitado para manejar el <b>Vehículo Asegurado</b>, ya sea por <b>Estado de Ebriedad</b>, embarazo, accidente, enfermedad o salida del hospital, se asistirá al <b>Conductor </b>para trasladarlo a él y al <b>Vehículo Asegurado </b>mediante la asistencia de un conductor o chofer (servicio programado) o en su defecto mediante el envío de una grúa, con un máximo de 2 (dos) <b>Evento</b>s al año.
            </p>
          </li>
        </ol>
      </li>
    </ol>
    <h3 style="padding-top: 11pt;padding-left: 39pt;text-indent: 0pt;text-align: center;">
      <a name="a143">Cláusula 3.10. Auto x Auto</a>
    </h3>
    <p class="s49" style="padding-left: 39pt;text-indent: 0pt;text-align: center;">Renta de auto Condiciones Particulares</p>
    <p style="text-indent: 0pt;text-align: center;">
      <br />
    </p>
    <ol id="l145">
      <li data-list-text="A)">
        <p class="s12" style="padding-left: 60pt;text-indent: -21pt;text-align: center;">
          <a name="a144">Definiciones.</a>
        </p>
        <p style="padding-left: 39pt;text-indent: 0pt;text-align: center;">Para la debida interpretación de la presente cobertura de Asistencia, se acuerda establecer tanto en lo singular como en lo plural las siguientes definiciones:</p>
        <p class="s12" style="padding-top: 11pt;padding-left: 39pt;text-indent: 0pt;text-align: center;">Zona de cobertura: <span class="p">República Mexicana.</span>
        </p>
        <p style="text-indent: 0pt;text-align: center;">
          <br />
        </p>
        <p class="s12" style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">Auto compacto: <span class="p">Es un vehículo motorizado, que, por su estructura y condiciones mecánicas, es apto específicamente para el transporte de personas, deberá tener el permiso o placa de circulación, otorgado por las autoridades competentes para el uso destinado del mismo. En este segmento encontramos autos que miden aproximadamente 4.5 metros de largo y que ofrecen habitabilidad razonable para 5 pasajeros de conformidad con la tarjeta de circulación.</span>
        </p>
        <p class="s13" style="padding-top: 11pt;padding-left: 39pt;text-indent: 0pt;text-align: center;">
          <span style=" color: #2C5293;">Beneficiarios: </span>Asegurado <span class="p">o </span>Contratante <span class="p">que tengan derecho a la asistencia.</span>
        </p>
        <p style="padding-top: 4pt;text-indent: 0pt;text-align: center;">
          <br />
        </p>
      </li>
      <li data-list-text="B)">
        <p class="s12" style="padding-left: 60pt;text-indent: -21pt;text-align: center;">
          <a name="a145">Alcance.</a>
        </p>
        <p style="padding-left: 39pt;text-indent: 0pt;text-align: center;">Cuando en la <b>Carátula de la Póliza </b>se haga constar su contratación, <b>L A T I N O </b>otorgará a través de sus proveedores externos, los servicios consistentes en: </p>
        <p style="padding-top: 11pt;padding-left: 39pt;text-indent: 0pt;text-align: justify;">
          <span class="s12">Renta de auto: </span>Se proporcionará un <b>Auto Compacto </b>( <b>Auto</b>) en renta al <b>Beneficiario </b>para que pueda seguir realizando sus actividades en caso de pérdida parcial, siempre y cuando la reparación de su vehículo dure más de 7 (siete) días. El tiempo del auto en renta será de máximo 7 (siete) días, con hasta 2 (dos) eventos al año.
        </p>
        <p style="text-indent: 0pt;text-align: center;">
          <br />
        </p>
        <p class="s15" style="padding-left: 39pt;text-indent: 0pt;text-align: center;">Sujeto a las condiciones y requisitos de la arrendadora. Servicio programado con un tiempo de 24 horas de antelación.</p>
        <p style="padding-top: 11pt;padding-left: 39pt;text-indent: 0pt;text-align: center;">La asistencia Auto X Auto opera bajo los siguientes términos y condiciones:</p>
        <p style="text-indent: 0pt;text-align: center;">
          <br />
        </p>
        <ol id="l146">
          <li data-list-text="1.">
            <p style="padding-left: 81pt;text-indent: -21pt;text-align: center;">El conductor deberá contar con una edad mínima de 25 años y con licencia de conducir vigente.</p>
          </li>
          <li data-list-text="2.">
            <p style="padding-left: 81pt;text-indent: -21pt;text-align: center;">Presentar identificación oficial vigente (INE o pasaporte) y firmar de conformidad el contrato de renta de auto del proveedor de servicios.</p>
          </li>
          <li data-list-text="3.">
            <p style="padding-left: 81pt;text-indent: -21pt;line-height: 11pt;text-align: center;">El servicio deberá ser programado con 24 horas de antelación.</p>
          </li>
          <li data-list-text="4.">
            <p style="padding-top: 3pt;padding-left: 81pt;text-indent: -21pt;text-align: justify;">El <b>Asegurado </b>deberá garantizar (garantía en depósito) con una tarjeta de crédito la devolución del vehículo en las mismas condiciones que se le entregó, así como cualquier gasto que pudiera generarse. Adicionalmente, el <b>Asegurado </b>se obliga a: </p>
            <ol id="l147">
              <li data-list-text="4.1.">
                <p style="padding-left: 102pt;text-indent: -21pt;text-align: justify;">Devolver de manera inmediata el <b>Auto </b>que le haya sido otorgado al concluir el periodo del préstamo y al horario de entrega pactado; transcurrido dicho plazo, el <b>Asegurado </b>se obliga a pagar los días que excedan la fecha de entrega de acuerdo con las tarifas establecidas por la compañía arrendadora. </p>
              </li>
              <li data-list-text="4.2.">
                <p style="padding-left: 102pt;text-indent: -21pt;text-align: justify;">El <b>Auto </b>deberá ser devuelto con la misma gasolina que le fue entregado, así como con las mismas condiciones físicas y mecánicas según el inventario que se haya levantado para su asignación, por lo que en caso de algún faltante (incluyendo gasolina) o daño, el <b>Asegurado </b>se obliga a resarcir los daños al proveedor. </p>
              </li>
              <li data-list-text="4.3.">
                <p style="padding-left: 102pt;text-indent: -21pt;text-align: justify;">Cualquier multa o recargo de tránsito que se llegue a generar durante el periodo de asignación del <b>Auto</b>, deberá ser pagado en un tiempo máximo de 15 días después de que le haya sido notificado. </p>
              </li>
              <li data-list-text="4.4.">
                <p style="padding-left: 102pt;text-indent: -21pt;line-height: 106%;text-align: justify;">En caso de siniestro del <b>Auto </b>arrendado, el <b>Asegurado </b>se obliga a pagar el deducible señalado en el contrato del proveedor. </p>
              </li>
              <li data-list-text="4.5.">
                <p style="padding-left: 102pt;text-indent: -21pt;text-align: justify;">Cumplir todas aquellas obligaciones que deriven de la documentación que tenga que firmar con el proveedor.</p>
              </li>
            </ol>
          </li>
        </ol>
      </li>
      <li data-list-text="C)">
        <p class="s21" style="padding-top: 11pt;padding-left: 60pt;text-indent: -21pt;text-align: center;">Suspensión del servicio.</p>
        <p class="s15" style="padding-left: 39pt;text-indent: 0pt;text-align: center;">Las causas de suspensión del servicio y responsabilidad total en caso de percance o accidente para el Asegurado son:</p>
        <ol id="l148">
          <li data-list-text="1.">
            <p class="s15" style="padding-left: 81pt;text-indent: -21pt;text-align: center;">Usar el Auto de forma lucrativa.</p>
          </li>
          <li data-list-text="2.">
            <p class="s15" style="padding-left: 81pt;text-indent: -21pt;text-align: center;">Abandonar el Auto.</p>
          </li>
          <li data-list-text="3.">
            <p class="s15" style="padding-left: 81pt;text-indent: -21pt;text-align: center;">Desobedecer los señalamientos de tránsito Federal, Estatal o Local.</p>
          </li>
          <li data-list-text="4.">
            <p class="s15" style="padding-left: 81pt;text-indent: -21pt;text-align: center;">Utilizar el Auto para arrastrar remolques.</p>
          </li>
          <li data-list-text="5.">
            <p class="s15" style="padding-left: 81pt;text-indent: -21pt;text-align: center;">Forzar el Auto con relación a su resistencia o capacidad normal</p>
          </li>
          <li data-list-text="6.">
            <p class="s15" style="padding-top: 4pt;padding-left: 81pt;text-indent: -21pt;text-align: center;">Participar directamente con el Auto en carreras o pruebas de seguridad, resistencia o velocidad.</p>
          </li>
          <li data-list-text="7.">
            <p class="s15" style="padding-left: 81pt;text-indent: -21pt;text-align: center;">Conducir el Auto en estado de ebriedad o bajo la influencia de drogas.</p>
          </li>
          <li data-list-text="8.">
            <p class="s15" style="padding-left: 81pt;text-indent: -21pt;text-align: center;">Conducir el Auto por caminos intransitables.</p>
          </li>
          <li data-list-text="9.">
            <p class="s15" style="padding-left: 81pt;text-indent: -21pt;text-align: center;">Utilizar el Auto para realizar actividades ilícitas</p>
            <p style="padding-top: 1pt;text-indent: 0pt;text-align: center;">
              <br />
            </p>
          </li>
        </ol>
      </li>
      <li data-list-text="D)">
        <p class="s21" style="padding-left: 60pt;text-indent: -21pt;text-align: center;">EXCLUSIONES.</p>
      </li>
    </ol>
    <p class="s15" style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">L A T I N O ni sus proveedores no se hacen responsables de los costos por daño o mal uso al vehículo, ni se cubre segundo conductor o conductores menores de 25 años, estos costos deberán ser cubiertos por el Asegurado.</p>
    <p style="text-indent: 0pt;text-align: center;">
      <br />
    </p>
    <p class="s15" style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">No se cubren costos por concepto de Drop (Recolección y/o entrega en puntos distintos a las arrendadoras).</p>
    <h3 style="padding-top: 13pt;padding-left: 39pt;text-indent: 0pt;text-align: justify;">
      <a name="a146">Cláusula 3.11. Llave Latino</a>
    </h3>
    <p class="s49" style="padding-left: 39pt;text-indent: 0pt;text-align: center;">Asistencia de cerrajería de auto. Condiciones Particulares</p>
    <p style="padding-top: 3pt;text-indent: 0pt;text-align: center;">
      <br />
    </p>
    <ol id="l149">
      <li data-list-text="A)">
        <p class="s12" style="padding-left: 60pt;text-indent: -21pt;text-align: center;">
          <a name="a147">Definiciones.</a>
        </p>
        <p style="padding-left: 39pt;text-indent: 0pt;text-align: center;">Para la debida interpretación de la presente cobertura de Asistencia, se acuerda establecer tanto en</p>
        <p style="padding-top: 3pt;padding-left: 39pt;text-indent: 0pt;text-align: justify;">lo singular como en lo plural las siguientes definiciones:</p>
        <p class="s12" style="padding-top: 11pt;padding-left: 39pt;text-indent: 0pt;text-align: justify;">Zona de cobertura: <span class="p">República Mexicana.</span>
        </p>
        <p class="s12" style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">Cerrajero para auto: <span class="p">Persona que cuenta con los conocimientos necesarios para abrir la cerradura de la puerta de un auto con sus herramientas. </span>
          <span class="s15">No aplica para apertura de cajuela o guantera.</span>
        </p>
        <p style="padding-top: 4pt;text-indent: 0pt;text-align: center;">
          <br />
        </p>
      </li>
      <li data-list-text="B)">
        <p class="s12" style="padding-left: 60pt;text-indent: -21pt;text-align: center;">
          <a name="a148">Alcance</a>
        </p>
        <p style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">Cuando en la <b>Carátula de la Póliza </b>se haga constar su contratación, <b>L A T I N O </b>otorgará a través de sus proveedores externos, el servicio de asistencia consistente en: </p>
        <ol id="l150">
          <li data-list-text="1.">
            <p style="padding-top: 11pt;padding-left: 81pt;text-indent: -21pt;text-align: justify;">En caso de que el <b>Asegurado </b>y/o <b>Conductor </b>haya olvidado las llaves del <b>Vehículo Asegurado </b>dentro de éste al cerrarlo, haya extraviado la llave, o haya sufrido un robo con violencia de la llave, <b>L A T I N O </b>realizará las gestiones necesarias para el envío de un <b>Cerrajero para auto </b>para abrir el <b>Vehículo Asegurado</b>. </p>
          </li>
          <li data-list-text="2.">
            <p style="padding-left: 81pt;text-indent: -21pt;text-align: justify;">Para que se otorgue el servicio, será necesario que el <b>Asegurado </b>y/o <b>Conductor </b>se identifique con el cerrajero, realice la acreditación de propiedad y demás requisitos que correspondan para proceder a otorgar el servicio. </p>
          </li>
          <li data-list-text="3.">
            <p style="padding-left: 81pt;text-indent: -21pt;text-align: justify;">El costo del servicio de envío de cerrajero, queda a cargo de <b>L A T I N O</b>, hasta el <b>Límite Máximo de Responsabilidad</b>. </p>
          </li>
          <li data-list-text="4.">
            <p style="padding-left: 81pt;text-indent: -21pt;text-align: center;">En caso de que el <b>Asegurado </b>o <b>Conductor </b>requiera de un duplicado de llave, por extravío o robo con violencia de la llave del <b>Vehículo Asegurado</b>, el costo de reposición quedara a cargo de <b>L A T I N O </b>hasta <b>Límite Máximo de Responsabilidad</b>. </p>
            <p style="padding-top: 1pt;text-indent: 0pt;text-align: center;">
              <br />
            </p>
            <p style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">Cualquier gasto excedente o complementario quedará a cargo del <b>Asegurado </b>y/o <b>Conductor </b>que lo haya autorizado. </p>
            <p style="padding-top: 9pt;text-indent: 0pt;text-align: center;">
              <br />
            </p>
          </li>
        </ol>
      </li>
      <li data-list-text="C)">
        <p class="s12" style="padding-left: 60pt;text-indent: -21pt;text-align: center;">
          <a name="a149">Límite Máximo de Responsabilidad</a>
          <span class="s51">.</span>
        </p>
      </li>
    </ol>
    <p style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">El <b>Límite Máximo de Responsabilidad </b>de <b>L A T I N O </b>para esta cobertura de servicio será de </p>
    <p class="s11" style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">$10,000.00 (diez mil pesos 00/100 M.N.) y se utilizará para cubrir todos los riesgos amparados. El <span class="s13">Límite Máximo de Responsabilidad </span>
      <span class="p">se reinstala anualmente.</span>
    </p>
    <p style="padding-top: 2pt;text-indent: 0pt;text-align: center;">
      <br />
    </p>
    <h3 style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">
      <a name="a150">Cláusula 4ª. Exclusiones Generales</a>
    </h3>
    <p class="s15" style="padding-top: 14pt;padding-left: 39pt;text-indent: 0pt;text-align: justify;">Queda entendido que, en adición de las Exclusiones específicas de cada Cobertura, este Contrato en ningún caso ampara <span style=" color: #2C5293;">:</span>
    </p>
    <ol id="l151">
      <ol id="l152">
        <li data-list-text="4.1.">
          <p class="s15" style="padding-top: 11pt;padding-left: 88pt;text-indent: -28pt;text-align: justify;">El Daño que sufra o cause el Vehículo Asegurado, cuando éste sea conducido por una persona que carezca de licencia para conducir expedida por la autoridad competente, o que dicha licencia no sea del tipo apropiado para conducir el Vehículo Asegurado (tipo de placa y uso); a menos que no pueda ser imputada al Conductor Culpa Grave, impericia o negligencia en la realización del Siniestro.</p>
          <p style="text-indent: 0pt;text-align: center;">
            <br />
          </p>
          <p class="s15" style="padding-left: 88pt;text-indent: 0pt;text-align: center;">No se considerarán para efectos de esta exclusión los siguientes casos:</p>
          <ol id="l153">
            <li data-list-text="a)">
              <p class="s15" style="padding-left: 117pt;text-indent: -21pt;text-align: center;">Que se carece de licencia para conducir cuando: la licencia esté vencida; se cuente con permiso vigente para conducir; sea una</p>
              <p class="s15" style="padding-top: 3pt;padding-left: 117pt;text-indent: 0pt;text-align: justify;">licencia expedida en el extranjero.</p>
            </li>
            <li data-list-text="b)">
              <p class="s15" style="padding-left: 117pt;text-indent: -21pt;text-align: justify;">Para cualquiera de los supuestos anteriores se deberá acreditar la preexistencia, al momento del Siniestro, de los documentos mencionados en el párrafo anterior.</p>
            </li>
            <li data-list-text="c)">
              <p class="s15" style="padding-left: 117pt;text-indent: -21pt;text-align: justify;">Para la cobertura de R.C. Terceros (Responsabilidad Civil por Daños a Terceros en sus Personas y Bienes) de estas Condiciones Generales, que se carece de licencia para conducir cuando el Conductor del Vehículo Asegurado sea el hijo del Asegurado y sea menor de edad momento del Siniestro.</p>
              <p style="text-indent: 0pt;text-align: center;">
                <br />
              </p>
            </li>
          </ol>
        </li>
        <li data-list-text="4.2.">
          <p class="s15" style="padding-left: 88pt;text-indent: -28pt;text-align: justify;">Las pérdidas o Daños que sufra o cause el Vehículo Asegurado, como consecuencia de cualquier tipo de operaciones bélicas, por guerra, por servicio militar, por rebelión, así como por expropiación, requisición, decomiso o incautación por parte de las autoridades legalmente reconocidas con motivo de sus funciones que intervengan en dichos actos con o sin consentimiento del Asegurado.</p>
          <p style="text-indent: 0pt;text-align: center;">
            <br />
          </p>
        </li>
        <li data-list-text="4.3.">
          <p class="s15" style="padding-left: 88pt;text-indent: -28pt;text-align: justify;">Cualquier perjuicio, sanción, gasto, pérdida o Daño indirecto que sufra el Asegurado, comprendiendo la privación del Uso del Vehículo Asegurado y pago de primas de fianzas que no se encuentren amparadas en este Contrato.</p>
          <p style="text-indent: 0pt;text-align: center;">
            <br />
          </p>
        </li>
        <li data-list-text="4.4.">
          <p class="s15" style="padding-left: 88pt;text-indent: -28pt;text-align: justify;">La rotura, descompostura mecánica o la falta de resistencia de cualquier pieza, a menos que fueren causados por alguno de los riesgos amparados.</p>
          <p style="text-indent: 0pt;text-align: center;">
            <br />
          </p>
        </li>
        <li data-list-text="4.5.">
          <p class="s15" style="padding-left: 88pt;text-indent: -28pt;text-align: justify;">Defecto de fabricación o desgaste natural del Vehículo Asegurado o de sus partes.</p>
          <p style="padding-top: 4pt;text-indent: 0pt;text-align: center;">
            <br />
          </p>
        </li>
        <li data-list-text="4.6.">
          <p class="s15" style="padding-left: 88pt;text-indent: -28pt;text-align: justify;">La depreciación que sufra el Vehículo Asegurado o sus partes, así como los Daños materiales que sufra el vehículo y que sean ocasionados por los bienes transportados, a menos que fueren causados por alguno de los riesgos amparados.</p>
        </li>
      </ol>
    </ol>
    <p style="text-indent: 0pt;text-align: center;">
      <br />
    </p>
    <p class="s15" style="padding-left: 88pt;text-indent: -28pt;text-align: justify;">4.7 Los Daños que sufra o cause el Vehículo Asegurado ocasionados por sobrecargarlo (exceso de dimensiones o de peso), por la distribución no adecuada de la carga y/o por someterlo a tracción excesiva con relación a su resistencia o capacidad. En estos casos, L A T I N O tampoco será responsable por Daños causados a viaductos, puentes, básculas o cualquier vía pública y/u objetos o instalaciones subterráneas, ya sea por vibración o por peso del vehículo o de su carga.</p>
    <p style="text-indent: 0pt;text-align: center;">
      <br />
    </p>
    <ol id="l154">
      <ol id="l155">
        <li data-list-text="4.8.">
          <p class="s15" style="padding-left: 88pt;text-indent: -28pt;text-align: center;">El Daño que sufra o cause el Vehículo Asegurado a consecuencia de</p>
          <p class="s15" style="padding-top: 3pt;padding-left: 88pt;text-indent: 0pt;text-align: center;">hechos diferentes a los amparados específicamente en cada Cobertura contratada.</p>
          <p style="text-indent: 0pt;text-align: center;">
            <br />
          </p>
        </li>
        <li data-list-text="4.9.">
          <p class="s15" style="padding-left: 88pt;text-indent: -28pt;text-align: justify;">Las pérdidas o Daños causados a las Partes Bajas del Vehículo Asegurado al transitar fuera de caminos o cuando éstos se encuentren en condiciones intransitables, es decir aquellos no reconocidos por la autoridad como vía de circulación para vehículos.</p>
        </li>
      </ol>
    </ol>
    <p style="text-indent: 0pt;text-align: center;">
      <br />
    </p>
    <ol id="l156">
      <ol id="l157">
        <li data-list-text="4.10">
          <p class="s15" style="padding-left: 88pt;text-indent: -28pt;text-align: justify;">Las prestaciones que deba solventar el Asegurado y/o Conductor por accidentes que sufran las personas Ocupantes del Vehículo Asegurado, de los que resulten obligaciones en materia de responsabilidad civil, penal o de riesgos profesionales, salvo que se encuentren amparadas en las Coberturas contratadas.</p>
          <p style="text-indent: 0pt;text-align: center;">
            <br />
          </p>
        </li>
        <li data-list-text="4.11">
          <p class="s15" style="padding-left: 88pt;text-indent: -28pt;text-align: justify;">Los Daños a Terceros en sus bienes o personas que cause el Vehículo Asegurado cuando al momento del Siniestro, el Conductor se encuentre en Estado de Ebriedad o bajo la influencia de estimulantes o depresores del sistema nervioso central aun cuando éstos hayan sido prescritos por un médico legalmente certificado para el ejercicio profesional, siempre que este hecho haya influido en la realización del Siniestro.</p>
          <p style="text-indent: 0pt;text-align: center;">
            <br />
          </p>
        </li>
        <li data-list-text="4.12">
          <p class="s15" style="padding-left: 88pt;text-indent: -28pt;text-align: justify;">Los Daños que sufra o cause el Vehículo Asegurado por actos intencionales del Asegurado y/o Conductor del vehículo.</p>
          <p style="text-indent: 0pt;text-align: center;">
            <br />
          </p>
        </li>
        <li data-list-text="4.13">
          <p class="s15" style="padding-left: 88pt;text-indent: -28pt;text-align: justify;">Bienes propiedad del Asegurado y/o Contratante, o de Terceras personas, que se encuentren en el Vehículo Asegurado.</p>
          <p style="text-indent: 0pt;text-align: center;">
            <br />
          </p>
        </li>
        <li data-list-text="4.14">
          <p class="s15" style="padding-left: 88pt;text-indent: -28pt;text-align: center;">Cualquier tipo de Fraude.</p>
          <p style="padding-top: 4pt;text-indent: 0pt;text-align: center;">
            <br />
          </p>
        </li>
        <li data-list-text="4.15">
          <p class="s15" style="padding-left: 88pt;text-indent: -28pt;text-align: justify;">Destinar el Vehículo Asegurado a un Uso diferente al particular, lo cual implica una mayor agravación del riesgo, incluyendo, pero no limitándose al transporte de mercancías, transporte de carga y/o transporte de pasajeros (Cabify, Uber, Taxi, EasyTaxi o cualquier otro servicio que se preste por medio de aplicaciones móviles).</p>
          <p style="text-indent: 0pt;text-align: center;">
            <br />
          </p>
        </li>
        <li data-list-text="4.16">
          <p class="s15" style="padding-left: 88pt;text-indent: -28pt;text-align: justify;">El Daño que sufra o cause el Vehículo Asegurado a consecuencia de Vandalismo.</p>
          <p style="text-indent: 0pt;text-align: center;">
            <br />
          </p>
        </li>
        <li data-list-text="4.17">
          <p class="s15" style="padding-left: 88pt;text-indent: -28pt;text-align: justify;">Las pérdidas o Daños causados al Vehículo Asegurado por robo parcial, salvo que se tenga contratada la cobertura de Robo Parical o se derive de un Robo Total.</p>
          <p style="text-indent: 0pt;text-align: center;">
            <br />
          </p>
        </li>
        <li data-list-text="4.18">
          <p class="s15" style="padding-left: 88pt;text-indent: -28pt;text-align: justify;">Los Daños que sufra o cause el Vehículo Asegurado por actos de terrorismo o como consecuencia del empleo de armas, explosivos o</p>
          <p class="s15" style="padding-top: 3pt;padding-left: 88pt;text-indent: 0pt;text-align: justify;">sustancias tóxicas, salvo los Daños que sufra el Vehículo Asegurado a consecuencia de impacto de bala y/o esquirla, siempre y cuando el Vehículo Asegurado no sea utilizado, por el Contratante, Asegurado, Conductor Habitual, Beneficiario o cualquier persona que tenga Parentesco con los anteriores, para actos que puedan configurar la comisión de un delito que se encuentre bajo investigación o actos que hayan sido determinados como delito por las autoridades competentes.</p>
          <p style="text-indent: 0pt;text-align: center;">
            <br />
          </p>
        </li>
        <li data-list-text="4.19">
          <p class="s15" style="padding-left: 88pt;text-indent: -28pt;text-align: justify;">Pérdidas y/o Daños ocasionados al Vehículo Asegurado por la instalación de cualquier dispositivo de seguridad y/o accesorios y/o Adaptaciones y/o Equipo Especial.</p>
          <p style="text-indent: 0pt;text-align: center;">
            <br />
          </p>
        </li>
        <li data-list-text="4.20">
          <p class="s15" style="padding-left: 88pt;text-indent: -28pt;text-align: justify;">Salvo pacto en contrario, los Daños ocasionados al propio Vehículo Asegurado por la carga que transporta, o Daños que cause por sí mismo o por la carga que transporte, al efectuar maniobras de carga o descarga.</p>
          <p style="text-indent: 0pt;text-align: center;">
            <br />
          </p>
        </li>
        <li data-list-text="4.21">
          <p class="s15" style="padding-left: 88pt;text-indent: -28pt;text-align: justify;">La falta de cumplimiento de los requisitos señalados en la Cobertura de Defensa Jurídica dará como consecuencia que la L A T I N O quedará eximida de cualquier obligación contractual.</p>
          <p style="text-indent: 0pt;text-align: center;">
            <br />
          </p>
        </li>
        <li data-list-text="4.22">
          <p class="s15" style="padding-left: 88pt;text-indent: -28pt;text-align: justify;">Cuando los hechos que den lugar al Siniestro constituyan el delito de Abuso de confianza, derivado de lo siguiente:</p>
          <p style="text-indent: 0pt;text-align: center;">
            <br />
          </p>
          <ol id="l158">
            <li data-list-text="a)">
              <p class="s15" style="padding-left: 117pt;text-indent: -21pt;text-align: center;">Que sea cometido por personas que tengan un Parentesco ya sea por consanguinidad, afinidad o civil con el Asegurado;</p>
            </li>
            <li data-list-text="b)">
              <p class="s15" style="padding-left: 117pt;text-indent: -21pt;text-align: center;">Que sea cometido por alguna de las personas que aparecen como Aseguradas en la Carátula de la Póliza;</p>
            </li>
            <li data-list-text="c)">
              <p class="s15" style="padding-left: 117pt;text-indent: -21pt;text-align: center;">Que tenga su origen en la pretensión del Asegurado de realizar transacciones de compra venta del Vehículo Asegurado.</p>
            </li>
            <li data-list-text="d)">
              <p class="s15" style="padding-top: 4pt;padding-left: 121pt;text-indent: -28pt;text-align: justify;">Que la posesión, uso y goce del Vehículo Asegurado se haya transmitido en virtud de un contrato de préstamo, crédito o de arrendamiento, en cualquiera de sus modalidades.</p>
              <p style="text-indent: 0pt;text-align: center;">
                <br />
              </p>
            </li>
          </ol>
        </li>
        <li data-list-text="4.23">
          <p class="s15" style="padding-left: 88pt;text-indent: -28pt;text-align: justify;">Pérdidas y/o Daños causados al Vehículo Asegurado antes de la entrada en vigor de la Póliza y/o endoso correspondiente.</p>
          <p style="text-indent: 0pt;text-align: center;">
            <br />
          </p>
        </li>
        <li data-list-text="4.24">
          <p class="s15" style="padding-left: 88pt;text-indent: -28pt;text-align: justify;">Daños causados cuando el Vehículo Asegurado circule dentro de instalaciones aeroportuarias.</p>
          <p style="text-indent: 0pt;text-align: center;">
            <br />
          </p>
        </li>
        <li data-list-text="4.25">
          <p class="s15" style="padding-left: 88pt;text-indent: -28pt;text-align: justify;">Los Daños que sufra o cause el Vehículo Asegurado, derivados de actos ilícitos, considerando entre otros el delito de extorsión o secuestro.</p>
        </li>
        <li data-list-text="4.26">
          <p class="s15" style="padding-top: 3pt;padding-left: 88pt;text-indent: -28pt;text-align: justify;">El robo ni los Daños que sufra el Vehículo Asegurado si este se encuentra restringido o prohibido para su circulación en el país de procedencia y en el título de propiedad se asiente la leyenda de “Parts only” (Sólo piezas), “Destruction” (Destruidos), “Assembled parts” (Piezas ensambladas), “Dismantlers” (Desmantelados), “Non reparaible” (No reparable), “Non rebuildable” (No reconstruibles), “Not street legal” (Ilegales para circular por la calle), “Junk” (Basura), “Crush” (Aplastados), “Scrap” (Chatarra), “Seizure/Forfeiture” (Decomisados/ Confiscados), “Off-highway use only” (Solo uso fuera de la autopista), “Not elegible for road use” (No elegibles para uso en carretera); en el caso de Vehículos Fronterizos, legalmente importados, y regularizados o importados.</p>
          <p style="text-indent: 0pt;text-align: center;">
            <br />
          </p>
        </li>
        <li data-list-text="4.27">
          <p class="s15" style="padding-left: 88pt;text-indent: -28pt;text-align: justify;">El Incendio del Vehículo Asegurado, cuando el fuego haya sido producido en forma intencional por el Asegurado.</p>
          <p style="text-indent: 0pt;text-align: center;">
            <br />
          </p>
        </li>
        <li data-list-text="4.28">
          <p class="s15" style="padding-left: 88pt;text-indent: -28pt;text-align: justify;">Participar directamente con el Vehículo Asegurado en carreras o pruebas de seguridad, resistencia o velocidad.</p>
        </li>
      </ol>
    </ol>
    <h3 style="padding-top: 13pt;padding-left: 39pt;text-indent: 0pt;text-align: center;">
      <a name="a151">Cláusula 5ª. Cláusulas Generales.</a>
    </h3>
    <p class="s21" style="padding-top: 13pt;padding-left: 39pt;text-indent: 0pt;line-height: 14pt;text-align: center;">Cláusula 5.1.</p>
    <p class="s21" style="padding-left: 39pt;text-indent: 0pt;line-height: 14pt;text-align: center;">Determinación de la Responsabilidad.</p>
    <p style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">La determinación de la responsabilidad del <b>Asegurado </b>o <b>Conductor</b>, cuando participe en un <b>Accidente Automovilístico</b>, <b>Vial </b>o de tránsito, se realizará en forma inicial en apego a lo establecido en la “Guía de Deslinde para las Compañías de Seguros” publicada por la Asociación Mexicana de Instituciones de Seguros, A.C. (AMIS), Guía que podrá ser consultada en el portal de Internet de <b>L A T I N O</b>
      <a href="http://www.latinoseguros.com.mx/" class="a" target="_blank">, </a>
      <a href="http://www.latinoseguros.com.mx/" target="_blank">www.latinoseguros.com.mx.</a>
    </p>
    <p style="text-indent: 0pt;text-align: center;">
      <br />
    </p>
    <p style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">En caso de no haber acuerdo entre las partes y se tome conocimiento por parte de una autoridad, la determinación de la responsabilidad se establecerá con base en el peritaje de causalidad o dictamen que emita la autoridad competente en términos del Reglamento de Tránsito o legislación vigente en la entidad federativa donde ocurre el hecho de tránsito.</p>
    <p style="text-indent: 0pt;text-align: center;">
      <br />
    </p>
    <p class="s21" style="padding-left: 39pt;text-indent: 0pt;text-align: center;">Cláusula 5.2.</p>
    <p class="s21" style="padding-left: 39pt;text-indent: 0pt;text-align: center;">Prima, plazos y obligaciones de pago.</p>
    <ol id="l159">
      <li data-list-text="1.">
        <p class="s13" style="padding-top: 4pt;padding-left: 60pt;text-indent: -21pt;text-align: justify;">
          <a name="a152">Prima</a>
        </p>
        <p style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">La <b>Prima </b>de la <b>Póliza </b>se compone de la suma de cada una de las <b>Coberturas </b>que se solicitaron por el <b>Contratante </b>y que aparecen indicadas en la <b>Carátula de la Póliza</b>, más los gastos de expedición e Impuesto al Valor Agregado (IVA). </p>
        <p style="text-indent: 0pt;text-align: center;">
          <br />
        </p>
        <p style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">La <b>Prima </b>vencerá en el momento de la celebración del <b>Contrato</b>, por lo que se refiere al primer periodo del seguro, entendiéndose por periodo del seguro el lapso para el cual resulte calculada la unidad de la <b>Prima</b>. En caso de duda, se entenderá que el periodo es de un año. </p>
      </li>
      <li data-list-text="2.">
        <p class="s13" style="padding-top: 11pt;padding-left: 60pt;text-indent: -21pt;text-align: justify;">
          <a name="a153">Plazo de pago de prima</a>
        </p>
        <p class="s13" style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">L A T I N O <span class="p">y el </span>Contratante <span class="p">fijarán de común acuerdo el plazo en que deberá pagarse la </span>Prima <span class="p">, plazo que se contará en días naturales y que será asentado por </span>L A T I N O <span class="p">en la </span>Carátula de la </p>
        <p class="s13" style="padding-top: 3pt;padding-left: 39pt;text-indent: 0pt;text-align: justify;">Póliza <span class="p">. En caso de no estipularse en la </span>Carátula de Póliza <span class="p">, aplicará el plazo dispuesto en el artículo 40 de la Ley sobre el Contrato de Seguro.</span>
        </p>
        <p style="padding-top: 10pt;padding-left: 39pt;text-indent: 0pt;text-align: justify;">El <b>Contratante </b>se obliga a pagar la <b>Prima</b>, o fracción de ella tratándose de pago en parcialidades, en el plazo de pago convenido, el cual se especifica en la <b>Carátula de la Póliza</b>, de no realizarlo, cesarán automáticamente los efectos del <b>Contrato </b>a las 12.00 hrs. del último día del plazo de pago convenido. Sin embargo, en caso de que el último día del plazo convenido sea inhábil, el <b>Contratante </b>deberá efectuar el pago respectivo el día hábil inmediato anterior al vencimiento de dicho plazo. </p>
        <p style="text-indent: 0pt;text-align: center;">
          <br />
        </p>
      </li>
      <li data-list-text="3.">
        <p class="s13" style="padding-left: 60pt;text-indent: -21pt;text-align: justify;">
          <a name="a154">Pago Fraccionado</a>
        </p>
        <p style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">El <b>Contratante </b>y <b>L A T I N O </b>podrán convenir el pago fraccionado de la <b>Prima</b>, en cuyo caso las exhibiciones deberán ser por períodos de igual duración, venciendo y debiendo ser pagadas al inicio de cada período pactado y aplicando la tasa de financiamiento convenida. </p>
      </li>
      <li data-list-text="4.">
        <p class="s13" style="padding-top: 11pt;padding-left: 60pt;text-indent: -21pt;text-align: justify;">
          <a name="a155">Primer recibo y recibos subsecuentes</a>
        </p>
        <p style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">Cuando a petición del contratante el pago de seguro se fraccione, existirán un primer recibo donde se adicione al pago de la prima el derecho de póliza y el recargo correspondiente por financiamiento, en los recibos subsecuentes se considerará el pago de la prima más el recargo por financiamiento, en ambos casos se adicionará el IVA.</p>
        <p style="text-indent: 0pt;text-align: center;">
          <br />
        </p>
      </li>
      <li data-list-text="5.">
        <p class="s13" style="padding-left: 60pt;text-indent: -21pt;text-align: justify;">
          <a name="a156">Pago mediante Cargo Automático</a>
        </p>
        <p style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">Cuando el <b>Contratante </b>o <b>Asegurado </b>solicite que el pago correspondiente al monto de la <b>Prima </b>del seguro o la fracción de que se trate, en el caso de pago en parcialidades, se realice con cargo automático a una cuenta bancaria mediante tarjeta de crédito o débito, cheque, CLABE o descuento por nómina previa autorización por escrito del <b>Contratante </b>o <b>Asegurado</b>, se efectuará el cargo correspondiente, obligándose el <b>Contratante </b>o <b>Asegurado </b>a mantener los saldos suficientes para realizar el cargo por el importe completo de la <b>Prima </b>o fracción cuando se trate de cargos a cuentas bancarias. En caso de que por causa imputable al <b>Contratante </b>o <b>Asegurado </b>no pueda efectuarse el cargo correspondiente, el <b>Contrato de Seguro </b>cesará en sus efectos en forma automática. </p>
        <p style="padding-top: 11pt;padding-left: 39pt;text-indent: 0pt;text-align: justify;">En caso de <b>Siniestro </b>dentro del plazo convenido para el pago de la <b>Prima </b>o fracción de ella, <b>L A T I N O </b>deducirá del pago o indemnización el total de la <b>Prima </b>pendiente de pago o las fracciones de ésta no liquidadas hasta completar el total de la <b>Prima </b>correspondiente al periodo del seguro contratado. </p>
        <p style="text-indent: 0pt;text-align: center;">
          <br />
        </p>
      </li>
      <li data-list-text="6.">
        <p class="s13" style="padding-left: 60pt;text-indent: -21pt;text-align: justify;">
          <a name="a157">Lugar de pago</a>
        </p>
        <p style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">Las <b>Prima</b>s convenidas deberán ser pagadas en las Instituciones Bancarias señaladas por <b>L A T I N O</b>, contra entrega del recibo correspondiente. En caso de que el <b>Contratante </b>o <b>Asegurado </b>efectúe el pago total de la <b>Prima</b>, o el total de la parte correspondiente de ella si se ha pactado su pago fraccionado, en cualquiera de las Instituciones Bancarias señaladas por <b>L A T I N O </b>, quedará bajo su responsabilidad hacer referencia del número de <b>Póliza </b>que se está pagando, para que el comprobante que para tal efecto sea expedido por dichas Instituciones Bancarias haga prueba plena del pago de la <b>Prima </b>o fracción de ella; asimismo el estado de cuenta del <b>Contratante </b>o <b>Asegurado </b>en el que aparezca el cargo correspondiente hará prueba plena de dicho pago; lo anterior hasta el momento en que <b>L A T I N O </b>haga entrega al <b>Contratante </b>o <b>Asegurado </b>del recibo correspondiente. </p>
      </li>
      <li data-list-text="7.">
        <p class="s13" style="padding-top: 11pt;padding-left: 60pt;text-indent: -21pt;text-align: justify;">
          <a name="a158">Solicitud de Información</a>
        </p>
        <p style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">Durante la vigencia de la <b>Póliza</b>, el <b>Contratante </b>podrá solicitar por escrito a <b>L A T I N O</b>, le informe el porcentaje de la <b>Prima </b>que, por concepto de comisión o compensación directa, corresponda al intermediario o persona moral por su intervención en la celebración de este <b>Contrato</b>. <b>L A T I N O </b>proporcionará dicha información, por escrito o por medios electrónicos, en un plazo que no excederá de diez días hábiles posteriores a la fecha de recepción de la solicitud. </p>
      </li>
      <li data-list-text="8.">
        <p class="s13" style="padding-top: 3pt;padding-left: 60pt;text-indent: -21pt;text-align: justify;">
          <a name="a159">Cesación de los efectos del Contrato por falta de pago</a>
        </p>
      </li>
    </ol>
    <p style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">Para efectos de este Seguro, el Plazo para el Pago se estipula en la <b>Carátula de la Póliza</b>. A falta de éste, aplicará lo dispuesto en el Artículo 40 de la Ley sobre el Contrato de Seguro: </p>
    <p class="s16" style="padding-top: 11pt;padding-left: 39pt;text-indent: 0pt;text-align: justify;">“Artículo 40.- Si no hubiese sido pagada la <b>Prima </b>o la fracción correspondiente, en los casos de pago en parcialidades, dentro del término convenido, los efectos del contrato cesarán automáticamente a las doce horas del último día de ese plazo. En caso de que no se haya convenido el término, se aplicará un plazo de treinta días naturales siguientes a la fecha de su vencimiento.” </p>
    <p style="text-indent: 0pt;text-align: center;">
      <br />
    </p>
    <p class="s21" style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">Cláusula 5.3.</p>
    <p class="s21" style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">Obligaciones del Asegurado en caso de Siniestro.</p>
    <p style="padding-top: 11pt;padding-left: 39pt;text-indent: 0pt;text-align: justify;">El <b>Asegurado </b>se obliga a: </p>
    <p style="text-indent: 0pt;text-align: center;">
      <br />
    </p>
    <ol id="l160">
      <li data-list-text="1.">
        <p class="s13" style="padding-left: 60pt;text-indent: -21pt;text-align: justify;">
          <a name="a160">Precauciones</a>
        </p>
        <p style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">Ejecutar todos los actos o medidas que tiendan a evitar o disminuir el <b>Daño</b>. Si no hay peligro en la demora, pedirá instrucciones a <b>L A T I N O</b>, debiendo atenerse a las que ella le indique. Los gastos hechos por el <b>Asegurado</b>, que no sean manifiestamente improcedentes, se cubrirán por <b>L A T I N O </b>y si ésta da instrucciones, anticipará dichos gastos. </p>
        <p style="text-indent: 0pt;text-align: center;">
          <br />
        </p>
        <p style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">Si el <b>Asegurado </b>no cumple con las obligaciones que le impone el párrafo anterior, <b>L A T I N O </b>tendrá derecho de limitar o reducir la indemnización, hasta el valor a que hubiere ascendido si el <b>Asegurado </b>hubiere cumplido con dichas obligaciones. </p>
      </li>
      <li data-list-text="2.">
        <p class="s13" style="padding-top: 11pt;padding-left: 60pt;text-indent: -21pt;text-align: justify;">
          <a name="a161">Aviso de siniestro</a>
        </p>
        <p style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">Dar aviso a <b>L A T I N O </b>tan pronto como tenga conocimiento del hecho y dentro un plazo de cinco días salvo caso fortuito o de fuerza mayor, debiendo darlo tan pronto como cese uno u otro. La falta oportuna de este aviso dará lugar a que <b>L A T I N O </b>quede desligada de las obligaciones derivadas del presente <b>Contrato</b>, si la intención del <b>Asegurado </b>o <b>Beneficiario </b>o <b>Conductor </b>fueron impedir la comprobación oportuna de las circunstancias en que sucedió el <b>Siniestro</b>. En caso contrario sólo podrá dar lugar a que la indemnización sea reducida a la cantidad que originalmente hubiere importado el <b>Siniestro</b>, si <b>L A T I N O </b>hubiere tenido pronto aviso sobre el mismo. </p>
      </li>
      <li data-list-text="3.">
        <p class="s52" style="padding-top: 11pt;padding-left: 60pt;text-indent: -21pt;text-align: justify;">Aviso a las autoridades</p>
        <p style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">Presentar formal querella o denuncia ante las autoridades competentes, tan pronto como tenga conocimiento de los hechos, cuando se trate de robo o cualquier otro acto delictuoso que pueda ser motivo de reclamación al amparo de esta <b>Póliza</b>, y cooperar con <b>L A T I N O </b>para conseguir la recuperación del <b>Vehículo Asegurado </b>o del importe del <b>Daño </b>sufrido, siendo responsable de los <b>Daños </b>y perjuicios que con su omisión cause a <b>L A T I N O</b>. </p>
      </li>
      <li data-list-text="4.">
        <p class="s52" style="padding-top: 11pt;padding-left: 60pt;text-indent: -21pt;line-height: 11pt;text-align: center;">En caso de reclamaciones</p>
        <p style="padding-left: 39pt;text-indent: 0pt;line-height: 11pt;text-align: center;">En caso de reclamaciones que afecten las <b>Coberturas </b>de Responsabilidad Civil de las presentes </p>
        <p class="s13" style="padding-left: 39pt;text-indent: 0pt;text-align: center;">Condiciones Generales <span class="p">, el </span>Asegurado <span class="p">se obliga además a:</span>
        </p>
        <ol id="l161">
          <li data-list-text="a.">
            <p class="s9" style="padding-top: 4pt;padding-left: 81pt;text-indent: -21pt;text-align: justify;">
              <span class="p">Comunicar a </span>
              <span class="s13">L A T I N O</span>
              <span class="p">, dentro de las 24 horas hábiles siguientes las reclamaciones o demandas recibidas por él o por sus representantes, a cuyo efecto le remitirá los </span>
              <span class="s24">documentos o copias de los mismos, que con ese motivo se le hubieren entregado. En caso de que el </span>Asegurado <span class="s11">no cumpla con dicha comunicación </span>L A T I N O <span class="s11">no tendrá obligación de cubrir cantidad alguna en caso de que el </span>Asegurado <span class="s11">y/o </span>Conductor <span class="s11">del </span>Vehículo Asegurado <span class="s11">sea condenado, este periodo no surtirá efecto en caso que el asegurado o contratante se encuentre impedido por caso fortuito o fuerza mayor para lo cual deberá notificar a la compañíatanprontocomodesaparezcandichossupuestos. </span>
              <span class="s13">L A T I N O </span>
              <span class="p">no quedará obligada por reconocimiento de adeudos, transacciones o cualesquiera otros actos jurídicos de naturaleza semejante, o hechos concertados sin el</span>
            </p>
            <p style="padding-top: 3pt;padding-left: 81pt;text-indent: 0pt;text-align: justify;">consentimiento de <b>L A T I N O</b>. La confesión de la materialidad de un hecho no podrá ser asimilada al reconocimiento de una responsabilidad. </p>
          </li>
          <li data-list-text="b.">
            <p style="padding-top: 11pt;padding-left: 81pt;text-indent: -21pt;text-align: justify;">Ejercitar y hacer valer las acciones y defensas que en derecho le correspondan ante cualquier autoridad con motivo de la responsabilidad civil amparada, proporcionando en su caso los datos y pruebas necesarios, que le hayan sido requeridos por <b>L A T I N O </b>para su defensa, incluyendo el otorgamiento de poderes en favor de la persona que designe <b>L A T I N O </b>, para que lo represente en los citados procedimientos, en caso de que no pueda intervenir en forma directa en todos los trámites de dichos procedimientos y cuando sea procedente dicha <b>Cobertura</b>. </p>
            <p style="text-indent: 0pt;text-align: center;">
              <br />
            </p>
          </li>
          <li data-list-text="c.">
            <p style="padding-left: 81pt;text-indent: -21pt;text-align: justify;">En caso de reclamaciones que afecten la cobertura de Gastos Médicos Ocupantes, el <b>Asegurado </b>o lesionado deberá notificar el <b>Siniestro </b>de manera inmediata o dentro de un plazo no mayor a 5 (cinco) días, cuyo incumplimiento puede dar lugar a la pérdida de la indemnización debida por <b>L A T I N O</b>, este periodo no surtirá efecto en caso que el asegurado o contratante se encuentre impedido por caso fortuito o fuerza mayor para lo cual deberá notificar a la compañía tan pronto como desaparezcan dichos supuestos. Tras recibir el pase médico que le sea asignado, el lesionado está obligado a hacer uso del mismo en un plazo no mayor a 30 (treinta) días naturales; en caso de no ser utilizado deberá dar un aviso a <b>L A T I N O </b>para que el mismo sea rehabilitado. </p>
            <p style="padding-top: 11pt;padding-left: 81pt;text-indent: 0pt;text-align: justify;">Tratándose de una urgencia real que impida la notificación inmediata del <b>Siniestro</b>, el lesionado o <b>Asegurado </b>podrá atenderse con un médico u hospital a falta del pase médico, debiendo éste o algún familiar dar aviso de las lesiones a <b>L A T I N O</b>. Los gastos generados por dicha urgencia deberán ser reembolsados aplicando el <b>Costo Usual y Acostumbrado </b>médico y hospitalario establecido por <b>L A T I N O</b>
            </p>
            <p style="text-indent: 0pt;text-align: center;">
              <br />
            </p>
            <p style="padding-left: 81pt;text-indent: 0pt;text-align: justify;">Se entenderá por una urgencia real, aquel estado clínico que pone en peligro la vida o la función de un órgano o sistema y que requiere <b>Atención Médica </b>inmediata para evitar <b>Daños </b>mayores. </p>
            <p style="text-indent: 0pt;text-align: center;">
              <br />
            </p>
          </li>
        </ol>
      </li>
      <li data-list-text="5.">
        <p class="s52" style="padding-left: 60pt;text-indent: -21pt;line-height: 11pt;text-align: center;">Documentación que debe entregar el Asegurado en caso de Pérdida Total <span class="s53">.</span>
        </p>
        <p style="padding-left: 39pt;text-indent: 0pt;line-height: 11pt;text-align: center;">En caso de vehículos fabricados en la República Mexicana, se deberá entregar:</p>
        <p class="s13" style="padding-top: 11pt;padding-left: 39pt;text-indent: 0pt;line-height: 11pt;text-align: center;">
          <a name="a162">Personas físicas</a>
          <span style=" color: #2C5293;">:</span>
        </p>
        <ol id="l162">
          <li data-list-text="1.">
            <p style="padding-left: 81pt;text-indent: -21pt;line-height: 11pt;text-align: center;">Factura Actual (Original) y copia de las que la anteceden.</p>
          </li>
          <li data-list-text="2.">
            <p style="padding-left: 81pt;text-indent: -21pt;text-align: center;">Se verificará el pago de las tenencias, en caso de no estar cubiertas se descontarán de la indemnización.</p>
          </li>
          <li data-list-text="3.">
            <p style="padding-left: 81pt;text-indent: -21pt;line-height: 11pt;text-align: center;">En caso de ser re-facturado, copia fotostática de la factura original.</p>
          </li>
          <li data-list-text="4.">
            <p style="padding-left: 81pt;text-indent: -21pt;text-align: center;">Llaves del vehículo, si las tiene.</p>
          </li>
          <li data-list-text="5.">
            <p style="padding-left: 81pt;text-indent: -21pt;text-align: center;">Copia de identificación oficial.</p>
          </li>
          <li data-list-text="6.">
            <p style="padding-left: 81pt;text-indent: -21pt;text-align: justify;">Finiquito, documento proporcionado por LATINO mismo que deberá requisitar, firmar y entregar el asegurado/contratante y/o beneficiario para el pago de la indemnización (pérdida, robo total, pago de daños, gastos médicos, trámites de gastos en general como grúas, pensiones y multas).</p>
          </li>
          <li data-list-text="7.">
            <p style="padding-left: 81pt;text-indent: -21pt;text-align: justify;">Baja de placas.</p>
          </li>
          <li data-list-text="8.">
            <p style="padding-left: 79pt;text-indent: -21pt;text-align: justify;">Comprobante Fiscal Digital por Internet (CFDI) por la enajenación de los efectos salvados (Formato entregado por el taller en caso de <b>Pérdida Total</b>). </p>
          </li>
          <li data-list-text="9.">
            <p style="padding-left: 82pt;text-indent: -23pt;line-height: 11pt;text-align: justify;">Comprobante de domicilio no mayor de tres meses.</p>
          </li>
        </ol>
        <p style="padding-top: 1pt;text-indent: 0pt;text-align: center;">
          <br />
        </p>
        <p class="s13" style="padding-left: 39pt;text-indent: 0pt;text-align: center;">
          <a name="a163">Persona moral:</a>
        </p>
        <p style="padding-left: 39pt;text-indent: 0pt;line-height: 11pt;text-align: center;">En adición a los documentos anteriores se requieren:</p>
        <ol id="l163">
          <li data-list-text="1.">
            <p style="padding-left: 81pt;text-indent: -21pt;line-height: 11pt;text-align: center;">Emitir factura a favor de LA LATINOAMERICANA SEGUROS.</p>
          </li>
          <li data-list-text="2.">
            <p style="padding-left: 81pt;text-indent: -21pt;line-height: 11pt;text-align: justify;">Copia de poder notarial del representante legal.</p>
          </li>
          <li data-list-text="3.">
            <p style="padding-left: 81pt;text-indent: -21pt;line-height: 11pt;text-align: justify;">Copia de identificación oficial.</p>
          </li>
          <li data-list-text="4.">
            <p style="padding-top: 3pt;padding-left: 81pt;text-indent: -21pt;text-align: center;">Sustituir la factura original de Agencia (origen) por copia fotostática.</p>
          </li>
        </ol>
        <p class="s13" style="padding-top: 11pt;padding-left: 39pt;text-indent: 0pt;text-align: center;">
          <a name="a164">En caso de Robo Total</a>
        </p>
        <p style="padding-left: 39pt;text-indent: 0pt;text-align: center;">En adición a los documentos anteriores se requieren:</p>
        <ol id="l164">
          <li data-list-text="1.">
            <p style="padding-left: 81pt;text-indent: -21pt;text-align: center;">Copia certificada de la Carpeta de Investigación y de la acreditación de la propiedad ante el Ministerio Público.</p>
          </li>
          <li data-list-text="2.">
            <p style="padding-left: 81pt;text-indent: -21pt;line-height: 11pt;text-align: center;">Reporte a la Autoridad competente, sólo para los estados en los que aplique.</p>
          </li>
          <li data-list-text="3.">
            <p style="padding-left: 81pt;text-indent: -21pt;text-align: center;">Comprobante Fiscal Digital por Internet (CFDI) por la enajenación de los efectos salvados (Formato entregado por el abogado).</p>
          </li>
        </ol>
        <p class="s13" style="padding-top: 11pt;padding-left: 39pt;text-indent: 0pt;text-align: center;">
          <a name="a165">En caso de vehículos de fabricación extranjera que se encuentren legalmente en el país:</a>
        </p>
        <p style="padding-left: 39pt;text-indent: 0pt;line-height: 11pt;text-align: center;">Además de los requisitos anteriores se deberá entregar:</p>
        <ol id="l165">
          <li data-list-text="1.">
            <p style="padding-left: 81pt;text-indent: -21pt;line-height: 11pt;text-align: center;">Título de propiedad original o certificado de propiedad del país de origen.</p>
          </li>
          <li data-list-text="2.">
            <p style="padding-left: 81pt;text-indent: -21pt;line-height: 11pt;text-align: center;">Pedimento de importación (sólo <b>Vehículos Fronterizos </b>o <b>Legalmente Importados</b>). </p>
          </li>
          <li data-list-text="3.">
            <p style="padding-left: 81pt;text-indent: -21pt;text-align: center;">Certificado de inscripción sobre la base de Decreto de la Secretaría De Hacienda y Crédito Público, (sólo <b>Vehículos Regularizados</b>). </p>
          </li>
          <li data-list-text="4.">
            <p style="padding-left: 81pt;text-indent: -21pt;text-align: center;">Comprobante original del pago de aranceles por las autoridades, considerando como comprobante el pedimento o certificado</p>
          </li>
        </ol>
        <p style="padding-top: 9pt;text-indent: 0pt;text-align: center;">
          <br />
        </p>
      </li>
      <li data-list-text="6.">
        <p class="s52" style="padding-left: 60pt;text-indent: -21pt;text-align: justify;">Plazo para el pago de la indemnización</p>
        <p class="s16" style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">El crédito que resulte del <b>Contrato de Seguro </b>vencerá treinta días después de la fecha en que la empresa haya recibido los documentos e informaciones que le permitan conocer el fundamento de la reclamación. </p>
        <p class="s16" style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">Será nula la cláusula en que se pacte que el crédito no podrá exigirse sino después de haber sido reconocido por la empresa o comprobado en juicio. <span class="p">(Artículo 71 de la Ley Sobre el Contrato de Seguro)</span>
          <span style=" color: #2C5293;">.</span>
        </p>
      </li>
      <li data-list-text="7.">
        <p class="s52" style="padding-top: 10pt;padding-left: 60pt;text-indent: -21pt;text-align: justify;">Obligación de comunicar la existencia de otros seguros.</p>
        <p style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">El <b>Asegurado </b>o <b>Contratante </b>tendrá la obligación de notificar a <b>L A T I N O </b>por escrito, la existencia de todo seguro que contrate o hubiere contratado con otra compañía, sobre el mismo riesgo y por el mismo interés, indicando el nombre del Asegurador, las sumas aseguradas y las <b>Coberturas</b>. </p>
        <p style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">Si el <b>Asegurado </b>omite intencionalmente el aviso de que ha contratado otros seguros, o si contrata los diversos seguros para obtener un provecho ilícito, <b>L A T I N O </b>quedará liberada de sus obligaciones. </p>
        <p style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">En caso de la existencia de otros seguros, <b>L A T I N O </b>se obliga a pagar el valor íntegro del <b>Daño </b>sufrido dentro de los límites de <b>Suma Asegurada </b>y podrá repetir contra las demás, las que pagarán los <b>Daños </b>y las pérdidas proporcionalmente a la cantidad o límites asegurados por ellas. </p>
        <p style="text-indent: 0pt;text-align: center;">
          <br />
        </p>
      </li>
      <li data-list-text="8.">
        <p class="s52" style="padding-left: 60pt;text-indent: -21pt;text-align: center;">Disposiciones aplicables para la entrega de información y documentación derivada de la Ley Sobre el Contrato de Seguro</p>
        <p style="text-indent: 0pt;text-align: center;">
          <br />
        </p>
        <p class="s16" style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">
          <span class="s55">Artículo 69. </span>La empresa aseguradora tendrá el derecho de exigir del <b>Asegurado </b>o <b>Beneficiario </b>toda clase de informaciones sobre los hechos relacionados con el <b>Siniestro </b>y por los cuales puedan determinarse las circunstancias de su realización y las consecuencias del mismo.
        </p>
        <p class="s16" style="padding-top: 11pt;padding-left: 39pt;text-indent: 0pt;text-align: justify;">
          <span class="s55">Artículo70. </span>Las obligaciones de la empresa quedarán extinguidas si demuestra que el <b>Asegurado</b>, el <b>Beneficiario </b>o los representantes de ambos, con el fin de hacerla incurrir en error, disimulan o declaran inexactamente hechos que excluían o podrían restringir dichas obligaciones. Lo mismo se observará en caso de que, con igual propósito, no le remitan en tiempo la documentación de que trata el artículo anterior.
        </p>
        <p style="text-indent: 0pt;text-align: center;">
          <br />
        </p>
        <p class="s16" style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">
          <span class="s55">Artículo 71</span>. El crédito que resulte del <b>Contrato de Seguro </b>vencerá treinta días después de la fecha en que la empresa haya recibido los documentos e informaciones que le permitan conocer el
        </p>
        <p class="s16" style="padding-top: 3pt;padding-left: 39pt;text-indent: 0pt;text-align: justify;">fundamento de la reclamación. Será nula la cláusula en que se pacte que el crédito no podrá exigirse sino después de haber sido reconocido por la empresa o comprobado en juicio.</p>
      </li>
      <li data-list-text="9.">
        <p class="s52" style="padding-top: 11pt;padding-left: 60pt;text-indent: -21pt;text-align: justify;">Gastos de custodia</p>
      </li>
    </ol>
    <p style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">Si el <b>Asegurado </b>no entrega la documentación correspondiente dentro de los primeros 90 (noventa) días naturales a partir del reporte de un <b>Siniestro</b>, en el que <b>L A T I N O </b>determine <b>Pérdida Total </b>por <b>Daños </b>materiales y/o <b>Robo Total </b>recuperado, <b>L A T I N O </b>descontará de la indemnización el monto correspondiente a los gastos por concepto de resguardo y/o depósito en corralón equivalente a 2 (dos) valores diarios de la <b>Unidad de Medida y Actualización (UMA)</b>, por cada día natural de estancia en el corralón a partir del día natural 91 (noventa y un) desde la fecha del reporte del <b>Siniestro</b>, con un límite equivalente al importe de la indemnización que corresponda a la <b>Pérdida Total</b>. </p>
    <p style="text-indent: 0pt;text-align: center;">
      <br />
    </p>
    <p class="s21" style="padding-left: 39pt;text-indent: 0pt;text-align: center;">Cláusula 5.4.</p>
    <p class="s21" style="padding-left: 39pt;text-indent: 0pt;text-align: center;">Reinstalación Automática del Límite Máximo de Responsabilidad</p>
    <p style="padding-top: 11pt;padding-left: 39pt;text-indent: 0pt;text-align: justify;">Los <b>Límites Máximos de Responsabilidad </b>de las siguientes <b>Coberturas </b>se reinstalarán automáticamente cuando hayan sido reducidas por el pago de cualquier indemnización parcial efectuada por <b>L A T I N O </b>durante la vigencia de la <b>Póliza</b>: </p>
    <ol id="l166">
      <li data-list-text="1.">
        <p style="padding-left: 81pt;text-indent: -21pt;line-height: 11pt;text-align: center;">Daños Materiales en el riesgo de <b>Pérdida Parcial</b>; </p>
      </li>
      <li data-list-text="2.">
        <p style="padding-left: 81pt;text-indent: -21pt;line-height: 11pt;text-align: center;">Robo Total en el caso de recuperación;</p>
      </li>
      <li data-list-text="3.">
        <p style="padding-left: 81pt;text-indent: -21pt;line-height: 11pt;text-align: center;">R.C. Terceros;</p>
      </li>
      <li data-list-text="4.">
        <p style="padding-left: 81pt;text-indent: -21pt;text-align: center;">R.C. Otros vehículos (Extensión de R..C.).;</p>
      </li>
      <li data-list-text="5.">
        <p style="padding-left: 81pt;text-indent: -21pt;line-height: 11pt;text-align: center;">R.C. Muerte 3º. (R.C. Catastrófica);</p>
      </li>
      <li data-list-text="6.">
        <p style="padding-left: 81pt;text-indent: -21pt;line-height: 11pt;text-align: center;">Cuidando tus Bienes (R.C. Cruzada);</p>
      </li>
      <li data-list-text="7.">
        <p style="padding-left: 81pt;text-indent: -21pt;line-height: 11pt;text-align: center;">R.C. Remolque;</p>
      </li>
      <li data-list-text="8.">
        <p style="padding-left: 81pt;text-indent: -21pt;line-height: 11pt;text-align: center;">R.C. Carga;</p>
      </li>
      <li data-list-text="9.">
        <p style="padding-left: 81pt;text-indent: -21pt;text-align: center;">Protección Ocupantes (R.C. Ocupantes); y</p>
      </li>
      <li data-list-text="10.">
        <p style="padding-left: 81pt;text-indent: -21pt;text-align: center;">Gastos Médicos Ocupantes.</p>
      </li>
    </ol>
    <p style="padding-top: 11pt;padding-left: 39pt;text-indent: 0pt;text-align: justify;">En el caso de la cobertura de Adaptaciones, Conversiones y Equipo Especial, toda indemnización que <b>L A T I N O </b>pague, reducirá en igual cantidad el límite de responsabilidad pactado originalmente, pudiendo ser reinstalado a solicitud del <b>Contratante</b>, previa aceptación de <b>L A T I N O , </b>en cuyo caso el <b>Contratante </b>deberá pagar la <b>Prima </b>que corresponda. </p>
    <p style="text-indent: 0pt;text-align: center;">
      <br />
    </p>
    <p class="s15" style="padding-left: 39pt;text-indent: 0pt;text-align: center;">Las coberturas que no estén mencionadas en los dos párrafos anteriores, el Límite Máximo de Responsabilidad NO se reinstala.</p>
    <p class="s21" style="padding-top: 11pt;padding-left: 39pt;text-indent: 0pt;line-height: 14pt;text-align: center;">Cláusula 5.5.</p>
    <p class="s21" style="padding-left: 39pt;text-indent: 0pt;line-height: 14pt;text-align: center;">Valuación y reparación del Daño en caso de Siniestro</p>
    <ol id="l167">
      <li data-list-text="1.">
        <p class="s13" style="padding-top: 10pt;padding-left: 60pt;text-indent: -21pt;text-align: justify;">
          <a name="a166">Valuación del daño</a>
        </p>
        <p style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">Si el <b>Asegurado </b>ha cumplido con la obligación que le impone la Cláusula &quot;Obligaciones del Asegurado en caso de Siniestro&quot;, y el <b>Vehículo Asegurado </b>se encuentra libre de cualquier detención, incautación, confiscación, secuestro, decomiso o embargo u otra situación semejante producida por órdenes de las autoridades legalmente reconocidas con motivo de sus funciones que intervengan en dichos actos, <b>L A T I N O </b>tendrá la obligación de iniciar sin demora la <b>Valuación </b>de los <b>Daños</b>, una vez conocida la ubicación física del <b>Vehículo Asegurado</b>. </p>
        <p class="s13" style="padding-top: 7pt;padding-left: 39pt;text-indent: 0pt;text-align: justify;">Contratante <span class="p">ha procedido a su reparación o desarmado antes de que </span>L A T I N O <span class="p">realice la</span>
        </p>
        <p class="s13" style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">Valuación <span class="p">y declare procedente la reclamación.</span>
        </p>
        <p style="text-indent: 0pt;text-align: center;">
          <br />
        </p>
        <p class="s13" style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">L A T I N O <span class="p">iniciará la </span>Valuación <span class="p">de los </span>Daños <span class="p">sufridos por el </span>Vehículo Asegurado <span class="p">dentro de las 72 (setenta y dos) horas siguientes a partir del momento del aviso del </span>Siniestro <span class="p">, siempre y cuando se haya cumplido lo señalado en los párrafos anteriores, de lo contrario el </span>Contratante <span class="p">queda facultado para proceder a la reparación de los mismos y exigir su importe a </span>L A T I N O <span class="p">en los términos de esta </span>Póliza <span class="p">.</span>
        </p>
        <p style="padding-top: 11pt;padding-left: 39pt;text-indent: 0pt;text-align: justify;">De igual forma no reconocerá los <b>Daños </b>o descomposturas que presente el <b>Vehículo Asegurado </b>que provengan <b>Siniestro</b>s o <b>Fallas Mecánicas </b>previas al <b>Siniestro </b>declarado. Si por causas imputables al <b>Contratante </b>no se pueda llevar a cabo la <b>Valuación</b>, <b>L A T I N O </b>sólo procederá a realizarla hasta que la causa se extinga. </p>
        <p style="text-indent: 0pt;text-align: center;">
          <br />
        </p>
        <p style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">Terminada la <b>Valuación </b>y reconocida su responsabilidad y sin perjuicio de lo señalado en el Artículo 71 de la Ley Sobre el Contrato de Seguro, <b>L A T I N O </b>indemnizará por el importe de la <b>Valuación </b>de los <b>Daños </b>sufridos en la fecha del <b>Siniestro</b>, o bien, reparará y/o repondrá el bien afectado por otro de características similares al contratado, a satisfacción del <b>Asegurado</b>. </p>
        <p style="text-indent: 0pt;text-align: center;">
          <br />
        </p>
        <p style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">La indemnización en <b>Pérdidas Parciales </b>comprenderá el valor de refacciones y mano de obra. Por lo que se refiere a <b>Pérdidas Totales</b>, se estará al <b>Valor Comercial </b>del <b>Vehículo Asegurado </b>o la <b>Suma Asegurada </b>convenida. </p>
        <p style="text-indent: 0pt;text-align: center;">
          <br />
        </p>
        <p style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">En todo caso, al hacerse la <b>Valuación </b>de la pérdida, se tomará en cuenta el precio de venta al público de refacciones o accesorios, menos descuentos obtenidos en la fecha del <b>Siniestro</b>. </p>
        <p class="s16" style="padding-top: 11pt;padding-left: 39pt;text-indent: 0pt;text-align: justify;">“ <b>Artículo 71 de la Ley sobre el Contrato de Seguro</b>. El crédito que resulte del contrato de seguro vencerá treinta días después de la fecha en que la empresa haya recibido los documentos e informaciones que le permitan conocer el fundamento de la reclamación. Será nula la cláusula en que se pacte que el crédito no podrá exigirse sino después de haber reconocido por la empresa o comprobado en juicio.” </p>
        <p style="text-indent: 0pt;text-align: center;">
          <br />
        </p>
      </li>
      <li data-list-text="2.">
        <p class="s13" style="padding-left: 60pt;text-indent: -21pt;text-align: justify;">
          <a name="a167">Condiciones al Daño aplicable</a>
        </p>
        <p class="s13" style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">L A T I N O <span class="p">podrá optar por reparar el </span>Vehículo Asegurado <span class="p">o indemnizar por el importe de la </span>Valuación <span class="p">de los </span>Daños <span class="p">sufridos en la fecha del </span>Siniestro <span class="p">una vez recibidos los documentos e informaciones que le permitan reconocer el fundamento de la reclamación en un lapso no mayor a 30 (treinta) días hábiles, con base a lo siguiente:</span>
        </p>
        <ol id="l168">
          <li data-list-text="I.">
            <p style="padding-top: 11pt;padding-left: 81pt;text-indent: -21pt;text-align: justify;">Cuando <b>L A T I N O </b>opte por la reparación de vehículos en términos del Artículo 116 de la Ley Sobre el Contrato del Seguro, lo hará del conocimiento expreso del <b>Asegurado </b>o <b>Beneficiario </b>considerando que: </p>
            <ol id="l169">
              <li data-list-text="a)">
                <p style="padding-top: 10pt;padding-left: 102pt;text-indent: -21pt;text-align: justify;">Independientemente de la antigüedad del vehículo, los centros de reparación previstos serán los talleres multimarcas o especializados que <b>L A T I N O </b>proponga, y el <b>Asegurado </b>/ <b>Beneficiario </b>elija. </p>
                <p style="padding-top: 4pt;text-indent: 0pt;text-align: center;">
                  <br />
                </p>
              </li>
              <li data-list-text="b)">
                <p style="padding-left: 102pt;text-indent: -21pt;text-align: justify;">Para los casos en los que la cobertura Agencia +5 haya sido contratada y se indique en la <b>Carátula de la Póliza </b>como amparada, los centros de reparación previstos serán las agencias o distribuidores de la marca con los que <b>L A T I N O </b>tenga convenio o aquellos talleres que presten servicios de manera supletoria y que estén reconocidos y autorizados por la marca en la localidad más cercana a la ocurrencia del <b>Siniestro</b>. </p>
                <p style="padding-top: 4pt;text-indent: 0pt;text-align: center;">
                  <br />
                </p>
              </li>
              <li data-list-text="c)">
                <p class="s9" style="padding-left: 102pt;text-indent: -21pt;text-align: justify;">
                  <span class="p">Para vehículos dentro de sus primeros 24 (veinticuatro) meses de uso a partir de la </span>
                  <span class="s24">fecha de la factura de origen, los centros de reparación en convenio con </span>L A T I N O <span class="s11">, serán las agencias o distribuidores de la marca con los que </span>L A T I N O
                </p>
                <p class="s11" style="padding-top: 3pt;padding-left: 102pt;text-indent: 0pt;text-align: justify;">
                  <a name="a168">tenga convenio o aquellos talleres que presten sus servicios de manera supletoria y que estén reconocidos y autorizados por la marca en la localidad más cercana a la ocurrencia del </a>
                  <b>Siniestro</b>.
                </p>
              </li>
              <li data-list-text="d)">
                <p style="padding-top: 11pt;padding-left: 102pt;text-indent: -21pt;text-align: justify;">Para vehículos con más de 24 (veinticuatro) meses de uso a partir de la fecha de la factura de origen; invariablemente los centros de reparación serán los talleres o proveedores especializados con los que <b>L A T I N O </b>tenga convenio en la República Mexicana. </p>
                <p style="text-indent: 0pt;text-align: center;">
                  <br />
                </p>
              </li>
              <li data-list-text="e)">
                <p style="padding-left: 102pt;text-indent: -21pt;text-align: justify;">Los plazos de entrega de vehículos reparados están sujetos a la disponibilidad de recursos del centro de reparación seleccionado, con un periodo máximo de entrega de 30 (treinta) días hábiles. Estos plazos podrán ampliarse únicamente y hasta por</p>
                <p style="padding-left: 102pt;text-indent: 0pt;text-align: justify;">15 (quince) días hábiles adicionales, lo anterior cuando existan circunstancias desfavorables en el abastecimiento comprobable de partes y componentes dañados, situación que <b>L A T I N O </b>podrá hacer del conocimiento del <b>Asegurado </b>y/o <b>Contratante</b>, de forma oportuna. </p>
                <p style="text-indent: 0pt;text-align: center;">
                  <br />
                </p>
                <p style="padding-left: 102pt;text-indent: 0pt;text-align: justify;">En caso de incumplimiento por parte de <b>L A T I N O</b>, el <b>Asegurado </b>y/o <b>Contratante </b>podrá solicitar el pago del interés moratorio conforme a la cláusula correspondiente de las presentes <b>Condiciones Generales</b>. </p>
                <p style="text-indent: 0pt;text-align: center;">
                  <br />
                </p>
              </li>
              <li data-list-text="f)">
                <p style="padding-left: 102pt;text-indent: -21pt;text-align: justify;">La disponibilidad de las partes y refacciones está sujeta a las existencias por parte del fabricante, importador y/o distribuidor por lo que no es materia de este <b>Contrato </b>la exigibilidad a <b>L A T I N O </b>de su localización en los casos de desabasto. Si concluida la <b>Valuación</b>, se determinan que existe desabasto de las partes y/o refacciones necesarias para la reparación, y en consecuencia no se pueda cumplir con los plazos determinados en el inciso b) del apartado I de la presente cláusula, <b>L A T I N O </b>podrá optar por la indemnización de la reparación conforme al inciso a) del apartado II de la presente cláusula. </p>
                <p style="text-indent: 0pt;text-align: center;">
                  <br />
                </p>
              </li>
              <li data-list-text="g)">
                <p style="padding-left: 102pt;text-indent: -21pt;text-align: justify;">En caso de reparación del vehículo, las partes y/o refacciones serán sustituidas sólo en los casos donde su reparación no sea garantizable o dañe su estética de manera visible.</p>
                <p style="text-indent: 0pt;text-align: center;">
                  <br />
                </p>
              </li>
              <li data-list-text="h)">
                <p style="padding-left: 102pt;text-indent: -21pt;text-align: justify;">En el caso de reparación de <b>Vehículos Regularizados</b>, <b>Fronterizos </b>o <b>Legalmente Importados</b>, <b>L A T I N O </b>podrá optar por la reparación del vehículo o la indemnización correspondiente bajo lo establecido en el inciso a) del apartado I. </p>
              </li>
              <li data-list-text="i)">
                <p style="padding-top: 11pt;padding-left: 102pt;text-indent: -21pt;text-align: justify;">La garantía de la reparación del vehículo estará sujeta a la que ofrece el fabricante, importador y/o distribuidor de las refacciones o partes, así como a las previstas por el taller o agencia en cuanto a su mano de obra. No obstante lo anterior, en la eventualidad de un <b>Daño </b>no detectado al momento de la valoración y que sea a consecuencia inmediata y directa del <b>Siniestro </b>reclamado, el <b>Asegurado </b>dará aviso a <b>L A T I N O </b>y presentará el vehículo para una nueva <b>Valuación </b>y, en su caso, su reparación correspondiente. </p>
                <p style="text-indent: 0pt;text-align: center;">
                  <br />
                </p>
              </li>
            </ol>
          </li>
          <li data-list-text="II.">
            <p style="padding-left: 61pt;text-indent: -17pt;line-height: 11pt;text-align: center;">Cuando <b>L A T I N O </b>opte por cubrir la indemnización lo hará del conocimiento expreso del </p>
            <p class="s13" style="padding-left: 57pt;text-indent: 0pt;line-height: 11pt;text-align: center;">Asegurado <span class="p">o </span>Beneficiario <span class="p">, quien podrá:</span>
            </p>
            <p style="text-indent: 0pt;text-align: center;">
              <br />
            </p>
            <ol id="l170">
              <li data-list-text="a)">
                <p style="padding-left: 102pt;text-indent: -21pt;text-align: justify;">Solicitar el pago de <b>Daños</b>, previa <b>Valuación </b>realizada por <b>L A T I N O </b>que será el importe de la indemnización. </p>
              </li>
            </ol>
          </li>
        </ol>
      </li>
    </ol>
    <p style="padding-left: 107pt;text-indent: -4pt;text-align: justify;">La intervención de <b>L A T I N O </b>en la <b>Valuación </b>de los <b>Daños </b>o cualquier ayuda que ésta, sus empleados o representantes, presten al <b>Asegurado </b>no implican aceptación o responsabilidad alguna respecto del <b>Siniestro </b>reclamado. </p>
    <p style="padding-left: 107pt;text-indent: 0pt;text-align: justify;">Para el eficaz cumplimiento del Artículo 71 de la Ley Sobre el Contrato de Seguro,</p>
    <p style="padding-top: 3pt;padding-left: 107pt;text-indent: 0pt;text-align: center;">se entenderá que el <b>Asegurado </b>ha cumplido con su obligación, entregando a <b>L A T I N O </b>la documentación que le haya sido requerida en caso de <b>Siniestro</b>. </p>
    <p class="s21" style="padding-top: 11pt;padding-left: 39pt;text-indent: 0pt;text-align: center;">Cláusula 5.6.</p>
    <p class="s21" style="padding-left: 39pt;text-indent: 0pt;text-align: center;">Sumas Aseguradas y Bases de Indemnización</p>
    <p style="text-indent: 0pt;text-align: center;">
      <br />
    </p>
    <p style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">En cualquier caso, para la indemnización que corresponda se deberá tomar en consideración los artículos 86, 91, 92 y 95 de la Ley Sobre el Contrato de Seguro.</p>
    <p style="text-indent: 0pt;text-align: center;">
      <br />
    </p>
    <p class="s16" style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">
      <span class="s55">Artículo 86: </span>“El seguro contra los <span class="p">daños</span>, la empresa aseguradora responde solamente por el <b>Daño </b>causado hasta el límite de la suma y el valor real asegurados. La empresa responderá de la pérdida del provecho o interés que se obtenga de la cosa asegurada, si así se conviene expresamente”.
    </p>
    <p class="s16" style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">
      <span class="s55">Artículo 91: </span>“Para fijar la indemnización del seguro se tendrán en cuenta el valor del interés asegurado en el momento de la realización del <b>Siniestro</b>”.
    </p>
    <p class="s16" style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">
      <span class="s55">Artículo 92: </span>“Salvo convenio en contrario, si la <b>Suma Asegurada </b>es inferior al interés asegurado, la empresa aseguradora responderá de manera proporcional al <b>Daño </b>causado”.
    </p>
    <p class="s16" style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">
      <span class="s55">Artículo 95: </span>“Cuando se celebre un contrato de seguro por una suma superior al valor real de la cosa asegurada y ha existido dolo o mala fe de una de las partes, la otra tendrá derecho para demandar u oponer la nulidad y exigir la indemnización que corresponda por <span class="p">daños </span>y perjuicios. Si no hubo dolo o mala fe, el contrato será válido; pero únicamente hasta la concurrencia del valor real de la cosa asegurada, teniendo ambas partes la facultad de pedir la reducción de la <b>Suma Asegurada</b>. La empresa aseguradora no tendrá derecho a las <b>Prima</b>s por el excedente; pero le pertenecerán las <b>Prima</b>s vencidas y la <b>Prima </b>por el período en curso, en el momento del aviso del <b>Asegurado</b>”.
    </p>
    <ol id="l171">
      <li data-list-text="1.">
        <p class="s12" style="padding-top: 11pt;padding-left: 60pt;text-indent: -21pt;text-align: justify;">
          <a name="a169">Límites Máximos de Responsabilidad</a>
        </p>
        <p style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">El <b>Límite Máximo de Responsabilidad </b>para <b>L A T I N O </b>en cada <b>Cobertura </b>se especifica en el apartado que le corresponde, o bien, en la <b>Carátula de la Póliza</b>. Dicho límite representa el importe o responsabilidad máxima que <b>L A T I N O </b>está obligada a pagar o restituir como consecuencia de la ocurrencia de un <b>Siniestro</b>. </p>
        <p style="text-indent: 0pt;text-align: center;">
          <br />
        </p>
        <p class="s13" style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">
          <span class="p">Para las coberturas básicas de las secciones de Daños Materiales y Robo, en caso de que </span>L A T I N O <span class="p">declare la </span>Pérdida Total <span class="p">del </span>Vehículo Asegurado <span class="p">, </span>
          <u>se indemnizará de acuerdo con la</u>
          <u>modalidad</u>
          <span class="p">contratada según se especifique en la </span>Carátula de la Póliza <span class="p">, conforme a lo siguiente:</span>
        </p>
        <p style="text-indent: 0pt;text-align: center;">
          <br />
        </p>
        <p class="s12" style="padding-left: 39pt;text-indent: 0pt;line-height: 11pt;text-align: justify;">
          <a name="a170">Valor Comercial para Vehículos en el primer año de uso</a>
        </p>
        <p class="s13" style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">L A T I N O <span class="p">indemnizará el </span>Valor Comercial <span class="p">del vehículo, entendiéndose por este el </span>Valor de Nuevo <span class="p">o valor de facturación menos la depreciación que por uso le corresponda, determinada entre la fecha de compra del vehículo y la fecha del </span>Siniestro <span class="p">, sin exceder el </span>Valor Factura <span class="p">.</span>
        </p>
        <p style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">El porcentaje de depreciación que se aplicará por cada mes de uso será del 1.66%.</p>
        <p class="s12" style="padding-top: 11pt;padding-left: 39pt;text-indent: 0pt;text-align: justify;">
          <a name="a171">Valor Comercial para Vehículos de más de doce meses de uso</a>
        </p>
        <p style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">Para <b>Vehículos Residentes</b>, de acuerdo con la marca, tipo y modelo del <b>Vehículo Asegurado</b>, se entenderá como <b>Valor Comercial </b>a la cantidad que resulte más alta entre los valores de “venta” consignados en las guías automovilísticas denominadas “Guía EBC”, “Guía Autométrica” y/o “Guía CESVI VIN PLUS”, que se encuentren vigentes a la fecha del <b>Siniestro</b>, sin exceder el <b>Valor Factura</b>. </p>
        <p style="text-indent: 0pt;text-align: center;">
          <br />
        </p>
        <p class="s12" style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">
          <a name="a172">Valor Comercial para Vehículos Fronterizo y Regularizados</a>
        </p>
        <p style="padding-left: 36pt;text-indent: 0pt;text-align: justify;">Para <b>Vehículos Fronterizos </b>y/o <b>Regularizados </b>que sean declarados <b>Pérdida Total </b>por <b>Daño </b>material o <b>Robo Total</b>, el importe de la indemnización que corresponda será determinado de la siguiente manera: </p>
        <p style="padding-left: 36pt;text-indent: 0pt;text-align: justify;">Para vehículos cuyo ingreso al territorio nacional sea por la frontera con los Estados Unidos de América, su <b>Valor Comercial </b>para efectos de determinar el importe de la indemnización será igual al valor de compra de la Guía N.A.D.A. (Oficial Older Used Car Guide) que esté vigente al momento del <b>Siniestro</b>, o en su caso aquella guía que la sustituya, más los gastos legalmente comprobados </p>
        <p style="padding-top: 3pt;padding-left: 36pt;text-indent: 0pt;text-align: justify;">de su importación menos el monto de <b>Deducible </b>que corresponda. </p>
        <p style="padding-top: 11pt;padding-left: 36pt;text-indent: 0pt;text-align: justify;">La Guía N.A.D.A. (Oficial Older Used Car Guide), es publicada de manera electrónica a través de la página web correspondiente.</p>
        <p style="padding-top: 11pt;padding-left: 39pt;text-indent: 0pt;text-align: justify;">Tratándose de <b>Vehículos Fronterizos </b>y/o <b>Regularizados</b>, que hayan sido indemnizados previamente por cualquier compañía aseguradora, o bien que en el documento que acredite la propiedad se haga constar la leyenda <b>Salvamento </b>o “salvage” (en inglés), la <b>Suma Asegurada </b>de las coberturas básicas de la secciones de Daños Materiales y Robo, se determinará con base a la guía N.A.D.A. (Oficial Older Used Car Guide) y en función del costo de adquisición de la unidad siniestrada más el valor demostrable de las refacciones y/o reparaciones que se hayan efectuado a los vehículos con posterioridad a la compra del <b>Salvamento</b>, teniendo en todos los casos como tope máximo el 85% del valor que aparece en la <b>Carátula de la Póliza</b>. </p>
        <p style="text-indent: 0pt;text-align: center;">
          <br />
        </p>
        <p style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">En caso de que en la <b>Carátula de la Póliza </b>se mencione que la unidad está siendo amparada a <b>Valor Convenido </b>y se indique que es <b>Salvamento </b>no se deberá realizar depreciación alguna, en caso contrario aplicará la base estipulada en el párrafo anterior. </p>
        <p style="padding-top: 11pt;padding-left: 39pt;text-indent: 0pt;text-align: justify;">En caso de <b>Pérdidas Parciales</b>, <b>L A T I N O </b>indemnizará el <b>Valor Factura </b>de las refacciones nuevas o a falta de estas, refacciones usadas, en caso de inexistencia de estas, se indemnizará el importe de las mismas a satisfacción del <b>Asegurado</b>, incluyendo la mano de obra más los impuestos que se generen en la facturación. </p>
        <p style="padding-top: 11pt;padding-left: 39pt;text-indent: 0pt;text-align: justify;">En caso de que ninguno de dichos instrumentos contemple al <b>Vehículo Asegurado</b>, las partes podrán recurrir a otras guías especializadas de valores de vehículos que se hubieren publicado a la fecha del <b>Siniestro</b>. </p>
        <p style="text-indent: 0pt;text-align: center;">
          <br />
        </p>
        <p class="s13" style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">
          <a name="a173">Valor factura</a>
        </p>
        <p style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">Tratándose de vehículos último modelo, el <b>Valor Factura </b>se determinará conforme al valor de la factura expedida por el distribuidor autorizado, más los gastos arancelarios generados e impuestos correspondientes, según sea el caso. </p>
        <p style="text-indent: 0pt;text-align: center;">
          <br />
        </p>
        <p class="s13" style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">
          <a name="a174">Valor convenido</a>
        </p>
        <p style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">Para efectos de este <b>Contrato</b>, se entenderá por <b>Valor Convenido </b>del vehículo, el que acuerden </p>
        <p class="s13" style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">L A T I N O <span class="p">y el </span>Asegurado <span class="p">.</span>
        </p>
        <p style="text-indent: 0pt;text-align: center;">
          <br />
        </p>
        <p class="s13" style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">
          <a name="a175">Reposición de Auto</a>
        </p>
        <p style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">La reposición del <b>Vehículo Asegurado </b>por otro de la misma marca, tipo, año–modelo y características estipuladas en la <b>Carátula de la Póliza </b>siempre y cuando la <b>Pérdida Total </b>se presente dentro de los primeros doce meses de uso del vehículo, contados desde la fecha en que el <b>Vehículo Asegurado </b>fue facturado como unidad nueva por una agencia autorizada y la fecha de ocurrencia del <b>Siniestro</b>. </p>
        <p style="text-indent: 0pt;text-align: center;">
          <br />
        </p>
        <p style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">Si no hubiera en el mercado nacional una unidad nueva del mismo año–modelo que la unidad afectada, la reposición se efectuará considerando un vehículo último modelo de la misma marca, tipo y características.</p>
        <p style="text-indent: 0pt;text-align: center;">
          <br />
        </p>
        <p style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">Si al momento del <b>Siniestro </b>no existiera en el mercado nacional un vehículo de las mismas características a las del <b>Vehículo Asegurado</b>, se indemnizará con base en el valor consignado en la factura original, al que se le adicionará la variación porcentual del Índice Nacional de Precios al Consumidor, calculando dicha variación entre la fecha de contratación del seguro y la fecha del <b>Siniestro</b>. </p>
        <p style="text-indent: 0pt;text-align: center;">
          <br />
        </p>
        <p style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">Si el <b>Siniestro </b>se presenta después de los primeros doce meses contados desde la fecha en que el <b>Vehículo Asegurado </b>fue facturado como unidad nueva vendida por una agencia autorizada, se indemnizará el <b>Valor Comercial </b>del vehículo a la fecha del <b>Siniestro</b>. </p>
        <p class="s13" style="padding-top: 3pt;padding-left: 39pt;text-indent: 0pt;text-align: justify;">
          <a name="a176">Vehículo de Salvamento</a>
        </p>
        <p style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">No obstante lo señalado en la <b>Carátula de la Póliza </b>respecto al monto de la indemnización y tratándose de vehículos facturados por una institución financiera (SALVAMENTOS) con motivo de una <b>Pérdida Total </b>por <b>Daños </b>materiales o robo, la indemnización que le corresponderá por <b>Pérdida Total </b>por <b>Daños </b>materiales o por robo será el <b>Valor Comercial </b>de las publicaciones especializadas Guía EBC, o Guía Autométrica o Guía CESVI VIN PLUS o en su caso aquellas guías que las sustituyan, aplicándole una depreciación del 25% (veinticinco por ciento). </p>
        <p class="s13" style="padding-top: 11pt;padding-left: 39pt;text-indent: 0pt;text-align: justify;">
          <a name="a177">Pólizas Multianuales</a>
        </p>
        <p style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">Para <b>Póliza</b>s cuya vigencia sea mayor a un año o multianuales, para los vehículos denominados como último modelo o de cero kilómetros, el monto a indemnizar corresponderá a: </p>
        <ol id="l172">
          <li data-list-text="a)">
            <p style="padding-left: 81pt;text-indent: -21pt;line-height: 88%;text-align: justify;">Al <b>Valor Factura </b>si el <b>Siniestro </b>ocurre en el primer año y el <b>Valor Comercial </b>en los <span class="s24">años subsecuentes de vigencia del seguro, determinado éste último conforme a lo estipulado en las definiciones, si se contrató </span>
              <span class="s9">Valor Factura </span>
              <span class="s11">a un año</span>
            </p>
          </li>
          <li data-list-text="b)">
            <p style="padding-left: 81pt;text-indent: -21pt;line-height: 12pt;text-align: justify;">Al <b>Valor Factura </b>si el <b>Siniestro </b>ocurre en el primer o segundo año y el <b>Valor Comercial</b>
            </p>
          </li>
        </ol>
        <p style="padding-left: 81pt;text-indent: 0pt;text-align: justify;">en los años subsecuentes de vigencia del seguro, determinado éste último conforme a lo estipulado en las definiciones anteriores de esta cláusula, si se contrató <b>Valor Factura </b>a dos años. </p>
        <p class="s13" style="padding-top: 10pt;padding-left: 39pt;text-indent: 0pt;text-align: justify;">
          <a name="a178">Vehículos clásicos</a>
        </p>
        <p style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">Vehículos considerados como &quot;antiguos y clásicos&quot;, según definición establecida en la Cláusula &quot;Definiciones&quot;, la <b>Suma Asegurada </b>o <b>Valor Convenido</b>, tanto a la contratación como en caso de <b>Siniestro </b>estará determinada por avalúo realizado a través de peritos valuadores. </p>
        <p style="text-indent: 0pt;text-align: center;">
          <br />
        </p>
        <p class="s13" style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">
          <a name="a179">Adaptaciones, conversiones y/o equipo especial</a>
        </p>
        <p style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">En el caso de que se haya contratado para los vehículos descritos en los puntos anteriores, la cobertura de Adaptaciones, Conversiones y Equipo Especial, la <b>Suma Asegurada </b>de las mismas deberá fijarse de acuerdo al valor que tengan, soportándose por avalúo o factura y en caso de <b>Siniestro</b>, el valor a indemnizar será éste, sin exceder del <b>Valor Comercial </b>que tenga el <b>Equipo Especial </b>y/o la <b>Adaptación </b>y/o <b>Conversión </b>al momento del <b>Siniestro</b>. </p>
        <p style="text-indent: 0pt;text-align: center;">
          <br />
        </p>
        <p class="s13" style="padding-left: 39pt;text-indent: 0pt;text-align: center;">
          <a name="a180">Blindaje</a>
        </p>
        <p style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">Tratándose del blindaje del <b>Vehículo Asegurado </b>cuando éste no haya sido instalado de fábrica, <b>L A T I N O </b>indemnizará de acuerdo al valor de la factura del blindaje descontando el <b>Deducible </b>y la depreciación que por uso le corresponda entre la fecha de instalación del blindaje del vehículo y la fecha del <b>Siniestro</b>. El porcentaje de depreciación que se aplicará será el que le corresponda de acuerdo con la siguiente tabla: </p>
        <p style="text-indent: 0pt;text-align: center;">
          <br />
        </p>
        <table style="border-collapse:collapse;margin-left:143.39pt" cellspacing="0">
          <tr style="height:23pt">
            <td style="width:63pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt" bgcolor="#DEEAF6">
              <p class="s39" style="padding-left: 22pt;padding-right: 11pt;text-indent: -10pt;text-align: center;">Años de Uso</p>
            </td>
            <td style="width:86pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt" bgcolor="#DEEAF6">
              <p class="s39" style="padding-left: 12pt;text-indent: 18pt;text-align: center;">% de depreciación</p>
            </td>
            <td style="width:85pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt" bgcolor="#DEEAF6">
              <p class="s39" style="padding-left: 8pt;text-indent: 9pt;text-align: center;">% sobre la indemnización</p>
            </td>
          </tr>
          <tr style="height:12pt">
            <td style="width:63pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
              <p class="s40" style="padding-left: 1pt;text-indent: 0pt;line-height: 11pt;text-align: center;">0</p>
            </td>
            <td style="width:86pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
              <p class="s40" style="padding-left: 2pt;padding-right: 1pt;text-indent: 0pt;line-height: 11pt;text-align: center;">15%</p>
            </td>
            <td style="width:85pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
              <p class="s40" style="text-indent: 0pt;line-height: 11pt;text-align: center;">85%</p>
            </td>
          </tr>
          <tr style="height:12pt">
            <td style="width:63pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
              <p class="s40" style="padding-left: 1pt;text-indent: 0pt;line-height: 11pt;text-align: center;">1</p>
            </td>
            <td style="width:86pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
              <p class="s40" style="padding-left: 2pt;padding-right: 1pt;text-indent: 0pt;line-height: 11pt;text-align: center;">15%</p>
            </td>
            <td style="width:85pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
              <p class="s40" style="text-indent: 0pt;line-height: 11pt;text-align: center;">85%</p>
            </td>
          </tr>
          <tr style="height:12pt">
            <td style="width:63pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
              <p class="s40" style="padding-left: 1pt;text-indent: 0pt;line-height: 11pt;text-align: center;">2</p>
            </td>
            <td style="width:86pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
              <p class="s40" style="padding-left: 2pt;padding-right: 1pt;text-indent: 0pt;line-height: 11pt;text-align: center;">30%</p>
            </td>
            <td style="width:85pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
              <p class="s40" style="text-indent: 0pt;line-height: 11pt;text-align: center;">70%</p>
            </td>
          </tr>
          <tr style="height:12pt">
            <td style="width:63pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
              <p class="s40" style="padding-left: 1pt;text-indent: 0pt;line-height: 11pt;text-align: center;">3</p>
            </td>
            <td style="width:86pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
              <p class="s40" style="padding-left: 2pt;padding-right: 1pt;text-indent: 0pt;line-height: 11pt;text-align: center;">45%</p>
            </td>
            <td style="width:85pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
              <p class="s40" style="text-indent: 0pt;line-height: 11pt;text-align: center;">55%</p>
            </td>
          </tr>
          <tr style="height:12pt">
            <td style="width:63pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
              <p class="s40" style="padding-left: 1pt;text-indent: 0pt;line-height: 11pt;text-align: center;">4</p>
            </td>
            <td style="width:86pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
              <p class="s40" style="padding-left: 2pt;padding-right: 1pt;text-indent: 0pt;line-height: 11pt;text-align: center;">60%</p>
            </td>
            <td style="width:85pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
              <p class="s40" style="text-indent: 0pt;line-height: 11pt;text-align: center;">40%</p>
            </td>
          </tr>
          <tr style="height:12pt">
            <td style="width:63pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
              <p class="s40" style="padding-left: 1pt;text-indent: 0pt;line-height: 11pt;text-align: center;">5</p>
            </td>
            <td style="width:86pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
              <p class="s40" style="padding-left: 2pt;padding-right: 1pt;text-indent: 0pt;line-height: 11pt;text-align: center;">70%</p>
            </td>
            <td style="width:85pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
              <p class="s40" style="text-indent: 0pt;line-height: 11pt;text-align: center;">30%</p>
            </td>
          </tr>
          <tr style="height:12pt">
            <td style="width:63pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
              <p class="s40" style="padding-left: 1pt;text-indent: 0pt;line-height: 11pt;text-align: center;">6</p>
            </td>
            <td style="width:86pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
              <p class="s40" style="padding-left: 2pt;padding-right: 1pt;text-indent: 0pt;line-height: 11pt;text-align: center;">80%</p>
            </td>
            <td style="width:85pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
              <p class="s40" style="text-indent: 0pt;line-height: 11pt;text-align: center;">20%</p>
            </td>
          </tr>
          <tr style="height:12pt">
            <td style="width:63pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
              <p class="s40" style="padding-left: 1pt;text-indent: 0pt;line-height: 11pt;text-align: center;">7</p>
            </td>
            <td style="width:86pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
              <p class="s40" style="padding-left: 2pt;padding-right: 1pt;text-indent: 0pt;line-height: 11pt;text-align: center;">90%</p>
            </td>
            <td style="width:85pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
              <p class="s40" style="text-indent: 0pt;line-height: 11pt;text-align: center;">10%</p>
            </td>
          </tr>
          <tr style="height:12pt">
            <td style="width:63pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
              <p class="s40" style="padding-left: 1pt;text-indent: 0pt;line-height: 11pt;text-align: center;">8 o más</p>
            </td>
            <td style="width:86pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
              <p class="s40" style="padding-left: 2pt;text-indent: 0pt;line-height: 11pt;text-align: center;">100%</p>
            </td>
            <td style="width:85pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
              <p class="s40" style="text-indent: 0pt;line-height: 11pt;text-align: center;">0%</p>
            </td>
          </tr>
        </table>
        <p style="text-indent: 0pt;text-align: center;">
          <br />
        </p>
        <p class="s13" style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">
          <a name="a181">Facturación electrónica</a>
        </p>
        <p style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">Con motivo de la entrada en vigor de las reformas fiscales relativas a la facturación electrónica, para el pago de una <b>Pérdida Total</b>, amparada por la presente <b>Póliza </b>de seguro, es requisito la expedición del Comprobante Fiscal Digital por Internet (CFDI) correspondiente. Este documento tiene la </p>
        <p style="padding-top: 7pt;padding-left: 39pt;text-indent: 0pt;text-align: justify;">finalidad de transmitir la propiedad del vehículo a <b>L A T I N O</b>, deslindando al <b>Asegurado </b>de cualquier trámite después de la fecha de emisión del CFDI. </p>
        <p style="text-indent: 0pt;text-align: center;">
          <br />
        </p>
        <p style="padding-left: 39pt;text-indent: 1pt;text-align: justify;">Lo anterior en cumplimiento a los artículos 27, 29 y 29-A del Código Fiscal de la Federación y Reglas Misceláneas, los cuales establecen la obligación de todos los contribuyentes de emitir facturas electrónicas.</p>
        <p style="text-indent: 0pt;text-align: center;">
          <br />
        </p>
        <p style="padding-left: 39pt;text-indent: 1pt;text-align: center;">
          <a href="http://www.sat.gob.mx/" class="a" target="_blank">Los requisitos para darse de alta ante la Secretaría de Hacienda y Crédito Público y tramitar su CFDI pueden ser consultados en la página del SAT </a>
          <a href="http://www.sat.gob.mx/" class="s56" target="_blank">www.sat.gob.mx</a>
          <a href="http://www.sat.gob.mx/" target="_blank">.</a>
        </p>
        <p style="padding-top: 11pt;padding-left: 39pt;text-indent: 0pt;text-align: justify;">En caso de que la persona física no se encuentre dada de alta ante la Secretaría de Hacienda y Crédito Público, tendrá la opción de firmar una “CARTA CONSENTIMIENTO” para que <b>L A T I N O </b>en su nombre expida el CFDI bajo protesta de decir verdad. </p>
        <p style="padding-top: 11pt;padding-left: 39pt;text-indent: 1pt;text-align: justify;">Toda vez que las disposiciones fiscales son de estricta aplicación, <b>L A T I N O </b>no estará obligada a indemnizar la <b>Pérdida Total </b>si por actos y omisiones del <b>Asegurado </b>o <b>Tercero </b>se impide o limita el cumplimiento de la emisión del CFDI, en cuyo caso las partes podrán acordar el pago de <b>Daños</b>. Cuando <b>L A T I N O </b>opte por reponer el bien afectado por otro de características similares, lo pondrá a la consideración del <b>Asegurado </b>o <b>Beneficiario </b>de manera expresa, indicándole la ubicación del bien susceptible para que el <b>Asegurado </b>acuda a su revisión, valoración y, en su caso, aceptación. La garantía en este caso estará sujeta a la que el fabricante, distribuidor, lote de vehículos o importador ofrezca normalmente al mercado. </p>
      </li>
      <li data-list-text="2.">
        <p class="s12" style="padding-top: 11pt;padding-left: 60pt;text-indent: -21pt;text-align: justify;">
          <a name="a182">Base de indemnización en caso de Pérdida Parciales</a>
        </p>
        <p style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">Cuando el costo del <b>Daño </b>causado al <b>Vehículo Asegurado </b>esté dentro de los límites establecidos en la definición de <b>Pérdida Parcial </b>hecha en la Cláusula &quot;Definiciones&quot; de las presentes <b>Condiciones Generales</b>, la indemnización corresponderá al monto del <b>Daño </b>valuado por <b>L A T I N O</b>, menos el monto del <b>Deducible </b>que para el caso corresponda. En todo caso, al hacerse la <b>Valuación </b>de la pérdida se tomará en cuenta el precio de refacciones o accesorios en la fecha del <b>Siniestro</b>. Cuando ocurra un <b>Siniestro </b>amparado por el <b>Contrato</b>, en donde resulten dañados componentes internos o externos del motor y/o de la transmisión del <b>Vehículo Asegurado</b>, <b>L A T I N O </b>aplicará un porcentaje de depreciación o demérito por el uso que tengan, de acuerdo a lo siguiente: </p>
        <p style="text-indent: 0pt;text-align: center;">
          <br />
        </p>
        <table style="border-collapse:collapse;margin-left:130.07pt" cellspacing="0">
          <tr style="height:17pt">
            <td style="width:163pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt" bgcolor="#DEEAF6">
              <p class="s57" style="padding-top: 3pt;text-indent: 0pt;text-align: center;">Antigüedad</p>
            </td>
            <td style="width:98pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt" bgcolor="#DEEAF6">
              <p class="s57" style="padding-top: 3pt;padding-left: 8pt;text-indent: 0pt;text-align: center;">% de depreciación</p>
            </td>
          </tr>
          <tr style="height:12pt">
            <td style="width:163pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
              <p class="s58" style="padding-left: 5pt;text-indent: 0pt;line-height: 10pt;text-align: center;">Hasta 3 meses</p>
            </td>
            <td style="width:98pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
              <p class="s58" style="padding-left: 18pt;text-indent: 0pt;line-height: 10pt;text-align: center;">0%</p>
            </td>
          </tr>
          <tr style="height:12pt">
            <td style="width:163pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
              <p class="s58" style="padding-left: 5pt;text-indent: 0pt;line-height: 10pt;text-align: center;">Más de 3 meses y hasta 4 meses</p>
            </td>
            <td style="width:98pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
              <p class="s58" style="padding-left: 18pt;padding-right: 7pt;text-indent: 0pt;line-height: 10pt;text-align: center;">5.0%</p>
            </td>
          </tr>
          <tr style="height:12pt">
            <td style="width:163pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
              <p class="s58" style="padding-left: 5pt;text-indent: 0pt;line-height: 10pt;text-align: center;">Más de 4 meses y hasta 5 meses</p>
            </td>
            <td style="width:98pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
              <p class="s58" style="padding-left: 18pt;padding-right: 7pt;text-indent: 0pt;line-height: 10pt;text-align: center;">5.5%</p>
            </td>
          </tr>
          <tr style="height:12pt">
            <td style="width:163pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
              <p class="s58" style="padding-left: 5pt;text-indent: 0pt;line-height: 10pt;text-align: center;">Más de 5 meses y hasta 6 meses</p>
            </td>
            <td style="width:98pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
              <p class="s58" style="padding-left: 18pt;padding-right: 7pt;text-indent: 0pt;line-height: 10pt;text-align: center;">6.0%</p>
            </td>
          </tr>
          <tr style="height:12pt">
            <td style="width:163pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
              <p class="s58" style="padding-left: 5pt;text-indent: 0pt;line-height: 10pt;text-align: center;">Más de 6 meses y hasta 7 meses</p>
            </td>
            <td style="width:98pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
              <p class="s58" style="padding-left: 18pt;padding-right: 7pt;text-indent: 0pt;line-height: 10pt;text-align: center;">6.5%</p>
            </td>
          </tr>
          <tr style="height:12pt">
            <td style="width:163pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
              <p class="s58" style="padding-left: 5pt;text-indent: 0pt;line-height: 10pt;text-align: center;">Más de 7 meses y hasta 8 meses</p>
            </td>
            <td style="width:98pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
              <p class="s58" style="padding-left: 18pt;padding-right: 7pt;text-indent: 0pt;line-height: 10pt;text-align: center;">7.0%</p>
            </td>
          </tr>
          <tr style="height:12pt">
            <td style="width:163pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
              <p class="s58" style="padding-left: 5pt;text-indent: 0pt;line-height: 10pt;text-align: center;">Más de 8 meses y hasta 9 meses</p>
            </td>
            <td style="width:98pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
              <p class="s58" style="padding-left: 18pt;padding-right: 7pt;text-indent: 0pt;line-height: 10pt;text-align: center;">7.5%</p>
            </td>
          </tr>
          <tr style="height:12pt">
            <td style="width:163pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
              <p class="s58" style="padding-left: 5pt;text-indent: 0pt;line-height: 10pt;text-align: center;">Más de 9 meses y hasta 10 meses</p>
            </td>
            <td style="width:98pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
              <p class="s58" style="padding-left: 18pt;padding-right: 7pt;text-indent: 0pt;line-height: 10pt;text-align: center;">8.0%</p>
            </td>
          </tr>
          <tr style="height:12pt">
            <td style="width:163pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
              <p class="s58" style="padding-left: 5pt;text-indent: 0pt;line-height: 10pt;text-align: center;">Más de 10 meses y hasta 11 meses</p>
            </td>
            <td style="width:98pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
              <p class="s58" style="padding-left: 18pt;padding-right: 7pt;text-indent: 0pt;line-height: 10pt;text-align: center;">8.5%</p>
            </td>
          </tr>
          <tr style="height:12pt">
            <td style="width:163pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
              <p class="s58" style="padding-left: 5pt;text-indent: 0pt;line-height: 10pt;text-align: center;">Más de 11 meses y hasta 12 meses</p>
            </td>
            <td style="width:98pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
              <p class="s58" style="padding-left: 18pt;padding-right: 7pt;text-indent: 0pt;line-height: 10pt;text-align: center;">9.0%</p>
            </td>
          </tr>
          <tr style="height:12pt">
            <td style="width:163pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
              <p class="s58" style="padding-left: 5pt;text-indent: 0pt;line-height: 10pt;text-align: center;">Más de 12 meses y hasta 13 meses</p>
            </td>
            <td style="width:98pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
              <p class="s58" style="padding-left: 18pt;padding-right: 12pt;text-indent: 0pt;line-height: 10pt;text-align: center;">10.0%</p>
            </td>
          </tr>
          <tr style="height:12pt">
            <td style="width:163pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
              <p class="s58" style="padding-left: 5pt;text-indent: 0pt;line-height: 10pt;text-align: center;">Más de 13 meses y hasta 14 meses</p>
            </td>
            <td style="width:98pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
              <p class="s58" style="padding-left: 18pt;padding-right: 12pt;text-indent: 0pt;line-height: 10pt;text-align: center;">11.0%</p>
            </td>
          </tr>
          <tr style="height:12pt">
            <td style="width:163pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
              <p class="s58" style="padding-left: 5pt;text-indent: 0pt;line-height: 10pt;text-align: center;">Más de 14 meses y hasta 15 meses</p>
            </td>
            <td style="width:98pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
              <p class="s58" style="padding-left: 18pt;padding-right: 12pt;text-indent: 0pt;line-height: 10pt;text-align: center;">12.0%</p>
            </td>
          </tr>
          <tr style="height:12pt">
            <td style="width:163pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
              <p class="s58" style="padding-left: 5pt;text-indent: 0pt;line-height: 10pt;text-align: center;">Más de 15 meses y hasta 16 meses</p>
            </td>
            <td style="width:98pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
              <p class="s58" style="padding-left: 18pt;padding-right: 12pt;text-indent: 0pt;line-height: 10pt;text-align: center;">13.0%</p>
            </td>
          </tr>
          <tr style="height:12pt">
            <td style="width:163pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
              <p class="s58" style="padding-left: 5pt;text-indent: 0pt;line-height: 10pt;text-align: center;">Más de 16 meses y hasta 17 meses</p>
            </td>
            <td style="width:98pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
              <p class="s58" style="padding-left: 18pt;padding-right: 12pt;text-indent: 0pt;line-height: 10pt;text-align: center;">14.0%</p>
            </td>
          </tr>
          <tr style="height:12pt">
            <td style="width:163pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
              <p class="s58" style="padding-left: 5pt;text-indent: 0pt;line-height: 10pt;text-align: center;">Más de 17 meses y hasta 24 meses</p>
            </td>
            <td style="width:98pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
              <p class="s58" style="padding-left: 18pt;padding-right: 12pt;text-indent: 0pt;line-height: 10pt;text-align: center;">15.0%</p>
            </td>
          </tr>
          <tr style="height:12pt">
            <td style="width:163pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
              <p class="s58" style="padding-left: 5pt;text-indent: 0pt;line-height: 10pt;text-align: center;">Más de 2 años y hasta 2.5 años</p>
            </td>
            <td style="width:98pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
              <p class="s58" style="padding-left: 18pt;padding-right: 12pt;text-indent: 0pt;line-height: 10pt;text-align: center;">20.0%</p>
            </td>
          </tr>
          <tr style="height:12pt">
            <td style="width:163pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
              <p class="s58" style="padding-left: 5pt;text-indent: 0pt;line-height: 10pt;text-align: center;">Más de 2.5 años y hasta 3 años</p>
            </td>
            <td style="width:98pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
              <p class="s58" style="padding-left: 18pt;padding-right: 12pt;text-indent: 0pt;line-height: 10pt;text-align: center;">25.0%</p>
            </td>
          </tr>
          <tr style="height:12pt">
            <td style="width:163pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
              <p class="s58" style="padding-left: 5pt;text-indent: 0pt;line-height: 10pt;text-align: center;">Más de 3.0 años y hasta 4 años</p>
            </td>
            <td style="width:98pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
              <p class="s58" style="padding-left: 18pt;padding-right: 12pt;text-indent: 0pt;line-height: 10pt;text-align: center;">27.5%</p>
            </td>
          </tr>
          <tr style="height:12pt">
            <td style="width:163pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
              <p class="s58" style="padding-left: 5pt;text-indent: 0pt;text-align: center;">Más de 4 años y hasta 6 años</p>
            </td>
            <td style="width:98pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
              <p class="s58" style="padding-left: 18pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">30.0%</p>
            </td>
          </tr>
        </table>
        <p style="text-indent: 0pt;text-align: center;">
          <br />
        </p>
        <table style="border-collapse:collapse;margin-left:130.07pt" cellspacing="0">
          <tr style="height:12pt">
            <td style="width:163pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
              <p class="s58" style="padding-left: 5pt;text-indent: 0pt;line-height: 10pt;text-align: center;">Más de 6 años y hasta 7 años</p>
            </td>
            <td style="width:98pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
              <p class="s58" style="padding-right: 32pt;text-indent: 0pt;line-height: 10pt;text-align: right;">35.0%</p>
            </td>
          </tr>
          <tr style="height:12pt">
            <td style="width:163pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
              <p class="s58" style="padding-left: 5pt;text-indent: 0pt;line-height: 10pt;text-align: center;">Más de 7 años y hasta 9 años</p>
            </td>
            <td style="width:98pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
              <p class="s58" style="padding-right: 32pt;text-indent: 0pt;line-height: 10pt;text-align: right;">40.0%</p>
            </td>
          </tr>
          <tr style="height:12pt">
            <td style="width:163pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
              <p class="s58" style="padding-left: 5pt;text-indent: 0pt;line-height: 10pt;text-align: center;">Más de 9 años y hasta 11 años</p>
            </td>
            <td style="width:98pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
              <p class="s58" style="padding-right: 32pt;text-indent: 0pt;line-height: 10pt;text-align: right;">50.0%</p>
            </td>
          </tr>
          <tr style="height:12pt">
            <td style="width:163pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
              <p class="s58" style="padding-left: 5pt;text-indent: 0pt;line-height: 10pt;text-align: center;">Más de 11 años</p>
            </td>
            <td style="width:98pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
              <p class="s58" style="padding-right: 32pt;text-indent: 0pt;line-height: 10pt;text-align: right;">60.0%</p>
            </td>
          </tr>
        </table>
        <p style="padding-top: 11pt;padding-left: 39pt;text-indent: 0pt;text-align: justify;">En caso de que se opte por la reparación del motor desbielado, no se aplicará la depreciación o demérito correspondiente; en cambio, si se opta por la sustitución del motor por uno nuevo se aplicará la tabla de depreciación anterior.</p>
        <p style="text-indent: 0pt;text-align: center;">
          <br />
        </p>
        <p class="s11" style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">Cuando ocurra un <b>Siniestro </b>amparado por el <b>Contrato</b>, en donde resulte dañada la batería del <span class="s13">Vehículo Asegurado</span>
          <span class="p">, </span>
          <span class="s13">L A T I N O </span>
          <span class="p">aplicará un porcentaje de depreciación o demérito por el uso que tenga, de acuerdo a lo siguiente:</span>
        </p>
        <ol id="l173">
          <li data-list-text="a)">
            <p style="padding-left: 81pt;text-indent: -21pt;text-align: justify;">Si se tiene la batería físicamente, se mandará evaluar con un proveedor especialista en la materia, el cual determinará el porcentaje de demérito en comparación con una batería nueva de las mismas o similares características o similares, aplicándose los siguientes criterios:</p>
            <p style="text-indent: 0pt;text-align: center;">
              <br />
            </p>
            <table style="border-collapse:collapse;margin-left:71.03pt" cellspacing="0">
              <tr style="height:15pt">
                <td style="width:99pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt" bgcolor="#DEEAF6">
                  <p class="s57" style="padding-top: 1pt;padding-left: 25pt;text-indent: 0pt;text-align: center;">Antigüedad</p>
                </td>
                <td style="width:94pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt" bgcolor="#DEEAF6">
                  <p class="s57" style="padding-top: 1pt;padding-left: 6pt;text-indent: 0pt;text-align: center;">% de depreciación</p>
                </td>
                <td style="width:92pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt" bgcolor="#DEEAF6">
                  <p class="s57" style="padding-top: 1pt;padding-left: 20pt;text-indent: 0pt;text-align: center;">Antigüedad</p>
                </td>
                <td style="width:94pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt" bgcolor="#DEEAF6">
                  <p class="s57" style="padding-top: 1pt;padding-left: 7pt;text-indent: 0pt;text-align: center;">% de depreciación</p>
                </td>
              </tr>
              <tr style="height:11pt">
                <td style="width:99pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                  <p class="s58" style="padding-left: 7pt;text-indent: 0pt;line-height: 9pt;text-align: center;">Hasta 12 meses</p>
                </td>
                <td style="width:94pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                  <p class="s58" style="padding-left: 14pt;text-indent: 0pt;line-height: 9pt;text-align: center;">0%</p>
                </td>
                <td style="width:92pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                  <p class="s58" style="padding-left: 5pt;text-indent: 0pt;line-height: 9pt;text-align: center;">Hasta 32 meses</p>
                </td>
                <td style="width:94pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                  <p class="s58" style="padding-left: 10pt;text-indent: 0pt;line-height: 9pt;text-align: center;">64%</p>
                </td>
              </tr>
              <tr style="height:11pt">
                <td style="width:99pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                  <p class="s58" style="padding-left: 7pt;text-indent: 0pt;line-height: 9pt;text-align: center;">Hasta 13 meses</p>
                </td>
                <td style="width:94pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                  <p class="s58" style="padding-left: 14pt;padding-right: 5pt;text-indent: 0pt;line-height: 9pt;text-align: center;">26%</p>
                </td>
                <td style="width:92pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                  <p class="s58" style="padding-left: 5pt;text-indent: 0pt;line-height: 9pt;text-align: center;">Hasta 33 meses</p>
                </td>
                <td style="width:94pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                  <p class="s58" style="padding-left: 10pt;text-indent: 0pt;line-height: 9pt;text-align: center;">66%</p>
                </td>
              </tr>
              <tr style="height:11pt">
                <td style="width:99pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                  <p class="s58" style="padding-left: 7pt;text-indent: 0pt;line-height: 9pt;text-align: center;">Hasta 14 meses</p>
                </td>
                <td style="width:94pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                  <p class="s58" style="padding-left: 14pt;padding-right: 5pt;text-indent: 0pt;line-height: 9pt;text-align: center;">28%</p>
                </td>
                <td style="width:92pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                  <p class="s58" style="padding-left: 5pt;text-indent: 0pt;line-height: 9pt;text-align: center;">Hasta 34 meses</p>
                </td>
                <td style="width:94pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                  <p class="s58" style="padding-left: 10pt;text-indent: 0pt;line-height: 9pt;text-align: center;">68%</p>
                </td>
              </tr>
              <tr style="height:11pt">
                <td style="width:99pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                  <p class="s58" style="padding-left: 7pt;text-indent: 0pt;line-height: 9pt;text-align: center;">Hasta 15 meses</p>
                </td>
                <td style="width:94pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                  <p class="s58" style="padding-left: 14pt;padding-right: 5pt;text-indent: 0pt;line-height: 9pt;text-align: center;">30%</p>
                </td>
                <td style="width:92pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                  <p class="s58" style="padding-left: 5pt;text-indent: 0pt;line-height: 9pt;text-align: center;">Hasta 35 meses</p>
                </td>
                <td style="width:94pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                  <p class="s58" style="padding-left: 10pt;text-indent: 0pt;line-height: 9pt;text-align: center;">70%</p>
                </td>
              </tr>
              <tr style="height:11pt">
                <td style="width:99pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                  <p class="s58" style="padding-left: 7pt;text-indent: 0pt;line-height: 9pt;text-align: center;">Hasta 16 meses</p>
                </td>
                <td style="width:94pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                  <p class="s58" style="padding-left: 14pt;padding-right: 5pt;text-indent: 0pt;line-height: 9pt;text-align: center;">32%</p>
                </td>
                <td style="width:92pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                  <p class="s58" style="padding-left: 5pt;text-indent: 0pt;line-height: 9pt;text-align: center;">Hasta 36 meses</p>
                </td>
                <td style="width:94pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                  <p class="s58" style="padding-left: 10pt;text-indent: 0pt;line-height: 9pt;text-align: center;">72%</p>
                </td>
              </tr>
              <tr style="height:11pt">
                <td style="width:99pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                  <p class="s58" style="padding-left: 7pt;text-indent: 0pt;line-height: 9pt;text-align: center;">Hasta 17 meses</p>
                </td>
                <td style="width:94pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                  <p class="s58" style="padding-left: 14pt;padding-right: 5pt;text-indent: 0pt;line-height: 9pt;text-align: center;">34%</p>
                </td>
                <td style="width:92pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                  <p class="s58" style="padding-left: 5pt;text-indent: 0pt;line-height: 9pt;text-align: center;">Hasta 37 meses</p>
                </td>
                <td style="width:94pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                  <p class="s58" style="padding-left: 10pt;text-indent: 0pt;line-height: 9pt;text-align: center;">74%</p>
                </td>
              </tr>
              <tr style="height:11pt">
                <td style="width:99pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                  <p class="s58" style="padding-left: 7pt;text-indent: 0pt;line-height: 9pt;text-align: center;">Hasta 18 meses</p>
                </td>
                <td style="width:94pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                  <p class="s58" style="padding-left: 14pt;padding-right: 5pt;text-indent: 0pt;line-height: 9pt;text-align: center;">36%</p>
                </td>
                <td style="width:92pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                  <p class="s58" style="padding-left: 5pt;text-indent: 0pt;line-height: 9pt;text-align: center;">Hasta 38 meses</p>
                </td>
                <td style="width:94pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                  <p class="s58" style="padding-left: 10pt;text-indent: 0pt;line-height: 9pt;text-align: center;">76%</p>
                </td>
              </tr>
              <tr style="height:11pt">
                <td style="width:99pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                  <p class="s58" style="padding-left: 7pt;text-indent: 0pt;line-height: 9pt;text-align: center;">Hasta 19 meses</p>
                </td>
                <td style="width:94pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                  <p class="s58" style="padding-left: 14pt;padding-right: 5pt;text-indent: 0pt;line-height: 9pt;text-align: center;">38%</p>
                </td>
                <td style="width:92pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                  <p class="s58" style="padding-left: 5pt;text-indent: 0pt;line-height: 9pt;text-align: center;">Hasta 39 meses</p>
                </td>
                <td style="width:94pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                  <p class="s58" style="padding-left: 10pt;text-indent: 0pt;line-height: 9pt;text-align: center;">78%</p>
                </td>
              </tr>
              <tr style="height:11pt">
                <td style="width:99pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                  <p class="s58" style="padding-left: 7pt;text-indent: 0pt;line-height: 9pt;text-align: center;">Hasta 20 meses</p>
                </td>
                <td style="width:94pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                  <p class="s58" style="padding-left: 14pt;padding-right: 5pt;text-indent: 0pt;line-height: 9pt;text-align: center;">40%</p>
                </td>
                <td style="width:92pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                  <p class="s58" style="padding-left: 5pt;text-indent: 0pt;line-height: 9pt;text-align: center;">Hasta 40 meses</p>
                </td>
                <td style="width:94pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                  <p class="s58" style="padding-left: 10pt;text-indent: 0pt;line-height: 9pt;text-align: center;">80%</p>
                </td>
              </tr>
              <tr style="height:11pt">
                <td style="width:99pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                  <p class="s58" style="padding-left: 7pt;text-indent: 0pt;line-height: 9pt;text-align: center;">Hasta 21 meses</p>
                </td>
                <td style="width:94pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                  <p class="s58" style="padding-left: 14pt;padding-right: 5pt;text-indent: 0pt;line-height: 9pt;text-align: center;">42%</p>
                </td>
                <td style="width:92pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                  <p class="s58" style="padding-left: 5pt;text-indent: 0pt;line-height: 9pt;text-align: center;">Hasta 41 meses</p>
                </td>
                <td style="width:94pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                  <p class="s58" style="padding-left: 10pt;text-indent: 0pt;line-height: 9pt;text-align: center;">82%</p>
                </td>
              </tr>
              <tr style="height:11pt">
                <td style="width:99pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                  <p class="s58" style="padding-left: 7pt;text-indent: 0pt;line-height: 9pt;text-align: center;">Hasta 22 meses</p>
                </td>
                <td style="width:94pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                  <p class="s58" style="padding-left: 14pt;padding-right: 5pt;text-indent: 0pt;line-height: 9pt;text-align: center;">44%</p>
                </td>
                <td style="width:92pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                  <p class="s58" style="padding-left: 5pt;text-indent: 0pt;line-height: 9pt;text-align: center;">Hasta 42 meses</p>
                </td>
                <td style="width:94pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                  <p class="s58" style="padding-left: 10pt;text-indent: 0pt;line-height: 9pt;text-align: center;">84%</p>
                </td>
              </tr>
              <tr style="height:11pt">
                <td style="width:99pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                  <p class="s58" style="padding-left: 7pt;text-indent: 0pt;line-height: 9pt;text-align: center;">Hasta 23 meses</p>
                </td>
                <td style="width:94pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                  <p class="s58" style="padding-left: 14pt;padding-right: 5pt;text-indent: 0pt;line-height: 9pt;text-align: center;">46%</p>
                </td>
                <td style="width:92pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                  <p class="s58" style="padding-left: 5pt;text-indent: 0pt;line-height: 9pt;text-align: center;">Hasta 43 meses</p>
                </td>
                <td style="width:94pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                  <p class="s58" style="padding-left: 10pt;text-indent: 0pt;line-height: 9pt;text-align: center;">86%</p>
                </td>
              </tr>
              <tr style="height:11pt">
                <td style="width:99pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                  <p class="s58" style="padding-left: 7pt;text-indent: 0pt;line-height: 9pt;text-align: center;">Hasta 24 meses</p>
                </td>
                <td style="width:94pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                  <p class="s58" style="padding-left: 14pt;padding-right: 5pt;text-indent: 0pt;line-height: 9pt;text-align: center;">48%</p>
                </td>
                <td style="width:92pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                  <p class="s58" style="padding-left: 5pt;text-indent: 0pt;line-height: 9pt;text-align: center;">Hasta 44 meses</p>
                </td>
                <td style="width:94pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                  <p class="s58" style="padding-left: 10pt;text-indent: 0pt;line-height: 9pt;text-align: center;">88%</p>
                </td>
              </tr>
              <tr style="height:11pt">
                <td style="width:99pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                  <p class="s58" style="padding-left: 7pt;text-indent: 0pt;line-height: 9pt;text-align: center;">Hasta 25 meses</p>
                </td>
                <td style="width:94pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                  <p class="s58" style="padding-left: 14pt;padding-right: 5pt;text-indent: 0pt;line-height: 9pt;text-align: center;">50%</p>
                </td>
                <td style="width:92pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                  <p class="s58" style="padding-left: 5pt;text-indent: 0pt;line-height: 9pt;text-align: center;">Hasta 45 meses</p>
                </td>
                <td style="width:94pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                  <p class="s58" style="padding-left: 10pt;text-indent: 0pt;line-height: 9pt;text-align: center;">90%</p>
                </td>
              </tr>
              <tr style="height:11pt">
                <td style="width:99pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                  <p class="s58" style="padding-left: 7pt;text-indent: 0pt;line-height: 9pt;text-align: center;">Hasta 26 meses</p>
                </td>
                <td style="width:94pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                  <p class="s58" style="padding-left: 14pt;padding-right: 5pt;text-indent: 0pt;line-height: 9pt;text-align: center;">52%</p>
                </td>
                <td style="width:92pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                  <p class="s58" style="padding-left: 5pt;text-indent: 0pt;line-height: 9pt;text-align: center;">Hasta 46 meses</p>
                </td>
                <td style="width:94pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                  <p class="s58" style="padding-left: 10pt;text-indent: 0pt;line-height: 9pt;text-align: center;">92%</p>
                </td>
              </tr>
              <tr style="height:11pt">
                <td style="width:99pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                  <p class="s58" style="padding-left: 7pt;text-indent: 0pt;line-height: 9pt;text-align: center;">Hasta 27 meses</p>
                </td>
                <td style="width:94pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                  <p class="s58" style="padding-left: 14pt;padding-right: 5pt;text-indent: 0pt;line-height: 9pt;text-align: center;">54%</p>
                </td>
                <td style="width:92pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                  <p class="s58" style="padding-left: 5pt;text-indent: 0pt;line-height: 9pt;text-align: center;">Hasta 47 meses</p>
                </td>
                <td style="width:94pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                  <p class="s58" style="padding-left: 10pt;text-indent: 0pt;line-height: 9pt;text-align: center;">94%</p>
                </td>
              </tr>
              <tr style="height:11pt">
                <td style="width:99pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                  <p class="s58" style="padding-left: 7pt;text-indent: 0pt;line-height: 9pt;text-align: center;">Hasta 28 meses</p>
                </td>
                <td style="width:94pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                  <p class="s58" style="padding-left: 14pt;padding-right: 5pt;text-indent: 0pt;line-height: 9pt;text-align: center;">56%</p>
                </td>
                <td style="width:92pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                  <p class="s58" style="padding-left: 5pt;text-indent: 0pt;line-height: 9pt;text-align: center;">Hasta 48 meses</p>
                </td>
                <td style="width:94pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                  <p class="s58" style="padding-left: 10pt;text-indent: 0pt;line-height: 9pt;text-align: center;">96%</p>
                </td>
              </tr>
              <tr style="height:11pt">
                <td style="width:99pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                  <p class="s58" style="padding-left: 7pt;text-indent: 0pt;line-height: 9pt;text-align: center;">Hasta 29 meses</p>
                </td>
                <td style="width:94pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                  <p class="s58" style="padding-left: 14pt;padding-right: 5pt;text-indent: 0pt;line-height: 9pt;text-align: center;">58%</p>
                </td>
                <td style="width:92pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                  <p class="s58" style="padding-left: 5pt;text-indent: 0pt;line-height: 9pt;text-align: center;">Hasta 49 meses</p>
                </td>
                <td style="width:94pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                  <p class="s58" style="padding-left: 10pt;text-indent: 0pt;line-height: 9pt;text-align: center;">98%</p>
                </td>
              </tr>
              <tr style="height:11pt">
                <td style="width:99pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                  <p class="s58" style="padding-left: 7pt;text-indent: 0pt;line-height: 9pt;text-align: center;">Hasta 30 meses</p>
                </td>
                <td style="width:94pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                  <p class="s58" style="padding-left: 14pt;padding-right: 5pt;text-indent: 0pt;line-height: 9pt;text-align: center;">60%</p>
                </td>
                <td style="width:92pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                  <p class="s58" style="padding-left: 5pt;text-indent: 0pt;line-height: 9pt;text-align: center;">Más de 49 meses</p>
                </td>
                <td style="width:94pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                  <p class="s58" style="padding-left: 10pt;padding-right: 5pt;text-indent: 0pt;line-height: 9pt;text-align: center;">100%</p>
                </td>
              </tr>
              <tr style="height:11pt">
                <td style="width:99pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                  <p class="s58" style="padding-left: 7pt;text-indent: 0pt;line-height: 9pt;text-align: center;">Hasta 31 meses</p>
                </td>
                <td style="width:94pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                  <p class="s58" style="padding-left: 10pt;text-indent: 0pt;line-height: 9pt;text-align: center;">62%</p>
                </td>
                <td style="width:186pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt" colspan="2">
                  <p style="text-indent: 0pt;text-align: center;">
                    <br />
                  </p>
                </td>
              </tr>
            </table>
            <p style="padding-top: 1pt;text-indent: 0pt;text-align: center;">
              <br />
            </p>
          </li>
          <li data-list-text="b)">
            <p style="padding-left: 81pt;text-indent: -21pt;text-align: center;">Si no se tiene la batería físicamente, se aplicará un demérito invariable del 25%.</p>
          </li>
        </ol>
      </li>
    </ol>
    <p style="text-indent: 0pt;text-align: center;">
      <br />
    </p>
    <p style="padding-left: 39pt;text-indent: 0pt;text-align: center;">Llantas</p>
    <p style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">Cuando ocurra un <b>Siniestro </b>amparado por el <b>Contrato</b>, en donde resulten afectadas las llantas del <b>Vehículo Asegurado </b>por <b>Daño </b>o por robo, <b>L A T I N O </b>aplicará un porcentaje de depreciación o demérito por el uso que tengan, conforme a lo siguiente: </p>
    <ol id="l174">
      <li data-list-text="1.">
        <p style="padding-top: 11pt;padding-left: 81pt;text-indent: -21pt;text-align: justify;">Si se tiene la llanta físicamente <b>, </b>se mandará a evaluar con un proveedor especialista en la materia, el cual determinará el porcentaje de demérito en comparación con una llanta nueva de las mismas o similares características, observando lo establecido en la Norma Oficial Mexicana NOM-086-SCFI-2010 o la que la sustituya: </p>
        <p style="text-indent: 0pt;text-align: center;">
          <br />
        </p>
        <ol id="l175">
          <li data-list-text="1.1.">
            <p style="padding-left: 102pt;text-indent: -21pt;text-align: justify;">Se considera un promedio de altura mínima sobre el indicador de desgaste para llanta nueva de 5 mm., asignándole a este caso un 90 % de vida útil (5 mm. de altura = Depreciación del 10%). Si cuenta con mayor altura, se tomará como llanta nueva, excluida de depreciación (más de 5 mm. de altura = 0 % de depreciación).</p>
          </li>
          <li data-list-text="1.2.">
            <p style="padding-top: 7pt;padding-left: 102pt;text-indent: -21pt;text-align: justify;">Por cada milímetro que descienda, se depreciará un 10% (diez por ciento) acumulativo del valor de la llanta, hasta el máximo del 50% (cincuenta por ciento), conforme a la siguiente tabla:</p>
            <p style="text-indent: 0pt;text-align: center;">
              <br />
            </p>
            <table style="border-collapse:collapse;margin-left:137.038pt" cellspacing="0">
              <tr style="height:23pt">
                <td style="width:120pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt" colspan="2">
                  <p class="s40" style="padding-top: 5pt;padding-left: 37pt;text-indent: 0pt;text-align: center;">Dimensión</p>
                </td>
                <td style="width:71pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt" rowspan="2">
                  <p class="s40" style="padding-top: 10pt;padding-left: 7pt;padding-right: 7pt;text-indent: 16pt;line-height: 109%;text-align: center;">% de depreciación</p>
                </td>
                <td style="width:73pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt" rowspan="2">
                  <p class="s40" style="padding-top: 4pt;padding-left: 3pt;padding-right: 2pt;text-indent: 0pt;line-height: 109%;text-align: center;">% sobre el valor de la llanta</p>
                </td>
              </tr>
              <tr style="height:22pt">
                <td style="width:60pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                  <p class="s40" style="padding-top: 5pt;padding-left: 1pt;padding-right: 2pt;text-indent: 0pt;text-align: center;">Mínimo</p>
                </td>
                <td style="width:60pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                  <p class="s40" style="padding-top: 5pt;padding-left: 2pt;padding-right: 1pt;text-indent: 0pt;text-align: center;">Máximo</p>
                </td>
              </tr>
              <tr style="height:14pt">
                <td style="width:60pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                  <p class="s40" style="padding-top: 1pt;padding-left: 2pt;padding-right: 1pt;text-indent: 0pt;line-height: 11pt;text-align: center;">Mayor que</p>
                </td>
                <td style="width:60pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                  <p class="s40" style="padding-top: 1pt;padding-left: 2pt;padding-right: 1pt;text-indent: 0pt;line-height: 11pt;text-align: center;">Máximo</p>
                </td>
                <td style="width:71pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                  <p class="s40" style="padding-top: 1pt;padding-left: 1pt;text-indent: 0pt;line-height: 11pt;text-align: center;">0.0%</p>
                </td>
                <td style="width:73pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                  <p class="s40" style="padding-top: 1pt;padding-left: 3pt;padding-right: 2pt;text-indent: 0pt;line-height: 11pt;text-align: center;">100%</p>
                </td>
              </tr>
              <tr style="height:14pt">
                <td style="width:60pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                  <p class="s40" style="padding-top: 1pt;padding-left: 13pt;text-indent: 0pt;line-height: 11pt;text-align: center;">4.6 mm</p>
                </td>
                <td style="width:60pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                  <p class="s40" style="padding-top: 1pt;padding-left: 13pt;text-indent: 0pt;line-height: 11pt;text-align: center;">5.5 mm</p>
                </td>
                <td style="width:71pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                  <p class="s40" style="padding-top: 1pt;padding-left: 1pt;text-indent: 0pt;line-height: 11pt;text-align: center;">10.0%</p>
                </td>
                <td style="width:73pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                  <p class="s40" style="padding-top: 1pt;padding-left: 3pt;padding-right: 2pt;text-indent: 0pt;line-height: 11pt;text-align: center;">90%</p>
                </td>
              </tr>
              <tr style="height:14pt">
                <td style="width:60pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                  <p class="s40" style="padding-top: 1pt;padding-left: 13pt;text-indent: 0pt;line-height: 11pt;text-align: center;">3.6 mm</p>
                </td>
                <td style="width:60pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                  <p class="s40" style="padding-top: 1pt;padding-left: 13pt;text-indent: 0pt;line-height: 11pt;text-align: center;">4.5 mm</p>
                </td>
                <td style="width:71pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                  <p class="s40" style="padding-top: 1pt;padding-left: 1pt;text-indent: 0pt;line-height: 11pt;text-align: center;">20.0%</p>
                </td>
                <td style="width:73pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                  <p class="s40" style="padding-top: 1pt;padding-left: 3pt;padding-right: 2pt;text-indent: 0pt;line-height: 11pt;text-align: center;">80%</p>
                </td>
              </tr>
              <tr style="height:14pt">
                <td style="width:60pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                  <p class="s40" style="padding-top: 1pt;padding-left: 13pt;text-indent: 0pt;line-height: 11pt;text-align: center;">2.6 mm</p>
                </td>
                <td style="width:60pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                  <p class="s40" style="padding-top: 1pt;padding-left: 13pt;text-indent: 0pt;line-height: 11pt;text-align: center;">3.5 mm</p>
                </td>
                <td style="width:71pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                  <p class="s40" style="padding-top: 1pt;padding-left: 1pt;text-indent: 0pt;line-height: 11pt;text-align: center;">30.0%</p>
                </td>
                <td style="width:73pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                  <p class="s40" style="padding-top: 1pt;padding-left: 3pt;padding-right: 2pt;text-indent: 0pt;line-height: 11pt;text-align: center;">70%</p>
                </td>
              </tr>
              <tr style="height:14pt">
                <td style="width:60pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                  <p class="s40" style="padding-top: 1pt;padding-left: 13pt;text-indent: 0pt;line-height: 11pt;text-align: center;">1.6 mm</p>
                </td>
                <td style="width:60pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                  <p class="s40" style="padding-top: 1pt;padding-left: 13pt;text-indent: 0pt;line-height: 11pt;text-align: center;">2.5 mm</p>
                </td>
                <td style="width:71pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                  <p class="s40" style="padding-top: 1pt;padding-left: 1pt;text-indent: 0pt;line-height: 11pt;text-align: center;">40.0%</p>
                </td>
                <td style="width:73pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                  <p class="s40" style="padding-top: 1pt;padding-left: 3pt;padding-right: 2pt;text-indent: 0pt;line-height: 11pt;text-align: center;">60%</p>
                </td>
              </tr>
              <tr style="height:14pt">
                <td style="width:60pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                  <p class="s40" style="padding-top: 1pt;padding-left: 13pt;text-indent: 0pt;line-height: 11pt;text-align: center;">1.5 mm</p>
                </td>
                <td style="width:60pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                  <p class="s40" style="padding-top: 1pt;padding-left: 2pt;padding-right: 1pt;text-indent: 0pt;line-height: 11pt;text-align: center;">o menor</p>
                </td>
                <td style="width:71pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                  <p class="s40" style="padding-top: 1pt;padding-left: 1pt;text-indent: 0pt;line-height: 11pt;text-align: center;">50.0%</p>
                </td>
                <td style="width:73pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                  <p class="s40" style="padding-top: 1pt;padding-left: 3pt;padding-right: 2pt;text-indent: 0pt;line-height: 11pt;text-align: center;">50%</p>
                </td>
              </tr>
            </table>
            <p style="padding-top: 10pt;text-indent: 0pt;text-align: center;">
              <br />
            </p>
          </li>
          <li data-list-text="1.3.">
            <p style="padding-left: 100pt;text-indent: -19pt;text-align: center;">Las llantas deben contar con indicadores de desgaste con una altura mínima de 1.6mm, lo cual se considera como límite de seguridad en la llanta.</p>
          </li>
        </ol>
      </li>
      <li data-list-text="2.">
        <p style="padding-top: 11pt;padding-left: 60pt;text-indent: -21pt;text-align: justify;">En caso de contar con evidencia sobre la ocurrencia del siniestro, y declarado como procedente por <b>L A T I N O</b>, pero que por las circunstancias de ocurrencia del mismo, sea imposible la presentación física de la llanta, se aplicará un demérito invariable del 50%. </p>
        <p style="padding-top: 11pt;padding-left: 39pt;text-indent: 0pt;text-align: justify;">Estas depreciaciones aplican únicamente en pérdidas parciales.</p>
      </li>
      <li data-list-text="3.">
        <p class="s12" style="padding-top: 11pt;padding-left: 60pt;text-indent: -21pt;text-align: justify;">
          <a name="a183">Base de indemnización en caso de Pérdidas Totales</a>
        </p>
        <p style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">Cuando el costo del <b>Daño </b>o pérdida causado al <b>Vehículo Asegurado </b>esté dentro de los límites establecidos en la definición de <b>Pérdida Total </b>hecha en la Cláusula &quot;Definiciones&quot;, la indemnización comprenderá el tipo de valor contratado, menos el monto del <b>Deducible </b>que para el caso corresponda. </p>
        <p style="text-indent: 0pt;text-align: center;">
          <br />
        </p>
      </li>
      <li data-list-text="4.">
        <p class="s12" style="padding-left: 60pt;text-indent: -21pt;text-align: justify;">
          <a name="a184">Bases de indemnización en caso de gastos, incapacidad y otros gastos</a>
        </p>
      </li>
    </ol>
    <p style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">Para el pago de gastos médicos, incapacidad, gastos de entierro, equipo especial, adaptación, grúa o pensión, los documentos deberán cumplir con todos los requisitos fiscales, de conformidad con la normativa legal aplicable.</p>
    <p style="text-indent: 0pt;text-align: center;">
      <br />
    </p>
    <p class="s21" style="padding-left: 39pt;text-indent: 0pt;text-align: center;">Cláusula 5.7. Interés moratorio</p>
    <p style="padding-top: 13pt;padding-left: 39pt;text-indent: 0pt;text-align: justify;">En caso de que <b>L A T I N O</b>, no cumpla con las obligaciones asumidas en el <b>Contrato de Seguro </b>al hacerse exigibles, estará obligada, aun cuando la reclamación sea extrajudicial, a cubrir su obligación de acuerdo al artículo 276 de la Ley de Instituciones de Seguros y de Fianzas que a continuación se transcribe textualmente. </p>
    <p class="s17" style="padding-top: 10pt;padding-left: 39pt;text-indent: 0pt;text-align: justify;">Art 276.- “ <span class="s16">Si una institución de seguros no cumple con las obligaciones asumidas en el contrato de seguro dentro de los plazos con que cuente legalmente para su cumplimiento, deberá pagar al acreedor una indemnización por mora de acuerdo con lo siguiente:</span>
    </p>
    <p style="text-indent: 0pt;text-align: center;">
      <br />
    </p>
    <p class="s17" style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">I.- <span class="s16">Las obligaciones en moneda nacional se denominarán en Unidades de Inversión, al valor de éstas en la fecha del vencimiento de los plazos referidos en la parte inicial de este artículo y su pago se hará en moneda nacional, al valor que las Unidades de Inversión tengan a la fecha en que se efectúe el mismo, de conformidad con lo dispuesto en el párrafo segundo de la fracción VIII de este artículo. Además, la Institución de Seguros pagará un interés moratorio sobre la obligación denominada en</span>
    </p>
    <p class="s16" style="padding-top: 3pt;padding-left: 39pt;text-indent: 0pt;text-align: justify;">Unidades de Inversión conforme a lo dispuesto en el párrafo anterior, el cual se capitalizará mensualmente y cuya tasa será igual al resultado de multiplicar por 1.25 el costo de captación a plazo de pasivos denominados en Unidades de Inversión de las instituciones de banca múltiple del país, publicado por el Banco de México en el Diario Oficial de la Federación, correspondiente a cada uno de los meses en que exista mora;</p>
    <p style="text-indent: 0pt;text-align: center;">
      <br />
    </p>
    <p class="s17" style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">II.- <span class="s16">Cuando la obligación principal se denomine en moneda extranjera, adicionalmente al pago de esa obligación, la Institución de Seguros estará obligada a pagar un interés moratorio el cual se capitalizará mensualmente y se calculará aplicando al monto de la propia obligación, el porcentaje que resulte de multiplicar por 1.25 el costo de captación a plazo de pasivos denominados en dólares de los Estados Unidos de América, de las instituciones de banca múltiple del país, publicado por el Banco de México en el Diario Oficial de la Federación, correspondiente a cada uno de los meses en que exista mora;</span>
    </p>
    <p style="text-indent: 0pt;text-align: center;">
      <br />
    </p>
    <p class="s17" style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">III.- <span class="s16">En caso de que a la fecha en que se realice el cálculo no se hayan publicado las tasas de referencia para el cálculo del interés moratorio a que aluden las fracciones I y II de este artículo, se aplicará la del mes inmediato anterior y, para el caso de que no se publiquen dichas tasas, el interés moratorio se computará multiplicando por 1.25 la tasa que las sustituya, conforme a las disposiciones aplicables.</span>
    </p>
    <p style="text-indent: 0pt;text-align: center;">
      <br />
    </p>
    <p class="s17" style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">IV.- <span class="s16">Los intereses moratorios a que se refiere este artículo se generarán por día, a partir de la fecha del vencimiento de los plazos referidos en la parte inicial de este artículo y hasta el día en que se efectúe el pago previsto en el párrafo segundo de la fracción VIII de este artículo. Para su cálculo, las tasas de referencia a que se refiere este artículo deberán dividirse entre trescientos sesenta y cinco y multiplicar el resultado por el número de días correspondientes a los meses en que persista el incumplimiento;</span>
    </p>
    <p style="text-indent: 0pt;text-align: center;">
      <br />
    </p>
    <p class="s17" style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">V.- <span class="s16">En caso de reparación o reposición del objeto siniestrado, la indemnización por mora consistirá únicamente en el pago del interés correspondiente a la moneda en que se haya denominado la obligación principal conforme a las fracciones I y II de este artículo y se calculará sobre el importe del costo de la reparación o reposición;</span>
    </p>
    <p style="text-indent: 0pt;text-align: center;">
      <br />
    </p>
    <p class="s17" style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">VI.- <span class="s16">Son irrenunciables los derechos del acreedor a las prestaciones indemnizatorias establecidas en este artículo. El pacto que pretenda extinguirlos o reducirlos no surtirá efecto legal alguno. Estos derechos surgirán por el solo transcurso del plazo establecido por la Ley para el pago de la obligación principal, aunque ésta no sea líquida en ese momento. Una vez fijado el monto de la obligación principal conforme a lo pactado por las partes o en la resolución definitiva dictada en juicio ante el juez o árbitro, las prestaciones indemnizatorias establecidas en este artículo deberán ser cubiertas por la Institución de Seguros sobre el monto de la obligación principal así determinado;</span>
    </p>
    <p style="text-indent: 0pt;text-align: center;">
      <br />
    </p>
    <p class="s17" style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">VII.- <span class="s16">Si en el juicio respectivo resulta procedente la reclamación, aun cuando no se hubiere demandado el pago de la indemnización por mora establecida en este artículo, el juez o árbitro, además de la obligación principal, deberá condenar al deudor a que también cubra esas prestaciones conforme a las fracciones precedentes;</span>
    </p>
    <p style="padding-top: 1pt;text-indent: 0pt;text-align: center;">
      <br />
    </p>
    <p class="s17" style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">VIII. <span class="s16">- La indemnización por mora consistente en el sistema de actualización e intereses a que se refieren las fracciones I, II, III y IV del presente artículo será aplicable en todo tipo de seguros, salvo tratándose de seguros de caución que garanticen indemnizaciones relacionadas con el impago de créditos fiscales, en cuyo caso se estará a lo dispuesto por el Código Fiscal de la Federación.</span>
    </p>
    <p class="s16" style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">El pago que realice la Institución de Seguros se hará en una sola exhibición que comprenda el saldo total por los siguientes conceptos:</p>
    <ol id="l176">
      <li data-list-text="a)">
        <p class="s16" style="padding-left: 60pt;text-indent: -21pt;text-align: center;">Los intereses moratorios;</p>
      </li>
      <li data-list-text="b)">
        <p class="s16" style="padding-left: 60pt;text-indent: -21pt;text-align: center;">La actualización a que se refiere el primer párrafo de la fracción I de este artículo, y</p>
      </li>
      <li data-list-text="c)">
        <p class="s16" style="padding-left: 60pt;text-indent: -21pt;text-align: center;">La obligación principal.</p>
      </li>
    </ol>
    <p class="s16" style="padding-top: 3pt;padding-left: 39pt;text-indent: 0pt;text-align: justify;">En caso de que la Institución de Seguros no pague en una sola exhibición la totalidad de los importes de las obligaciones asumidas en el contrato de seguros y la indemnización por mora, los pagos que realice se aplicarán a los conceptos señalados en el orden establecido en el párrafo anterior, por lo que la indemnización por mora se continuará generando en términos del presente artículo, sobre el monto de la obligación principal no pagada, hasta en tanto se cubra en su totalidad.</p>
    <p style="text-indent: 0pt;text-align: center;">
      <br />
    </p>
    <p class="s16" style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">Cuando la Institución interponga un medio de defensa que suspenda el procedimiento de ejecución previsto en esta ley, y se dicte sentencia firme por la que queden subsistentes los actos impugnados, el pago o cobro correspondientes deberán incluir la indemnización por mora que hasta ese momento hubiere generado la obligación principal, y</p>
    <p style="text-indent: 0pt;text-align: center;">
      <br />
    </p>
    <p class="s17" style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">IX.- <span class="s16">Si la Institución de Seguros, dentro de los plazos y términos legales, no efectúa el pago de las indemnizaciones por mora, el juez o la Comisión Nacional para la Protección y Defensa de los Usuarios de Servicios Financieros, según corresponda, le impondrán una multa de 1,000 a 15,000 Días de Salario. En el caso del procedimiento administrativo de ejecución previsto en el artículo 278 de esta Ley, si la Institución de Seguros, dentro de los plazos o términos legales, no efectúan el pago de las indemnizaciones por mora, la Comisión le impondrá la multa señalada en esta fracción, a petición de la autoridad ejecutora que corresponda conforme a la fracción II de dicho artículo”.</span>
    </p>
    <p style="text-indent: 0pt;text-align: center;">
      <br />
    </p>
    <p class="s21" style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">Cláusula 5.8.</p>
    <p class="s21" style="padding-left: 38pt;text-indent: 0pt;text-align: justify;">Pérdida al derecho a ser indemnizado</p>
    <p style="padding-top: 13pt;padding-left: 39pt;text-indent: 0pt;text-align: justify;">Las obligaciones de <b>L A T I N O </b>quedarán extinguidas de conformidad con la Ley Sobre el Contrato de Seguro en los siguientes casos: </p>
    <ol id="l177">
      <li data-list-text="1.">
        <p class="s16" style="padding-top: 11pt;padding-left: 60pt;text-indent: -21pt;text-align: justify;">Las obligaciones de la empresa quedarán extinguidas si demuestra que el <b>Asegurado</b>, el <b>Beneficiario </b>o los representantes de ambos, con el fin de hacerla incurrir en error, disimulan o declaran inexactamente hechos que excluirían o podrían restringir dichas obligaciones. Lo mismo se observará en caso de que, con igual propósito, no le remitan en tiempo la documentación de que trata el artículo anterior. <b>(Artículo 70 de la Ley Sobre el Contrato de Seguro).</b>
        </p>
        <p style="text-indent: 0pt;text-align: center;">
          <br />
        </p>
        <p class="s17" style="padding-left: 60pt;text-indent: 0pt;text-align: justify;">Artículo 69 de la Ley Sobre el Contrato de Seguro. <span class="s16">La empresa aseguradora tendrá el derecho de exigir del </span>Asegurado <span class="s16">o </span>Beneficiario <span class="s16">toda clase de informaciones sobre los hechos relacionados con el </span>Siniestro <span class="s16">y por los cuales puedan determinarse las circunstancias de su realización y las consecuencias del mismo.</span>
        </p>
      </li>
      <li data-list-text="2.">
        <p class="s16" style="padding-top: 11pt;padding-left: 60pt;text-indent: -21pt;text-align: justify;">Cualquier omisión o inexacta declaración de los hechos a que se refieren los artículos 8, 9 y 10 de la presente ley, facultará a la empresa aseguradora para considerar rescindido de pleno derecho el contrato, aunque no hayan influido en la realización del <b>Siniestro</b>. <b>(Artículo 47 de la Ley Sobre el Contrato de Seguro).</b>
        </p>
        <p style="text-indent: 0pt;text-align: center;">
          <br />
        </p>
      </li>
      <li data-list-text="3.">
        <p class="s16" style="padding-left: 60pt;text-indent: -21pt;text-align: justify;">El proponente estará obligado a declarar por escrito a la empresa aseguradora, de acuerdo con el cuestionario relativo, todos los hechos importantes para la apreciación del riesgo que puedan influir en las condiciones convenidas, tales como los conozca o deba conocer en el momento de la celebración del contrato <span class="p">. </span>
          <b>(Artículo 8 de la Ley Sobre el Contrato de Seguro).</b>
        </p>
        <p style="text-indent: 0pt;text-align: center;">
          <br />
        </p>
      </li>
      <li data-list-text="4.">
        <p class="s16" style="padding-left: 60pt;text-indent: -21pt;text-align: justify;">Si el <b>Contrato </b>se celebra por un representante del <b>Asegurado</b>, deberán declararse todos los hechos importantes que sean o deban ser conocidos del representante y del representado. <b>(Artículo 9 de la Ley Sobre el Contrato de Seguro).</b>
        </p>
        <p style="text-indent: 0pt;text-align: center;">
          <br />
        </p>
      </li>
      <li data-list-text="5.">
        <p class="s16" style="padding-left: 60pt;text-indent: -21pt;text-align: justify;">Cuando se proponga un seguro por cuenta de otro, el proponente deberá declarar todos los hechos importantes que sean o deban ser conocidos del tercero <b>Asegurado </b>o de su intermediario. <b>(Artículo 10 de la Ley Sobre el Contrato de Seguro).</b>
        </p>
      </li>
      <li data-list-text="6.">
        <p class="s16" style="padding-top: 3pt;padding-left: 60pt;text-indent: -21pt;text-align: justify;">La empresa aseguradora comunicará en forma auténtica al <b>Asegurado </b>o a sus <b>Beneficiario</b>s, la rescisión del contrato dentro de los treinta días naturales siguientes a la fecha en que la propia empresa conozca la omisión o inexacta declaración. <b>(Artículo 48 de la Ley Sobre el Contrato de Seguro).</b>
        </p>
      </li>
      <li data-list-text="7.">
        <p class="s16" style="padding-top: 4pt;padding-left: 60pt;text-indent: -21pt;text-align: justify;">El <b>Asegurado </b>deberá comunicar a la empresa aseguradora las agravaciones esenciales que tenga el riesgo durante el curso del seguro, dentro de las veinticuatro horas siguientes al momento en que las conozca. Si el <b>Asegurado </b>omitiere el aviso o si él provoca una agravación esencial del riesgo, cesarán de pleno derecho las obligaciones de la empresa en lo sucesivo. <b>(Artículo 52 de la Ley Sobre el Contrato de Seguro).</b>
        </p>
        <p style="text-indent: 0pt;text-align: center;">
          <br />
        </p>
      </li>
      <li data-list-text="8.">
        <p class="s16" style="padding-left: 60pt;text-indent: -21pt;text-align: justify;">En caso de rescisión unilateral del contrato por las causas a que se refiere el artículo 47 de la Ley Sobre el Contrato de Seguro, la empresa aseguradora conservará su derecho a la <b>Prima </b>por el período del seguro en curso en el momento de la rescisión; pero si ésta tiene lugar antes de que el riesgo haya comenzado a correr para la empresa, el derecho se reducirá al reembolso de los gastos efectuados Si la <b>Prima </b>se hubiere pagado anticipadamente por varios períodos del seguro, la empresa restituirá las tres cuartas partes de las <b>Prima</b>s correspondientes a los períodos futuros del seguro. <b>(Artículo 51 de la Ley Sobre el Contrato de Seguro).</b>
        </p>
        <p style="text-indent: 0pt;text-align: center;">
          <br />
        </p>
      </li>
      <li data-list-text="9.">
        <p class="s16" style="padding-left: 60pt;text-indent: -21pt;text-align: justify;">El <b>Contrato de Seguro </b>será nulo si en el momento de su celebración, el riesgo hubiere desaparecido o el <b>Siniestro </b>se hubiere ya realizado. Sin embargo, los efectos del <b>Contrato </b>podrán hacerse retroactivos por convenio expreso de las partes contratantes. En caso de retroactividad, la empresa aseguradora que conozca la inexistencia del riesgo, no tendrá derecho a las <b>Prima</b>s ni al reembolso de sus gastos; el <b>Contratante </b>que conozca esa circunstancia perderá el derecho a la restitución de las <b>Prima</b>s y estará obligado al pago de los gastos. <b>(Artículo 45 de la Ley Sobre el Contrato de Seguro).</b>
        </p>
        <p style="text-indent: 0pt;text-align: center;">
          <br />
        </p>
      </li>
      <li data-list-text="10.">
        <p class="s16" style="padding-left: 60pt;text-indent: -21pt;text-align: justify;">El <b>Contrato </b>será nulo si en el momento de su celebración, la cosa asegurada ha perecido o no puede seguir ya expuesta a los riesgos. </p>
      </li>
    </ol>
    <p class="s16" style="padding-left: 60pt;text-indent: 0pt;text-align: justify;">Las <b>Prima</b>s pagadas serán restituidas al <b>Asegurado </b>con deducción de los gastos hechos por la empresa. </p>
    <p class="s16" style="padding-left: 60pt;text-indent: 0pt;text-align: justify;">El dolo o mala fe de alguna de las partes, le impondrá la obligación de pagar a la otra una cantidad igual al duplo de la <b>Prima </b>de un año. <b>(Artículo 88 de la Ley Sobre el Contrato de Seguro).</b>
    </p>
    <p style="text-indent: 0pt;text-align: center;">
      <br />
    </p>
    <p class="s21" style="padding-left: 38pt;text-indent: 0pt;text-align: center;">Cláusula 5.9. Territorialidad</p>
    <p style="padding-top: 11pt;padding-left: 39pt;text-indent: 0pt;text-align: justify;">Las <b>Coberturas </b>amparadas por esta <b>Póliza </b>se aplicarán en caso de accidentes ocurridos dentro de la República Mexicana. La aplicación de las coberturas de las secciones de Daños Materiales, Robo, así como las coberturas de Gastos Médicos Ocupantes y Accidentes al Conductor; en el caso de la cobertura de Adaptaciones, Conversiones y Equipo Especial los riesgos por <b>Daños </b>materiales y <b>Robo Total</b>, se extiende a los Estados Unidos de Norte América y Canadá. </p>
    <p style="padding-top: 2pt;text-indent: 0pt;text-align: center;">
      <br />
    </p>
    <p class="s21" style="padding-left: 39pt;text-indent: 0pt;text-align: center;">Cláusula 5.10.</p>
    <p class="s21" style="padding-left: 38pt;text-indent: 0pt;text-align: center;">Salvamentos y Recuperaciones</p>
    <p style="padding-top: 13pt;padding-left: 39pt;text-indent: 0pt;text-align: justify;">Cuando exista <b>Pérdida Total</b>, <b>L A T I N O </b>pagará la cantidad correspondiente a la indemnización y, en su caso, el importe correspondiente al valor de adquisición del <b>Salvamento</b>, que será el determinado mediante <b>Valuación </b>pericial. La suma de la indemnización y del pago del <b>Salvamento</b>, a la que se deberá descontar el <b>Deducible</b>, no deberá exceder de la <b>Suma Asegurada </b>o <b>Límite Máximo de Responsabilidad</b>. </p>
    <p style="padding-top: 2pt;text-indent: 0pt;text-align: center;">
      <br />
    </p>
    <p style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">El valor del <b>Salvamento </b>no podrá exceder de la diferencia entre la <b>Suma Asegurada </b>y el importe </p>
    <p style="padding-top: 3pt;padding-left: 39pt;text-indent: 0pt;text-align: justify;">equivalente al porcentaje del <b>Daño</b>, cuando este último porcentaje es tomado en cuenta para determinar la <b>Pérdida Total </b>del <b>Vehículo Asegurado </b>por parte de <b>L A T I N O </b>. </p>
    <p style="text-indent: 0pt;text-align: center;">
      <br />
    </p>
    <p style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">El valor de adquisición del <b>Salvamento </b>se determinará por <b>Valuación </b>pericial, como lo prevé el artículo 116 de la Ley sobre el Contrato de Seguro. Esta <b>Valuación </b>pericial, además de los elementos propios de la estimación de la pérdida o el <b>Siniestro </b>sufrido por el <b>Asegurado</b>, contendrá el valor de adquisición del <b>Salvamento</b>; debiendo utilizarse para dicha <b>Valuación</b>, las referencias que para la compraventa de vehículos existan en el mercado. </p>
    <p style="text-indent: 0pt;text-align: center;">
      <br />
    </p>
    <p style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">En caso de que opte <b>L A T I N O </b>por la indemnización, y solo cuando el monto de los <b>Daños </b>de <b>Salvamento </b>rebase la cantidad de $227,400.00 Moneda Nacional, se retendrá el 20% de dicho monto por concepto de Impuesto Sobre la Renta (ISR), de conformidad con lo establecido en el artículo 126, párrafos quinto y sexto de la Ley del Impuesto Sobre la Renta. </p>
    <p style="padding-top: 11pt;padding-left: 39pt;text-indent: 0pt;text-align: justify;">Salvo que las partes pacten lo contrario, al pagar <b>L A T I N O </b>el valor del <b>Salvamento </b>al <b>Asegurado</b>, determinado mediante la mencionada <b>Valuación </b>pericial, <b>L A T I N O </b>será la propietaria de dicho <b>Salvamento </b>pudiendo disponer de él en la forma que más le convenga, conforme a las disposiciones legales vigentes, con excepción del <b>Equipo Especial </b>que no estuviere <b>Asegurado</b>. </p>
    <p style="text-indent: 0pt;text-align: center;">
      <br />
    </p>
    <p style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">Si el <b>Asegurado </b>omite declarar ante <b>L A T I N O </b>que el vehículo fue adquirido con el carácter de <b>Salvamento</b>, <b>L A T I N O </b>se apegará a lo establecido en la Cláusula &quot;Sumas Aseguradas y Bases de Indemnización&quot;, en el rubro denominado <b>Vehículo de Salvamento</b>. </p>
    <p style="padding-top: 2pt;text-indent: 0pt;text-align: center;">
      <br />
    </p>
    <p class="s21" style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">Cláusula 5.11.</p>
    <p class="s21" style="padding-left: 38pt;text-indent: 0pt;text-align: justify;">Terminación anticipada del contrato (Cancelación)</p>
    <p style="padding-top: 13pt;padding-left: 39pt;text-indent: 0pt;text-align: justify;">Las partes convienen expresamente en que este <b>Contrato </b>podrá darse por terminado anticipadamente en cuyo caso se aplicará lo siguiente: </p>
    <ol id="l178">
      <li data-list-text="1.">
        <p style="padding-top: 11pt;padding-left: 60pt;text-indent: -21pt;text-align: justify;">
          <span class="s12">Cuando el Asegurado dé por terminado el Contrato celebrado. </span>El <b>Asegurado </b>tendrá derecho a la <b>Prima </b>correspondiente al riesgo no transcurrido a la fecha de cancelación del <b>Contrato de Seguro</b>. Se brindará la atención para la solicitar la cancelación en los teléfonos 55 5130 2801 en la Ciudad de México, o al 800 685 1170 para el resto de la República.
        </p>
      </li>
      <li data-list-text="2.">
        <p style="padding-left: 60pt;text-indent: -21pt;text-align: justify;">
          <span class="s12">En caso de Pérdida Total. </span>En los casos de <b>Pérdida Total </b>y tener contratadas dos o más <b>Coberturas</b>, en caso de solicitar la terminación y antes del fin del período de vigencia pactado ocurriere la <b>Pérdida Total </b>del <b>vehículo Asegurado</b>, <b>L A T I N O </b>devolverá, el 100% de la parte no devengada de la <b>Prima </b>o <b>Prima</b>s correspondientes a las <b>Coberturas </b>no afectadas durante la vigencia de la <b>Póliza </b>por el tiempo en que el vehículo ya no estará en riesgo, será necesario que el contratante o asegurado ingrese Carta solicitud de cancelación por Perdida Total firmada, anexando su identificación oficial, dentro de la carta deberá informar si desea que el pago se realice por transferencia para lo cual deberá adjuntar estado de cuenta con clave interbancaria o si lo prefiere orden de pago a ventanilla en ambos casos el pago se verá reflejado en 7 días hábiles.
        </p>
      </li>
      <li data-list-text="3.">
        <p style="padding-left: 60pt;text-indent: -21pt;text-align: justify;">
          <span class="s12">En caso de existir designación del Beneficiario Preferente. </span>El <b>Asegurado </b>y/o <b>Contratante </b>deberá presentar a <b>L A T I N O </b>carta de conformidad del <b>Beneficiario Preferente</b>, carta de liberación del crédito o documento que acredité lo anterior.
        </p>
      </li>
      <li data-list-text="4.">
        <p style="padding-left: 60pt;text-indent: -21pt;text-align: justify;">
          <span class="s12">Cuando L A T I N O dé por terminado el Contrato. </span>La terminación del <b>Contrato </b>se hará mediante notificación por escrito al <b>Asegurado</b>, surtiendo efectos la terminación del seguro después de quince días naturales de recibida la notificación respectiva, <b>L A T I N O </b>devolverá al <b>Asegurado </b>el 100% de la <b>Prima </b>en forma proporcional al tiempo de vigencia no corrido, a más tardar al hacer dicha notificación, sin cuyo requisito se tendrá por no hecha. Si se ha designado un <b>Beneficiario Preferente</b>, el <b>Asegurado </b>no podrá dar por terminado el <b>Contrato </b>sin el consentimiento por escrito de dicho <b>Beneficiario Preferente </b>designado.
        </p>
      </li>
      <li data-list-text="5.">
        <p class="s13" style="padding-left: 60pt;text-indent: -21pt;text-align: justify;">L A T I N O <span class="p">no podrá negar o retrasar el trámite de cancelación sin que exista causa justificada</span>
        </p>
        <p style="padding-top: 3pt;padding-left: 60pt;text-indent: 0pt;text-align: justify;">o impedimento legal. La solicitud que realice el <b>Asegurado </b>y/o <b>Contratante </b>podrá ser por escrito en las oficinas de <b>L A T I N O </b>o por el mismo medio por el cual se contrató el seguro o bien por cualquier otro medio acordado entre el <b>Asegurado </b>y/o <b>Contratante </b>y <b>L A T I N O</b>. </p>
      </li>
      <li data-list-text="6.">
        <p style="padding-top: 4pt;padding-left: 60pt;text-indent: -21pt;text-align: justify;">Previo a efectuar la terminación anticipada del <b>Contrato de Seguro</b>, será verificada y/o certificada por parte de <b>L A T I N O </b>la autenticidad y veracidad de la identidad de la persona que está efectuando la solicitud de terminación respectiva y posterior a ello, será proporciona <span class="s24">el acuse de recibo, la clave de confirmación o número de folio correspondiente, según sea el caso.</span>
        </p>
      </li>
      <li data-list-text="7.">
        <p class="s12" style="padding-left: 60pt;text-indent: -21pt;text-align: justify;">
          <a name="a185">En caso de rescisión del Contrato</a>
        </p>
        <ol id="l179">
          <li data-list-text="7.1">
            <p style="padding-left: 81pt;text-indent: -21pt;line-height: 11pt;text-align: justify;">De acuerdo al Artículo 96 de la Ley Sobre el Contrato de Seguro:</p>
            <p class="s16" style="padding-left: 60pt;text-indent: 0pt;text-align: justify;">En caso de <b>Daño </b>parcial por el cual se reclame una indemnización, la empresa aseguradora y el <b>Asegurado</b>, tendrán derecho para rescindir el <b>Contrato </b>a más tardar en el momento del pago de la indemnización, aplicándose entonces las siguientes reglas: </p>
            <ol id="l180">
              <li data-list-text="I.">
                <p class="s16" style="padding-left: 81pt;text-indent: -21pt;text-align: justify;">Si la empresa hace uso del derecho de rescisión, su responsabilidad terminará quince días después de comunicarlo así al <b>Asegurado</b>, debiendo reembolsar la <b>Prima </b>que corresponda a la parte no transcurrida del periodo del seguro en curso y al resto de la <b>Suma Asegurada</b>; </p>
              </li>
              <li data-list-text="II.">
                <p class="s16" style="padding-left: 81pt;text-indent: -21pt;text-align: justify;">Si el <b>Asegurado </b>ejercita ese derecho, la empresa podrá exigir la <b>Prima </b>por el periodo del seguro en curso. Cuando la <b>Prima </b>haya sido cubierta anticipadamente por varios periodos del seguro, la empresa reembolsará el monto que corresponda a los periodos futuros. </p>
              </li>
            </ol>
          </li>
          <li data-list-text="7.2">
            <p style="padding-left: 81pt;text-indent: -21pt;line-height: 11pt;text-align: justify;">De acuerdo al Artículo 51 de la Ley Sobre el Contrato de Seguro:</p>
          </li>
        </ol>
      </li>
    </ol>
    <p class="s16" style="padding-left: 81pt;text-indent: 0pt;text-align: justify;">En caso de rescisión unilateral del <b>Contrato </b>por las causas a que se refiere el artículo 47 de la Ley Sobre el Contrato de Seguro, la empresa aseguradora conservará su derecho a la <b>Prima </b>por el periodo del seguro en curso en el momento de la rescisión; pero si esta tiene lugar antes de que el riesgo haya comenzado a correr para la empresa, el derecho se reducirá al reembolso de los gastos efectuados. </p>
    <p class="s16" style="padding-left: 81pt;text-indent: 0pt;text-align: justify;">Si la <b>Prima </b>se hubiere pagado anticipadamente por varios periodos del seguro, la empresa restituirá las tres cuartas partes de las <b>Prima</b>s correspondientes a los periodos futuros del seguro. </p>
    <p class="s16" style="padding-left: 88pt;text-indent: 0pt;text-align: justify;">“ <span class="s55">Artículo 47.-</span>Cualquiera omisión o inexacta declaración de los hechos a que se refieren los artículos 8, 9 y 10 de la presente ley, facultará a la empresa aseguradora para considerar rescindido de pleno derecho el contrato, aunque no hayan influido en la realización del <b>Siniestro</b>.” </p>
    <p style="padding-top: 2pt;text-indent: 0pt;text-align: center;">
      <br />
    </p>
    <p class="s15" style="padding-left: 39pt;text-indent: 0pt;text-align: center;">
      <u>En ninguno de los casos anteriores se realizará la devolución de los gastos</u>
      <u>de expedición (Derecho de Póliza).</u>
    </p>
    <p style="padding-top: 2pt;text-indent: 0pt;text-align: center;">
      <br />
    </p>
    <p style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">En caso de que el <b>Contratante </b>requiera la cancelación de la <b>Póliza</b>, se brindará la atención para la solicitar la cancelación en los teléfonos 55 5130 2801 en la Ciudad de México, o al 800 685 1170 para el resto de la República. </p>
    <p style="padding-top: 4pt;text-indent: 0pt;text-align: center;">
      <br />
    </p>
    <p class="s21" style="padding-left: 38pt;text-indent: 0pt;text-align: center;">Cláusula 5.12. Prescripción</p>
    <p style="padding-top: 13pt;padding-left: 39pt;text-indent: 0pt;text-align: justify;">Todas las acciones que se deriven de este <b>Contrato de Seguro </b>prescribirán en dos años, contados desde la fecha del acontecimiento que les dio origen, en los términos del artículo 81 de la Ley Sobre el Contrato de Seguro, salvo los casos de excepción consignados en el artículo 82 de la misma Ley, que a letra menciona: </p>
    <p class="s55" style="padding-top: 10pt;padding-left: 67pt;text-indent: 0pt;text-align: justify;">Artículo 81.- <span class="s16">Todas las acciones que se deriven de un contrato de seguro prescribirán: I.- En cinco años, tratándose de la cobertura de fallecimiento en los seguros de vida. II.- En dos años, en los demás casos. En todos los casos, los plazos serán contados desde la fecha del acontecimiento que les dio origen.</span>
    </p>
    <p style="padding-top: 3pt;text-indent: 0pt;text-align: center;">
      <br />
    </p>
    <p class="s55" style="padding-left: 67pt;text-indent: 0pt;text-align: justify;">Artículo 82.- <span class="s16">El plazo de que trata el artículo anterior no correrá en caso de omisión, falsas o inexactas declaraciones sobre el riesgo corrido, sino desde el día en que la empresa haya tenido conocimiento de él; y si se trata de la realización del siniestro, desde el día en que haya llegado a conocimiento de los interesados, quienes deberán demostrar que hasta entonces ignoraban dicha realización.</span>
    </p>
    <p style="padding-top: 4pt;text-indent: 0pt;text-align: center;">
      <br />
    </p>
    <p class="s21" style="padding-left: 38pt;text-indent: 0pt;text-align: center;">Cláusula 5.13. Competencia</p>
    <p style="padding-top: 13pt;padding-left: 39pt;text-indent: 0pt;text-align: justify;">La competencia por territorio para demandar en materia de seguros será determinada, a elección del reclamante, en razón del domicilio de cualquiera de las delegaciones de la Comisión Nacional para la Protección y Defensa de los Usuarios de Servicios Financieros (CONDUSEF).</p>
    <p style="text-indent: 0pt;text-align: center;">
      <br />
    </p>
    <p style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">Asimismo, será competente el Juez del domicilio de dicha delegación; cualquier pacto que se estipule contrario a lo dispuesto en este párrafo, será nulo. En caso de juicio, se deberá notificar a <b>L A T I N O </b>en el domicilio que se indica en la <b>Carátula de la Póliza</b>. En caso de controversia el reclamante tendrá la prerrogativa de acudir a la Comisión Nacional para la Protección y Defensa de los Usuarios de Servicios Financieros en sus oficinas centrales o en sus delegaciones; a la unidad de atención a clientes de <b>L A T I N O</b>, o acudir directamente ante los tribunales competentes </p>
    <p style="padding-top: 1pt;text-indent: 0pt;text-align: center;">
      <br />
    </p>
    <p class="s21" style="padding-left: 38pt;text-indent: 0pt;text-align: center;">Cláusula 5.14. Subrogación</p>
    <p style="padding-top: 13pt;padding-left: 39pt;text-indent: 0pt;text-align: justify;">En los términos de la Ley una vez pagada la indemnización correspondiente, <b>L A T I N O </b>se subrogará hasta por la cantidad pagada en los derechos del <b>Contratante</b>, así como en sus correspondientes acciones, contra los autores o responsables del <b>Siniestro</b>. Si <b>L A T I N O </b>lo solicita, a costa de ella, el <b>Contratante </b>hará constar la subrogación en escritura pública. </p>
    <p style="text-indent: 0pt;text-align: center;">
      <br />
    </p>
    <p style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">Si por hechos u omisiones del <b>Asegurado </b>se impide totalmente la subrogación, <b>L A T I N O</b>
    </p>
    <p style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">quedará liberada en todo o en parte de sus obligaciones.</p>
    <p style="padding-top: 11pt;padding-left: 39pt;text-indent: 0pt;text-align: justify;">Si el <b>Daño </b>fue indemnizado sólo en parte, el <b>Asegurado </b>y <b>L A T I N O </b>concurrirán a hacer valer sus derechos en la proporción correspondiente. </p>
    <p style="padding-top: 11pt;padding-left: 39pt;text-indent: 0pt;text-align: justify;">El derecho a la subrogación no procederá en el caso de que el <b>Asegurado </b>tenga relación conyugal o de <b>Parentesco </b>por consanguinidad, afinidad o civil hasta el segundo grado, con la persona que le haya causado el <b>Daño</b>, o bien si es civilmente responsable de la misma. </p>
    <p style="padding-top: 2pt;text-indent: 0pt;text-align: center;">
      <br />
    </p>
    <p class="s21" style="padding-left: 38pt;text-indent: 0pt;text-align: center;">Cláusula 5.15. Aceptación del contrato</p>
    <p style="padding-top: 13pt;padding-left: 36pt;text-indent: 0pt;text-align: justify;">A continuación se transcriben los artículos 19 y 25 de la Ley Sobre el Contrato de Seguro y el artículo 202 de la Ley de Instituciones de Seguros y Fianzas, para mayor referencia de nuestros <b>Asegurados </b>en los casos de solicitar rectificaciones o modificaciones en el contenido de su <b>Póliza</b>. </p>
    <p style="text-indent: 0pt;text-align: center;">
      <br />
    </p>
    <p style="padding-left: 36pt;text-indent: 0pt;text-align: justify;">Artículo 19.- Para fines de prueba, el <b>contrato </b>de seguro, así como sus adiciones y reformas, se harán constar por escrito. Ninguna otra prueba, salvo la confesional, será admisible para probar su existencia, así como la del hecho del conocimiento de la aceptación, a que se refiere la primera parte de la fracción I del artículo 21. </p>
    <p style="text-indent: 0pt;text-align: center;">
      <br />
    </p>
    <p style="padding-left: 36pt;text-indent: 0pt;text-align: justify;">Artículo 25.- Si el contenido de la póliza o sus modificaciones no concordaren con la oferta, el asegurado podrá pedir la rectificación correspondiente dentro de los treinta días que sigan al día en</p>
    <p style="padding-top: 3pt;padding-left: 36pt;text-indent: 0pt;text-align: center;">que reciba la póliza. Transcurrido este plazo se considerarán aceptadas las estipulaciones de la póliza o de sus modificaciones.</p>
    <p class="s13" style="padding-top: 11pt;padding-left: 36pt;text-indent: 0pt;text-align: justify;">ARTÍCULO 202 <span class="p">.- Las Instituciones de Seguros sólo podrán ofrecer al público los servicios relacionados con las operaciones que esta Ley les autoriza, mediante productos de seguros que cumplan con lo señalado en los artículos 200 y 201 de esta Ley.</span>
    </p>
    <p style="text-indent: 0pt;text-align: center;">
      <br />
    </p>
    <p style="padding-left: 36pt;text-indent: 0pt;text-align: justify;">En el caso de los productos de seguros que se ofrezcan al público en general y que se formalicen mediante contratos de adhesión, entendidos como tales aquellos elaborados unilateralmente en formatos por una Institución de Seguros y en los que se establezcan los términos y condiciones aplicables a la contratación de un seguro, así como los modelos de cláusulas elaborados para ser incorporados mediante endosos adicionales a esos contratos, además de cumplir con lo señalado en el primer párrafo de este artículo, deberán registrarse de manera previa ante la Comisión en los términos del artículo 203 de este ordenamiento. Lo señalado en este párrafo será también aplicable a los productos de seguros que, sin formalizarse mediante contratos de adhesión, se refieran a los seguros de grupo o seguros colectivos de las operaciones señaladas en las fracciones I y II del artículo 25 de esta Ley, y a los seguros de caución previstos en el inciso g), fracción III, del propio artículo 25 del presente ordenamiento.</p>
    <p style="text-indent: 0pt;text-align: center;">
      <br />
    </p>
    <p style="padding-left: 36pt;text-indent: 0pt;text-align: justify;">Las Instituciones de Seguros deberán consignar en la documentación contractual de los productos de seguros a que se refiere el párrafo anterior, que el producto que ofrece al público se encuentra bajo registro ante la Comisión, en la forma y términos que ésta determine mediante disposiciones de carácter general.</p>
    <p style="text-indent: 0pt;text-align: center;">
      <br />
    </p>
    <p style="padding-left: 36pt;text-indent: 0pt;text-align: justify;">El contrato o cláusula incorporada al mismo, celebrado por una Institución de Seguros sin el registro a que se refiere el presente artículo, es anulable, pero la acción sólo podrá ser ejercida por el contratante, asegurado o beneficiario o por sus causahabientes contra la Institución de Seguros y nunca por ésta contra aquéllos.</p>
    <p class="s21" style="padding-top: 10pt;padding-left: 38pt;text-indent: 0pt;text-align: center;">Cláusula 5.16. Inspección vehicular</p>
    <p style="padding-top: 13pt;padding-left: 39pt;text-indent: 0pt;text-align: justify;">Durante la vigencia de la <b>Póliza</b>, <b>L A T I N O </b>tendrá en todo momento el derecho a solicitar información y fotografías del <b>Vehículo Asegurado</b>, así como inspeccionar y/o verificar la existencia y estado físico del <b>Vehículo Asegurado, </b>el <b>Contratante </b>y/o <b>Asegurado </b>deberá brindar las facilidades necesarias, así como proporcionar la información que le sea solicitada referente al vehículo. </p>
    <p style="text-indent: 0pt;text-align: center;">
      <br />
    </p>
    <p style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">Esta inspección se realizará en días y horas hábiles previa confirmación con el Contratante y/o Asegurado.</p>
    <p style="text-indent: 0pt;text-align: center;">
      <br />
    </p>
    <ol id="l181">
      <li data-list-text="1.">
        <p style="padding-left: 79pt;text-indent: -18pt;text-align: justify;">Para realizar la inspección vehicular Latino enviará un link al correo electrónico o teléfono móvil proporcionado por el Contratante y/o Asegurado.</p>
        <p style="text-indent: 0pt;text-align: center;">
          <br />
        </p>
      </li>
      <li data-list-text="2.">
        <p style="padding-left: 79pt;text-indent: -18pt;text-align: justify;">Al ingresar a la aplicación se mostrará un mensaje de bienvenida informando que serán solicitadas algunas fotografías del exterior del vehículo, de la tarjeta de circulación, Identificación Oficial del asegurado, Número de serie y Odómetro de vehículo.</p>
        <p style="padding-top: 1pt;text-indent: 0pt;text-align: center;">
          <br />
        </p>
      </li>
      <li data-list-text="3.">
        <p style="padding-left: 79pt;text-indent: -18pt;text-align: justify;">Usando el teléfono móvil deberá tomar fotografías a la parte delantera, trasera, lateral frontal y lateral trasera de ambos costados del vehículo. La pantalla mostrará un ejemplo del cuerpo del vehículo que debe abarcar cada fotografía.</p>
        <p style="text-indent: 0pt;text-align: center;">
          <br />
        </p>
      </li>
      <li data-list-text="4.">
        <p style="padding-left: 81pt;text-indent: -21pt;text-align: justify;">Posteriormente la aplicación solicitará fotografías de la tarjeta de circulación, identificación Oficial, Número de serie del vehículo, Odómetro (kilometraje del vehículo asegurado con el auto encendido) y número de serie del vehículo.</p>
        <p style="padding-top: 3pt;text-indent: 0pt;text-align: center;">
          <br />
        </p>
      </li>
      <li data-list-text="5.">
        <p style="padding-left: 79pt;text-indent: -18pt;text-align: justify;">En la siguiente pantalla se solicitará la firma del <b>Contratante </b>y/o <b>Asegurado </b>dentro en el recuadro indicado. </p>
      </li>
      <li data-list-text="6.">
        <p style="padding-top: 11pt;padding-left: 79pt;text-indent: -18pt;text-align: justify;">Finalizada la inspección se solicitará evaluar el proceso de inspección como bueno, regular o malo.</p>
        <p style="text-indent: 0pt;text-align: center;">
          <br />
        </p>
      </li>
      <li data-list-text="7.">
        <p style="padding-left: 81pt;text-indent: -21pt;text-align: justify;">Para finalizar, la aplicación mostrará el número de inspección, con lo cual se da por terminado el proceso de inspección.</p>
      </li>
      <li data-list-text="8.">
        <p style="padding-top: 11pt;padding-left: 79pt;text-indent: -18pt;text-align: justify;">Solo en caso necesario, <span class="s9">L A T I N O </span>solicitará la recaptura de las fotografías que no sean claras o nítidas, lo cual se indicará mediante un mensaje al teléfono móvil señalando que el proceso de inspección ha sido reabierto, mostrando una nueva liga que solicitará solamente las fotografías que son necesarias recapturar sin necesidad de pasar por el resto de las pantallas. </p>
      </li>
    </ol>
    <p style="text-indent: 0pt;text-align: center;">
      <br />
    </p>
    <p class="s15" style="padding-left: 58pt;text-indent: 0pt;text-align: justify;">Si derivado de la inspección vehicular se confirma la prexistencia de daños, los mismos quedarán excluidos de cualquier indemnización al amparo de la presente Póliza.</p>
    <p style="padding-top: 13pt;padding-left: 58pt;text-indent: 0pt;text-align: justify;">Si el <b>Contratante </b>y/o <b>Asegurado </b>no llevase a cabo la inspección del vehículo asegurado mediante el proceso señalado anteriormente ya sea por alguna razón ajena a él o a <span class="s9">L A T I N O, </span>transcurridos 5 días naturales posteriores a que debiera ser completada la inspección mediante la liga enviada al teléfono móvil, <span class="s9">L A T I N O </span>notificará al Asegurado, a través de los datos de contacto que hayan sido proporcionados por el <b>Contratante </b>y/o <b>Asegurado </b>la recepción de la liga y proporcionar asesoría para concluir la inspección vehicular. </p>
    <p style="text-indent: 0pt;text-align: center;">
      <br />
    </p>
    <p style="padding-left: 58pt;text-indent: 0pt;text-align: justify;">Si el Asegurado, tras haber sido notificado o en su defecto no haya sido posible contactarlo por ninguno de los datos de contacto que hayan sido designados por el <b>Contratante </b>y/o <b>Asegurado</b>, no se llevase a cabo la inspección mencionada, en caso de <b>Siniestro</b>, se adicionarán 30 puntos porcentuales adicionales al <b>Deducible </b>estipulado en la <b>Carátula de póliza</b>, al momento de reclamación en las coberturas: <b>Daños Materiales, Solo Pérdida Total y Robo Total</b>. </p>
    <p style="text-indent: 0pt;text-align: center;">
      <br />
    </p>
    <p class="s21" style="padding-left: 39pt;text-indent: 0pt;text-align: center;">Cláusula 5.17.</p>
    <p class="s21" style="padding-left: 38pt;text-indent: 0pt;text-align: center;">Conocimiento explícito del contrato</p>
    <p class="s13" style="padding-top: 13pt;padding-left: 39pt;text-indent: 0pt;text-align: center;">L A T I N O <span class="p">se obliga a entregar al </span>Asegurado <span class="p">o </span>Contratante <span class="p">de la </span>Póliza <span class="p">, los documentos en los que consten los derechos y obligaciones del seguro, a través de cualquiera de los siguientes medios:</span>
    </p>
    <ul id="l182">
      <li data-list-text="">
        <p style="padding-left: 74pt;text-indent: -17pt;line-height: 12pt;text-align: center;">De manera personal al momento de contratar el seguro</p>
      </li>
      <li data-list-text="">
        <p style="padding-left: 74pt;text-indent: -18pt;text-align: center;">Envío a domicilio por los medios que <b>L A T I N O </b>utilice para el efecto, pudiendo ser por correo certificado o correo ordinario, o bien, </p>
      </li>
      <li data-list-text="">
        <p style="padding-left: 74pt;text-indent: -17pt;text-align: center;">Cuenta de correo electrónico del <b>Contratante </b>o <b>Asegurado</b>. </p>
      </li>
    </ul>
    <p style="padding-top: 11pt;padding-left: 39pt;text-indent: 0pt;text-align: justify;">Asimismo, se hace de su conocimiento que las <b>Condiciones Generales </b>están a su disposición para su impresión y consulta en la página de internet de <a href="http://www.latinoseguros.com.mx/" style=" color: black; font-family:Arial, sans-serif; font-style: normal; font-weight: bold; text-decoration: none; font-size: 10pt;" target="_blank">L A T I N O </a>www.latinoseguros.com.mx, así como a través del sello “QR” que aparece en esta <b>Póliza</b>, o en las oficinas de <b>L A T I N O </b>en la dirección establecida en la misma. </p>
    <p style="text-indent: 0pt;text-align: center;">
      <br />
    </p>
    <p class="s13" style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">L A T I N O <span class="p">dejará constancia de la entrega de los documentos antes mencionados, así como el uso de los medios utilizados y señalados para la entrega de la </span>Documentación Contractual <span class="p">de conformidad al medio que hubiera sido utilizado.</span>
    </p>
    <p style="padding-top: 2pt;text-indent: 0pt;text-align: center;">
      <br />
    </p>
    <p style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">Si el <b>Asegurado </b>o <b>Contratante </b>no recibe, dentro de los 30 (treinta) días siguientes de haber contratado su seguro, los documentos a que hace mención el párrafo anterior, deberá comunicarse a los teléfonos 55 5130 2801 en la Ciudad de México, o al 800 685 1170, para el resto de la República, o para que, a través de correo electrónico, obtenga las <b>Condiciones Generales </b>de su producto. </p>
    <p style="text-indent: 0pt;text-align: center;">
      <br />
    </p>
    <p class="s21" style="padding-left: 39pt;text-indent: 0pt;text-align: center;">Cláusula 5.18.</p>
    <p class="s21" style="padding-left: 38pt;text-indent: 0pt;text-align: center;">Modificaciones hechas a las Condiciones Generales</p>
    <p style="padding-top: 13pt;padding-left: 39pt;text-indent: 0pt;text-align: justify;">Si durante la vigencia de la <b>Póliza L A T I N O </b>registra ante la Comisión Nacional de Seguros y Fianzas modificaciones a las <b>Condiciones Generales </b>de este Seguro, éstas se harán del conocimiento del <b>Asegurado </b>mediante endoso, en el que se indicará el apartado en el que se encuentren dentro de las <b>Condiciones Generales </b>y la fecha a partir de la cual comenzarán a surtir efectos. </p>
    <p style="text-indent: 0pt;text-align: center;">
      <br />
    </p>
    <p style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">Pero si dichas modificaciones implican prestaciones más elevadas para <b>L A T I N O</b>, quedará a elección del <b>Asegurado </b>su aplicación, ya que estará obligado a pagar la diferencia en <b>Prima </b>que corresponda. </p>
    <p style="text-indent: 0pt;text-align: center;">
      <br />
    </p>
    <p style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">Adicionalmente, el <b>Asegurado </b>podrá tener acceso a las mismas en la página web de <b>L A T I N O</b>
      <a href="http://www.latinoseguros.com.mx/" class="a" target="_blank">: </a>www.latinoseguros.com.mx. Lo anterior, se lleva a cabo en cumplimiento a lo establecido por el artículo 65 de la Ley sobre el Contrato de Seguro.
    </p>
    <p class="s21" style="padding-top: 4pt;padding-left: 38pt;text-indent: 0pt;text-align: center;">Cláusula 5.19. Agravación del riesgo</p>
    <p style="padding-top: 13pt;padding-left: 39pt;text-indent: 0pt;text-align: justify;">Las obligaciones de <b>L A T I N O </b>cesarán de pleno derecho por las agravaciones esenciales que tenga el riesgo durante el curso del seguro de conformidad con lo previsto en el Artículo 52 y 53 fracción I de la Ley Sobre el Contrato del Seguro. </p>
    <p style="text-indent: 0pt;text-align: center;">
      <br />
    </p>
    <p class="s16" style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">
      <span class="s12">Artículo 52 de la Ley Sobre el Contrato de Seguro. </span>El <b>Asegurado </b>deberá comunicar a la empresa aseguradora las agravaciones esenciales que tenga el riesgo durante el curso del seguro, dentro de las veinticuatro horas siguientes al momento en que las conozca. Si el <b>Asegurado </b>omitiere el aviso o si él provoca una agravación esencial del riesgo, cesarán de pleno derecho las obligaciones de la empresa en lo sucesivo.
    </p>
    <p class="s12" style="padding-top: 11pt;padding-left: 39pt;text-indent: 0pt;text-align: justify;">Artículo 53 de la Ley Sobre el Contrato de Seguro. <span class="s16">Para los efectos del artículo anterior se presumirá siempre:</span>
    </p>
    <p class="s16" style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">I.- Que la agravación es esencial, cuando se refiera a un hecho importante para la apreciación de un riesgo de tal suerte que la empresa habría contratado en condiciones diversas si al celebrar el contrato hubiera conocido una agravación análoga;</p>
    <p class="s16" style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">II.- Que el <b>Asegurado </b>conoce o debe conocer toda agravación que emane de actos u omisiones de sus inquilinos, cónyuge, descendientes o cualquier otra persona que, con el consentimiento del <b>Asegurado</b>, habite el edificio o tenga en su poder el mueble que fuere materia del seguro. </p>
    <p style="text-indent: 0pt;text-align: center;">
      <br />
    </p>
    <p class="s12" style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">Artículo 55 de la Ley Sobre el Contrato de Seguro. <span class="p">Si el asegurado no cumple con esas obligaciones, la empresa aseguradora no podrá hacer uso de la cláusula que la libere de sus obligaciones, cuando el incumplimiento no tenga influencia sobre el siniestro o sobre la extensión de sus prestaciones.</span>
    </p>
    <p style="text-indent: 0pt;text-align: center;">
      <br />
    </p>
    <p class="s16" style="padding-left: 39pt;text-indent: -1pt;text-align: justify;">
      <span class="s12">Artículo 60 de la Ley Sobre el Contrato de Seguro. </span>En los casos de dolo o mala fe en la agravación al riesgo, el <b>Asegurado </b>perderá las <b>Prima</b>s anticipadas.
    </p>
    <p style="padding-top: 3pt;text-indent: 0pt;text-align: center;">
      <br />
    </p>
    <p style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">Las obligaciones de <b>L A T I N O </b>quedarán extinguidas si demuestra que el <b>Asegurado</b>, el <b>Beneficiario </b>o los representantes de ambos, con el fin de hacerla incurrir en error, disimulan o declaran inexactamente hechos que excluirían o podrían restringir dichas obligaciones. </p>
    <p style="padding-top: 11pt;padding-left: 39pt;text-indent: 0pt;text-align: justify;">Lo mismo se observará en caso de que, con igual propósito, no le remitan en tiempo la documentación sobre los hechos relacionados con el <b>Siniestro</b>. <b>(Artículo 70 de la Ley sobre el Contrato de Seguro).</b>
    </p>
    <p style="text-indent: 0pt;text-align: center;">
      <br />
    </p>
    <p class="s21" style="padding-left: 39pt;text-indent: 0pt;text-align: center;">Cláusula 5.20.</p>
    <p class="s21" style="padding-left: 38pt;text-indent: 0pt;text-align: center;">Gastos de recuperación y traslado</p>
    <p style="padding-top: 13pt;padding-left: 39pt;text-indent: 0pt;text-align: justify;">En caso de <b>Siniestro </b>que amerite la indemnización en los términos de esta <b>Póliza </b>y que afecte alguna de las coberturas básicas de Daños Materiales, Sólo Pérdida Total o Robo Total, siempre y cuando el <b>Daño </b>exceda el <b>Deducible </b>contratado, <b>LATINO </b>se hará cargo de las maniobras y gastos correspondientes para poner el <b>Vehículo Asegurado </b>en condiciones de traslado, hasta un límite de 240 UMA (doscientas cuarenta <b>Unidad</b>es <b>de Medida y Actualización</b>), así como de los costos que implique dicho traslado hasta el taller más cercano que asigne <b>LATINO</b>, dicho traslado no está sujeto a límite. </p>
    <p style="text-indent: 0pt;text-align: center;">
      <br />
    </p>
    <p style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">Si el <b>Asegurado </b>o <b>Contratante </b>opta por trasladarlo a un lugar distinto del elegido por <b>LATINO</b>, ésta sólo responderá por este concepto, hasta por la cantidad de 30 UMA (treinta <b>Unidad</b>es <b>de Medida y Actualización</b>) al momento del <b>Siniestro</b>, por lo cual no operarían los 240 UMA (doscientas cuarenta <b>Unidad</b>es <b>de Medida y Actualización</b>) señalados en el párrafo anterior. </p>
    <p style="text-indent: 0pt;text-align: center;">
      <br />
    </p>
    <p style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">En caso de <b>Pérdida Total</b>, por Daños Materiales, Solo Pérdida Total o Robo Total, y cuando el <b>Vehículo Asegurado </b>sea recuperado y remitido a una pensión o corralón perteneciente de la Autoridad, <b>LATINO </b>se obliga a cubrir los gastos por pensión hasta un límite de 30 UMA (treinta <b>Unidad</b>es <b>de Medida y Actualización</b>) vigente al momento del <b>Siniestro</b>. </p>
    <p style="padding-left: 105pt;text-indent: 0pt;text-align: center;">.</p>
    <p class="s21" style="padding-left: 38pt;text-indent: 0pt;text-align: center;">Cláusula 5.21. Peritaje</p>
    <p style="padding-top: 13pt;padding-left: 39pt;text-indent: 0pt;text-align: justify;">En caso de desacuerdo entre el <b>Contratante </b>y <b>L A T I N O </b>, acerca del monto de cualquier pérdida o <b>Daño</b>, la cuestión será sometida a dictamen de un perito, que ambas partes designen de común acuerdo por escrito; pero si no se pusieran de acuerdo en el nombramiento de un solo perito, se designarán dos, uno por cada parte, lo cual se hará en un plazo de diez días contados a partir de la fecha en que cada una de ellas hubiere sido requerida por la otra por escrito para que lo hiciere, antes de empezar sus labores los dos peritos nombrarán un tercero para el caso de discordia. </p>
    <p style="text-indent: 0pt;text-align: center;">
      <br />
    </p>
    <p style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">Si una de las partes se negase a nombrar su perito o simplemente no lo hiciere cuando fuere requerido por la otra parte o si los peritos no se pusieren de acuerdo en el nombramiento del tercero, será la autoridad judicial la que a petición de cualquiera de las partes hará el nombramiento del perito, del perito tercero o de ambos si fuera necesario, sin embargo, la Comisión Nacional para la Protección y Defensa de los Usuarios de Servicios Financieros CONDUSEF podrá nombrar el perito o el perito tercero en su caso, si de común acuerdo las partes así lo solicitaren.</p>
    <p style="text-indent: 0pt;text-align: center;">
      <br />
    </p>
    <p style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">El fallecimiento de una de las partes si fuera persona física, o su disolución si fuera persona moral, ocurrido mientras se esté realizando el peritaje, no anulará ni afectará los poderes o atribuciones del perito, del perito tercero según sea el caso, o si alguno de los peritos de las partes o del perito tercero falleciere antes del dictamen, será designado otro por quien corresponda (las partes, los peritos, la autoridad judicial o la Comisión Nacional para la Protección y Defensa de los Usuarios de Servicios Financieros) para que lo sustituya <span class="s24">.</span>
    </p>
    <p style="padding-top: 3pt;padding-left: 39pt;text-indent: 0pt;text-align: center;">Los gastos que se originen con motivo del peritaje serán a cargo de <b>L A T I N O </b>y del <b>Contratante</b>
    </p>
    <p style="padding-left: 39pt;text-indent: 0pt;text-align: center;">por partes iguales, pero cada parte cubrirá los honorarios de su propio perito.</p>
    <p style="text-indent: 0pt;text-align: center;">
      <br />
    </p>
    <p style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">El peritaje a que se refiere esta cláusula no significa aceptación de la reclamación por parte de <b>L A T I N O</b>, simplemente determinará el monto de la pérdida que eventualmente estaría obligada <b>L A T I N O </b>a resarcir, quedando las partes en libertad de ejercer las acciones y oponer las excepciones correspondientes. </p>
    <p style="text-indent: 0pt;text-align: center;">
      <br />
    </p>
    <p class="s21" style="padding-left: 38pt;text-indent: 0pt;text-align: center;">Cláusula 5.22. Renovación</p>
    <p class="s15" style="padding-top: 13pt;padding-left: 38pt;text-indent: 0pt;text-align: center;">L A T I N O</p>
    <p style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">Al vencimiento del periodo del seguro, <b>L A T I N O </b>informará al <b>Contratante </b>o <b>Asegurado</b>, el procedimiento para la renovación de la <b>Póliza</b>, el cual deberá realizarse dentro del periodo de 30 (treinta) días naturales de anticipación a dicha renovación. <b>L A T I N O </b>tendrá el derecho de solicitar información del <b>Vehículo Asegurado </b>a través de plataformas digitales, del agente y/o de personas debidamente autorizadas por <b>L A T I N O</b>. </p>
    <p style="text-indent: 0pt;text-align: center;">
      <br />
    </p>
    <p class="s13" style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">L A T I N O <span class="p">contará con un periodo de 5 (cinco) días naturales, posteriores a la realización del procedimiento para la renovación por el </span>Contratante <span class="p">o </span>Asegurado <span class="p">, para informar al </span>Contratante <span class="p">o </span>Asegurado <span class="p">el valor de la </span>Prima <span class="p">bajo los mismos términos y condiciones que fue contratada la </span>Póliza <span class="p">, expidiendo una nueva </span>Póliza <span class="p">a la que se aplicará la tarifa vigente al momento de la renovación; si dentro de los últimos 20 (veinte) días hábiles antes del vencimiento de la </span>Póliza <span class="p">, el </span>Contratante <span class="p">y/o </span>Asegurado <span class="p">no da aviso a </span>L A T I N O <span class="p">por escrito, de su voluntad de que no sea renovada.</span>
    </p>
    <p style="padding-top: 4pt;padding-left: 38pt;text-indent: 0pt;text-align: justify;">Si dentro de los últimos 25 (veinticinco) días naturales anteriores al vencimiento de la <b>Póliza</b>, el </p>
    <p class="s13" style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">Contratante <span class="p">y/o </span>Asegurado <span class="p">no realiza el procedimiento de renovación, la </span>Póliza <span class="p">no será renovada.</span>
    </p>
    <p style="text-indent: 0pt;text-align: center;">
      <br />
    </p>
    <p class="s21" style="padding-left: 39pt;text-indent: 0pt;text-align: center;">Cláusula 5.23.</p>
    <p class="s21" style="padding-left: 38pt;text-indent: 0pt;text-align: center;">Descuento por nómina, domiciliación bancaria o cargo on-line recurrente</p>
    <p style="padding-top: 13pt;padding-left: 39pt;text-indent: 0pt;text-align: justify;">El <b>Contratante </b>(empleado o funcionario) que haya adquirido un seguro de manera voluntaria bajo el esquema de cobro “Descuento por Nómina” o “Domiciliación Bancaria” o “Cargo Online Recurrente” (cuenta de cheques, débito o crédito), tiene la obligación de vigilar que en sus recibos de pago o estados de cuenta se haya realizado la retención o cargo de la <b>Prima </b>del seguro contratado, de acuerdo con los siguientes plazos. </p>
    <p style="padding-top: 1pt;text-indent: 0pt;text-align: center;">
      <br />
    </p>
    <p style="padding-left: 72pt;text-indent: -11pt;text-align: center;">
      <span class="s59"></span>En Descuento por Nómina dentro de los primeros 120 (ciento veinte) días naturales posteriores al inicio de vigencia de la <b>Póliza </b>de seguro, o;
    </p>
    <p style="padding-top: 1pt;padding-left: 72pt;text-indent: -11pt;text-align: center;">
      <span class="s59"></span>En Domiciliación Bancaria o Cargo Online Recurrente dentro de los primeros 30 (treinta) días naturales, posteriores al inicio de la vigencia de la <b>Póliza </b>de seguro.
    </p>
    <p style="text-indent: 0pt;text-align: center;">
      <br />
    </p>
    <p style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">En caso de que no aparezca dicha retención o cargo, deberá recurrir de inmediato con su agente de seguros o llamar directamente al centro de atención telefónico <b>L A T I N O </b>para reportarlo. </p>
    <p style="text-indent: 0pt;text-align: center;">
      <br />
    </p>
    <p style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">Si dentro del periodo estipulado, según sea el caso, no se ha realizado la primera retención o cargo, cesarán automáticamente los efectos del <b>Contrato</b>, de acuerdo con la Cláusula &quot;Prima, plazo y obligaciones de pago&quot;, descrita en estas <b>Condiciones Generales.</b>
    </p>
    <p style="padding-top: 4pt;text-indent: 0pt;text-align: center;">
      <br />
    </p>
    <p style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">En los cargos subsecuentes, de ser el caso, el <b>Asegurado </b>tendrá el mismo plazo de prórroga de pago, que el primer recibo, una vez transcurridos este periodo sin que se realice el mismo, <b>L A T I N O </b>tendrá el derecho de efectuar la terminación anticipada del <b>Contrato </b>o cancelación del mismo por falta de pago, lo anterior de conformidad con lo señalado en las presentes <b>Condiciones</b>
    </p>
    <p class="s13" style="padding-top: 3pt;padding-left: 39pt;text-indent: 0pt;text-align: justify;">Generales <span class="p">en la Cláusula &quot;Prima, plazo y obligaciones de pago&quot;.</span>
    </p>
    <p style="text-indent: 0pt;text-align: center;">
      <br />
    </p>
    <p style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">Cuando por falta de fondos, no se pudiera efectuar la retención pactada, <b>L A T I N O </b>le solicitará al banco que efectúe el cargo del próximo periodo y un importe adicional de hasta el monto de pago no efectuado del o los periodo(s) anteriores; si pasado el periodo de prorroga no se logró efectuar el pago correspondiente de dicho atraso, <b>L A T I N O </b>podrá efectuar la terminación anticipada del <b>Contrato </b>o cancelación por falta de pago, de acuerdo con la Cláusula &quot;Prima, plazos y obligaciones de pago&quot;, descrita en las presentes <b>Condiciones Generales</b>. </p>
    <p style="text-indent: 0pt;text-align: center;">
      <br />
    </p>
    <p style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">Las retenciones o cargos podrán ser suspendidos en los siguientes casos:</p>
    <ol id="l183">
      <li data-list-text="1.">
        <p style="padding-top: 11pt;padding-left: 81pt;text-indent: -21pt;text-align: justify;">Por cancelación del seguro, con instrucción escrita del <b>Contratante</b>. Esta cancelación surtirá efecto a partir de la fecha en que sea recibida por <b>L A T I N O </b>, en el entendido de que por el desfasamiento del cobro puede proceder el cobro de uno o más periodos subsecuentes a la fecha de terminación anticipada del <b>Contrato </b>o cancelación de éste, considerando el periodo que la <b>Póliza </b>estuvo en riesgo para <b>L A T I N O </b>. </p>
      </li>
      <li data-list-text="2.">
        <p style="padding-left: 81pt;text-indent: -21pt;text-align: justify;">Por terminación de la relación laboral con la empresa o colectividad de que se trate.</p>
      </li>
    </ol>
    <p style="text-indent: 0pt;text-align: center;">
      <br />
    </p>
    <p style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">Para los cargos por Domiciliación Bancaria o Cargo Online Recurrente (cuenta de cheques, débito o crédito) también serán causas de suspensión:</p>
    <ol id="l184">
      <li data-list-text="1.">
        <p style="padding-top: 11pt;padding-left: 81pt;text-indent: -23pt;text-align: center;">Cancelación del instrumento bancario no notificado a <b>L A T I N O</b>. </p>
      </li>
      <li data-list-text="2.">
        <p style="padding-left: 81pt;text-indent: -23pt;text-align: center;">Reposición(es) de tarjeta(s) de crédito no notificada(s) a <b>L A T I N O </b>con diferente número de cuenta o tarjeta. </p>
      </li>
      <li data-list-text="3.">
        <p style="padding-left: 81pt;text-indent: -23pt;line-height: 11pt;text-align: center;">Por rechazo bancario.</p>
      </li>
      <li data-list-text="4.">
        <p style="padding-left: 81pt;text-indent: -23pt;line-height: 11pt;text-align: center;">Falta de fondos o crédito.</p>
      </li>
      <li data-list-text="5.">
        <p class="s9" style="padding-top: 4pt;padding-left: 79pt;text-indent: -23pt;text-align: justify;">
          <span class="p">Cualquier otra causa que impida el cargo respectivo, ajena a la responsabilidad de </span>L A T I N O <span class="s11">renovará este seguro y la </span>Póliza <span class="s11">, siempre y cuando se encuentre al corriente en sus pagos y no reciba instrucción en contrario por parte del </span>Asegurado <span class="s11">. Si la presente </span>Póliza <span class="s11">corresponde a una renovación, sólo surtirá efecto si no existen </span>Prima <span class="s11">s pendientes de pago de vigencias anteriores.</span>
        </p>
        <p style="padding-top: 3pt;text-indent: 0pt;text-align: center;">
          <br />
        </p>
        <p class="s21" style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">Cláusula 5.24.</p>
        <p class="s21" style="padding-top: 4pt;padding-left: 39pt;text-indent: 0pt;text-align: justify;">Entrega de documentación cuando la contratación de este seguro se efectúe a través de un prestador de servicios</p>
        <p style="padding-top: 4pt;text-indent: 0pt;text-align: center;">
          <br />
        </p>
        <p style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">Cuando la contratación del Seguro se realice a través de un prestador de servicios, <b>L A T I N O </b>hará entrega por este conducto de la <b>Póliza </b>de seguro, <b>Condiciones Generales</b>, y cualquier otro documento que contenga derechos y obligaciones que deriven del <b>Contrato de Seguro</b>, quien recabará del <b>Asegurado </b>o <b>Contratante </b>constancia de entrega. </p>
        <p style="padding-top: 11pt;padding-left: 39pt;text-indent: 0pt;text-align: justify;">Con independencia de la obligación de <b>L A T I N O </b>de entregar por escrito la <b>Documentación Contractual </b>que contenga los derechos y obligaciones de las partes, derivados del <b>Contrato </b>celebrado, el <b>Asegurado </b>o <b>Contratante </b>podrá consultar e imprimir las <b>Condiciones Generales </b>
          <a href="http://www.latinoseguros.com.mx/" class="a" target="_blank">y modelo de clausulado que correspondan al seguro contratado, accediendo a la página </a>www.latinoseguros.com.mx. Si el <b>Asegurado </b>o <b>Contratante </b>por cualquier motivo, no recibe o no puede obtener los documentos referidos en párrafos anteriores dentro de los 30 (treinta) días naturales siguientes a su contratación, deberá acudir a las oficinas de <b>L A T I N O </b>o llamar Centro de Atención Telefónica de la compañía al telefónico 55 5130 2801 en la Ciudad de México, o al 800 685 1170 para el resto de la República, para que se le indique en razón de su domicilio, la ubicación del lugar al que deberá acudir a recoger su <b>Carátula de Póliza </b>y todos los documentos relacionados con el seguro contratado.
        </p>
        <p style="padding-top: 3pt;text-indent: 0pt;text-align: center;">
          <br />
        </p>
        <p style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">En caso de que el último día de plazo señalado en el párrafo anterior sea inhábil, la entrega de la documentación se realizará el día hábil inmediato siguiente.</p>
        <p style="padding-top: 4pt;text-indent: 0pt;text-align: center;">
          <br />
        </p>
        <p style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">El <b>Asegurado </b>o <b>Contratante </b>podrá solicitar la cancelación de su <b>Póliza </b>de seguro, o la no renovación a través del prestador de servicios con quien efectuó la contratación, o por medio de <b>L A T I N O </b>, según corresponda, en un plazo de 24 (veinticuatro) horas a 10 (diez) días hábiles posteriores a la solicitud, debiendo recabar el prestador de servicios o <b>L A T I N O </b>la firma del <b>Asegurado </b>o <b>Contratante </b>para dejar constancia de haber recibido el endoso correspondiente o podrá llamar al Centro de Atención Telefónica de <b>L A T I N O </b>al teléfono 55 5130 2801 en la Ciudad de México, o al 800 685 1170 para el resto de la República, para recibir asesoría. </p>
        <p class="s21" style="padding-top: 11pt;padding-left: 39pt;text-indent: 0pt;text-align: center;">Cláusula 5.25.</p>
        <p class="s21" style="padding-top: 4pt;padding-left: 39pt;text-indent: 0pt;text-align: center;">Limitación en la intermediación</p>
        <p style="padding-top: 11pt;padding-left: 39pt;text-indent: 0pt;text-align: justify;">Los agentes de seguro con quienes <b>L A T I N O </b>celebre contratos de intermediación para efectuar la venta de seguros carecen de facultades de representación de <b>L A T I N O </b>para aceptar riesgos y/o suscribir y/o modificar pólizas. </p>
        <p style="text-indent: 0pt;text-align: center;">
          <br />
        </p>
        <p class="s21" style="padding-left: 39pt;text-indent: 0pt;text-align: center;">Cláusula 5.26.</p>
        <p class="s21" style="padding-top: 4pt;padding-left: 39pt;text-indent: 0pt;text-align: center;">Derechos de los contratantes</p>
        <p style="padding-top: 4pt;text-indent: 0pt;text-align: center;">
          <br />
        </p>
        <p style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">Durante la vigencia de la <b>Póliza</b>, el <b>Contratante </b>podrá solicitar por escrito a <b>L A T I N O </b>le informe el porcentaje de la <b>Prima </b>que, por concepto de comisión o compensación directa, corresponda al intermediario o persona moral por su intervención en la celebración de este contrato. <b>L A T I N O </b>proporcionará dicha información, por escrito o por medios electrónicos, en un plazo que no excederá de diez días hábiles posteriores a la fecha de recepción de la solicitud. </p>
        <p style="padding-top: 1pt;text-indent: 0pt;text-align: center;">
          <br />
        </p>
        <p class="s16" style="padding-left: 60pt;text-indent: 0pt;text-align: justify;">
          <span class="s55">Artículo 101 de la Ley de Instituciones de Seguros y de Fianzas. </span>Las Instituciones deberán diversificar los conductos de colocación de sus productos, a fin de evitar situaciones de dependencia o coacción de un agente de seguros, un agente de fianzas, intermediario, <b>Contratante</b>, <b>Asegurado</b>, fiado o <b>Beneficiario</b>.
        </p>
        <p class="s16" style="padding-top: 11pt;padding-left: 60pt;text-indent: 0pt;text-align: justify;">Las Instituciones sólo podrán pagar comisiones y cualquier otra compensación por la contratación de seguros o de fianzas, a agentes de seguros o a agentes de fianzas, sobre las <b>Prima</b>s que efectivamente hayan ingresado a la Institución de que se trate. </p>
        <p style="padding-top: 4pt;text-indent: 0pt;text-align: center;">
          <br />
        </p>
        <p class="s16" style="padding-left: 60pt;text-indent: 0pt;text-align: justify;">Las Instituciones podrán, tomando en cuenta las condiciones de contratación o características de los riesgos que cubran los seguros, o las características de las obligaciones y responsabilidades que garanticen las fianzas, aplicar total o parcialmente las comisiones establecidas para los agentes en beneficio del <b>Asegurado </b>o <b>Contratante</b>, o del solicitante o fiado, según sea el caso, procurando en todo momento el desarrollo de los planes de seguros o de la fianza, en las mejores condiciones de contratación. En este supuesto, las Instituciones deberán especificar en la <b>Póliza </b>y en los recibos de <b>Prima</b>s correspondientes, el monto de la reducción de <b>Prima</b>s que corresponda a la aplicación total o parcial de las citadas comisiones. </p>
        <p style="padding-top: 4pt;text-indent: 0pt;text-align: center;">
          <br />
        </p>
        <p class="s55" style="padding-left: 60pt;text-indent: 0pt;text-align: justify;">Artículo 102 de la Ley de Instituciones de Seguros y de Fianzas. <span class="s16">En los seguros que se formalicen a través de contratos de adhesión, excepto los que se refieran a seguros de pensiones derivados de las leyes de seguridad social y a seguros de caución, la contratación podrá realizarse a través de una persona moral, sin la intervención de un agente de seguros. Las Instituciones de Seguros podrán pagar o compensar a las citadas personas morales</span>
        </p>
        <p class="s16" style="padding-top: 3pt;padding-left: 60pt;text-indent: 0pt;text-align: justify;">servicios distintos a los que esta Ley reserva a los agentes de seguros. Para ello deberán suscribir contratos de prestación de servicios cuyos textos deberán registrarse previamente ante la Comisión, la que dentro de un plazo de quince días hábiles siguientes a la recepción de la documentación podrá negar el registro, cuando a su juicio los contratos no se apeguen a las disposiciones jurídicas aplicables y podrá ordenar las modificaciones o correcciones necesarias, prohibiendo su utilización hasta en tanto no se lleven a cabo los cambios ordenados. En caso de que la Comisión no formule observaciones dentro del plazo señalado, se entenderá que los documentos han quedado registrados y no existirá inconveniente para su utilización.</p>
        <p class="s16" style="padding-left: 60pt;text-indent: 0pt;text-align: justify;">Las personas morales a que se refiere este artículo estarán sujetas a la inspección y vigilancia de la Comisión, respecto de las operaciones previstas en el mismo.</p>
        <p style="text-indent: 0pt;text-align: center;">
          <br />
        </p>
        <p class="s55" style="padding-left: 60pt;text-indent: 0pt;text-align: justify;">Artículo 103 de la Ley de Instituciones de Seguros y de Fianzas. <span class="s16">La operación de las personas morales a que se refiere el artículo 102 de la presente Ley, deberá ajustarse a las siguientes bases:</span>
        </p>
        <p style="text-indent: 0pt;text-align: center;">
          <br />
        </p>
        <ol id="l185">
          <li data-list-text="I.">
            <p class="s16" style="padding-left: 60pt;text-indent: 0pt;text-align: justify;">Tratándose de intermediarios financieros sujetos a la inspección y vigilancia por parte de las autoridades financieras, y que celebren con el público operaciones de promoción o venta de productos de seguros para una sola Institución de Seguros, para Instituciones de Seguros integrantes de un mismo grupo financiero o para Instituciones de Seguros que practiquen operaciones o ramos distintos entre sí, su operación se sujetará a lo siguiente:</p>
            <ol id="l186">
              <li data-list-text="a)">
                <p class="s16" style="padding-top: 4pt;padding-left: 81pt;text-indent: -21pt;text-align: justify;">En el caso de productos de seguros con componentes de ahorro o inversión, la Institución de Seguros con la cual el intermediario financiero tenga celebrado un contrato de prestación de servicios conforme a lo dispuesto en el artículo 102 de esta Ley, deberá registrar ante la Comisión, en los términos previstos en los artículos 202 a 205 de este ordenamiento, como parte de la documentación contractual del producto de seguro, un programa de capacitación especializada que deberá aplicarse a los empleados y apoderados del intermediario financiero que participará en la comercialización del producto de seguro de que se trate tomando en consideración las características y naturaleza del mismo, y</p>
              </li>
              <li data-list-text="b)">
                <p class="s16" style="padding-left: 81pt;text-indent: -21pt;text-align: justify;">En el caso de productos de seguros distintos a los señalados en el inciso anterior, la Institución de Seguros con la cual el intermediario financiero tenga celebrado un contrato de prestación de servicios en términos de lo previsto en el artículo 102 de esta Ley, deberá establecer en el propio contrato los programas de capacitación que, en su caso, se requieran en función de las características o complejidad de los productos de seguros de que se trate, y</p>
                <p style="text-indent: 0pt;text-align: center;">
                  <br />
                </p>
              </li>
            </ol>
          </li>
          <li data-list-text="II.">
            <p class="s16" style="padding-left: 60pt;text-indent: 0pt;text-align: justify;">Tratándose de personas morales que no se ubiquen en el supuesto señalado en la fracción anterior, su operación se sujetará a las disposiciones de carácter general que al efecto expida la Comisión, conforme a lo siguiente:</p>
            <ol id="l187">
              <li data-list-text="a)">
                <p class="s16" style="padding-left: 81pt;text-indent: -21pt;text-align: justify;">Establecerán los casos en que los empleados o apoderados de la persona moral que celebren con el público operaciones de promoción o venta de productos de seguros, deban recibir capacitación por parte de las Instituciones de Seguros, o bien obtener la evaluación y certificación correspondiente ante la propia Comisión, considerando para ello la naturaleza de las actividades que conforme a su objeto social realice la persona moral y las características o complejidad de los productos de seguros de que se trate, y</p>
              </li>
              <li data-list-text="b)">
                <p class="s16" style="padding-left: 81pt;text-indent: -21pt;text-align: justify;">Determinarán los requisitos y medidas que deberán cumplir para prevenir y evitar conflictos de interés, que puedan derivarse de la venta de productos de seguros de más de una Institución de Seguros por parte de una misma persona moral, o de varias personas morales cuando se encuentren bajo el control patrimonial o administrativo de una misma persona o Grupo de Personas.</p>
              </li>
            </ol>
          </li>
        </ol>
      </li>
    </ol>
    <p style="text-indent: 0pt;text-align: center;">
      <br />
    </p>
    <p class="s16" style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">
      <span class="s55">Artículo 104 de la Ley de Instituciones de Seguros y de Fianzas. </span>Las Instituciones de Seguros serán responsables de los daños y perjuicios que se lleguen a ocasionar a los <b>Asegurado</b>s, <b>Contratante</b>s o <b>Beneficiario</b>s, con la actuación de las personas morales con las que celebren
    </p>
    <p class="s16" style="padding-top: 3pt;padding-left: 39pt;text-indent: 0pt;text-align: justify;">contratos en los términos del artículo 102 de esta Ley.</p>
    <p class="s55" style="padding-top: 11pt;padding-left: 39pt;text-indent: 0pt;text-align: justify;">Artículo 105 de la Ley de Instituciones de Seguros y de Fianzas. <span class="s16">Las Instituciones, los agentes de seguros, los agentes de fianzas y las personas morales a que se refiere el artículo 102 de este ordenamiento, deberán dar a conocer al público información sobre su operación, en la forma y términos que determine la Comisión mediante disposiciones de carácter general.</span>
    </p>
    <p style="text-indent: 0pt;text-align: center;">
      <br />
    </p>
    <p class="s21" style="padding-left: 39pt;text-indent: 0pt;text-align: center;">Cláusula 5.27.</p>
    <p class="s21" style="padding-top: 4pt;padding-left: 39pt;text-indent: 0pt;text-align: center;">Datos de UNE y CONDUSEF</p>
    <p class="s21" style="padding-top: 11pt;padding-left: 39pt;text-indent: 0pt;text-align: center;">Unidad Especializada de Atención a Usuarios (UNE)</p>
    <p style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">Para cualquier aclaración o duda con relación al seguro, podrá contactar a la Unidad Especializada de <b>L A T I N O </b>ubicada en: </p>
    <p style="text-indent: 0pt;text-align: center;">
      <br />
    </p>
    <table style="border-collapse:collapse;margin-left:39.594pt" cellspacing="0">
      <tr style="height:12pt">
        <td style="width:62pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s39" style="padding-left: 14pt;text-indent: 0pt;line-height: 11pt;text-align: center;">Oficina</p>
        </td>
        <td style="width:86pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s39" style="padding-left: 22pt;text-indent: 0pt;line-height: 11pt;text-align: center;">Teléfono</p>
        </td>
        <td style="width:91pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s39" style="padding-left: 22pt;text-indent: 0pt;line-height: 11pt;text-align: center;">Domicilio</p>
        </td>
        <td style="width:214pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s39" style="padding-left: 6pt;text-indent: 0pt;line-height: 11pt;text-align: center;">Horarios de atención y correo electrónico.</p>
        </td>
      </tr>
      <tr style="height:70pt">
        <td style="width:62pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s40" style="padding-left: 5pt;text-indent: 0pt;text-align: center;">Delegación Matriz</p>
        </td>
        <td style="width:86pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s40" style="padding-left: 5pt;text-indent: 0pt;line-height: 11pt;text-align: center;">5551302800</p>
          <p class="s40" style="padding-left: 5pt;text-indent: 0pt;line-height: 11pt;text-align: center;">ext. 1633</p>
          <p class="s40" style="padding-left: 5pt;text-indent: 0pt;line-height: 11pt;text-align: center;">800 001 19 00</p>
        </td>
        <td style="width:91pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s40" style="padding-left: 5pt;padding-right: 7pt;text-indent: 0pt;text-align: center;">Eje Central Lázaro Cárdenas No. 2 Piso 8 Col.</p>
          <p class="s40" style="padding-left: 5pt;text-indent: 0pt;line-height: 11pt;text-align: center;">Centro CP 06007</p>
          <p class="s40" style="padding-left: 5pt;text-indent: 0pt;line-height: 12pt;text-align: center;">Del. Cuauhtémoc, CDMX</p>
        </td>
        <td style="width:214pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p style="padding-left: 5pt;padding-right: 5pt;text-indent: 0pt;text-align: center;">
            <a href="mailto:unidad_especializada@latinoseguros.com.mx" style=" color: black; font-family:Arial, sans-serif; font-style: normal; font-weight: normal; text-decoration: none; font-size: 10pt;" target="_blank">De lunes a jueves de 9 am a 5 pm y viernes de 9 am a 2 pm. </a>
            <a href="mailto:unidad_especializada@latinoseguros.com.mx" class="s60" target="_blank">unidad_especializada@latinoseguros.com.mx</a>
          </p>
        </td>
      </tr>
      <tr style="height:58pt">
        <td style="width:62pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s40" style="padding-left: 5pt;text-indent: 0pt;text-align: center;">Delegación Bajío</p>
        </td>
        <td style="width:86pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s40" style="padding-left: 5pt;text-indent: 0pt;line-height: 11pt;text-align: center;">477 71 71 539 -</p>
          <p class="s40" style="padding-left: 5pt;text-indent: 0pt;line-height: 11pt;text-align: center;">3659 ext. 1800</p>
          <p class="s40" style="padding-left: 5pt;text-indent: 0pt;line-height: 11pt;text-align: center;">800 001 19 00</p>
        </td>
        <td style="width:91pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s40" style="padding-left: 5pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">Fuego No. 101 L 1 Col. Jardines del Moral CP 37160 León Guanajuato</p>
        </td>
        <td style="width:214pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p style="padding-left: 5pt;padding-right: 5pt;text-indent: 0pt;text-align: center;">
            <a href="mailto:unidad_especializada@latinoseguros.com.mx" style=" color: black; font-family:Arial, sans-serif; font-style: normal; font-weight: normal; text-decoration: none; font-size: 10pt;" target="_blank">De lunes a jueves de 9 am a 5 pm y viernes de 9 am a 2 pm </a>
            <a href="mailto:unidad_especializada@latinoseguros.com.mx" class="s60" target="_blank">unidad_especializada@latinoseguros.com.mx</a>
          </p>
        </td>
      </tr>
      <tr style="height:70pt">
        <td style="width:62pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s40" style="padding-left: 5pt;padding-right: 7pt;text-indent: 0pt;text-align: center;">Delegación Chihuahua</p>
        </td>
        <td style="width:86pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s40" style="padding-left: 5pt;text-indent: 0pt;line-height: 11pt;text-align: center;">614 413 38 92</p>
          <p class="s40" style="padding-left: 5pt;text-indent: 0pt;text-align: center;">800 001 19 00</p>
        </td>
        <td style="width:91pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p class="s40" style="padding-left: 5pt;padding-right: 17pt;text-indent: 0pt;text-align: center;">Av. San Felipe No. 1014 A Col.</p>
          <p class="s40" style="padding-left: 5pt;padding-right: 23pt;text-indent: 0pt;text-align: center;">San Felipe CP 31203</p>
          <p class="s40" style="padding-left: 5pt;text-indent: 0pt;line-height: 12pt;text-align: center;">Chihuahua, Chihuahua</p>
        </td>
        <td style="width:214pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
          <p style="padding-left: 5pt;padding-right: 5pt;text-indent: 0pt;text-align: center;">
            <a href="mailto:unidad_especializada@latinoseguros.com.mx" style=" color: black; font-family:Arial, sans-serif; font-style: normal; font-weight: normal; text-decoration: none; font-size: 10pt;" target="_blank">De lunes a jueves de 9 am a 5 pm y viernes de 9 am a 2 pm </a>
            <a href="mailto:unidad_especializada@latinoseguros.com.mx" class="s60" target="_blank">unidad_especializada@latinoseguros.com.mx</a>
          </p>
        </td>
      </tr>
    </table>
    <p style="text-indent: 0pt;text-align: center;">
      <br />
    </p>
    <p class="s21" style="padding-left: 39pt;text-indent: 0pt;text-align: center;">Comisión Nacional para la Protección y Defensa de los Usuarios de Servicios Financieros (CONDUSEF)</p>
    <p style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">Avenida Insurgentes Sur #762, Colonia del Valle, Ciudad de México C.P. 03100. Teléfono (55) 5340 0999 y (800) 999 80 80.</p>
    <p style="padding-left: 39pt;text-indent: 0pt;line-height: 11pt;text-align: justify;">
      <a href="http://www.condusef.gob.mx/" class="a" target="_blank">Página Web </a>
      <a href="mailto:asesorÃ­a@condusef.gob.mx" class="a" target="_blank">www.condusef.gob.mx; correo electrónico </a>
      <a href="mailto:asesorÃ­a@condusef.gob.mx" target="_blank">asesoría@condusef.gob.mx.</a>
    </p>
    <p class="s21" style="padding-top: 11pt;padding-left: 39pt;text-indent: 0pt;text-align: justify;">Cláusula 5.28.</p>
    <p class="s8" style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">
      <a name="a186">Cláusula relativa a los delitos considerados por el artículo 492 de la Ley de Instituciones de Seguros y de Fianzas.</a>
    </p>
    <p style="padding-top: 1pt;text-indent: 0pt;text-align: center;">
      <br />
    </p>
    <p style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">En caso de que, en el presente o a futuro, el (los) <b>Contratante</b>(s), <b>Asegurado</b>(s) o <b>Beneficiario</b>(s) realicen actividades ilícitas, o se relacionen con las mismas, será considerado como agravación esencial del riesgo en términos de Ley y de las presentes <b>Condiciones Generales </b>y cesarán de pleno derecho las obligaciones de <b>L A T I N O</b>. </p>
    <p style="text-indent: 0pt;text-align: center;">
      <br />
    </p>
    <p style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">De igual forma, se considerará agravación esencial del riesgo y en consecuencia cesarán de pleno derecho las obligaciones de <b>L A T I N O</b>, si el (los) <b>Contratante</b>(s), <b>Asegurado</b>(s) o <b>Beneficiario</b>(s), en los términos del Artículo 492 de la Ley de Instituciones de Seguros y de Fianzas, y sus disposiciones generales, fuere(n) condenado(s) mediante sentencia definitiva que haya causado estado, por cualquier delito vinculado o derivado de lo establecido en los Artículos 139, 139 Quáter, </p>
    <p style="padding-top: 3pt;padding-left: 39pt;text-indent: 0pt;text-align: justify;">148 Bis, 193 a 199, 400 Bis del Código Penal Federal y/o cualquier artículo relativo a la delincuencia organizada en territorio nacional; dicha sentencia podrá ser emitida por cualquier autoridad competente del fuero local o federal, o legalmente reconocida por el Gobierno Mexicano; o, si el nombre del(los) <b>Contratante</b>(s), <b>Asegurado</b>(s) o <b>Beneficiario</b>(s), sus actividades, bienes cubiertos por la <b>Póliza </b>o sus nacionalidades, es (son) publicado(s) en alguna lista emitida en términos de la fracción X disposición Trigésima Novena, fracción VII de la disposición Cuadragésima Cuarta, Capítulo XV, y disposición Septuagésima Séptima del ACUERDO por la que se emiten las disposiciones de carácter general a que se refiere el Artículo 492 de la Ley de Instituciones de Seguro y de Fianzas, aplicables a instituciones y sociedades mutualistas de seguros. </p>
    <p style="padding-top: 11pt;padding-left: 39pt;text-indent: 0pt;text-align: justify;">En caso de que el <b>Asegurado</b>, <b>Beneficiario </b>y/o <b>Contratante</b>, obtenga sentencia absolutoria definitiva o deje de encontrarse en las listas mencionadas anteriormente, cuando así lo solicite el <b>Asegurado </b>y/o <b>Contratante</b>, y la <b>Póliza </b>se encuentre dentro del periodo de vigencia <b>L A T I N O</b>, rehabilitara la <b>Póliza </b>del <b>Asegurado</b>, con efectos retroactivos por el periodo que quedo asegurado el <b>Asegurado</b>, <b>Beneficiario </b>y/o <b>Contratante </b>al descubierto, debiendo el <b>Asegurado</b>, <b>Beneficiario </b>y/o <b>Contratante</b>, cubrir las <b>Prima</b>s que haya dejado de pagar, restableciéndose de nueva cuenta los derechos, obligaciones y antigüedad del <b>Contrato de Seguro </b>que se está rehabilitando, procediendo en consecuencia la indemnización de cualquier siniestro asegurado que hubiere ocurrido en ese lapso. </p>
    <p style="text-indent: 0pt;text-align: center;">
      <br />
    </p>
    <p class="s13" style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">L A T I N O <span class="p">consignará ante la autoridad jurisdiccional, cualquier cantidad que derivada de este </span>Contrato de Seguro <span class="p">pudiera quedar a favor de la persona o personas a las que se refiere el párrafo anterior, con la finalidad de que dicha autoridad determine el destino de los recursos.</span>
    </p>
    <p class="s11" style="padding-top: 11pt;padding-left: 36pt;text-indent: 0pt;text-align: center;">
      <a name="a187">Toda cantidad pagada no devengada, que sea pagada con posterioridad a la realización de las condiciones previamente señaladas será consignada a favor de la autoridad correspondiente.</a>
    </p>
    <p class="s21" style="padding-top: 12pt;padding-left: 39pt;text-indent: 0pt;line-height: 14pt;text-align: center;">Cláusula 5.29.</p>
    <p class="s8" style="padding-left: 39pt;text-indent: 0pt;line-height: 12pt;text-align: center;">
      <a name="a188">Aviso de Privacidad</a>
    </p>
    <p style="text-indent: 0pt;text-align: center;">
      <br />
    </p>
    <p style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">La Latinoamericana Seguros, S.A., con domicilio en Eje Central Lázaro Cárdenas No. 2, 8º piso, Centro, C.P. 06000, en la Ciudad de México, en cumplimiento a la Ley Federal de Protección de Datos Personales en Posesión de los Particulares, le informa que sus datos personales (de identificación, académicos, laborales, patrimoniales, bancarios, de procedimientos administrativos seguidos en forma de juicio y/o jurisdiccionales, de tránsito y movimientos migratorios), incluyendo los sensibles (ideológicos, afiliación sindical, de salud, biométricos, vida sexual, características físicas, fisiológicas, personales, de comportamiento o rasgos de la personalidad medibles); proporcionados mediante la <b>Solicitud de Seguro</b>, cuestionarios, formatos institucionales, facturas, estudios clínicos, informes médicos y documentación de los bienes asegurables, recabados por cualquier medio o tecnología, o los que se generen durante la relación jurídica que se establezca con Usted, serán tratados, con el fin de evaluar su <b>Solicitud de Seguro</b>, selección de riesgos, subasta de <b>Salvamento</b>s, administración de la <b>Póliza</b>, pago de <b>Prima</b>s, prevención de operaciones ilícitas y <b>Fraude</b>, estudios estadísticos, financieros y de calidad, dar servicio y soporte técnico por los productos y servicios contratados y para cumplimiento de obligaciones contractuales y las contempladas en la Ley sobre el Contrato de Seguro y demás normatividad aplicable. Sus datos podrán ser tratados para el ofrecimiento y promoción de nuestros productos, servicios y/o prospección comercial; de no estar de acuerdo con el tratamiento de sus datos personales para los fines indicados, deberá manifestarlo. Sus datos personales podrán ser transferidos a: i. Las autoridades que los requieran con el fin de cumplir obligaciones legales; ii. Instituciones del sector para fines estadísticos, de selección de riesgos y prevención de operaciones ilícitas y <b>Fraude</b>; iii. Al <b>Contratante </b>de la <b>Póliza </b>para fines de administración; y, iv. A personas nacionales o extranjeras vinculadas con <b>L A T I N O</b>, quienes estarán obligados en los mismos términos del presente aviso, para cumplir con los fines mencionados. Usted podrá ejercer sus derechos de acceso, rectificación, </p>
    <p style="padding-top: 3pt;padding-left: 39pt;text-indent: 0pt;text-align: justify;">
      <a href="http://www.latinoseguros.com.mx/" class="a" target="_blank">cancelación y oposición, revocar su consentimiento, o limitar el uso y divulgación de datos personales: a) utilizando el procedimiento que se encuentra en la página de internet: </a>www.latinoseguros.com.mx, sección “Aviso de Privacidad”; b) por escrito dirigido al Oficial de Protección de Datos Personales, en el domicilio de <b>L A T I N O </b>
      <a href="mailto:protecciondatos@latinoseguros.com.mx" class="a" target="_blank">; c) por correo electrónico: </a>
      <a href="mailto:protecciondatos@latinoseguros.com.mx" class="s56" target="_blank">protecciondatos@latinoseguros.com.mx</a>; o d) comunicándose al 55 5130-2800 ext. 1338, o al 800- 001-1900 del interior de la República. Las modificaciones al presente Aviso de Privacidad, estarán a su disposición en el domicilio y/o la página de internet de <b>L A T I N O</b>. La aceptación del Aviso de Privacidad constituye el otorgamiento del consentimiento expreso del titular de los datos personales a <b>L A T I N O </b>para el tratamiento de sus datos personales en los términos del presente, quien manifiesta que en caso de proporcionar datos personales de terceros, necesarios para la relación establecida con <b>L A T I N O </b>o, en su caso, solicitar información de siniestralidad de los miembros de un grupo o colectividad, cuenta con el consentimiento expreso de sus titulares, asimismo se hace sabedor de que <b>L A T I N O </b>no es responsable del contenido de información generada por terceros, incluidos estudios clínicos. Fecha de actualización: 27 de mayo de 2019.
    </p>
    <p style="text-indent: 0pt;text-align: center;">
      <br />
    </p>
    <p class="s15" style="padding-left: 39pt;text-indent: 0pt;text-align: justify;">En cumplimiento a lo dispuesto en el artículo 202 de la Ley de Instituciones de Seguros y de Fianzas, la Documentación Contractual y la Nota Técnica que integran este producto de seguro, quedaron registradas ante la Comisión Nacional de Seguros y Fianzas, a partir del día 30 de enero del 2024, con el número PPAQ-S0013-0045-2023 / CONDUSEF-006011-04.</p>                 
    </div>
  </div>    
</template>

<script>
export default {
  name: "ScrollComponent",
  methods: {
    handleScroll(event) {
      const scrollContainer = event.target; 
      const scrollTop = scrollContainer.scrollTop;
      const scrollHeight = scrollContainer.scrollHeight;
      const clientHeight = scrollContainer.clientHeight;
      
      if (scrollTop + clientHeight >= scrollHeight - 1) {
        this.$emit('scroll-end');
      }
    }
  }
};
</script>

<style scoped>
 * {
        margin: 0;
        padding: 0;
        text-indent: 0;
      }

      .s1 {
        color: #FFF;
        font-family: Arial, sans-serif;
        font-style: normal;
        font-weight: normal;
        text-decoration: none;
        font-size: 18pt;
      }

      h1 {
        color: #FFF;
        font-family: Arial, sans-serif;
        font-style: normal;
        font-weight: bold;
        text-decoration: none;
        font-size: 28pt;
      }

      .s2 {
        color: #FFF;
        font-family: Arial, sans-serif;
        font-style: normal;
        font-weight: normal;
        text-decoration: none;
        font-size: 10pt;
      }

      .s3 {
        color: #898A8D;
        font-family: Arial, sans-serif;
        font-style: normal;
        font-weight: normal;
        text-decoration: none;
        font-size: 10pt;
      }

      .s5 {
        color: #3D3D3B;
        font-family: Arial, sans-serif;
        font-style: normal;
        font-weight: normal;
        text-decoration: none;
        font-size: 6.5pt;
      }

      .s6 {
        color: #2C5293;
        font-family: Arial, sans-serif;
        font-style: italic;
        font-weight: bold;
        text-decoration: none;
        font-size: 11pt;
      }

      .s7 {
        color: black;
        font-family: Arial, sans-serif;
        font-style: normal;
        font-weight: bold;
        text-decoration: none;
        font-size: 14pt;
      }

      .s8 {
        color: #2C5293;
        font-family: Arial, sans-serif;
        font-style: normal;
        font-weight: bold;
        text-decoration: none;
        font-size: 11pt;
      }

      .s9 {
        color: black;
        font-family: Arial, sans-serif;
        font-style: normal;
        font-weight: bold;
        text-decoration: none;
        font-size: 11pt;
      }

      .s10 {
        color: #2C5293;
        font-family: Arial, sans-serif;
        font-style: normal;
        font-weight: bold;
        text-decoration: none;
        font-size: 28pt;
      }

      .s11 {
        color: black;
        font-family: Arial, sans-serif;
        font-style: normal;
        font-weight: normal;
        text-decoration: none;
        font-size: 11pt;
      }

      .s12 {
        color: #2C5293;
        font-family: Arial, sans-serif;
        font-style: normal;
        font-weight: bold;
        text-decoration: none;
        font-size: 10pt;
      }

      .s13 {
        color: black;
        font-family: Arial, sans-serif;
        font-style: normal;
        font-weight: bold;
        text-decoration: none;
        font-size: 10pt;
      }

      .p,
      p {
        color: black;
        font-family: Arial, sans-serif;
        font-style: normal;
        font-weight: normal;
        text-decoration: none;
        font-size: 10pt;
        margin: 0pt;
      }

      .s14 {
        color: #2C5293;
        font-family: Arial, sans-serif;
        font-style: normal;
        font-weight: normal;
        text-decoration: none;
        font-size: 15pt;
      }

      .s15 {
        color: black;
        font-family: Arial, sans-serif;
        font-style: normal;
        font-weight: bold;
        text-decoration: none;
        font-size: 12pt;
      }

      .s16 {
        color: black;
        font-family: Arial, sans-serif;
        font-style: italic;
        font-weight: normal;
        text-decoration: none;
        font-size: 10pt;
      }

      .s17 {
        color: black;
        font-family: Arial, sans-serif;
        font-style: italic;
        font-weight: bold;
        text-decoration: none;
        font-size: 10pt;
      }

      h2 {
        color: #2C5293;
        font-family: Arial, sans-serif;
        font-style: normal;
        font-weight: bold;
        text-decoration: none;
        font-size: 22pt;
      }

      .a,
      a {
        color: black;
        font-family: Arial, sans-serif;
        font-style: normal;
        font-weight: normal;
        text-decoration: none;
        font-size: 10pt;
      }

      .s18 {
        color: black;
        font-family: Arial, sans-serif;
        font-style: italic;
        font-weight: bold;
        text-decoration: none;
        font-size: 12pt;
      }

      h4 {
        color: #1F4E79;
        font-family: Arial, sans-serif;
        font-style: normal;
        font-weight: bold;
        text-decoration: none;
        font-size: 14pt;
      }

      .s19 {
        color: #2C5293;
        font-family: Arial, sans-serif;
        font-style: normal;
        font-weight: bold;
        text-decoration: none;
        font-size: 10pt;
      }

      .s20 {
        color: #2C5293;
        font-family: Arial, sans-serif;
        font-style: normal;
        font-weight: bold;
        text-decoration: none;
        font-size: 11pt;
      }

      .s21 {
        color: #2C5293;
        font-family: Arial, sans-serif;
        font-style: normal;
        font-weight: bold;
        text-decoration: none;
        font-size: 12pt;
      }

      .s22 {
        color: #1F4E79;
        font-family: Arial, sans-serif;
        font-style: normal;
        font-weight: bold;
        text-decoration: none;
        font-size: 10pt;
      }

      .s23 {
        color: #1F4E79;
        font-family: Arial, sans-serif;
        font-style: normal;
        font-weight: bold;
        text-decoration: none;
        font-size: 11pt;
      }

      .s24 {
        color: black;
        font-family: Arial, sans-serif;
        font-style: normal;
        font-weight: normal;
        text-decoration: none;
        font-size: 11pt;
      }

      .s25 {
        color: #161616;
        font-family: Arial, sans-serif;
        font-style: normal;
        font-weight: bold;
        text-decoration: none;
        font-size: 12pt;
      }

      .s26 {
        color: black;
        font-family: Arial, sans-serif;
        font-style: italic;
        font-weight: normal;
        text-decoration: underline;
        font-size: 11pt;
      }

      .s27 {
        color: black;
        font-family: Arial, sans-serif;
        font-style: italic;
        font-weight: normal;
        text-decoration: none;
        font-size: 11pt;
      }

      .s30 {
        color: #2C5293;
        font-family: Arial, sans-serif;
        font-style: normal;
        font-weight: bold;
        text-decoration: none;
        font-size: 9.5pt;
      }

      .s31 {
        color: black;
        font-family: Arial, sans-serif;
        font-style: normal;
        font-weight: bold;
        text-decoration: underline;
        font-size: 12pt;
      }

      .s32 {
        color: #5B9BD2;
        font-family: Arial, sans-serif;
        font-style: normal;
        font-weight: bold;
        text-decoration: none;
        font-size: 11pt;
      }

      .s33 {
        color: #1F3861;
        font-family: Arial, sans-serif;
        font-style: normal;
        font-weight: bold;
        text-decoration: none;
        font-size: 10pt;
      }

      .s36 {
        color: #333;
        font-family: Arial, sans-serif;
        font-style: normal;
        font-weight: normal;
        text-decoration: none;
        font-size: 10pt;
      }

      .s37 {
        color: #333;
        font-family: Arial, sans-serif;
        font-style: normal;
        font-weight: bold;
        text-decoration: none;
        font-size: 12pt;
      }

      .s38 {
        color: #333;
        font-family: Arial, sans-serif;
        font-style: normal;
        font-weight: normal;
        text-decoration: none;
        font-size: 12pt;
      }

      .s39 {
        color: black;
        font-family: Arial, sans-serif;
        font-style: normal;
        font-weight: bold;
        text-decoration: none;
        font-size: 10pt;
      }

      .s40 {
        color: black;
        font-family: Arial, sans-serif;
        font-style: normal;
        font-weight: normal;
        text-decoration: none;
        font-size: 10pt;
      }

      .s41 {
        color: #1F4E79;
        font-family: Arial, sans-serif;
        font-style: normal;
        font-weight: bold;
        text-decoration: none;
        font-size: 10pt;
      }

      .s42 {
        color: #1F4E79;
        font-family: Arial, sans-serif;
        font-style: normal;
        font-weight: bold;
        text-decoration: none;
        font-size: 12pt;
      }

      .s43 {
        color: #1F4E79;
        font-family: Arial, sans-serif;
        font-style: normal;
        font-weight: bold;
        text-decoration: none;
        font-size: 11pt;
      }

      h3 {
        color: #1F4E79;
        font-family: Arial, sans-serif;
        font-style: normal;
        font-weight: bold;
        text-decoration: none;
        font-size: 18pt;
      }

      .s44 {
        color: #2C74B5;
        font-family: Arial, sans-serif;
        font-style: normal;
        font-weight: bold;
        text-decoration: none;
        font-size: 10pt;
      }

      .s45 {
        color: #2C74B5;
        font-family: Arial, sans-serif;
        font-style: normal;
        font-weight: bold;
        text-decoration: none;
        font-size: 12pt;
      }

      .s46 {
        color: #2C5293;
        font-family: Arial, sans-serif;
        font-style: normal;
        font-weight: bold;
        text-decoration: none;
        font-size: 11pt;
      }

      .s47 {
        color: #1F4E79;
        font-family: Arial, sans-serif;
        font-style: normal;
        font-weight: normal;
        text-decoration: none;
        font-size: 12pt;
      }

      .s48 {
        color: #1F4E79;
        font-family: Arial, sans-serif;
        font-style: normal;
        font-weight: normal;
        text-decoration: none;
        font-size: 11pt;
      }

      .s49 {
        color: #2C5293;
        font-family: Arial, sans-serif;
        font-style: normal;
        font-weight: normal;
        text-decoration: none;
        font-size: 10pt;
      }

      .s50 {
        color: black;
        font-family: Arial, sans-serif;
        font-style: normal;
        font-weight: normal;
        text-decoration: none;
        font-size: 12pt;
      }

      .s51 {
        color: #2C5293;
        font-family: Arial, sans-serif;
        font-style: normal;
        font-weight: bold;
        text-decoration: none;
        font-size: 12pt;
      }

      .s52 {
        color: black;
        font-family: Arial, sans-serif;
        font-style: normal;
        font-weight: bold;
        text-decoration: none;
        font-size: 9pt;
      }

      .s53 {
        color: #2C5293;
        font-family: Arial, sans-serif;
        font-style: normal;
        font-weight: bold;
        text-decoration: none;
        font-size: 10pt;
      }

      .s55 {
        color: #2C5293;
        font-family: Arial, sans-serif;
        font-style: italic;
        font-weight: bold;
        text-decoration: none;
        font-size: 10pt;
      }

      .s56 {
        color: #0460C1;
        font-family: Arial, sans-serif;
        font-style: normal;
        font-weight: normal;
        text-decoration: underline;
        font-size: 10pt;
      }

      .s57 {
        color: black;
        font-family: Arial, sans-serif;
        font-style: normal;
        font-weight: bold;
        text-decoration: none;
        font-size: 9pt;
      }

      .s58 {
        color: black;
        font-family: Arial, sans-serif;
        font-style: normal;
        font-weight: normal;
        text-decoration: none;
        font-size: 9pt;
      }

      .s59 {
        color: black;
        font-family: "Times New Roman", serif;
        font-style: normal;
        font-weight: normal;
        text-decoration: none;
        font-size: 10pt;
      }

      .s60 {
        color: #0460C1;
        font-family: Arial, sans-serif;
        font-style: normal;
        font-weight: normal;
        text-decoration: underline;
        font-size: 10pt;
      }

      li {
        display: block;
      }

      #l1 {
        padding-left: 0pt;
        counter-reset: c1 1;
      }

      #l1>li>*:first-child:before {
        counter-increment: c1;
        content: counter(c1, decimal)". ";
        color: black;
        font-family: Arial, sans-serif;
        font-style: normal;
        font-weight: normal;
        text-decoration: none;
        font-size: 10pt;
      }

      #l1>li:first-child>*:first-child:before {
        counter-increment: c1 0;
      }

      li {
        display: block;
      }

      #l2 {
        padding-left: 0pt;
        counter-reset: d1 1;
      }

      #l2>li>*:first-child:before {
        counter-increment: d1;
        content: counter(d1, decimal)". ";
        color: black;
        font-family: Arial, sans-serif;
        font-style: italic;
        font-weight: normal;
        text-decoration: none;
        font-size: 10pt;
      }

      #l2>li:first-child>*:first-child:before {
        counter-increment: d1 0;
      }

      li {
        display: block;
      }

      #l3 {
        padding-left: 0pt;
        counter-reset: e1 1;
      }

      #l3>li>*:first-child:before {
        counter-increment: e1;
        content: counter(e1, upper-latin)") ";
        color: black;
        font-style: normal;
        font-weight: normal;
        text-decoration: none;
      }

      #l3>li:first-child>*:first-child:before {
        counter-increment: e1 0;
      }

      #l4 {
        padding-left: 0pt;
        counter-reset: e2 1;
      }

      #l4>li>*:first-child:before {
        counter-increment: e2;
        content: counter(e2, decimal)". ";
        color: #2C5293;
        font-family: Arial, sans-serif;
        font-style: normal;
        font-weight: bold;
        text-decoration: none;
        font-size: 10pt;
      }

      #l4>li:first-child>*:first-child:before {
        counter-increment: e2 0;
      }

      #l5 {
        padding-left: 0pt;
        counter-reset: f1 1;
      }

      #l5>li>*:first-child:before {
        counter-increment: f1;
        content: counter(f1, decimal)". ";
        color: black;
        font-family: Arial, sans-serif;
        font-style: normal;
        font-weight: bold;
        text-decoration: none;
        font-size: 10pt;
      }

      #l5>li:first-child>*:first-child:before {
        counter-increment: f1 0;
      }

      li {
        display: block;
      }

      #l6 {
        padding-left: 0pt;
        counter-reset: g1 1;
      }

      #l6>li>*:first-child:before {
        counter-increment: g1;
        content: counter(g1, decimal)". ";
        color: black;
        font-style: normal;
        font-weight: normal;
        text-decoration: none;
      }

      #l6>li:first-child>*:first-child:before {
        counter-increment: g1 0;
      }

      #l7 {
        padding-left: 0pt;
        counter-reset: g2 1;
      }

      #l7>li>*:first-child:before {
        counter-increment: g2;
        content: counter(g1, decimal)"."counter(g2, decimal)". ";
        color: black;
        font-family: Arial, sans-serif;
        font-style: normal;
        font-weight: bold;
        text-decoration: none;
        font-size: 12pt;
      }

      #l7>li:first-child>*:first-child:before {
        counter-increment: g2 0;
      }

      li {
        display: block;
      }

      #l8 {
        padding-left: 0pt;
        counter-reset: h1 1;
      }

      #l8>li>*:first-child:before {
        counter-increment: h1;
        content: counter(h1, upper-latin)") ";
        color: #2C5293;
        font-family: Arial, sans-serif;
        font-style: normal;
        font-weight: bold;
        text-decoration: none;
        font-size: 12pt;
      }

      #l8>li:first-child>*:first-child:before {
        counter-increment: h1 0;
      }

      #l9 {
        padding-left: 0pt;
        counter-reset: i1 1;
      }

      #l9>li>*:first-child:before {
        counter-increment: i1;
        content: counter(i1, decimal)". ";
        color: black;
        font-family: Arial, sans-serif;
        font-style: normal;
        font-weight: normal;
        text-decoration: none;
        font-size: 10pt;
      }

      #l9>li:first-child>*:first-child:before {
        counter-increment: i1 0;
      }

      li {
        display: block;
      }

      #l10 {
        padding-left: 0pt;
        counter-reset: j1 1;
      }

      #l10>li>*:first-child:before {
        counter-increment: j1;
        content: counter(j1, decimal)". ";
        color: black;
        font-family: Arial, sans-serif;
        font-style: normal;
        font-weight: bold;
        text-decoration: none;
        font-size: 12pt;
      }

      #l10>li:first-child>*:first-child:before {
        counter-increment: j1 0;
      }

      li {
        display: block;
      }

      #l11 {
        padding-left: 0pt;
        counter-reset: k1 1;
      }

      #l11>li>*:first-child:before {
        counter-increment: k1;
        content: counter(k1, upper-latin)") ";
        color: #2C5293;
        font-family: Arial, sans-serif;
        font-style: normal;
        font-weight: bold;
        text-decoration: none;
        font-size: 12pt;
      }

      #l11>li:first-child>*:first-child:before {
        counter-increment: k1 0;
      }

      #l12 {
        padding-left: 0pt;
        counter-reset: l1 1;
      }

      #l12>li>*:first-child:before {
        counter-increment: l1;
        content: counter(l1, decimal)" ";
        color: black;
        font-style: normal;
        font-weight: normal;
        text-decoration: none;
      }

      #l12>li:first-child>*:first-child:before {
        counter-increment: l1 0;
      }

      #l13 {
        padding-left: 0pt;
        counter-reset: l2 1;
      }

      #l13>li>*:first-child:before {
        counter-increment: l2;
        content: counter(l1, decimal)"."counter(l2, decimal)". ";
        color: #2C74B5;
        font-family: Arial, sans-serif;
        font-style: normal;
        font-weight: bold;
        text-decoration: none;
        font-size: 10pt;
      }

      #l13>li:first-child>*:first-child:before {
        counter-increment: l2 0;
      }

      #l14 {
        padding-left: 0pt;
        counter-reset: m1 1;
      }

      #l14>li>*:first-child:before {
        counter-increment: m1;
        content: counter(m1, decimal)". ";
        color: #2C74B5;
        font-family: Arial, sans-serif;
        font-style: normal;
        font-weight: bold;
        text-decoration: none;
        font-size: 10pt;
      }

      #l14>li:first-child>*:first-child:before {
        counter-increment: m1 0;
      }

      #l15 {
        padding-left: 0pt;
        counter-reset: k2 1;
      }

      #l15>li>*:first-child:before {
        counter-increment: k2;
        content: counter(k2, decimal)". ";
        color: black;
        font-family: Arial, sans-serif;
        font-style: normal;
        font-weight: bold;
        text-decoration: none;
        font-size: 12pt;
      }

      #l15>li:first-child>*:first-child:before {
        counter-increment: k2 0;
      }

      li {
        display: block;
      }

      #l16 {
        padding-left: 0pt;
        counter-reset: k1 1;
      }

      #l16>li>*:first-child:before {
        counter-increment: k1;
        content: counter(k1, upper-latin)") ";
        color: #2C5293;
        font-family: Arial, sans-serif;
        font-style: normal;
        font-weight: bold;
        text-decoration: none;
        font-size: 12pt;
      }

      #l16>li:first-child>*:first-child:before {
        counter-increment: k1 0;
      }

      #l17 {
        padding-left: 0pt;
        counter-reset: k2 2;
      }

      #l17>li>*:first-child:before {
        counter-increment: k2;
        content: counter(k2, decimal)". ";
        color: black;
        font-family: Arial, sans-serif;
        font-style: normal;
        font-weight: bold;
        text-decoration: none;
        font-size: 12pt;
      }

      #l17>li:first-child>*:first-child:before {
        counter-increment: k2 0;
      }

      li {
        display: block;
      }

      #l18 {
        padding-left: 0pt;
        counter-reset: n1 1;
      }

      #l18>li>*:first-child:before {
        counter-increment: n1;
        content: counter(n1, upper-latin)") ";
        color: #2C5293;
        font-family: Arial, sans-serif;
        font-style: normal;
        font-weight: bold;
        text-decoration: none;
        font-size: 12pt;
      }

      #l18>li:first-child>*:first-child:before {
        counter-increment: n1 0;
      }

      #l19 {
        padding-left: 0pt;
        counter-reset: n2 1;
      }

      #l19>li>*:first-child:before {
        counter-increment: n2;
        content: counter(n2, decimal)". ";
        color: black;
        font-family: Arial, sans-serif;
        font-style: normal;
        font-weight: bold;
        text-decoration: none;
        font-size: 12pt;
      }

      #l19>li:first-child>*:first-child:before {
        counter-increment: n2 0;
      }

      li {
        display: block;
      }

      #l20 {
        padding-left: 0pt;
        counter-reset: n1 1;
      }

      #l20>li>*:first-child:before {
        counter-increment: n1;
        content: counter(n1, upper-latin)") ";
        color: #2C5293;
        font-family: Arial, sans-serif;
        font-style: normal;
        font-weight: bold;
        text-decoration: none;
        font-size: 12pt;
      }

      #l20>li:first-child>*:first-child:before {
        counter-increment: n1 0;
      }

      #l21 {
        padding-left: 0pt;
        counter-reset: n2 1;
      }

      #l21>li>*:first-child:before {
        counter-increment: n2;
        content: counter(n2, decimal)". ";
        color: black;
        font-family: Arial, sans-serif;
        font-style: normal;
        font-weight: bold;
        text-decoration: none;
        font-size: 12pt;
      }

      #l21>li:first-child>*:first-child:before {
        counter-increment: n2 0;
      }

      #l22 {
        padding-left: 0pt;
        counter-reset: n3 1;
      }

      #l22>li>*:first-child:before {
        counter-increment: n3;
        content: counter(n3, upper-latin)") ";
        color: black;
        font-style: normal;
        font-weight: normal;
        text-decoration: none;
      }

      #l22>li:first-child>*:first-child:before {
        counter-increment: n3 0;
      }

      #l23 {
        padding-left: 0pt;
        counter-reset: o1 1;
      }

      #l23>li>*:first-child:before {
        counter-increment: o1;
        content: counter(o1, decimal)". ";
        color: black;
        font-family: Arial, sans-serif;
        font-style: normal;
        font-weight: bold;
        text-decoration: none;
        font-size: 12pt;
      }

      #l23>li:first-child>*:first-child:before {
        counter-increment: o1 0;
      }

      #l24 {
        padding-left: 0pt;
        counter-reset: p1 1;
      }

      #l24>li>*:first-child:before {
        counter-increment: p1;
        content: counter(p1, decimal)". ";
        color: black;
        font-family: Arial, sans-serif;
        font-style: normal;
        font-weight: normal;
        text-decoration: none;
        font-size: 10pt;
      }

      #l24>li:first-child>*:first-child:before {
        counter-increment: p1 0;
      }

      #l25 {
        padding-left: 0pt;
        counter-reset: n4 1;
      }

      #l25>li>*:first-child:before {
        counter-increment: n4;
        content: counter(n4, decimal)". ";
        color: black;
        font-family: Arial, sans-serif;
        font-style: normal;
        font-weight: bold;
        text-decoration: none;
        font-size: 12pt;
      }

      #l25>li:first-child>*:first-child:before {
        counter-increment: n4 0;
      }

      #l26 {
        padding-left: 0pt;
        counter-reset: n5 1;
      }

      #l26>li>*:first-child:before {
        counter-increment: n5;
        content: counter(n4, decimal)"."counter(n5, decimal)". ";
        color: black;
        font-family: Arial, sans-serif;
        font-style: normal;
        font-weight: bold;
        text-decoration: none;
        font-size: 12pt;
      }

      #l26>li:first-child>*:first-child:before {
        counter-increment: n5 0;
      }

      li {
        display: block;
      }

      #l27 {
        padding-left: 0pt;
        counter-reset: q1 1;
      }

      #l27>li>*:first-child:before {
        counter-increment: q1;
        content: counter(q1, upper-latin)") ";
        color: #2C5293;
        font-family: Arial, sans-serif;
        font-style: normal;
        font-weight: bold;
        text-decoration: none;
        font-size: 12pt;
      }

      #l27>li:first-child>*:first-child:before {
        counter-increment: q1 0;
      }

      #l28 {
        padding-left: 0pt;
        counter-reset: r1 1;
      }

      #l28>li>*:first-child:before {
        counter-increment: r1;
        content: counter(r1, decimal)". ";
        color: black;
        font-style: normal;
        font-weight: normal;
        text-decoration: none;
      }

      #l28>li:first-child>*:first-child:before {
        counter-increment: r1 0;
      }

      #l29 {
        padding-left: 0pt;
        counter-reset: q2 1;
      }

      #l29>li>*:first-child:before {
        counter-increment: q2;
        content: counter(q2, decimal)". ";
        color: black;
        font-family: Arial, sans-serif;
        font-style: normal;
        font-weight: bold;
        text-decoration: none;
        font-size: 12pt;
      }

      #l29>li:first-child>*:first-child:before {
        counter-increment: q2 0;
      }

      li {
        display: block;
      }

      #l30 {
        padding-left: 0pt;
        counter-reset: s1 1;
      }

      #l30>li>*:first-child:before {
        counter-increment: s1;
        content: counter(s1, upper-latin)") ";
        color: #2C5293;
        font-family: Arial, sans-serif;
        font-style: normal;
        font-weight: bold;
        text-decoration: none;
        font-size: 12pt;
      }

      #l30>li:first-child>*:first-child:before {
        counter-increment: s1 0;
      }

      li {
        display: block;
      }

      #l31 {
        padding-left: 0pt;
        counter-reset: t1 1;
      }

      #l31>li>*:first-child:before {
        counter-increment: t1;
        content: counter(t1, upper-latin)") ";
        color: #2C5293;
        font-family: Arial, sans-serif;
        font-style: normal;
        font-weight: bold;
        text-decoration: none;
        font-size: 12pt;
      }

      #l31>li:first-child>*:first-child:before {
        counter-increment: t1 0;
      }

      #l32 {
        padding-left: 0pt;
        counter-reset: t2 1;
      }

      #l32>li>*:first-child:before {
        counter-increment: t2;
        content: counter(t2, decimal)". ";
        color: black;
        font-style: normal;
        font-weight: normal;
        text-decoration: none;
      }

      #l32>li:first-child>*:first-child:before {
        counter-increment: t2 0;
      }

      #l33 {
        padding-left: 0pt;
        counter-reset: r1 3;
      }

      #l33>li>*:first-child:before {
        counter-increment: r1;
        content: counter(r1, decimal)". ";
        color: black;
        font-style: normal;
        font-weight: normal;
        text-decoration: none;
      }

      #l33>li:first-child>*:first-child:before {
        counter-increment: r1 0;
      }

      #l34 {
        padding-left: 0pt;
        counter-reset: t2 1;
      }

      #l34>li>*:first-child:before {
        counter-increment: t2;
        content: counter(t2, decimal)". ";
        color: black;
        font-style: normal;
        font-weight: normal;
        text-decoration: none;
      }

      #l34>li:first-child>*:first-child:before {
        counter-increment: t2 0;
      }

      li {
        display: block;
      }

      #l35 {
        padding-left: 0pt;
        counter-reset: u1 1;
      }

      #l35>li>*:first-child:before {
        counter-increment: u1;
        content: counter(u1, upper-latin)") ";
        color: #2C5293;
        font-family: Arial, sans-serif;
        font-style: normal;
        font-weight: bold;
        text-decoration: none;
        font-size: 12pt;
      }

      #l35>li:first-child>*:first-child:before {
        counter-increment: u1 0;
      }

      #l36 {
        padding-left: 0pt;
        counter-reset: v1 1;
      }

      #l36>li>*:first-child:before {
        counter-increment: v1;
        content: counter(v1, decimal)". ";
        color: #2C74B5;
        font-family: Arial, sans-serif;
        font-style: normal;
        font-weight: bold;
        text-decoration: none;
        font-size: 10pt;
      }

      #l36>li:first-child>*:first-child:before {
        counter-increment: v1 0;
      }

      #l37 {
        padding-left: 0pt;
        counter-reset: u2 1;
      }

      #l37>li>*:first-child:before {
        counter-increment: u2;
        content: counter(u2, decimal)". ";
        color: black;
        font-family: Arial, sans-serif;
        font-style: normal;
        font-weight: bold;
        text-decoration: none;
        font-size: 12pt;
      }

      #l37>li:first-child>*:first-child:before {
        counter-increment: u2 0;
      }

      li {
        display: block;
      }

      #l38 {
        padding-left: 0pt;
        counter-reset: w1 1;
      }

      #l38>li>*:first-child:before {
        counter-increment: w1;
        content: counter(w1, upper-latin)") ";
        color: #2C5293;
        font-family: Arial, sans-serif;
        font-style: normal;
        font-weight: bold;
        text-decoration: none;
        font-size: 12pt;
      }

      #l38>li:first-child>*:first-child:before {
        counter-increment: w1 0;
      }

      #l39 {
        padding-left: 0pt;
        counter-reset: x1 2;
      }

      #l39>li>*:first-child:before {
        counter-increment: x1;
        content: counter(x1, decimal)" ";
        color: black;
        font-style: normal;
        font-weight: normal;
        text-decoration: none;
      }

      #l39>li:first-child>*:first-child:before {
        counter-increment: x1 0;
      }

      #l40 {
        padding-left: 0pt;
        counter-reset: x2 10;
      }

      #l40>li>*:first-child:before {
        counter-increment: x2;
        content: counter(x1, decimal)"."counter(x2, decimal)" ";
        color: black;
        font-style: normal;
        font-weight: normal;
        text-decoration: none;
      }

      #l40>li:first-child>*:first-child:before {
        counter-increment: x2 0;
      }

      #l41 {
        padding-left: 0pt;
        counter-reset: x3 1;
      }

      #l41>li>*:first-child:before {
        counter-increment: x3;
        content: counter(x1, decimal)"."counter(x2, decimal)"."counter(x3, decimal)". ";
        color: #2C5293;
        font-family: Arial, sans-serif;
        font-style: normal;
        font-weight: bold;
        text-decoration: none;
        font-size: 11pt;
      }

      #l41>li:first-child>*:first-child:before {
        counter-increment: x3 0;
      }

      #l42 {
        padding-left: 0pt;
        counter-reset: y1 1;
      }

      #l42>li>*:first-child:before {
        counter-increment: y1;
        content: counter(y1, decimal)". ";
        color: #2C5293;
        font-family: Arial, sans-serif;
        font-style: normal;
        font-weight: bold;
        text-decoration: none;
        font-size: 10pt;
      }

      #l42>li:first-child>*:first-child:before {
        counter-increment: y1 0;
      }

      #l43 {
        padding-left: 0pt;
        counter-reset: w2 1;
      }

      #l43>li>*:first-child:before {
        counter-increment: w2;
        content: counter(w2, decimal)". ";
        color: black;
        font-family: Arial, sans-serif;
        font-style: normal;
        font-weight: bold;
        text-decoration: none;
        font-size: 12pt;
      }

      #l43>li:first-child>*:first-child:before {
        counter-increment: w2 0;
      }

      li {
        display: block;
      }

      #l44 {
        padding-left: 0pt;
        counter-reset: w1 1;
      }

      #l44>li>*:first-child:before {
        counter-increment: w1;
        content: counter(w1, upper-latin)") ";
        color: #2C5293;
        font-family: Arial, sans-serif;
        font-style: normal;
        font-weight: bold;
        text-decoration: none;
        font-size: 12pt;
      }

      #l44>li:first-child>*:first-child:before {
        counter-increment: w1 0;
      }

      #l45 {
        padding-left: 0pt;
        counter-reset: w2 1;
      }

      #l45>li>*:first-child:before {
        counter-increment: w2;
        content: counter(w2, decimal)". ";
        color: black;
        font-family: Arial, sans-serif;
        font-style: normal;
        font-weight: bold;
        text-decoration: none;
        font-size: 12pt;
      }

      #l45>li:first-child>*:first-child:before {
        counter-increment: w2 0;
      }

      #l46 {
        padding-left: 0pt;
        counter-reset: w3 1;
      }

      #l46>li>*:first-child:before {
        counter-increment: w3;
        content: counter(w3, upper-latin)") ";
        color: #006EC0;
        font-family: Arial, sans-serif;
        font-style: normal;
        font-weight: bold;
        text-decoration: none;
        font-size: 12pt;
      }

      #l46>li:first-child>*:first-child:before {
        counter-increment: w3 0;
      }

      #l47 {
        padding-left: 0pt;
        counter-reset: z1 1;
      }

      #l47>li>*:first-child:before {
        counter-increment: z1;
        content: counter(z1, decimal)". ";
        color: black;
        font-style: normal;
        font-weight: normal;
        text-decoration: none;
      }

      #l47>li:first-child>*:first-child:before {
        counter-increment: z1 0;
      }

      #l48 {
        padding-left: 0pt;
        counter-reset: z2 1;
      }

      #l48>li>*:first-child:before {
        counter-increment: z2;
        content: counter(z2, lower-latin)") ";
        color: black;
        font-style: normal;
        font-weight: normal;
        text-decoration: none;
      }

      #l48>li:first-child>*:first-child:before {
        counter-increment: z2 0;
      }

      #l49 {
        padding-left: 0pt;
        counter-reset: z2 1;
      }

      #l49>li>*:first-child:before {
        counter-increment: z2;
        content: counter(z2, lower-latin)") ";
        color: black;
        font-style: normal;
        font-weight: normal;
        text-decoration: none;
      }

      #l49>li:first-child>*:first-child:before {
        counter-increment: z2 0;
      }

      li {
        display: block;
      }

      #l50 {
        padding-left: 0pt;
        counter-reset: c1 1;
      }

      #l50>li>*:first-child:before {
        counter-increment: c1;
        content: counter(c1, decimal)". ";
        color: black;
        font-family: Arial, sans-serif;
        font-style: normal;
        font-weight: bold;
        text-decoration: none;
        font-size: 12pt;
      }

      #l50>li:first-child>*:first-child:before {
        counter-increment: c1 0;
      }

      #l51 {
        padding-left: 0pt;
        counter-reset: c2 1;
      }

      #l51>li>*:first-child:before {
        counter-increment: c2;
        content: counter(c1, decimal)"."counter(c2, decimal)". ";
        color: black;
        font-family: Arial, sans-serif;
        font-style: normal;
        font-weight: bold;
        text-decoration: none;
        font-size: 12pt;
      }

      #l51>li:first-child>*:first-child:before {
        counter-increment: c2 0;
      }

      li {
        display: block;
      }

      #l52 {
        padding-left: 0pt;
        counter-reset: d1 1;
      }

      #l52>li>*:first-child:before {
        counter-increment: d1;
        content: counter(d1, upper-latin)") ";
        color: black;
        font-style: normal;
        font-weight: normal;
        text-decoration: none;
      }

      #l52>li:first-child>*:first-child:before {
        counter-increment: d1 0;
      }

      #l53 {
        padding-left: 0pt;
        counter-reset: d2 1;
      }

      #l53>li>*:first-child:before {
        counter-increment: d2;
        content: counter(d2, decimal)". ";
        color: black;
        font-family: Arial, sans-serif;
        font-style: normal;
        font-weight: bold;
        text-decoration: none;
        font-size: 12pt;
      }

      #l53>li:first-child>*:first-child:before {
        counter-increment: d2 0;
      }

      li {
        display: block;
      }

      #l54 {
        padding-left: 0pt;
        counter-reset: e1 1;
      }

      #l54>li>*:first-child:before {
        counter-increment: e1;
        content: counter(e1, upper-latin)") ";
        color: black;
        font-style: normal;
        font-weight: normal;
        text-decoration: none;
      }

      #l54>li:first-child>*:first-child:before {
        counter-increment: e1 0;
      }

      #l55 {
        padding-left: 0pt;
        counter-reset: e2 1;
      }

      #l55>li>*:first-child:before {
        counter-increment: e2;
        content: counter(e2, decimal)". ";
        color: black;
        font-family: Arial, sans-serif;
        font-style: normal;
        font-weight: bold;
        text-decoration: none;
        font-size: 12pt;
      }

      #l55>li:first-child>*:first-child:before {
        counter-increment: e2 0;
      }

      li {
        display: block;
      }

      #l56 {
        padding-left: 0pt;
        counter-reset: f1 1;
      }

      #l56>li>*:first-child:before {
        counter-increment: f1;
        content: counter(f1, upper-latin)") ";
        color: black;
        font-style: normal;
        font-weight: normal;
        text-decoration: none;
      }

      #l56>li:first-child>*:first-child:before {
        counter-increment: f1 0;
      }

      #l57 {
        padding-left: 0pt;
        counter-reset: f2 1;
      }

      #l57>li>*:first-child:before {
        counter-increment: f2;
        content: counter(f2, decimal)". ";
        color: black;
        font-family: Arial, sans-serif;
        font-style: normal;
        font-weight: bold;
        text-decoration: none;
        font-size: 12pt;
      }

      #l57>li:first-child>*:first-child:before {
        counter-increment: f2 0;
      }

      li {
        display: block;
      }

      #l58 {
        padding-left: 0pt;
        counter-reset: g1 1;
      }

      #l58>li>*:first-child:before {
        counter-increment: g1;
        content: counter(g1, upper-latin)") ";
        color: black;
        font-style: normal;
        font-weight: normal;
        text-decoration: none;
      }

      #l58>li:first-child>*:first-child:before {
        counter-increment: g1 0;
      }

      #l59 {
        padding-left: 0pt;
        counter-reset: g2 1;
      }

      #l59>li>*:first-child:before {
        counter-increment: g2;
        content: counter(g2, decimal)". ";
        color: black;
        font-family: Arial, sans-serif;
        font-style: normal;
        font-weight: bold;
        text-decoration: none;
        font-size: 12pt;
      }

      #l59>li:first-child>*:first-child:before {
        counter-increment: g2 0;
      }

      li {
        display: block;
      }

      #l60 {
        padding-left: 0pt;
        counter-reset: h1 1;
      }

      #l60>li>*:first-child:before {
        counter-increment: h1;
        content: counter(h1, upper-latin)") ";
        color: black;
        font-style: normal;
        font-weight: normal;
        text-decoration: none;
      }

      #l60>li:first-child>*:first-child:before {
        counter-increment: h1 0;
      }

      #l61 {
        padding-left: 0pt;
        counter-reset: h2 1;
      }

      #l61>li>*:first-child:before {
        counter-increment: h2;
        content: counter(h2, decimal)". ";
        color: black;
        font-family: Arial, sans-serif;
        font-style: normal;
        font-weight: bold;
        text-decoration: none;
        font-size: 12pt;
      }

      #l61>li:first-child>*:first-child:before {
        counter-increment: h2 0;
      }

      li {
        display: block;
      }

      #l62 {
        padding-left: 0pt;
        counter-reset: i1 1;
      }

      #l62>li>*:first-child:before {
        counter-increment: i1;
        content: counter(i1, upper-latin)") ";
        color: black;
        font-style: normal;
        font-weight: normal;
        text-decoration: none;
      }

      #l62>li:first-child>*:first-child:before {
        counter-increment: i1 0;
      }

      #l63 {
        padding-left: 0pt;
        counter-reset: i2 1;
      }

      #l63>li>*:first-child:before {
        counter-increment: i2;
        content: counter(i2, decimal)". ";
        color: black;
        font-style: normal;
        font-weight: normal;
        text-decoration: none;
      }

      #l63>li:first-child>*:first-child:before {
        counter-increment: i2 0;
      }

      #l64 {
        padding-left: 0pt;
        counter-reset: i3 1;
      }

      #l64>li>*:first-child:before {
        counter-increment: i3;
        content: counter(i2, decimal)"."counter(i3, decimal)". ";
        color: #2C5293;
        font-family: Arial, sans-serif;
        font-style: normal;
        font-weight: bold;
        text-decoration: none;
        font-size: 10pt;
      }

      #l64>li:first-child>*:first-child:before {
        counter-increment: i3 0;
      }

      #l65 {
        padding-left: 0pt;
        counter-reset: i2 1;
      }

      #l65>li>*:first-child:before {
        counter-increment: i2;
        content: counter(i2, decimal)". ";
        color: black;
        font-style: normal;
        font-weight: normal;
        text-decoration: none;
      }

      #l65>li:first-child>*:first-child:before {
        counter-increment: i2 0;
      }

      li {
        display: block;
      }

      #l66 {
        padding-left: 0pt;
        counter-reset: j1 1;
      }

      #l66>li>*:first-child:before {
        counter-increment: j1;
        content: counter(j1, upper-latin)") ";
        color: black;
        font-style: normal;
        font-weight: normal;
        text-decoration: none;
      }

      #l66>li:first-child>*:first-child:before {
        counter-increment: j1 0;
      }

      #l67 {
        padding-left: 0pt;
        counter-reset: k1 1;
      }

      #l67>li>*:first-child:before {
        counter-increment: k1;
        content: counter(k1, decimal)". ";
        color: #5B9BD2;
        font-family: Arial, sans-serif;
        font-style: normal;
        font-weight: bold;
        text-decoration: none;
        font-size: 11pt;
      }

      #l67>li:first-child>*:first-child:before {
        counter-increment: k1 0;
      }

      #l68 {
        padding-left: 0pt;
        counter-reset: k2 1;
      }

      #l68>li>*:first-child:before {
        counter-increment: k2;
        content: counter(k2, lower-latin)") ";
        color: #2C5293;
        font-family: Arial, sans-serif;
        font-style: normal;
        font-weight: bold;
        text-decoration: none;
        font-size: 10pt;
      }

      #l68>li:first-child>*:first-child:before {
        counter-increment: k2 0;
      }

      #l69 {
        padding-left: 0pt;
        counter-reset: k2 1;
      }

      #l69>li>*:first-child:before {
        counter-increment: k2;
        content: counter(k2, lower-latin)") ";
        color: #2C5293;
        font-family: Arial, sans-serif;
        font-style: normal;
        font-weight: bold;
        text-decoration: none;
        font-size: 10pt;
      }

      #l69>li:first-child>*:first-child:before {
        counter-increment: k2 0;
      }

      #l70 {
        padding-left: 0pt;
        counter-reset: k2 1;
      }

      #l70>li>*:first-child:before {
        counter-increment: k2;
        content: counter(k2, lower-latin)") ";
        color: #2C5293;
        font-family: Arial, sans-serif;
        font-style: normal;
        font-weight: bold;
        text-decoration: none;
        font-size: 10pt;
      }

      #l70>li:first-child>*:first-child:before {
        counter-increment: k2 0;
      }

      #l71 {
        padding-left: 0pt;
        counter-reset: k2 1;
      }

      #l71>li>*:first-child:before {
        counter-increment: k2;
        content: counter(k2, lower-latin)") ";
        color: #2C5293;
        font-family: Arial, sans-serif;
        font-style: normal;
        font-weight: bold;
        text-decoration: none;
        font-size: 10pt;
      }

      #l71>li:first-child>*:first-child:before {
        counter-increment: k2 0;
      }

      #l72 {
        padding-left: 0pt;
        counter-reset: j2 1;
      }

      #l72>li>*:first-child:before {
        counter-increment: j2;
        content: counter(j2, decimal)". ";
        color: black;
        font-style: normal;
        font-weight: normal;
        text-decoration: none;
      }

      #l72>li:first-child>*:first-child:before {
        counter-increment: j2 0;
      }

      #l73 {
        padding-left: 0pt;
        counter-reset: j3 1;
      }

      #l73>li>*:first-child:before {
        counter-increment: j3;
        content: counter(j3, lower-latin)") ";
        color: #2C5293;
        font-family: Arial, sans-serif;
        font-style: normal;
        font-weight: bold;
        text-decoration: none;
        font-size: 10pt;
      }

      #l73>li:first-child>*:first-child:before {
        counter-increment: j3 0;
      }

      #l74 {
        padding-left: 0pt;
        counter-reset: j3 1;
      }

      #l74>li>*:first-child:before {
        counter-increment: j3;
        content: counter(j3, lower-latin)") ";
        color: #2C5293;
        font-family: Arial, sans-serif;
        font-style: normal;
        font-weight: bold;
        text-decoration: none;
        font-size: 10pt;
      }

      #l74>li:first-child>*:first-child:before {
        counter-increment: j3 0;
      }

      #l75 {
        padding-left: 0pt;
        counter-reset: j2 1;
      }

      #l75>li>*:first-child:before {
        counter-increment: j2;
        content: counter(j2, decimal)". ";
        color: black;
        font-style: normal;
        font-weight: normal;
        text-decoration: none;
      }

      #l75>li:first-child>*:first-child:before {
        counter-increment: j2 0;
      }

      #l76 {
        padding-left: 0pt;
        counter-reset: j3 1;
      }

      #l76>li>*:first-child:before {
        counter-increment: j3;
        content: counter(j3, lower-latin)") ";
        color: #2C5293;
        font-family: Arial, sans-serif;
        font-style: normal;
        font-weight: bold;
        text-decoration: none;
        font-size: 10pt;
      }

      #l76>li:first-child>*:first-child:before {
        counter-increment: j3 0;
      }

      #l77 {
        padding-left: 0pt;
        counter-reset: l1 1;
      }

      #l77>li>*:first-child:before {
        counter-increment: l1;
        content: counter(l1, lower-latin)") ";
        color: #2C5293;
        font-family: Arial, sans-serif;
        font-style: normal;
        font-weight: bold;
        text-decoration: none;
        font-size: 10pt;
      }

      #l77>li:first-child>*:first-child:before {
        counter-increment: l1 0;
      }

      #l78 {
        padding-left: 0pt;
        counter-reset: j2 1;
      }

      #l78>li>*:first-child:before {
        counter-increment: j2;
        content: counter(j2, decimal)". ";
        color: black;
        font-style: normal;
        font-weight: normal;
        text-decoration: none;
      }

      #l78>li:first-child>*:first-child:before {
        counter-increment: j2 0;
      }

      li {
        display: block;
      }

      #l79 {
        padding-left: 0pt;
        counter-reset: m1 1;
      }

      #l79>li>*:first-child:before {
        counter-increment: m1;
        content: counter(m1, upper-latin)") ";
        color: #2C5293;
        font-family: Arial, sans-serif;
        font-style: normal;
        font-weight: bold;
        text-decoration: none;
        font-size: 10pt;
      }

      #l79>li:first-child>*:first-child:before {
        counter-increment: m1 0;
      }

      #l80 {
        padding-left: 0pt;
        counter-reset: m2 1;
      }

      #l80>li>*:first-child:before {
        counter-increment: m2;
        content: counter(m2, lower-latin)") ";
        color: black;
        font-style: normal;
        font-weight: normal;
        text-decoration: none;
      }

      #l80>li:first-child>*:first-child:before {
        counter-increment: m2 0;
      }

      li {
        display: block;
      }

      #l81 {
        padding-left: 0pt;
        counter-reset: n1 1;
      }

      #l81>li>*:first-child:before {
        counter-increment: n1;
        content: counter(n1, decimal)". ";
        color: black;
        font-style: normal;
        font-weight: normal;
        text-decoration: none;
      }

      #l81>li:first-child>*:first-child:before {
        counter-increment: n1 0;
      }

      li {
        display: block;
      }

      #l82 {
        padding-left: 0pt;
        counter-reset: n1 1;
      }

      #l82>li>*:first-child:before {
        counter-increment: n1;
        content: counter(n1, decimal)". ";
        color: black;
        font-style: normal;
        font-weight: normal;
        text-decoration: none;
      }

      #l82>li:first-child>*:first-child:before {
        counter-increment: n1 0;
      }

      #l83 {
        padding-left: 0pt;
        counter-reset: n2 1;
      }

      #l83>li>*:first-child:before {
        counter-increment: n2;
        content: counter(n2, upper-latin)") ";
        color: black;
        font-style: normal;
        font-weight: normal;
        text-decoration: none;
      }

      #l83>li:first-child>*:first-child:before {
        counter-increment: n2 0;
      }

      #l84 {
        padding-left: 0pt;
        counter-reset: n3 1;
      }

      #l84>li>*:first-child:before {
        counter-increment: n3;
        content: counter(n3, decimal)". ";
        color: black;
        font-family: Arial, sans-serif;
        font-style: normal;
        font-weight: bold;
        text-decoration: none;
        font-size: 12pt;
      }

      #l84>li:first-child>*:first-child:before {
        counter-increment: n3 0;
      }

      li {
        display: block;
      }

      #l85 {
        padding-left: 0pt;
        counter-reset: o1 1;
      }

      #l85>li>*:first-child:before {
        counter-increment: o1;
        content: counter(o1, decimal)". ";
        color: #2C5293;
        font-family: Arial, sans-serif;
        font-style: normal;
        font-weight: bold;
        text-decoration: none;
        font-size: 12pt;
      }

      #l85>li:first-child>*:first-child:before {
        counter-increment: o1 0;
      }

      #l86 {
        padding-left: 0pt;
        counter-reset: p1 1;
      }

      #l86>li>*:first-child:before {
        counter-increment: p1;
        content: counter(p1, upper-latin)") ";
        color: black;
        font-style: normal;
        font-weight: normal;
        text-decoration: none;
      }

      #l86>li:first-child>*:first-child:before {
        counter-increment: p1 0;
      }

      #l87 {
        padding-left: 0pt;
        counter-reset: p2 1;
      }

      #l87>li>*:first-child:before {
        counter-increment: p2;
        content: counter(p2, decimal)". ";
        color: black;
        font-style: normal;
        font-weight: normal;
        text-decoration: none;
      }

      #l87>li:first-child>*:first-child:before {
        counter-increment: p2 0;
      }

      #l88 {
        padding-left: 0pt;
        counter-reset: p2 1;
      }

      #l88>li>*:first-child:before {
        counter-increment: p2;
        content: counter(p2, decimal)". ";
        color: black;
        font-style: normal;
        font-weight: normal;
        text-decoration: none;
      }

      #l88>li:first-child>*:first-child:before {
        counter-increment: p2 0;
      }

      li {
        display: block;
      }

      #l89 {
        padding-left: 0pt;
        counter-reset: q1 1;
      }

      #l89>li>*:first-child:before {
        counter-increment: q1;
        content: counter(q1, upper-latin)") ";
        color: #2C5293;
        font-family: Arial, sans-serif;
        font-style: normal;
        font-weight: bold;
        text-decoration: none;
        font-size: 10pt;
      }

      #l89>li:first-child>*:first-child:before {
        counter-increment: q1 0;
      }

      li {
        display: block;
      }

      #l90 {
        padding-left: 0pt;
        counter-reset: r1 1;
      }

      #l90>li>*:first-child:before {
        counter-increment: r1;
        content: counter(r1, upper-latin)") ";
        color: black;
        font-style: normal;
        font-weight: normal;
        text-decoration: none;
      }

      #l90>li:first-child>*:first-child:before {
        counter-increment: r1 0;
      }

      #l91 {
        padding-left: 0pt;
        counter-reset: r2 1;
      }

      #l91>li>*:first-child:before {
        counter-increment: r2;
        content: counter(r2, decimal)". ";
        color: black;
        font-style: normal;
        font-weight: normal;
        text-decoration: none;
      }

      #l91>li:first-child>*:first-child:before {
        counter-increment: r2 0;
      }

      #l92 {
        padding-left: 0pt;
        counter-reset: r2 1;
      }

      #l92>li>*:first-child:before {
        counter-increment: r2;
        content: counter(r2, decimal)". ";
        color: black;
        font-style: normal;
        font-weight: normal;
        text-decoration: none;
      }

      #l92>li:first-child>*:first-child:before {
        counter-increment: r2 0;
      }

      li {
        display: block;
      }

      #l93 {
        padding-left: 0pt;
        counter-reset: s1 1;
      }

      #l93>li>*:first-child:before {
        counter-increment: s1;
        content: counter(s1, upper-latin)") ";
        color: black;
        font-style: normal;
        font-weight: normal;
        text-decoration: none;
      }

      #l93>li:first-child>*:first-child:before {
        counter-increment: s1 0;
      }

      #l94 {
        padding-left: 0pt;
        counter-reset: s2 1;
      }

      #l94>li>*:first-child:before {
        counter-increment: s2;
        content: counter(s2, decimal)". ";
        color: #1F4E79;
        font-family: Arial, sans-serif;
        font-style: normal;
        font-weight: bold;
        text-decoration: none;
        font-size: 10pt;
      }

      #l94>li:first-child>*:first-child:before {
        counter-increment: s2 0;
      }

      #l95 {
        padding-left: 0pt;
        counter-reset: s3 1;
      }

      #l95>li>*:first-child:before {
        counter-increment: s3;
        content: counter(s2, decimal)"."counter(s3, decimal)". ";
        color: #2C5293;
        font-family: Arial, sans-serif;
        font-style: normal;
        font-weight: bold;
        text-decoration: none;
        font-size: 10pt;
      }

      #l95>li:first-child>*:first-child:before {
        counter-increment: s3 0;
      }

      #l96 {
        padding-left: 0pt;
        counter-reset: t1 1;
      }

      #l96>li>*:first-child:before {
        counter-increment: t1;
        content: counter(t1, decimal)" ";
        color: black;
        font-style: normal;
        font-weight: normal;
        text-decoration: none;
      }

      #l96>li:first-child>*:first-child:before {
        counter-increment: t1 0;
      }

      #l97 {
        padding-left: 0pt;
        counter-reset: t2 4;
      }

      #l97>li>*:first-child:before {
        counter-increment: t2;
        content: counter(t1, decimal)"."counter(t2, decimal)" ";
        color: #2C5293;
        font-family: Arial, sans-serif;
        font-style: normal;
        font-weight: bold;
        text-decoration: none;
        font-size: 10pt;
      }

      #l97>li:first-child>*:first-child:before {
        counter-increment: t2 0;
      }

      #l98 {
        padding-left: 0pt;
        counter-reset: t3 1;
      }

      #l98>li>*:first-child:before {
        counter-increment: t3;
        content: counter(t3, decimal)". ";
        color: black;
        font-family: Arial, sans-serif;
        font-style: normal;
        font-weight: bold;
        text-decoration: none;
        font-size: 12pt;
      }

      #l98>li:first-child>*:first-child:before {
        counter-increment: t3 0;
      }

      #l99 {
        padding-left: 0pt;
        counter-reset: t4 1;
      }

      #l99>li>*:first-child:before {
        counter-increment: t4;
        content: counter(t4, lower-latin)") ";
        color: black;
        font-family: Arial, sans-serif;
        font-style: normal;
        font-weight: bold;
        text-decoration: none;
        font-size: 12pt;
      }

      #l99>li:first-child>*:first-child:before {
        counter-increment: t4 0;
      }

      li {
        display: block;
      }

      #l100 {
        padding-left: 0pt;
        counter-reset: u1 2;
      }

      #l100>li>*:first-child:before {
        counter-increment: u1;
        content: counter(u1, decimal)" ";
        color: black;
        font-style: normal;
        font-weight: normal;
        text-decoration: none;
      }

      #l100>li:first-child>*:first-child:before {
        counter-increment: u1 0;
      }

      #l101 {
        padding-left: 0pt;
        counter-reset: u2 1;
      }

      #l101>li>*:first-child:before {
        counter-increment: u2;
        content: counter(u1, decimal)"."counter(u2, decimal)" ";
        color: black;
        font-style: normal;
        font-weight: normal;
        text-decoration: none;
      }

      #l101>li:first-child>*:first-child:before {
        counter-increment: u2 0;
      }

      #l102 {
        padding-left: 0pt;
        counter-reset: u3 1;
      }

      #l102>li>*:first-child:before {
        counter-increment: u3;
        content: counter(u3, decimal)". ";
        color: black;
        font-family: Arial, sans-serif;
        font-style: normal;
        font-weight: bold;
        text-decoration: none;
        font-size: 12pt;
      }

      #l102>li:first-child>*:first-child:before {
        counter-increment: u3 0;
      }

      #l103 {
        padding-left: 0pt;
        counter-reset: u3 1;
      }

      #l103>li>*:first-child:before {
        counter-increment: u3;
        content: counter(u3, decimal)". ";
        color: black;
        font-family: Arial, sans-serif;
        font-style: normal;
        font-weight: bold;
        text-decoration: none;
        font-size: 12pt;
      }

      #l103>li:first-child>*:first-child:before {
        counter-increment: u3 0;
      }

      li {
        display: block;
      }

      #l104 {
        padding-left: 0pt;
        counter-reset: v1 3;
      }

      #l104>li>*:first-child:before {
        counter-increment: v1;
        content: counter(v1, decimal)" ";
        color: black;
        font-style: normal;
        font-weight: normal;
        text-decoration: none;
      }

      #l104>li:first-child>*:first-child:before {
        counter-increment: v1 0;
      }

      #l105 {
        padding-left: 0pt;
        counter-reset: v2 1;
      }

      #l105>li>*:first-child:before {
        counter-increment: v2;
        content: counter(v1, decimal)"."counter(v2, decimal)" ";
        color: black;
        font-style: normal;
        font-weight: normal;
        text-decoration: none;
      }

      #l105>li:first-child>*:first-child:before {
        counter-increment: v2 0;
      }

      #l106 {
        padding-left: 0pt;
        counter-reset: v3 1;
      }

      #l106>li>*:first-child:before {
        counter-increment: v3;
        content: counter(v3, decimal)". ";
        color: black;
        font-style: normal;
        font-weight: normal;
        text-decoration: none;
      }

      #l106>li:first-child>*:first-child:before {
        counter-increment: v3 0;
      }

      #l107 {
        padding-left: 0pt;
        counter-reset: w1 1;
      }

      #l107>li>*:first-child:before {
        counter-increment: w1;
        content: counter(w1, upper-roman)". ";
        color: #2C5293;
        font-family: Arial, sans-serif;
        font-style: normal;
        font-weight: normal;
        text-decoration: none;
        font-size: 10pt;
      }

      #l107>li:first-child>*:first-child:before {
        counter-increment: w1 0;
      }

      #l108 {
        padding-left: 0pt;
        counter-reset: w2 1;
      }

      #l108>li>*:first-child:before {
        counter-increment: w2;
        content: counter(w2, decimal)". ";
        color: black;
        font-family: Arial, sans-serif;
        font-style: normal;
        font-weight: normal;
        text-decoration: none;
        font-size: 10pt;
      }

      #l108>li:first-child>*:first-child:before {
        counter-increment: w2 0;
      }

      #l109 {
        padding-left: 0pt;
        counter-reset: x1 1;
      }

      #l109>li>*:first-child:before {
        counter-increment: x1;
        content: counter(x1, decimal)". ";
        color: black;
        font-family: Arial, sans-serif;
        font-style: normal;
        font-weight: normal;
        text-decoration: none;
        font-size: 10pt;
      }

      #l109>li:first-child>*:first-child:before {
        counter-increment: x1 0;
      }

      #l110 {
        padding-left: 0pt;
        counter-reset: y1 1;
      }

      #l110>li>*:first-child:before {
        counter-increment: y1;
        content: counter(y1, decimal)". ";
        color: black;
        font-family: Arial, sans-serif;
        font-style: normal;
        font-weight: normal;
        text-decoration: none;
        font-size: 10pt;
      }

      #l110>li:first-child>*:first-child:before {
        counter-increment: y1 0;
      }

      #l111 {
        padding-left: 0pt;
        counter-reset: z1 1;
      }

      #l111>li>*:first-child:before {
        counter-increment: z1;
        content: counter(z1, decimal)". ";
        color: black;
        font-family: Arial, sans-serif;
        font-style: normal;
        font-weight: bold;
        text-decoration: none;
        font-size: 12pt;
      }

      #l111>li:first-child>*:first-child:before {
        counter-increment: z1 0;
      }

      #l112 {
        padding-left: 0pt;
        counter-reset: z2 1;
      }

      #l112>li>*:first-child:before {
        counter-increment: z2;
        content: counter(z2, lower-latin)". ";
        color: black;
        font-family: Arial, sans-serif;
        font-style: normal;
        font-weight: bold;
        text-decoration: none;
        font-size: 12pt;
      }

      #l112>li:first-child>*:first-child:before {
        counter-increment: z2 0;
      }

      #l113 {
        padding-left: 0pt;
        counter-reset: v3 1;
      }

      #l113>li>*:first-child:before {
        counter-increment: v3;
        content: counter(v3, decimal)". ";
        color: black;
        font-style: normal;
        font-weight: normal;
        text-decoration: none;
      }

      #l113>li:first-child>*:first-child:before {
        counter-increment: v3 0;
      }

      #l114 {
        padding-left: 0pt;
        counter-reset: v3 1;
      }

      #l114>li>*:first-child:before {
        counter-increment: v3;
        content: counter(v3, decimal)". ";
        color: black;
        font-style: normal;
        font-weight: normal;
        text-decoration: none;
      }

      #l114>li:first-child>*:first-child:before {
        counter-increment: v3 0;
      }

      #l115 {
        padding-left: 0pt;
        counter-reset: c1 4;
      }

      #l115>li>*:first-child:before {
        counter-increment: c1;
        content: counter(c1, decimal)" ";
        color: black;
        font-family: Arial, sans-serif;
        font-style: normal;
        font-weight: bold;
        text-decoration: none;
        font-size: 12pt;
      }

      #l115>li:first-child>*:first-child:before {
        counter-increment: c1 0;
      }

      #l116 {
        padding-left: 0pt;
        counter-reset: d1 1;
      }

      #l116>li>*:first-child:before {
        counter-increment: d1;
        content: counter(d1, upper-roman)". ";
        color: #2C5293;
        font-family: Arial, sans-serif;
        font-style: normal;
        font-weight: normal;
        text-decoration: none;
        font-size: 10pt;
      }

      #l116>li:first-child>*:first-child:before {
        counter-increment: d1 0;
      }

      #l117 {
        padding-left: 0pt;
        counter-reset: v3 1;
      }

      #l117>li>*:first-child:before {
        counter-increment: v3;
        content: counter(v3, decimal)". ";
        color: black;
        font-style: normal;
        font-weight: normal;
        text-decoration: none;
      }

      #l117>li:first-child>*:first-child:before {
        counter-increment: v3 0;
      }

      #l118 {
        padding-left: 0pt;
        counter-reset: v3 1;
      }

      #l118>li>*:first-child:before {
        counter-increment: v3;
        content: counter(v3, decimal)". ";
        color: black;
        font-style: normal;
        font-weight: normal;
        text-decoration: none;
      }

      #l118>li:first-child>*:first-child:before {
        counter-increment: v3 0;
      }

      #l119 {
        padding-left: 0pt;
        counter-reset: v3 1;
      }

      #l119>li>*:first-child:before {
        counter-increment: v3;
        content: counter(v3, decimal)". ";
        color: black;
        font-style: normal;
        font-weight: normal;
        text-decoration: none;
      }

      #l119>li:first-child>*:first-child:before {
        counter-increment: v3 0;
      }

      #l120 {
        padding-left: 0pt;
        counter-reset: v4 1;
      }

      #l120>li>*:first-child:before {
        counter-increment: v4;
        content: counter(v4, decimal)". ";
        color: #2C5293;
        font-family: Arial, sans-serif;
        font-style: normal;
        font-weight: bold;
        text-decoration: none;
        font-size: 10pt;
      }

      #l120>li:first-child>*:first-child:before {
        counter-increment: v4 0;
      }

      #l121 {
        padding-left: 0pt;
        counter-reset: v5 1;
      }

      #l121>li>*:first-child:before {
        counter-increment: v5;
        content: counter(v5, decimal)". ";
        color: black;
        font-style: normal;
        font-weight: normal;
        text-decoration: none;
      }

      #l121>li:first-child>*:first-child:before {
        counter-increment: v5 0;
      }

      #l122 {
        padding-left: 0pt;
      }

      #l122>li>*:first-child:before {
        content: "• ";
        color: black;
        font-family: Arial, sans-serif;
        font-style: normal;
        font-weight: normal;
        text-decoration: none;
        font-size: 10pt;
      }

      #l123 {
        padding-left: 0pt;
        counter-reset: v5 1;
      }

      #l123>li>*:first-child:before {
        counter-increment: v5;
        content: counter(v5, decimal)". ";
        color: black;
        font-style: normal;
        font-weight: normal;
        text-decoration: none;
      }

      #l123>li:first-child>*:first-child:before {
        counter-increment: v5 0;
      }

      li {
        display: block;
      }

      #l124 {
        padding-left: 0pt;
        counter-reset: e1 1;
      }

      #l124>li>*:first-child:before {
        counter-increment: e1;
        content: counter(e1, upper-latin)") ";
        color: #2C5293;
        font-family: Arial, sans-serif;
        font-style: normal;
        font-weight: bold;
        text-decoration: none;
        font-size: 12pt;
      }

      #l124>li:first-child>*:first-child:before {
        counter-increment: e1 0;
      }

      #l125 {
        padding-left: 0pt;
        counter-reset: e2 1;
      }

      #l125>li>*:first-child:before {
        counter-increment: e2;
        content: counter(e2, decimal)". ";
        color: #1F4E79;
        font-family: Arial, sans-serif;
        font-style: normal;
        font-weight: bold;
        text-decoration: none;
        font-size: 10pt;
      }

      #l125>li:first-child>*:first-child:before {
        counter-increment: e2 0;
      }

      #l126 {
        padding-left: 0pt;
        counter-reset: e3 1;
      }

      #l126>li>*:first-child:before {
        counter-increment: e3;
        content: counter(e2, decimal)"."counter(e3, decimal)" ";
        color: #1F4E79;
        font-family: Arial, sans-serif;
        font-style: normal;
        font-weight: bold;
        text-decoration: none;
        font-size: 10pt;
      }

      #l126>li:first-child>*:first-child:before {
        counter-increment: e3 0;
      }

      #l127 {
        padding-left: 0pt;
        counter-reset: f1 3;
      }

      #l127>li>*:first-child:before {
        counter-increment: f1;
        content: counter(f1, decimal)" ";
        color: black;
        font-style: normal;
        font-weight: normal;
        text-decoration: none;
      }

      #l127>li:first-child>*:first-child:before {
        counter-increment: f1 0;
      }

      #l128 {
        padding-left: 0pt;
        counter-reset: f2 3;
      }

      #l128>li>*:first-child:before {
        counter-increment: f2;
        content: counter(f1, decimal)"."counter(f2, decimal)". ";
        color: #2C5293;
        font-family: Arial, sans-serif;
        font-style: normal;
        font-weight: bold;
        text-decoration: none;
        font-size: 10pt;
      }

      #l128>li:first-child>*:first-child:before {
        counter-increment: f2 0;
      }

      #l129 {
        padding-left: 0pt;
        counter-reset: e2 1;
      }

      #l129>li>*:first-child:before {
        counter-increment: e2;
        content: counter(e2, decimal)". ";
        color: #1F4E79;
        font-family: Arial, sans-serif;
        font-style: normal;
        font-weight: bold;
        text-decoration: none;
        font-size: 10pt;
      }

      #l129>li:first-child>*:first-child:before {
        counter-increment: e2 0;
      }

      li {
        display: block;
      }

      #l130 {
        padding-left: 0pt;
        counter-reset: g1 1;
      }

      #l130>li>*:first-child:before {
        counter-increment: g1;
        content: counter(g1, upper-latin)") ";
        color: #2C5293;
        font-family: Arial, sans-serif;
        font-style: normal;
        font-weight: bold;
        text-decoration: none;
        font-size: 10pt;
      }

      #l130>li:first-child>*:first-child:before {
        counter-increment: g1 0;
      }

      #l131 {
        padding-left: 0pt;
        counter-reset: g2 1;
      }

      #l131>li>*:first-child:before {
        counter-increment: g2;
        content: counter(g2, decimal)". ";
        color: #2C5293;
        font-family: Arial, sans-serif;
        font-style: normal;
        font-weight: bold;
        text-decoration: none;
        font-size: 10pt;
      }

      #l131>li:first-child>*:first-child:before {
        counter-increment: g2 0;
      }

      #l132 {
        padding-left: 0pt;
        counter-reset: g2 1;
      }

      #l132>li>*:first-child:before {
        counter-increment: g2;
        content: counter(g2, decimal)". ";
        color: #2C5293;
        font-family: Arial, sans-serif;
        font-style: normal;
        font-weight: bold;
        text-decoration: none;
        font-size: 10pt;
      }

      #l132>li:first-child>*:first-child:before {
        counter-increment: g2 0;
      }

      li {
        display: block;
      }

      #l133 {
        padding-left: 0pt;
        counter-reset: h1 1;
      }

      #l133>li>*:first-child:before {
        counter-increment: h1;
        content: counter(h1, upper-latin)") ";
        color: #2C5293;
        font-family: Arial, sans-serif;
        font-style: normal;
        font-weight: bold;
        text-decoration: none;
        font-size: 12pt;
      }

      #l133>li:first-child>*:first-child:before {
        counter-increment: h1 0;
      }

      #l134 {
        padding-left: 0pt;
        counter-reset: h2 1;
      }

      #l134>li>*:first-child:before {
        counter-increment: h2;
        content: counter(h2, decimal)". ";
        color: #2C5293;
        font-family: Arial, sans-serif;
        font-style: normal;
        font-weight: bold;
        text-decoration: none;
        font-size: 12pt;
      }

      #l134>li:first-child>*:first-child:before {
        counter-increment: h2 0;
      }

      li {
        display: block;
      }

      #l135 {
        padding-left: 0pt;
        counter-reset: i1 1;
      }

      #l135>li>*:first-child:before {
        counter-increment: i1;
        content: counter(i1, decimal)". ";
        color: black;
        font-family: Arial, sans-serif;
        font-style: normal;
        font-weight: bold;
        text-decoration: none;
        font-size: 10pt;
      }

      #l135>li:first-child>*:first-child:before {
        counter-increment: i1 0;
      }

      #l136 {
        padding-left: 0pt;
        counter-reset: i2 1;
      }

      #l136>li>*:first-child:before {
        counter-increment: i2;
        content: counter(i1, decimal)"."counter(i2, decimal)" ";
        color: #2C5293;
        font-family: Arial, sans-serif;
        font-style: normal;
        font-weight: bold;
        text-decoration: none;
        font-size: 10pt;
      }

      #l136>li:first-child>*:first-child:before {
        counter-increment: i2 0;
      }

      li {
        display: block;
      }

      #l137 {
        padding-left: 0pt;
        counter-reset: j1 2;
      }

      #l137>li>*:first-child:before {
        counter-increment: j1;
        content: counter(j1, decimal)" ";
        color: black;
        font-style: normal;
        font-weight: normal;
        text-decoration: none;
      }

      #l137>li:first-child>*:first-child:before {
        counter-increment: j1 0;
      }

      #l138 {
        padding-left: 0pt;
        counter-reset: j2 2;
      }

      #l138>li>*:first-child:before {
        counter-increment: j2;
        content: counter(j1, decimal)"."counter(j2, decimal)". ";
        color: #2C74B5;
        font-family: Arial, sans-serif;
        font-style: normal;
        font-weight: bold;
        text-decoration: none;
        font-size: 10pt;
      }

      #l138>li:first-child>*:first-child:before {
        counter-increment: j2 0;
      }

      li {
        display: block;
      }

      #l139 {
        padding-left: 0pt;
        counter-reset: k1 1;
      }

      #l139>li>*:first-child:before {
        counter-increment: k1;
        content: counter(k1, decimal)". ";
        color: black;
        font-style: normal;
        font-weight: normal;
        text-decoration: none;
      }

      #l139>li:first-child>*:first-child:before {
        counter-increment: k1 0;
      }

      li {
        display: block;
      }

      #l140 {
        padding-left: 0pt;
        counter-reset: l1 1;
      }

      #l140>li>*:first-child:before {
        counter-increment: l1;
        content: counter(l1, upper-latin)") ";
        color: #2C5293;
        font-family: Arial, sans-serif;
        font-style: normal;
        font-weight: bold;
        text-decoration: none;
        font-size: 10pt;
      }

      #l140>li:first-child>*:first-child:before {
        counter-increment: l1 0;
      }

      #l141 {
        padding-left: 0pt;
        counter-reset: l2 1;
      }

      #l141>li>*:first-child:before {
        counter-increment: l2;
        content: counter(l2, decimal)". ";
        color: #2C5293;
        font-family: Arial, sans-serif;
        font-style: normal;
        font-weight: bold;
        text-decoration: none;
        font-size: 10pt;
      }

      #l141>li:first-child>*:first-child:before {
        counter-increment: l2 0;
      }

      #l142 {
        padding-left: 0pt;
        counter-reset: l3 1;
      }

      #l142>li>*:first-child:before {
        counter-increment: l3;
        content: counter(l2, decimal)"."counter(l3, decimal)". ";
        color: #2C5293;
        font-family: Arial, sans-serif;
        font-style: normal;
        font-weight: bold;
        text-decoration: none;
        font-size: 10pt;
      }

      #l142>li:first-child>*:first-child:before {
        counter-increment: l3 0;
      }

      li {
        display: block;
      }

      #l143 {
        padding-left: 0pt;
        counter-reset: m1 1;
      }

      #l143>li>*:first-child:before {
        counter-increment: m1;
        content: counter(m1, upper-latin)") ";
        color: #2C5293;
        font-family: Arial, sans-serif;
        font-style: normal;
        font-weight: bold;
        text-decoration: none;
        font-size: 10pt;
      }

      #l143>li:first-child>*:first-child:before {
        counter-increment: m1 0;
      }

      #l144 {
        padding-left: 0pt;
        counter-reset: m2 1;
      }

      #l144>li>*:first-child:before {
        counter-increment: m2;
        content: counter(m2, decimal)". ";
        color: #2C5293;
        font-family: Arial, sans-serif;
        font-style: normal;
        font-weight: bold;
        text-decoration: none;
        font-size: 10pt;
      }

      #l144>li:first-child>*:first-child:before {
        counter-increment: m2 0;
      }

      li {
        display: block;
      }

      #l145 {
        padding-left: 0pt;
        counter-reset: n1 1;
      }

      #l145>li>*:first-child:before {
        counter-increment: n1;
        content: counter(n1, upper-latin)") ";
        color: #2C5293;
        font-family: Arial, sans-serif;
        font-style: normal;
        font-weight: bold;
        text-decoration: none;
        font-size: 10pt;
      }

      #l145>li:first-child>*:first-child:before {
        counter-increment: n1 0;
      }

      #l146 {
        padding-left: 0pt;
        counter-reset: n2 1;
      }

      #l146>li>*:first-child:before {
        counter-increment: n2;
        content: counter(n2, decimal)". ";
        color: #2C5293;
        font-family: Arial, sans-serif;
        font-style: normal;
        font-weight: bold;
        text-decoration: none;
        font-size: 10pt;
      }

      #l146>li:first-child>*:first-child:before {
        counter-increment: n2 0;
      }

      #l147 {
        padding-left: 0pt;
        counter-reset: n3 1;
      }

      #l147>li>*:first-child:before {
        counter-increment: n3;
        content: counter(n2, decimal)"."counter(n3, decimal)". ";
        color: #2C5293;
        font-family: Arial, sans-serif;
        font-style: normal;
        font-weight: bold;
        text-decoration: none;
        font-size: 10pt;
      }

      #l147>li:first-child>*:first-child:before {
        counter-increment: n3 0;
      }

      #l148 {
        padding-left: 0pt;
        counter-reset: n2 1;
      }

      #l148>li>*:first-child:before {
        counter-increment: n2;
        content: counter(n2, decimal)". ";
        color: #2C5293;
        font-family: Arial, sans-serif;
        font-style: normal;
        font-weight: bold;
        text-decoration: none;
        font-size: 10pt;
      }

      #l148>li:first-child>*:first-child:before {
        counter-increment: n2 0;
      }

      li {
        display: block;
      }

      #l149 {
        padding-left: 0pt;
        counter-reset: o1 1;
      }

      #l149>li>*:first-child:before {
        counter-increment: o1;
        content: counter(o1, upper-latin)") ";
        color: black;
        font-style: normal;
        font-weight: normal;
        text-decoration: none;
      }

      #l149>li:first-child>*:first-child:before {
        counter-increment: o1 0;
      }

      #l150 {
        padding-left: 0pt;
        counter-reset: p1 1;
      }

      #l150>li>*:first-child:before {
        counter-increment: p1;
        content: counter(p1, decimal)". ";
        color: black;
        font-style: normal;
        font-weight: normal;
        text-decoration: none;
      }

      #l150>li:first-child>*:first-child:before {
        counter-increment: p1 0;
      }

      li {
        display: block;
      }

      #l151 {
        padding-left: 0pt;
        counter-reset: p1 1;
      }

      #l151>li>*:first-child:before {
        counter-increment: p1;
        content: counter(p1, decimal)". ";
        color: black;
        font-style: normal;
        font-weight: normal;
        text-decoration: none;
      }

      #l151>li:first-child>*:first-child:before {
        counter-increment: p1 0;
      }

      #l152 {
        padding-left: 0pt;
        counter-reset: p2 1;
      }

      #l152>li>*:first-child:before {
        counter-increment: p2;
        content: counter(p1, decimal)"."counter(p2, decimal)". ";
        color: black;
        font-family: Arial, sans-serif;
        font-style: normal;
        font-weight: bold;
        text-decoration: none;
        font-size: 12pt;
      }

      #l152>li:first-child>*:first-child:before {
        counter-increment: p2 0;
      }

      #l153 {
        padding-left: 0pt;
        counter-reset: p3 1;
      }

      #l153>li>*:first-child:before {
        counter-increment: p3;
        content: counter(p3, lower-latin)") ";
        color: black;
        font-family: Arial, sans-serif;
        font-style: normal;
        font-weight: bold;
        text-decoration: none;
        font-size: 12pt;
      }

      #l153>li:first-child>*:first-child:before {
        counter-increment: p3 0;
      }

      li {
        display: block;
      }

      #l154 {
        padding-left: 0pt;
        counter-reset: q1 4;
      }

      #l154>li>*:first-child:before {
        counter-increment: q1;
        content: counter(q1, decimal)" ";
        color: black;
        font-style: normal;
        font-weight: normal;
        text-decoration: none;
      }

      #l154>li:first-child>*:first-child:before {
        counter-increment: q1 0;
      }

      #l155 {
        padding-left: 0pt;
        counter-reset: q2 8;
      }

      #l155>li>*:first-child:before {
        counter-increment: q2;
        content: counter(q1, decimal)"."counter(q2, decimal)". ";
        color: black;
        font-family: Arial, sans-serif;
        font-style: normal;
        font-weight: bold;
        text-decoration: none;
        font-size: 12pt;
      }

      #l155>li:first-child>*:first-child:before {
        counter-increment: q2 0;
      }

      li {
        display: block;
      }

      #l156 {
        padding-left: 0pt;
        counter-reset: r1 4;
      }

      #l156>li>*:first-child:before {
        counter-increment: r1;
        content: counter(r1, decimal)" ";
        color: black;
        font-style: normal;
        font-weight: normal;
        text-decoration: none;
      }

      #l156>li:first-child>*:first-child:before {
        counter-increment: r1 0;
      }

      #l157 {
        padding-left: 0pt;
        counter-reset: r2 10;
      }

      #l157>li>*:first-child:before {
        counter-increment: r2;
        content: counter(r1, decimal)"."counter(r2, decimal)" ";
        color: black;
        font-family: Arial, sans-serif;
        font-style: normal;
        font-weight: bold;
        text-decoration: none;
        font-size: 12pt;
      }

      #l157>li:first-child>*:first-child:before {
        counter-increment: r2 0;
      }

      #l158 {
        padding-left: 0pt;
        counter-reset: r3 1;
      }

      #l158>li>*:first-child:before {
        counter-increment: r3;
        content: counter(r3, lower-latin)") ";
        color: black;
        font-family: Arial, sans-serif;
        font-style: normal;
        font-weight: bold;
        text-decoration: none;
        font-size: 12pt;
      }

      #l158>li:first-child>*:first-child:before {
        counter-increment: r3 0;
      }

      li {
        display: block;
      }

      #l159 {
        padding-left: 0pt;
        counter-reset: s1 1;
      }

      #l159>li>*:first-child:before {
        counter-increment: s1;
        content: counter(s1, decimal)". ";
        color: black;
        font-family: Arial, sans-serif;
        font-style: normal;
        font-weight: bold;
        text-decoration: none;
        font-size: 10pt;
      }

      #l159>li:first-child>*:first-child:before {
        counter-increment: s1 0;
      }

      li {
        display: block;
      }

      #l160 {
        padding-left: 0pt;
        counter-reset: t1 1;
      }

      #l160>li>*:first-child:before {
        counter-increment: t1;
        content: counter(t1, decimal)". ";
        color: black;
        font-family: Arial, sans-serif;
        font-style: normal;
        font-weight: bold;
        text-decoration: none;
        font-size: 10pt;
      }

      #l160>li:first-child>*:first-child:before {
        counter-increment: t1 0;
      }

      #l161 {
        padding-left: 0pt;
        counter-reset: t2 1;
      }

      #l161>li>*:first-child:before {
        counter-increment: t2;
        content: counter(t2, lower-latin)". ";
        color: #2C5293;
        font-family: Arial, sans-serif;
        font-style: normal;
        font-weight: bold;
        text-decoration: none;
        font-size: 10pt;
      }

      #l161>li:first-child>*:first-child:before {
        counter-increment: t2 0;
      }

      #l162 {
        padding-left: 0pt;
        counter-reset: u1 1;
      }

      #l162>li>*:first-child:before {
        counter-increment: u1;
        content: counter(u1, decimal)". ";
        color: black;
        font-family: Arial, sans-serif;
        font-style: normal;
        font-weight: bold;
        text-decoration: none;
        font-size: 10pt;
      }

      #l162>li:first-child>*:first-child:before {
        counter-increment: u1 0;
      }

      #l163 {
        padding-left: 0pt;
        counter-reset: v1 1;
      }

      #l163>li>*:first-child:before {
        counter-increment: v1;
        content: counter(v1, decimal)". ";
        color: black;
        font-family: Arial, sans-serif;
        font-style: normal;
        font-weight: bold;
        text-decoration: none;
        font-size: 10pt;
      }

      #l163>li:first-child>*:first-child:before {
        counter-increment: v1 0;
      }

      #l164 {
        padding-left: 0pt;
        counter-reset: w1 1;
      }

      #l164>li>*:first-child:before {
        counter-increment: w1;
        content: counter(w1, decimal)". ";
        color: black;
        font-family: Arial, sans-serif;
        font-style: normal;
        font-weight: bold;
        text-decoration: none;
        font-size: 10pt;
      }

      #l164>li:first-child>*:first-child:before {
        counter-increment: w1 0;
      }

      #l165 {
        padding-left: 0pt;
        counter-reset: x1 1;
      }

      #l165>li>*:first-child:before {
        counter-increment: x1;
        content: counter(x1, decimal)". ";
        color: black;
        font-family: Arial, sans-serif;
        font-style: normal;
        font-weight: bold;
        text-decoration: none;
        font-size: 10pt;
      }

      #l165>li:first-child>*:first-child:before {
        counter-increment: x1 0;
      }

      li {
        display: block;
      }

      #l166 {
        padding-left: 0pt;
        counter-reset: y1 1;
      }

      #l166>li>*:first-child:before {
        counter-increment: y1;
        content: counter(y1, decimal)". ";
        color: black;
        font-family: Arial, sans-serif;
        font-style: normal;
        font-weight: bold;
        text-decoration: none;
        font-size: 10pt;
      }

      #l166>li:first-child>*:first-child:before {
        counter-increment: y1 0;
      }

      li {
        display: block;
      }

      #l167 {
        padding-left: 0pt;
        counter-reset: z1 1;
      }

      #l167>li>*:first-child:before {
        counter-increment: z1;
        content: counter(z1, decimal)". ";
        color: black;
        font-family: Arial, sans-serif;
        font-style: normal;
        font-weight: bold;
        text-decoration: none;
        font-size: 10pt;
      }

      #l167>li:first-child>*:first-child:before {
        counter-increment: z1 0;
      }

      #l168 {
        padding-left: 0pt;
        counter-reset: z2 1;
      }

      #l168>li>*:first-child:before {
        counter-increment: z2;
        content: counter(z2, upper-roman)". ";
        color: #2C5293;
        font-family: Arial, sans-serif;
        font-style: normal;
        font-weight: bold;
        text-decoration: none;
        font-size: 10pt;
      }

      #l168>li:first-child>*:first-child:before {
        counter-increment: z2 0;
      }

      #l169 {
        padding-left: 0pt;
        counter-reset: z3 1;
      }

      #l169>li>*:first-child:before {
        counter-increment: z3;
        content: counter(z3, lower-latin)") ";
        color: #2C5293;
        font-family: Arial, sans-serif;
        font-style: normal;
        font-weight: bold;
        text-decoration: none;
        font-size: 10pt;
      }

      #l169>li:first-child>*:first-child:before {
        counter-increment: z3 0;
      }

      #l170 {
        padding-left: 0pt;
        counter-reset: z3 1;
      }

      #l170>li>*:first-child:before {
        counter-increment: z3;
        content: counter(z3, lower-latin)") ";
        color: #2C5293;
        font-family: Arial, sans-serif;
        font-style: normal;
        font-weight: bold;
        text-decoration: none;
        font-size: 10pt;
      }

      #l170>li:first-child>*:first-child:before {
        counter-increment: z3 0;
      }

      li {
        display: block;
      }

      #l171 {
        padding-left: 0pt;
        counter-reset: c1 1;
      }

      #l171>li>*:first-child:before {
        counter-increment: c1;
        content: counter(c1, decimal)". ";
        color: black;
        font-style: normal;
        font-weight: normal;
        text-decoration: none;
      }

      #l171>li:first-child>*:first-child:before {
        counter-increment: c1 0;
      }

      #l172 {
        padding-left: 0pt;
        counter-reset: d1 1;
      }

      #l172>li>*:first-child:before {
        counter-increment: d1;
        content: counter(d1, lower-latin)") ";
        color: black;
        font-family: Arial, sans-serif;
        font-style: normal;
        font-weight: bold;
        text-decoration: none;
        font-size: 12pt;
      }

      #l172>li:first-child>*:first-child:before {
        counter-increment: d1 0;
      }

      #l173 {
        padding-left: 0pt;
        counter-reset: c2 1;
      }

      #l173>li>*:first-child:before {
        counter-increment: c2;
        content: counter(c2, lower-latin)") ";
        color: #2C5293;
        font-family: Arial, sans-serif;
        font-style: normal;
        font-weight: bold;
        text-decoration: none;
        font-size: 10pt;
      }

      #l173>li:first-child>*:first-child:before {
        counter-increment: c2 0;
      }

      li {
        display: block;
      }

      #l174 {
        padding-left: 0pt;
        counter-reset: e1 1;
      }

      #l174>li>*:first-child:before {
        counter-increment: e1;
        content: counter(e1, decimal)". ";
        color: #2C5293;
        font-family: Arial, sans-serif;
        font-style: normal;
        font-weight: bold;
        text-decoration: none;
        font-size: 10pt;
      }

      #l174>li:first-child>*:first-child:before {
        counter-increment: e1 0;
      }

      #l175 {
        padding-left: 0pt;
        counter-reset: e2 1;
      }

      #l175>li>*:first-child:before {
        counter-increment: e2;
        content: counter(e1, decimal)"."counter(e2, decimal)". ";
        color: #2C5293;
        font-family: Arial, sans-serif;
        font-style: normal;
        font-weight: bold;
        text-decoration: none;
        font-size: 10pt;
      }

      #l175>li:first-child>*:first-child:before {
        counter-increment: e2 0;
      }

      li {
        display: block;
      }

      #l176 {
        padding-left: 0pt;
        counter-reset: f1 1;
      }

      #l176>li>*:first-child:before {
        counter-increment: f1;
        content: counter(f1, lower-latin)") ";
        color: black;
        font-family: Arial, sans-serif;
        font-style: italic;
        font-weight: bold;
        text-decoration: none;
        font-size: 10pt;
      }

      #l176>li:first-child>*:first-child:before {
        counter-increment: f1 0;
      }

      li {
        display: block;
      }

      #l177 {
        padding-left: 0pt;
        counter-reset: g1 1;
      }

      #l177>li>*:first-child:before {
        counter-increment: g1;
        content: counter(g1, decimal)". ";
        color: #2C5293;
        font-family: Arial, sans-serif;
        font-style: normal;
        font-weight: bold;
        text-decoration: none;
        font-size: 10pt;
      }

      #l177>li:first-child>*:first-child:before {
        counter-increment: g1 0;
      }

      li {
        display: block;
      }

      #l178 {
        padding-left: 0pt;
        counter-reset: h1 1;
      }

      #l178>li>*:first-child:before {
        counter-increment: h1;
        content: counter(h1, decimal)". ";
        color: #2C5293;
        font-family: Arial, sans-serif;
        font-style: normal;
        font-weight: bold;
        text-decoration: none;
        font-size: 10pt;
      }

      #l178>li:first-child>*:first-child:before {
        counter-increment: h1 0;
      }

      #l179 {
        padding-left: 0pt;
        counter-reset: h2 1;
      }

      #l179>li>*:first-child:before {
        counter-increment: h2;
        content: counter(h1, decimal)"."counter(h2, decimal)" ";
        color: #2C5293;
        font-family: Arial, sans-serif;
        font-style: normal;
        font-weight: bold;
        text-decoration: none;
        font-size: 10pt;
      }

      #l179>li:first-child>*:first-child:before {
        counter-increment: h2 0;
      }

      #l180 {
        padding-left: 0pt;
        counter-reset: i1 1;
      }

      #l180>li>*:first-child:before {
        counter-increment: i1;
        content: counter(i1, upper-roman)". ";
        color: #2C5293;
        font-family: Arial, sans-serif;
        font-style: italic;
        font-weight: bold;
        text-decoration: none;
        font-size: 10pt;
      }

      #l180>li:first-child>*:first-child:before {
        counter-increment: i1 0;
      }

      li {
        display: block;
      }

      #l181 {
        padding-left: 0pt;
        counter-reset: j1 1;
      }

      #l181>li>*:first-child:before {
        counter-increment: j1;
        content: counter(j1, decimal)". ";
        color: black;
        font-family: Arial, sans-serif;
        font-style: normal;
        font-weight: normal;
        text-decoration: none;
        font-size: 10pt;
      }

      #l181>li:first-child>*:first-child:before {
        counter-increment: j1 0;
      }

      li {
        display: block;
      }

      #l182 {
        padding-left: 0pt;
      }

      #l182>li>*:first-child:before {
        content: " ";
        color: black;
        font-family: Symbol, serif;
        font-style: normal;
        font-weight: normal;
        text-decoration: none;
      }

      li {
        display: block;
      }

      #l183 {
        padding-left: 0pt;
        counter-reset: l1 1;
      }

      #l183>li>*:first-child:before {
        counter-increment: l1;
        content: counter(l1, decimal)". ";
        color: #2C5293;
        font-family: Arial, sans-serif;
        font-style: normal;
        font-weight: bold;
        text-decoration: none;
        font-size: 10pt;
      }

      #l183>li:first-child>*:first-child:before {
        counter-increment: l1 0;
      }

      li {
        display: block;
      }

      #l184 {
        padding-left: 0pt;
        counter-reset: m1 1;
      }

      #l184>li>*:first-child:before {
        counter-increment: m1;
        content: counter(m1, decimal)". ";
        color: #2C5293;
        font-family: Arial, sans-serif;
        font-style: normal;
        font-weight: bold;
        text-decoration: none;
        font-size: 10pt;
      }

      #l184>li:first-child>*:first-child:before {
        counter-increment: m1 0;
      }

      #l185 {
        padding-left: 0pt;
        counter-reset: m2 1;
      }

      #l185>li>*:first-child:before {
        counter-increment: m2;
        content: counter(m2, upper-roman)". ";
        color: #2C5293;
        font-family: Arial, sans-serif;
        font-style: italic;
        font-weight: bold;
        text-decoration: none;
        font-size: 10pt;
      }

      #l185>li:first-child>*:first-child:before {
        counter-increment: m2 0;
      }

      #l186 {
        padding-left: 0pt;
        counter-reset: m3 1;
      }

      #l186>li>*:first-child:before {
        counter-increment: m3;
        content: counter(m3, lower-latin)") ";
        color: black;
        font-style: normal;
        font-weight: normal;
        text-decoration: none;
      }

      #l186>li:first-child>*:first-child:before {
        counter-increment: m3 0;
      }

      #l187 {
        padding-left: 0pt;
        counter-reset: m3 1;
      }

      #l187>li>*:first-child:before {
        counter-increment: m3;
        content: counter(m3, lower-latin)") ";
        color: black;
        font-style: normal;
        font-weight: normal;
        text-decoration: none;
      }

      #l187>li:first-child>*:first-child:before {
        counter-increment: m3 0;
      }

      table,
      tbody {
        vertical-align: top;
        overflow: visible;
      }
      .contenedorF {
        display: flex;
        justify-content: center;
      }
      .contenedorS {
        width: 100%;
      } 
      .scroll-content {
      flex: 1;  
      overflow-y: auto;
      padding: 10px;  
      }

      /********Movil************/

      /* Estilo para pantallas grandes (no móviles) */
      @media (min-width: 1025px) {
        p.Definiciones {
          padding-left: 180pt;  
          text-indent: 0pt;
          text-align: justify;
        }
        .s13 {
        padding-left: 180pt;
        text-indent: -141pt;
        text-align: justify;
        }
        .s13-CGP{ /*CGP -> CONDICIONES GENERALES PRELIMINAR*/ 
          padding-left: 180pt;
          text-indent: 0pt;
          text-align: justify;
        }
        .s13-CGP-BLACK{
        color: black;
        font-family: Arial, sans-serif;
        font-style: normal;
        font-weight: bold;
        text-decoration: none;
        font-size: 10pt;
        padding-left: 40pt;
        }

        
      }

      /* Estilos para tablets en modo horizontal */
      @media (min-width: 769px) and (max-width: 1024px) {
        p.Definiciones {
        padding-left: 180pt; 
        text-indent: 0pt;
        text-align: justify;
        }
        .s13 {
        padding-left: 180pt;
        text-indent: -141pt;
        text-align: justify;
        }
        .s13-CGP{ /*CGP -> CONDICIONES GENERALES PRELIMINAR*/ 
          padding-left: 180pt;
          text-indent: 0pt;
          text-align: justify;
        }
         .s13-CGP-BLACK{
        color: black;
        font-family: Arial, sans-serif;
        font-style: normal;
        font-weight: bold;
        text-decoration: none;
        font-size: 10pt;
        padding-left: 40pt;
        }
      }

      @media (min-width: 810px) and (max-width: 820px) {
        p.Definiciones {
          padding-left: 180pt;  
          text-align: justify;
          text-indent: 0pt;

        }
      }

      /* Ajustes para pantallas pequeñas (móviles) */
      @media (max-width: 768px) {
        p.Definiciones {
        padding-left: 38pt; 
        text-align: justify;
        text-indent: 0pt;
        word-break: normal;
        }
        .s13 {
        padding-left: 38pt;    
        text-indent: 0pt;     
        text-align: justify;  
        white-space: normal;  
        word-wrap: break-word;  
        hyphens: auto;       
        }
        .p {
         padding-left: 38pt;  
         text-align: justify;
         white-space: normal; 
         word-break: break-word;  
        }
         .s13-CGP{
          padding-left: 38pt;    
          text-indent: 0pt;     
          text-align: justify;  
          white-space: normal;  
        
        }
         .s13-CGP-BLACK{
          color: black;
          font-family: Arial, sans-serif;
          font-style: normal;
          font-weight: bold;
          text-decoration: none;
          padding-left: 38pt;  
          text-align: justify;
          white-space: normal; 
          word-break: break-word;  
        }
      }




</style>
